/* tslint:disable */
/* eslint-disable */
/**
 * Dentobook API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.73
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Request to accept terms and conditions
 */
export interface AcceptTermsRequest {
    /**
     * Must be true to accept terms
     */
    'accepted': boolean;
}

export const AccessMode = {
    NoLogin: 'no_login',
    Invite: 'invite'
} as const;

export type AccessMode = typeof AccessMode[keyof typeof AccessMode];


export interface Appointment {
    'name'?: string | null;
    'date'?: string | null;
    'patientId': string;
    'clinicId'?: string | null;
    'id': string;
    'deletedAt'?: string | null;
    'createdAt'?: string | null;
    'updatedAt'?: string | null;
}
export interface AppointmentCreate {
    'name'?: string | null;
    'clinicId'?: string | null;
}
export interface AppointmentUpdate {
    'name'?: string | null;
    'clinicId'?: string | null;
}
/**
 * Paginated audit log response matching Java pagination
 */
export interface AuditLogEventListResponse {
    'content': Array<AuditLogEventWithUser>;
    'totalElements': number;
    'totalPages': number;
    'page': number;
    'perPage': number;
    'sortBy': string;
    'order': string;
}
/**
 * Audit log event response matching Java AuditLogEvent
 */
export interface AuditLogEventResponse {
    'id': string;
    'userId'?: string | null;
    'organizationId': string;
    'eventType': string;
    'affectedEntityType'?: string | null;
    'affectedEntityId'?: string | null;
    'affectedEntityStateBeforeChange'?: string | null;
    'affectedEntityStateAfterChange'?: string | null;
    'createdAt': string;
    'updatedAt': string;
}
/**
 * Audit log with user details (for list views)
 */
export interface AuditLogEventWithUser {
    'id': string;
    'userId'?: string | null;
    'organizationId': string;
    'eventType': string;
    'affectedEntityType'?: string | null;
    'affectedEntityId'?: string | null;
    'affectedEntityStateBeforeChange'?: string | null;
    'affectedEntityStateAfterChange'?: string | null;
    'createdAt': string;
    'updatedAt': string;
    'userFirstName'?: string | null;
    'userLastName'?: string | null;
    'userEmail'?: string | null;
}
export interface AuthUserResponse {
    'id': string;
    'email': string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'phone'?: string | null;
    'role': string;
    'organizationId': string;
    'termsAccepted': boolean;
    'termsAcceptedAt'?: string | null;
    'emailVerified'?: boolean;
    'emailVerifiedAt'?: string | null;
    'createdAt': string;
}
/**
 * Request schema for batch-get calendar events by patient IDs
 */
export interface BatchGetEventsByPatientsRequest {
    /**
     * List of patient UUIDs to fetch events for
     */
    'patient_ids': Array<string>;
}
/**
 * Request schema for batch-get operations
 */
export interface BatchGetRequest {
    /**
     * List of organization UUIDs to fetch counts for
     */
    'organization_ids': Array<string>;
}
export interface BodyConfirmUserEmailVerification {
    'token': string;
}
export interface BodyFetchNzisAccessToken {
    'challenge': string;
}
/**
 * Create calendar event schema
 */
export interface CalendarEventCreate {
    'title': string;
    'start': string;
    'end': string;
    'patient'?: string | null;
    'patientEmail'?: string | null;
    'unregisteredPatient'?: string | null;
    'doctor'?: string | null;
    'clinicId'?: string | null;
    'notes'?: string | null;
    'timezone'?: string | null;
    'organizationId': string;
    'userId'?: number | null;
    'syncStatus'?: SyncStatus | null;
}


/**
 * Calendar event response schema
 */
export interface CalendarEventResponse {
    'title': string;
    'start': string;
    'end': string;
    'patient'?: string | null;
    'patientEmail'?: string | null;
    'unregisteredPatient'?: string | null;
    'doctor'?: string | null;
    'clinicId'?: string | null;
    'notes'?: string | null;
    'timezone'?: string | null;
    'id': string;
    'organizationId': string;
    'userId'?: number | null;
    'googleId'?: string | null;
    'syncStatus'?: SyncStatus | null;
    'createdAt': string;
    'updatedAt': string;
}


/**
 * Update calendar event schema
 */
export interface CalendarEventUpdate {
    'title'?: string | null;
    'start'?: string | null;
    'end'?: string | null;
    'patient'?: string | null;
    'patientEmail'?: string | null;
    'unregisteredPatient'?: string | null;
    'doctor'?: string | null;
    'clinicId'?: string | null;
    'notes'?: string | null;
    'timezone'?: string | null;
    'googleId'?: string | null;
    'syncStatus'?: SyncStatus | null;
}


/**
 * Request to change treatment NZIS status  Maps to Java: ChangePatientTreatmentNzisStatusRequest
 */
export interface ChangePatientTreatmentNzisStatusRequest {
    'treatmentId': string;
    'sentToNzis': boolean;
    'nrnDental'?: string | null;
}
/**
 * Checkout session response
 */
export interface CheckoutSessionResponse {
    'sessionId': string;
    'url': string;
}
export interface ClinicCreate {
    'name': string;
    'address': string;
    'timezone'?: string;
    'organizationId'?: string | null;
}
/**
 * Response schema — uses plain str to tolerate legacy DB rows with empty fields.
 */
export interface ClinicResponse {
    'id': string;
    'name': string;
    'address': string;
    'timezone': string;
    'organizationId': string;
    'createdAt': string;
    'updatedAt': string;
}
export interface ClinicUpdate {
    'name'?: string | null;
    'address'?: string | null;
    'timezone'?: string | null;
}
/**
 * Request to validate-and-commit a manual quick-entry batch in one call.
 */
export interface CommitManualRequest {
    'rows': Array<ImportRowInput>;
}
/**
 * Result of a commit operation.
 */
export interface CommitResponse {
    'committed': number;
    'failed': number;
    'skipped': number;
    'rows': Array<PatientImportRowResponse>;
}
export interface Condition {
    'title': string;
    'titleEnglish'?: string | null;
    'type': string;
    'id': string;
    'organizationId': string;
    'displayName'?: string | null;
    'createdAt': string;
    'updatedAt': string;
}
export interface ConditionCreate {
    'title': string;
    'titleEnglish'?: string | null;
    'type': string;
    'organizationId': string;
}
export interface ConditionUpdate {
    'title'?: string | null;
    'titleEnglish'?: string | null;
    'type'?: string | null;
}
/**
 * Request to create a checkout session
 */
export interface CreateCheckoutSessionRequest {
    'invoiceId': string;
    'successUrl': string;
    'cancelUrl': string;
}
/**
 * Request for dental treatment creation with token and XML data
 */
export interface CreateNZISedentalTreatmentRequest {
    'token': string;
    'data': string;
}
/**
 * Request to create a payment intent
 */
export interface CreatePaymentIntentRequest {
    /**
     * Amount in dollars (must be positive)
     */
    'amount': number;
    'currency'?: string;
    'invoiceId'?: string | null;
    'description'?: string | null;
    'customerEmail'?: string | null;
}
/**
 * Request to create a refund
 */
export interface CreateRefundRequest {
    'paymentIntentId': string;
    'amount'?: number | null;
    'reason'?: string | null;
}
/**
 * Request to create a subscription
 */
export interface CreateSubscriptionRequest {
    'customerEmail'?: string | null;
    'priceId': string;
    'organizationId': string;
    'paymentMethodId'?: string | null;
}
/**
 * Dental activity type/code from NZIS
 */
export interface DentalActivityType {
    'key': string;
    'descriptionBG': string;
    'cl112Mapping': string;
    'oldMHCode': string;
    'nhifCode': string;
    'version': string;
}
/**
 * Contents of dental treatment response  Matches Java: DentalResponseContents
 */
export interface DentalResponseContents {
    'nrnDental'?: string | null;
    'errorMessage'?: string | null;
}
/**
 * Contents of dental treatment augment response  Matches Java: DentalTreatmentAugmentContents
 */
export interface DentalTreatmentAugmentContents {
    'errorMessage'?: string | null;
}
/**
 * Request for augmenting dental treatment record (XML generation)  Matches Java: DentalTreatmentAugmentRequest
 */
export interface DentalTreatmentAugmentRequest {
    'header': object;
    'contents': object;
}
/**
 * Response from augmenting dental treatment record  Matches Java: DentalTreatmentAugmentResponse
 */
export interface DentalTreatmentAugmentResponse {
    'contents'?: DentalTreatmentAugmentContents | null;
}
/**
 * Request for cancelling dental treatment record (XML generation)  Matches Java: DentalTreatmentCancelRequest
 */
export interface DentalTreatmentCancelRequest {
    'header': object;
    'contents': object;
}
/**
 * Response from cancelling dental treatment record  Matches Java: DentalTreatmentCancelResponse
 */
export interface DentalTreatmentCancelResponse {
    'contents'?: DentalResponseContents | null;
}
/**
 * Request for opening dental treatment record (XML generation)  Matches Java: DentalTreatmentOpenRequest
 */
export interface DentalTreatmentOpenRequest {
    'header': object;
    'contents': object;
}
/**
 * Response from opening dental treatment record  Matches Java: DentalTreatmentOpenResponse
 */
export interface DentalTreatmentOpenResponse {
    'contents'?: DentalResponseContents | null;
}
/**
 * Response from deleting a document
 */
export interface DocumentDeleteResponse {
    'message': string;
}
/**
 * Document response matching Java DocumentEntity. Returns document metadata after upload or when listing.
 */
export interface DocumentResponse {
    'name': string;
    'fileName': string;
    'id': string;
    'organizationId': string;
    'deleted': boolean;
    'createdAt': string;
    'updatedAt': string;
}
/**
 * Information about a detected duplicate patient.
 */
export interface DuplicateInfo {
    'type': string;
    'patientId'?: string | null;
    'name'?: string | null;
}
/**
 * Request to enqueue an email
 */
export interface EmailEnqueueRequest {
    'toEmail': string;
    'toName'?: string | null;
    'subject': string;
    'bodyHtml'?: string | null;
    'bodyText'?: string | null;
    'cc'?: Array<{ [key: string]: string; }> | null;
    'bcc'?: Array<{ [key: string]: string; }> | null;
    'templateName'?: string | null;
    'templateData'?: object | null;
    'idempotencyKey'?: string | null;
}
/**
 * Response schema for list of emails
 */
export interface EmailListResponse {
    'emails': Array<OutboundEmailResponse>;
    'total': number;
    'limit': number;
    'offset': number;
}
/**
 * Response schema for queue statistics
 */
export interface EmailQueueStatsResponse {
    'total': number;
    'queued': number;
    'sending': number;
    'sent': number;
    'failed': number;
    'dead': number;
}
/**
 * Status of an outbound email
 */

export const EmailStatus = {
    Queued: 'queued',
    Sending: 'sending',
    Sent: 'sent',
    Failed: 'failed',
    Dead: 'dead'
} as const;

export type EmailStatus = typeof EmailStatus[keyof typeof EmailStatus];


/**
 * Response schema for worker status
 */
export interface EmailWorkerStatusResponse {
    'running': boolean;
    'provider': string;
    'rateLimiter': object;
    'queue': EmailQueueStatsResponse;
    'pollIntervalSeconds': number;
    'batchSize': number;
}
/**
 * Feature create schema
 */
export interface FeatureCreate {
    'name': string;
    'code': string;
    'description'?: string | null;
    'organizationId': string;
}
/**
 * Feature response schema matching Java Feature DTO
 */
export interface FeatureResponse {
    'id': string;
    'name': string;
    'code': string;
    'description'?: string | null;
    'organizationId'?: string | null;
    'createdAt': string;
    'updatedAt': string;
}
/**
 * Response from NZIS access token exchange  Matches Java: FetchNzisAccessToken200Response
 */
export interface FetchNzisAccessTokenResponse {
    'token': string;
}
/**
 * Request to initiate Google Calendar connection
 */
export interface GoogleCalendarConnectRequest {
    /**
     * Frontend URL to redirect after OAuth
     */
    'redirectUri': string;
}
/**
 * Response with OAuth authorization URL
 */
export interface GoogleCalendarConnectResponse {
    'authorizationUrl': string;
}
/**
 * Google Calendar connection status for an organization
 */
export interface GoogleCalendarConnectionStatus {
    'connected': boolean;
    'googleAccountEmail'?: string | null;
    'calendarId'?: string | null;
    'status'?: string | null;
    'lastSyncAt'?: string | null;
    'lastError'?: string | null;
}
/**
 * Response from disconnecting Google Calendar
 */
export interface GoogleCalendarDisconnectResponse {
    'message': string;
    'status': string;
}
/**
 * Response from manual sync trigger
 */
export interface GoogleCalendarSyncResponse {
    'message': string;
    'eventsSynced': number;
    'eventsFailed': number;
}
export interface HTTPValidationError {
    'detail'?: Array<ValidationError>;
}
/**
 * Health insurance company schema
 */
export interface HealthInsuranceCompany {
    'id': string;
    'name': string;
    'countryCode': string;
}
export interface HealthInsuranceCompanyCreate {
    'name': string;
    'code'?: string | null;
    'address'?: string | null;
    'phone'?: string | null;
    'email'?: string | null;
}
export interface HealthInsuranceCompanyResponse {
    'name': string;
    'code'?: string | null;
    'address'?: string | null;
    'phone'?: string | null;
    'email'?: string | null;
    'id': string;
    'created_at': string;
    'updated_at': string;
}
export interface HealthInsuranceCompanyUpdate {
    'name'?: string | null;
    'code'?: string | null;
    'address'?: string | null;
    'phone'?: string | null;
    'email'?: string | null;
}
/**
 * A single row supplied by the caller (manual grid or parsed file).
 */
export interface ImportRowInput {
    'rowIndex': number;
    'firstName'?: string | null;
    'secondName'?: string | null;
    'lastName'?: string | null;
    'email'?: string | null;
    'phone'?: string | null;
    'birthDate'?: string | null;
    'gender'?: string | null;
    'addressOne'?: string | null;
    'addressTwo'?: string | null;
    'town'?: string | null;
    'country'?: string | null;
    'nationalId'?: string | null;
    'notes'?: string | null;
}
/**
 * Per-row result from validate or commit-manual.
 */
export interface ImportRowResult {
    'rowIndex': number;
    'status': string;
    'validationErrors'?: { [key: string]: Array<string>; } | null;
    'duplicateInfo'?: Array<DuplicateInfo> | null;
    'firstName'?: string | null;
    'secondName'?: string | null;
    'lastName'?: string | null;
    'email'?: string | null;
    'phone'?: string | null;
    'birthDate'?: string | null;
    'gender'?: string | null;
    'addressOne'?: string | null;
    'addressTwo'?: string | null;
    'town'?: string | null;
    'country'?: string | null;
    'nationalId'?: string | null;
    'notes'?: string | null;
}

export const InviteStatus = {
    ExistingUserInvited: 'existing_user_invited',
    InviteSent: 'invite_sent'
} as const;

export type InviteStatus = typeof InviteStatus[keyof typeof InviteStatus];


/**
 * Create invoice configuration
 */
export interface InvoiceConfigCreate {
    'organizationId': string;
    'documentType': string;
    'prefix'?: string | null;
    'lastNumber': number;
    'digitsCount'?: number;
    'invoiceNumber'?: string | null;
    'startingNumber'?: string | null;
}
/**
 * Invoice configuration response
 */
export interface InvoiceConfigResponse {
    'id': string;
    'organizationId': string;
    'documentType': string;
    'prefix'?: string | null;
    'lastNumber': number;
    'digitsCount'?: number;
    'invoiceNumber'?: string | null;
    'startingNumber'?: string | null;
}
export interface InvoiceCreate {
    'patientId': string;
    'organizationId': string;
    'invoiceNumber': string;
    'documentType': string;
    'treatmentToothIds': Array<string>;
    'date': string;
    'paymentDueDate': string;
    'subtotal': number;
    'discount': number;
    'vat': number;
    'vatAmount': number;
    'total': number;
    'paymentMethod': string;
    'status': string;
    'cancelled'?: boolean;
    'supplierName': string;
    'supplierEIK': string;
    'supplierCity': string;
    'supplierAddress': string;
    'recipientName': string;
    'recipientEIK': string;
    'recipientCity': string;
    'recipientAddress': string;
}
export interface InvoiceResponse {
    'id': string;
    'patientId': string;
    'organizationId': string;
    'invoiceNumber': string;
    'date'?: string | null;
    'paymentDueDate'?: string | null;
    'subtotal'?: number | null;
    'discount'?: number | null;
    'vatAmount'?: number | null;
    'total'?: number | null;
    'vat'?: number | null;
    'status'?: string | null;
    'paymentMethod'?: string | null;
    'documentType'?: string | null;
    'cancelled'?: boolean | null;
    'createdAt'?: string | null;
    'supplierName'?: string | null;
    'supplierEIK'?: string | null;
    'supplierCity'?: string | null;
    'supplierAddress'?: string | null;
    'recipientName'?: string | null;
    'recipientEIK'?: string | null;
    'recipientCity'?: string | null;
    'recipientAddress'?: string | null;
}
/**
 * Invoice statistics response
 */
export interface InvoiceStatisticsResponse {
    'totalInvoices': number;
    'unpaidInvoices': number;
    'totalRevenue': number;
    'outstandingAmount': number;
}
export interface InvoiceUpdate {
    'status'?: string | null;
    'paidAmount'?: string | null;
    'paymentDate'?: string | null;
    'notes'?: string | null;
}
export interface Laboratoryprice {
}
export interface LocationInner {
}
/**
 * Response from marking all notifications as read
 */
export interface MarkAllReadResponse {
    'markedAsRead': number;
}
/**
 * Request to issue medical notice (excuse note) XML
 */
export interface MedicalNoticeIssueRequest {
    'header': object;
    'contents': object;
}
/**
 * Response from medical notice issuance
 */
export interface MedicalNoticeIssueResponse {
    'status': string;
    'message'?: string | null;
}
export interface MedicalStaff {
    'firstName': string;
    'lastName': string;
    'email'?: string | null;
    'contactEmail'?: string | null;
    'phone'?: string | null;
    'specialisation'?: string | null;
    'uin'?: string | null;
    'id': string;
    'organizationId': string;
    'userId'?: string | null;
    'isActive': boolean;
    'hasPortalAccess'?: boolean;
    'secondName'?: string | null;
    'town'?: string | null;
    'country'?: string | null;
    'addressOne'?: string | null;
    'addressTwo'?: string | null;
    'notes'?: string | null;
    'avatar'?: string | null;
    'avatarUrl'?: string | null;
    'role'?: UserRole | null;
    'roleBg'?: string | null;
    'specialisationCode'?: string | null;
    'createdAt': string;
    'updatedAt': string;
    'portalAccessStatus'?: PortalAccessStatus | null;
}


export interface MedicalStaffCountResponse {
    'doctors': number;
    'receptionists': number;
    'assistants': number;
}
/**
 * Response envelope for POST /staff.
 */
export interface MedicalStaffCreateResponse {
    'staff': MedicalStaff;
    'inviteStatus'?: InviteStatus | null;
}


/**
 * Staff creation schema with explicit access-mode support.  access_mode = \"no_login\"  (default)     Create a staff record only.  No User account or OrganizationMembership     is created.  contact_email is purely for notifications.  access_mode = \"invite\"     Create a staff record AND send an invitation to the email address:         invite_email  (if provided)         otherwise contact_email     The operation is atomic – staff is never deleted as compensation for     a failed invite.
 */
export interface MedicalStaffCreateWithAccess {
    'firstName': string;
    'lastName': string;
    'email'?: string | null;
    'contactEmail'?: string | null;
    'phone'?: string | null;
    'specialisation'?: string | null;
    'uin'?: string | null;
    'organizationId': string;
    'userId'?: string | null;
    'role'?: string | null;
    'roleBg'?: string | null;
    'specialisationCode'?: string | null;
    'secondName'?: string | null;
    'town'?: string | null;
    'country'?: string | null;
    'addressOne'?: string | null;
    'addressTwo'?: string | null;
    'notes'?: string | null;
    'accessMode'?: AccessMode;
    'inviteEmail'?: string | null;
}


export interface MedicalStaffPaginationResponse {
    'medicalStaff': Array<MedicalStaff>;
    'totalElements': number;
    'page': number;
    'perPage': number;
    'pagesCount': number;
}
export interface MedicalStaffUpdate {
    'firstName'?: string | null;
    'lastName'?: string | null;
    'secondName'?: string | null;
    'email'?: string | null;
    'contactEmail'?: string | null;
    'phone'?: string | null;
    'specialisation'?: string | null;
    'uin'?: string | null;
    'town'?: string | null;
    'country'?: string | null;
    'addressOne'?: string | null;
    'addressTwo'?: string | null;
    'notes'?: string | null;
    'avatar'?: string | null;
    'role'?: string | null;
    'roleBg'?: string | null;
    'specialisationCode'?: string | null;
    'isActive'?: boolean | null;
}
/**
 * Response for PATCH /auth/memberships/{membership_id}
 */
export interface MembershipStatusResponse {
    'id': string;
    'organizationId': string;
    'userId': string;
    'role': string;
    'status': string;
}
export interface MessagingSettingsResponse {
    'id': string;
    'organizationId': string;
    'emailEnabled': boolean;
    'smsEnabled'?: boolean;
    'whatsappEnabled'?: boolean;
    'defaultChannel': string;
    'reminderOffsetsMinutes': Array<number>;
    'quietHoursStart'?: string | null;
    'quietHoursEnd'?: string | null;
    'emailFromName'?: string | null;
    'emailFromAddress'?: string | null;
    'twilioConfigured'?: boolean;
    'twilioAccountSidLast4'?: string | null;
    'twilioVerifiedAt'?: string | null;
    'twilioSmsFrom'?: string | null;
    'twilioWhatsappFrom'?: string | null;
    'createdAt': string;
    'updatedAt': string;
}
export interface MessagingSettingsUpdate {
    'emailEnabled'?: boolean | null;
    'smsEnabled'?: boolean | null;
    'whatsappEnabled'?: boolean | null;
    'defaultChannel'?: string | null;
    'reminderOffsetsMinutes'?: Array<number> | null;
    'quietHoursStart'?: string | null;
    'quietHoursEnd'?: string | null;
    'emailFromName'?: string | null;
    'emailFromAddress'?: string | null;
    'twilioAccountSid'?: string | null;
    'twilioAuthToken'?: string | null;
    'twilioSmsFrom'?: string | null;
    'twilioWhatsappFrom'?: string | null;
    'clearTwilioCredentials'?: boolean | null;
}

export const MonetaryType = {
    Free: 'FREE',
    Paid: 'PAID',
    FreeTrial: 'FREE_TRIAL'
} as const;

export type MonetaryType = typeof MonetaryType[keyof typeof MonetaryType];


/**
 * Response containing next invoice number
 */
export interface NextInvoiceNumberResponse {
    'invoiceNumber': string;
}
/**
 * Response containing next payment date information
 */
export interface NextPaymentResponse {
    'nextPaymentDate'?: number | null;
    'subscriptionId'?: string | null;
    'status': string;
}
/**
 * Request for NZIS nomenclatures (XML format)  Matches Java: NomenclatureRequest
 */
export interface NomenclatureRequest {
    'token'?: string | null;
    'filter'?: object | null;
}
/**
 * Response from NZIS nomenclatures fetch  Matches Java: NomenclatureResponse
 */
export interface NomenclatureResponse {
    'nomenclatures'?: Array<object>;
}
/**
 * Notice response schema
 */
export interface Notice {
    'patientId': string;
    'mkb'?: string | null;
    'institution'?: string | null;
    'startDate'?: string | null;
    'endDate'?: string | null;
    'id': string;
    'organizationId': string;
    'createdAt': string;
    'updatedAt': string;
}
/**
 * Create notice schema matching Java Notice DTO
 */
export interface NoticeCreate {
    'patient': PatientNested;
    'mkb'?: string | null;
    'institution'?: string | null;
    'startDate'?: string | null;
    'endDate'?: string | null;
}
export interface NotificationCreate {
    'title': string;
    'message': string;
    'type'?: string;
    'relatedEntityType'?: string | null;
    'relatedEntityId'?: string | null;
    'userId': string;
    'organizationId': string;
    'isSentEmail'?: boolean;
}
export interface NotificationResponse {
    'title': string;
    'message': string;
    'type'?: string;
    'relatedEntityType'?: string | null;
    'relatedEntityId'?: string | null;
    'id': string;
    'userId': string;
    'organizationId': string;
    'isRead': boolean;
    'isSentEmail': boolean;
    'createdAt': string;
    'updatedAt': string;
    'deletedAt'?: string | null;
}
export interface Organization {
    'name': string;
    'email'?: string | null;
    'phone'?: string | null;
    'address'?: string | null;
    'town'?: string | null;
    'country'?: string | null;
    'postalCode'?: string | null;
    'website'?: string | null;
    'id': string;
    'avatar'?: string | null;
    'avatarUrl'?: string | null;
    'address2'?: string | null;
    'companyName'?: string | null;
    'companyAddress'?: string | null;
    'uic'?: string | null;
    'vat'?: string | null;
    'rziPracticeCode'?: string | null;
    'accountablePerson'?: string | null;
    'iban'?: string | null;
    'healthArea'?: string | null;
    'healthRegion'?: string | null;
    'invoiceNumber'?: string | null;
    'proformaInvoiceNumber'?: string | null;
    'currency'?: string | null;
    'isFreeTrialUsed'?: boolean | null;
    'paymentStatus'?: PaymentStatus | null;
    'subscription'?: SubscriptionResponse | null;
    'createdAt': string;
    'updatedAt': string;
}


/**
 * Response with organization availability
 */
export interface OrganizationAvailabilityResponse {
    'organizationId': string;
    'organizationName': string;
    'allowsSelfRegistration': boolean;
    'requiresApproval': boolean;
    'message'?: string | null;
}
export interface OrganizationCreate {
    'name': string;
    'email'?: string | null;
    'phone'?: string | null;
    'address'?: string | null;
    'town'?: string | null;
    'country'?: string | null;
    'postalCode'?: string | null;
    'website'?: string | null;
}
/**
 * Response model for user\'s organization memberships
 */
export interface OrganizationMembershipResponse {
    'membershipId': string;
    'organizationId': string;
    'organizationName': string;
    'role': string;
    'status': string;
    'avatarUrl'?: string | null;
}
/**
 * Response for POST /organizations/self.  Returns the newly created organization together with a JWT already scoped to it so the caller can start using the new org immediately — no separate /api/auth/select-org call is needed.  Token fields follow the existing Token schema convention (snake_case, no aliases) so the frontend can reuse the same token-handling code path.
 */
export interface OrganizationSelfCreateResponse {
    'organization': Organization;
    'access_token': string;
    'refresh_token': string;
    'token_type'?: string;
    'terms_accepted': boolean;
}
export interface OrganizationUpdate {
    'name'?: string | null;
    'email'?: string | null;
    'phone'?: string | null;
    'address'?: string | null;
    'address2'?: string | null;
    'town'?: string | null;
    'country'?: string | null;
    'postalCode'?: string | null;
    'website'?: string | null;
    'avatar'?: string | null;
    'companyName'?: string | null;
    'companyAddress'?: string | null;
    'uic'?: string | null;
    'vat'?: string | null;
    'rziPracticeCode'?: string | null;
    'accountablePerson'?: string | null;
    'iban'?: string | null;
    'healthArea'?: string | null;
    'healthRegion'?: string | null;
    'invoiceNumber'?: string | null;
    'proformaInvoiceNumber'?: string | null;
    'currency'?: string | null;
    'paymentStatus'?: PaymentStatus | null;
}


/**
 * Response schema for outbound email
 */
export interface OutboundEmailResponse {
    'id': string;
    'idempotencyKey': string;
    'status': EmailStatus;
    'toEmail': string;
    'toName'?: string | null;
    'subject': string;
    'bodyHtml'?: string | null;
    'bodyText'?: string | null;
    'cc'?: Array<{ [key: string]: string; }> | null;
    'bcc'?: Array<{ [key: string]: string; }> | null;
    'templateName'?: string | null;
    'templateData'?: object | null;
    'createdAt': string;
    'updatedAt': string;
    'availableAt': string;
    'lockedAt'?: string | null;
    'lockedBy'?: string | null;
    'attemptCount': number;
    'maxAttempts': number;
    'lastErrorCode'?: string | null;
    'lastErrorMessage'?: string | null;
    'providerMessageId'?: string | null;
    'clientRequestId'?: string | null;
}


/**
 * Confirm password reset with token and new password
 */
export interface PasswordResetConfirm {
    'token': string;
    'new_password': string;
}
/**
 * Request to reset password - receives email
 */
export interface PasswordResetRequest {
    'email': string;
    'turnstileToken'?: string | null;
}
/**
 * Generic response for password reset operations
 */
export interface PasswordResetResponse {
    'message': string;
}
export interface Patient {
    'firstName': string;
    'lastName': string;
    'email'?: string | null;
    'phone'?: string | null;
    'birthDate'?: string | null;
    'gender'?: string | null;
    'addressOne'?: string | null;
    'town'?: string | null;
    'country'?: string | null;
    'id': string;
    'organizationId': string;
    'secondName'?: string | null;
    'addressTwo'?: string | null;
    'notes'?: string | null;
    'avatar'?: string | null;
    'avatarUrl'?: string | null;
    'pregnancyPlan'?: string | null;
    'pregnancyDate'?: string | null;
    'nursing'?: boolean | null;
    'anesthesia'?: boolean | null;
    'regularHygiene'?: boolean | null;
    'visitPeriod'?: string | null;
    'lastVisit'?: string | null;
    'lastVisitReason'?: string | null;
    'fear'?: string | null;
    'isSmoker'?: boolean | null;
    'healthInsuranceCompanyId'?: string | null;
    'egn'?: string | null;
    'patientSource'?: string | null;
    'patientSourceName'?: string | null;
    'healthArea'?: string | null;
    'healthRegion'?: string | null;
    'ekatte'?: string | null;
    'profession'?: string | null;
    'emailNotificationsEnabled'?: boolean;
    'phoneNotificationsEnabled'?: boolean;
    'preferredNotificationChannel'?: string;
    'deletedAt'?: string | null;
    'createdAt': string;
    'updatedAt': string;
    'conditions'?: Array<Condition>;
    'lastAppointment'?: string | null;
    'nextAppointment'?: string | null;
    'treatingDentists'?: Array<string>;
}
export interface PatientCreate {
    'firstName': string;
    'lastName': string;
    'email'?: string | null;
    'phone'?: string | null;
    'birthDate'?: string | null;
    'gender'?: string | null;
    'addressOne'?: string | null;
    'town'?: string | null;
    'country'?: string | null;
    'organizationId'?: string | null;
    'egn'?: string | null;
}
export interface PatientDocumentResponse {
    'name': string;
    'id': string;
    'file_name': string;
    'file_path': string;
    'organization_id': string;
    'deleted': boolean;
    'created_at': string;
    'updated_at': string;
}
/**
 * Paginated list of patient imports.
 */
export interface PatientImportHistoryResponse {
    'items': Array<PatientImportListItem>;
    'total': number;
    'page': number;
    'pageSize': number;
}
/**
 * Summary row for the import history list.
 */
export interface PatientImportListItem {
    'id': string;
    'status': string;
    'source': string;
    'originalFilename'?: string | null;
    'totalRows': number;
    'validRows': number;
    'committedRows': number;
    'warningRows': number;
    'createdAt': string;
    'createdByName'?: string | null;
}
/**
 * Full patient import with all rows.
 */
export interface PatientImportResponse {
    'id': string;
    'status': string;
    'source': string;
    'originalFilename'?: string | null;
    'totalRows': number;
    'validRows': number;
    'committedRows': number;
    'conflictRows': number;
    'createdAt': string;
    'rows'?: Array<PatientImportRowResponse>;
}
/**
 * A row as stored (and returned) by the import endpoints.
 */
export interface PatientImportRowResponse {
    'id': string;
    'rowIndex': number;
    'status': string;
    'validationErrors'?: { [key: string]: Array<string>; } | null;
    'duplicateInfo'?: Array<object> | null;
    'firstName'?: string | null;
    'secondName'?: string | null;
    'lastName'?: string | null;
    'email'?: string | null;
    'phone'?: string | null;
    'birthDate'?: string | null;
    'gender'?: string | null;
    'addressOne'?: string | null;
    'addressTwo'?: string | null;
    'town'?: string | null;
    'country'?: string | null;
    'nationalId'?: string | null;
    'notes'?: string | null;
    'createdPatientId'?: string | null;
}
export interface PatientListResponse {
    'id': string;
    'firstName': string;
    'lastName': string;
    'email'?: string | null;
    'phone'?: string | null;
    'createdAt': string;
}
/**
 * Lightweight Patient schema for nested contexts - only includes ID
 */
export interface PatientNested {
    'id': string;
}
/**
 * Pagination response matching Java PatientPaginationResponse exactly
 */
export interface PatientPaginationResponse {
    'totalElements': number;
    'page': number;
    'perPage': number;
    'pagesCount': number;
    'patients': Array<PatientListResponse>;
}
/**
 * Response for patient self-register URL
 */
export interface PatientSelfRegisterUrlResponse {
    'id': string;
    'organizationId': string;
    'usedAt'?: string | null;
    'createdAt': string;
    'updatedAt': string;
}
/**
 * Request for patient self-registration
 */
export interface PatientSelfRegistrationRequest {
    /**
     * Clinic/organization to register with
     */
    'organizationId': string;
    'firstName': string;
    'lastName': string;
    'email': string;
    'phone': string;
    'dateOfBirth': string;
    'address'?: string | null;
    'city'?: string | null;
    'postalCode'?: string | null;
    'country'?: string | null;
    'allergies'?: string | null;
    'medicalHistory'?: string | null;
    'currentMedications'?: string | null;
    'egn'?: string | null;
    'password': string;
}
/**
 * Response for patient self-registration
 */
export interface PatientSelfRegistrationResponse {
    'patientId': string;
    'userId': string;
    'email': string;
    'patientNumber': string;
    'status': string;
    'message': string;
    'verificationEmailSent': boolean;
}
export interface PatientUpdate {
    'firstName'?: string | null;
    'secondName'?: string | null;
    'lastName'?: string | null;
    'email'?: string | null;
    'phone'?: string | null;
    'birthDate'?: string | null;
    'gender'?: string | null;
    'addressOne'?: string | null;
    'addressTwo'?: string | null;
    'town'?: string | null;
    'country'?: string | null;
    'notes'?: string | null;
    'avatar'?: string | null;
    'pregnancyPlan'?: string | null;
    'pregnancyDate'?: string | null;
    'nursing'?: boolean | null;
    'anesthesia'?: boolean | null;
    'regularHygiene'?: boolean | null;
    'visitPeriod'?: string | null;
    'lastVisit'?: string | null;
    'lastVisitReason'?: string | null;
    'fear'?: string | null;
    'isSmoker'?: boolean | null;
    'healthInsuranceCompanyId'?: string | null;
    'egn'?: string | null;
    'patientSource'?: string | null;
    'patientSourceName'?: string | null;
    'healthArea'?: string | null;
    'healthRegion'?: string | null;
    'ekatte'?: string | null;
    'profession'?: string | null;
    'emailNotificationsEnabled'?: boolean | null;
    'phoneNotificationsEnabled'?: boolean | null;
    'preferredNotificationChannel'?: string | null;
}
/**
 * Create payment details request
 */
export interface PaymentDetailsCreate {
    'paymentMethod'?: string | null;
    'cardholderName'?: string | null;
    'cardNumber'?: string | null;
    'expiryDate'?: string | null;
    'cvv'?: string | null;
    'billingAddress'?: string | null;
    'country'?: string | null;
    'postalCode'?: string | null;
    'organizationId': string;
}
/**
 * Payment details response
 */
export interface PaymentDetailsResponse {
    'paymentMethod'?: string | null;
    'cardholderName'?: string | null;
    'cardNumber'?: string | null;
    'expiryDate'?: string | null;
    'cvv'?: string | null;
    'billingAddress'?: string | null;
    'country'?: string | null;
    'postalCode'?: string | null;
    'id': string;
    'organizationId': string;
    'createdAt': string;
    'updatedAt': string;
}
/**
 * Update payment details request (all fields optional)
 */
export interface PaymentDetailsUpdate {
    'paymentMethod'?: string | null;
    'cardholderName'?: string | null;
    'cardNumber'?: string | null;
    'expiryDate'?: string | null;
    'cvv'?: string | null;
    'billingAddress'?: string | null;
    'country'?: string | null;
    'postalCode'?: string | null;
}
/**
 * Individual payment history item
 */
export interface PaymentHistoryItem {
    'id': string;
    'paymentId': string;
    'amount': number;
    'currency': string;
    'hasFailed': boolean;
    'failureReason'?: string | null;
    'createdAt'?: string | null;
    'updatedAt'?: string | null;
}
/**
 * Payment intent response
 */
export interface PaymentIntentResponse {
    'paymentIntentId': string;
    'clientSecret': string;
    'amount': number;
    'currency': string;
    'status': string;
}
/**
 * Request to record a payment
 */
export interface PaymentRequest {
    'amount': string;
    'paymentDate': string;
    'paymentMethod'?: string | null;
    'notes'?: string | null;
}

export const PaymentStatus = {
    Pending: 'PENDING',
    Paid: 'PAID',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
} as const;

export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];


/**
 * Response containing list of payment history
 */
export interface PaymentsHistoryResponse {
    'payments': Array<PaymentHistoryItem>;
}
/**
 * Photo response matching Java Photo DTO
 */
export interface PhotoResponse {
    'type'?: string | null;
    'id': string;
    'path'?: string | null;
    'url'?: string | null;
    'createdAt'?: string | null;
    'updatedAt'?: string | null;
}
export interface PlanCreate {
    'name': string;
    'monetaryType': MonetaryType;
    'price': number;
    'duration'?: string | null;
}


export interface PlanResponse {
    'name': string;
    'monetaryType': MonetaryType;
    'price': number;
    'duration'?: string | null;
    'id': string;
    'createdAt': string;
    'updatedAt': string;
}


export interface PlanUpdate {
    'name'?: string | null;
    'price'?: number | null;
    'duration'?: string | null;
}

export const PortalAccessStatus = {
    None: 'none',
    PendingInvite: 'pending_invite',
    Invited: 'invited',
    Active: 'active'
} as const;

export type PortalAccessStatus = typeof PortalAccessStatus[keyof typeof PortalAccessStatus];


/**
 * Response containing presigned preview URL for a document
 */
export interface PreviewUrlResponse {
    'url': string;
}
export interface Price {
}
export interface Procedure {
    'name': string;
    'description'?: string | null;
    'code'?: string | null;
    'defaultPrice'?: number | null;
    'durationMinutes'?: number | null;
    'id': string;
    'organizationId': string;
    'displayName'?: string | null;
    'createdAt': string;
    'updatedAt': string;
}
export interface ProcedureCreate {
    'name': string;
    'description'?: string | null;
    'code'?: string | null;
    'defaultPrice'?: number | null;
    'durationMinutes'?: number | null;
    'organizationId': string;
}
export interface ProcedureUpdate {
    'name'?: string | null;
    'description'?: string | null;
    'code'?: string | null;
    'defaultPrice'?: number | null;
    'durationMinutes'?: number | null;
}
/**
 * Request to process payment token (legacy)
 */
export interface ProcessPaymentTokenRequest {
    'organizationId': string;
    'paymentToken': string;
    'customerEmail': string;
    'customerName'?: string | null;
    'billingAddress'?: object | null;
    'taxId'?: string | null;
}
/**
 * Response from processing payment token
 */
export interface ProcessPaymentTokenResponse {
    'success': boolean;
    'paymentId'?: string | null;
}
/**
 * Update proforma invoice schema matching Java updateProformaInvoice
 */
export interface ProformaInvoiceUpdate {
    'documentType'?: string | null;
    'status'?: string | null;
    'paymentMethod'?: string | null;
    'vat'?: number | null;
}
/**
 * Refresh token request - uses snake_case for frontend compatibility
 */
export interface RefreshTokenRequest {
    'refresh_token': string;
}
/**
 * Refund response
 */
export interface RefundResponse {
    'refundId': string;
    'amount': number;
    'currency': string;
    'status': string;
}
/**
 * Individual report entry - type-safe structure matching Java ReportDTO
 */
export interface Report {
    'id': string;
    'patient': ReportPatient;
    'date'?: string | null;
    'conditionId'?: string | null;
    'conditionDisplayName'?: string | null;
    'treatmentId'?: string | null;
    'treatmentDisplayName'?: string | null;
    'toothNumber': number;
    'price': number;
    'debt': number;
    'paid': number;
    'doctorId'?: string | null;
    'doctorDisplayName'?: string | null;
    'createdAt'?: string | null;
    'updatedAt'?: string | null;
}
/**
 * Patient information subset for reports - type-safe alternative to manual dict construction
 */
export interface ReportPatient {
    'id': string;
    'firstName': string;
    'lastName': string;
    'email'?: string | null;
    'phone'?: string | null;
    'dateOfBirth'?: string | null;
    'avatar'?: string | null;
    'organizationId': string;
    'createdAt': string;
    'updatedAt': string;
}
/**
 * Paginated reports response - now type-safe with Report schema
 */
export interface ReportsPaginationResponse {
    'totalElements': number;
    'page': number;
    'perPage': number;
    'pagesCount': number;
    'reports': Array<Report>;
}
/**
 * Public request to resend email verification (no auth required).
 */
export interface ResendEmailVerificationRequest {
    'email': string;
}
/**
 * Request to resend verification email
 */
export interface ResendVerificationEmailRequest {
    'email': string;
}
/**
 * Response for resend verification
 */
export interface ResendVerificationEmailResponse {
    'success': boolean;
    'message': string;
}
/**
 * Request to select active organization
 */
export interface SelectOrganizationRequest {
    'organizationId': string;
}
/**
 * Schema for self-registration (creates organization, medical staff, and user transactionally)
 */
export interface SelfRegisterRequest {
    'email': string;
    'password': string;
    'confirmPassword': string;
    'firstName': string;
    'lastName': string;
    'phone': string;
    'role'?: UserRole;
    'organizationName': string;
    'organizationEmail'?: string | null;
    'organizationPhone'?: string | null;
    'organizationCountry': string;
    'organizationCurrency': string;
    'organizationAddress'?: string | null;
    'turnstileToken'?: string | null;
}


/**
 * Simplified calendar event for batch responses
 */
export interface SimplifiedCalendarEvent {
    'id': string;
    'title': string;
    'start'?: string | null;
    'end'?: string | null;
    'patient'?: string | null;
    'doctor'?: string | null;
    'notes'?: string | null;
}
/**
 * Body for POST /staff/{id}/grant-access.
 */
export interface StaffAccessGrantRequest {
    'email': string;
}
/**
 * Response for POST /staff/{id}/grant-access.  invite_status is always INVITE_SENT (Phase 3): all grants go through an invite token regardless of whether the user already has an account.
 */
export interface StaffAccessGrantResponse {
    'staff': MedicalStaff;
    'inviteStatus': InviteStatus;
}


/**
 * Compact access snapshot returned by GET /staff/{id}/access.
 */
export interface StaffAccessView {
    'staffId': string;
    'hasPortalAccess': boolean;
    'userId'?: string | null;
    'contactEmail'?: string | null;
    'membershipId'?: string | null;
    'membershipStatus'?: string | null;
    'roleInOrg'?: string | null;
    'pendingInviteEmail'?: string | null;
}
/**
 * Response for GET /public/staff-invite/{token}.  Returns only what is safe to expose without authentication. Email is masked to prevent enumeration via token guessing.
 */
export interface StaffInviteInfoResponse {
    'maskedEmail': string;
    'orgName': string;
    'inviterName'?: string | null;
    'expiresAt': string;
    'status': string;
    'isNewUser': boolean;
}
/**
 * Body for POST /public/staff-invite/redeem.
 */
export interface StaffInviteRedeemRequest {
    'token': string;
    'password'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'turnstileToken'?: string | null;
}
/**
 * Response for POST /public/staff-invite/redeem.
 */
export interface StaffInviteRedeemResponse {
    'action': string;
    'redirectHint': string;
    'organizationId': string;
    'accessToken'?: string | null;
    'refreshToken'?: string | null;
}
export interface StatusCreate {
    'name'?: string | null;
    'nameEn'?: string | null;
    'label'?: string | null;
    'nzisKey'?: string | null;
    'color'?: string | null;
    'nzisCondition'?: string | null;
    'organizationId': string;
}
/**
 * Lightweight Status schema for nested contexts - only includes fields used by frontend
 */
export interface StatusNested {
    'id': string;
    'name'?: string | null;
    'nameEn'?: string | null;
    'displayName'?: string | null;
    'label'?: string | null;
    'color'?: string | null;
    'nzisKey'?: string | null;
    'nzisCondition'?: string | null;
}
export interface StatusResponse {
    'name'?: string | null;
    'nameEn'?: string | null;
    'label'?: string | null;
    'nzisKey'?: string | null;
    'color'?: string | null;
    'nzisCondition'?: string | null;
    'id': string;
    'organizationId': string;
    'displayName'?: string | null;
    'createdAt': string;
    'updatedAt': string;
}
export interface StatusToothCreate {
    'statusId'?: string | null;
    'nzisStatusId'?: string | null;
    'notes'?: string | null;
    'date'?: string | null;
    'sequenceId'?: string | null;
    'toothId'?: string | null;
    'appointmentId'?: string | null;
}
export interface StatusToothUpdate {
    'statusId'?: string | null;
    'nzisStatusId'?: string | null;
    'notes'?: string | null;
    'date'?: string | null;
}
export interface StatusUpdate {
    'name'?: string | null;
    'nameEn'?: string | null;
    'label'?: string | null;
    'nzisKey'?: string | null;
    'color'?: string | null;
    'nzisCondition'?: string | null;
}
/**
 * Response indicating if Stripe is enabled
 */
export interface StripeEnabledResponse {
    'enabled': boolean;
}
/**
 * Individual Stripe invoice item
 */
export interface StripeInvoiceItem {
    'created'?: string | null;
    'status': string;
    'hostedInvoiceUrl'?: string | null;
    'invoicePdf'?: string | null;
    'amountPaid': number;
}
/**
 * Response containing Stripe publishable key
 */
export interface StripePublishableKeyResponse {
    'publishableKey': string;
}
/**
 * Subscription response
 */
export interface StripeSubscriptionResponse {
    'subscriptionId': string;
    'status': string;
    'currentPeriodStart'?: number | null;
    'currentPeriodEnd'?: number | null;
    'cancelAtPeriodEnd'?: boolean;
}
/**
 * Response from cancelling a subscription
 */
export interface SubscriptionCancelResponse {
    'message': string;
}
export interface SubscriptionCreate {
    'organizationId': string;
    'planId': string;
    'status': SubscriptionStatus;
    'expiration'?: string | null;
}


/**
 * Response from renewing a subscription
 */
export interface SubscriptionRenewResponse {
    'message': string;
    'success': boolean;
    'status': string;
}
export interface SubscriptionResponse {
    'organizationId': string;
    'planId': string;
    'status': SubscriptionStatus;
    'expiration'?: string | null;
    'id': string;
    'plan'?: PlanResponse | null;
    'createdAt': string;
    'updatedAt': string;
}



export const SubscriptionStatus = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Trial: 'TRIAL',
    Expired: 'EXPIRED',
    Cancelled: 'CANCELLED'
} as const;

export type SubscriptionStatus = typeof SubscriptionStatus[keyof typeof SubscriptionStatus];


export interface SubscriptionUpdate {
    'status'?: SubscriptionStatus | null;
    'expiration'?: string | null;
}


/**
 * Google Calendar sync status
 */

export const SyncStatus = {
    CreatePending: 'CREATE_PENDING',
    UpdatePending: 'UPDATE_PENDING',
    DeletePending: 'DELETE_PENDING',
    Synced: 'SYNCED'
} as const;

export type SyncStatus = typeof SyncStatus[keyof typeof SyncStatus];


export interface TestSmsRequest {
    'phoneNumber': string;
    'channel'?: string;
}
/**
 * Login token response - uses snake_case for frontend compatibility
 */
export interface Token {
    'access_token': string;
    'refresh_token': string;
    'token_type'?: string;
    /**
     * Whether user has accepted terms and conditions
     */
    'terms_accepted': boolean;
    /**
     * Whether user has verified their email address
     */
    'email_verified'?: boolean;
}
export interface Tooth {
    'position': number;
    'orderNumber'?: number | null;
    'id': string;
    'patientId': string;
    'createdAt': string;
    'updatedAt': string;
}
/**
 * Tooth condition code from NZIS
 */
export interface ToothConditionCode {
    'key': string;
    'descriptionBG': string;
    'descriptionEN': string;
    'nhifMapping': string;
    'nhifText': string;
    'incompatibleCodes': string;
    'requiredCodes': string;
    'version': string;
}
export interface ToothCreate {
    'position': number;
    'orderNumber'?: number | null;
    'patientId': string;
}
/**
 * Lightweight Tooth schema for nested contexts - only includes fields used by frontend
 */
export interface ToothNested {
    'id': string;
    'position'?: number | null;
}
export interface ToothStatus {
    'statusId'?: string | null;
    'nzisStatusId'?: string | null;
    'notes'?: string | null;
    'date'?: string | null;
    'sequenceId'?: string | null;
    'id': string;
    'toothId'?: string | null;
    'tooth'?: ToothNested | null;
    'appointmentId'?: string | null;
    'deletedAt'?: string | null;
    'createdAt': string;
    'updatedAt': string;
    'statusNameSnapshot'?: string | null;
    'status'?: StatusNested | null;
}
/**
 * Response schema for tooth treatment - does NOT inherit problematic Union types
 */
export interface ToothTreatment {
    'id': string;
    'createdAt': string;
    'updatedAt': string;
    'treatmentId'?: string | null;
    'nzisTreatmentId'?: string | null;
    'medicalStaffId'?: string | null;
    'statusId'?: string | null;
    'nzisStatusId'?: string | null;
    'toothId'?: string | null;
    'appointmentId'?: string | null;
    'price'?: number | null;
    'discount'?: number | null;
    'laboratoryPrice'?: number | null;
    'status'?: string | null;
    'notes'?: string | null;
    'isSentToNzis'?: boolean;
    'nrnDental'?: string | null;
    'date'?: string | null;
    'sequenceId'?: string | null;
    'invoiced'?: boolean;
    'tooth'?: ToothNested | null;
    'paidAt'?: string | null;
    'deletedAt'?: string | null;
    'treatmentNameSnapshot'?: string | null;
    'statusNameSnapshot'?: string | null;
    'medicalStaffNameSnapshot'?: string | null;
    'procedures'?: Array<any>;
}
/**
 * Lightweight TreatmentTooth schema for nested contexts in /teeth endpoint  Deliberately omits createdAt/updatedAt timestamps as they are not needed for display in nested contexts (frontend only needs status + tooth position).
 */
export interface ToothTreatmentNested {
    'id': string;
    'treatmentId'?: string | null;
    'toothId'?: string | null;
    'appointmentId'?: string | null;
    'status'?: string | null;
    'tooth'?: ToothNested | null;
    'treatmentNameSnapshot'?: string | null;
    'procedures'?: Array<any>;
}
/**
 * Extended Tooth schema with nested relationships for fetchPatientTeeth endpoint
 */
export interface ToothWithRelationships {
    'position': number;
    'orderNumber'?: number | null;
    'id': string;
    'patientId': string;
    'createdAt': string;
    'updatedAt': string;
    'toothStatuses'?: Array<ToothStatus>;
    'toothTreatments'?: Array<ToothTreatmentNested>;
}
export interface Treatment {
    'name': string;
    'nameEn'?: string | null;
    'date'?: string | null;
    'price'?: string | null;
    'laboratoryPrice'?: string | null;
    'nzisCondition'?: string | null;
    'id': string;
    'organizationId': string;
    'displayName'?: string | null;
    'createdAt': string;
    'updatedAt': string;
}
export interface TreatmentCreate {
    'name': string;
    'nameEn'?: string | null;
    'date'?: string | null;
    'price'?: Price | null;
    'laboratoryPrice'?: Laboratoryprice | null;
    'nzisCondition'?: string | null;
    'organizationId': string;
}
export interface TreatmentToothCreate {
    'treatmentId'?: string | null;
    'nzisTreatmentId'?: string | null;
    'medicalStaffId'?: string | null;
    'statusId'?: string | null;
    'nzisStatusId'?: string | null;
    'price'?: number | null;
    'discount'?: number | null;
    'laboratoryPrice'?: number | null;
    'status'?: string | null;
    'notes'?: string | null;
    'isSentToNzis'?: boolean;
    'nrnDental'?: string | null;
    'date'?: string | null;
    'sequenceId'?: string | null;
    'invoiced'?: boolean;
    'toothId'?: string | null;
    'appointmentId'?: string | null;
}
export interface TreatmentToothUpdate {
    'treatmentId'?: string | null;
    'medicalStaffId'?: string | null;
    'statusId'?: string | null;
    'price'?: number | null;
    'discount'?: number | null;
    'laboratoryPrice'?: number | null;
    'status'?: string | null;
    'notes'?: string | null;
    'paidAt'?: string | null;
    'invoiced'?: boolean | null;
}
export interface TreatmentUpdate {
    'name'?: string | null;
    'nameEn'?: string | null;
    'date'?: string | null;
    'price'?: Price | null;
    'laboratoryPrice'?: Laboratoryprice | null;
    'nzisCondition'?: string | null;
}
/**
 * Response containing unread notification count
 */
export interface UnreadCountResponse {
    'unreadCount': number;
}
/**
 * Request body for PATCH /auth/memberships/{membership_id}
 */
export interface UpdateMembershipStatusRequest {
    /**
     * New membership status: \'removed\' or \'suspended\'
     */
    'status': string;
}
/**
 * Request to update treatment financial information (payment status)     
 */
export interface UpdateTreatmentsFinancialsRequest {
    'paid'?: boolean | null;
}
/**
 * Schema for inviting a user (admin creates user)
 */
export interface UserInvite {
    'email': string;
    'firstName': string;
    'lastName': string;
    'phone'?: string | null;
    'role': UserRole;
    'organizationId': string;
    'password'?: string | null;
}


export interface UserLastLogin {
    'id': string;
    'userId': string;
    'email': string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'lastLogin'?: string | null;
    'lastLoginTimestamp'?: string | null;
    'loginCount'?: number;
}
export interface UserLogin {
    'email': string;
    'password': string;
}
export interface UserResponse {
    'id': string;
    'email': string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'phone'?: string | null;
    'role': UserRole;
    'organizationId': string;
    'medicalStaffId'?: string | null;
    'patientId'?: string | null;
    'avatar'?: string | null;
    'isActive': boolean;
    'features'?: Array<string> | null;
    'createdAt': string;
    'updatedAt': string;
}



export const UserRole = {
    PlatformAdministrator: 'PLATFORM_ADMINISTRATOR',
    ClinicAdmin: 'CLINIC_ADMIN',
    MedicalDoctor: 'MEDICAL_DOCTOR',
    MedicalAssistant: 'MEDICAL_ASSISTANT',
    Receptionist: 'RECEPTIONIST',
    Patient: 'PATIENT'
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];


/**
 * Response model for user settings
 */
export interface UserSettingsResponse {
    'settings': object;
    'created_at': string;
    'updated_at': string;
}
/**
 * Request model for updating user settings  Supports partial updates - only provided fields will be updated. Settings are merged with existing values.  Examples:     {\"language\": \"bg\"}                          # Update language only     {\"language\": \"en\", \"currency\": \"USD\"}       # Update both     {\"notifications\": {\"email\": true}}          # Add new setting
 */
export interface UserSettingsUpdate {
    'settings': object;
}
export interface UserUpdate {
    'email'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'phone'?: string | null;
    'role'?: string | null;
    'avatar'?: string | null;
    'isActive'?: boolean | null;
}
export interface ValidateRequest {
    'rows': Array<ImportRowInput>;
}
export interface ValidateResponse {
    'rows': Array<ImportRowResult>;
    'validCount': number;
    'invalidCount': number;
    'duplicateWarningCount': number;
    'conflictCount': number;
}
export interface ValidationError {
    'loc': Array<LocationInner>;
    'msg': string;
    'type': string;
}
/**
 * Request to verify email
 */
export interface VerifyEmailRequest {
    /**
     * Email verification token
     */
    'token': string;
}
/**
 * Response for email verification
 */
export interface VerifyEmailResponse {
    'success': boolean;
    'message': string;
    'patientId'?: string | null;
}
/**
 * Webhook event handling response
 */
export interface WebhookEventResponse {
    'status': string;
    'eventType'?: string | null;
    'message'?: string | null;
}

/**
 * AuditApi - axios parameter creator
 */
export const AuditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get single audit log event by ID  Matches Java: GET /audit/{id} Maps to Java: AuditLogController.fetchAuditLogEvent(UUID id) line 22 Requires ACTIVITY_LOG authority
         * @summary Get Audit Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAuditLogEvent: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('fetchAuditLogEvent', 'eventId', eventId)
            const localVarPath = `/api/audit/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List audit log events with filtering, sorting, and pagination  Matches Java: GET /audit/ Maps to Java: AuditLogController.fetchAuditLogEvents() line 27 Requires ACTIVITY_LOG authority  Supports filters: - keyword: Search in entity type and event type - filterBy: \"create\", \"update\", \"delete\" (event type), \"user\" (current user only) - entityType: Filter by specific entity type (Python-only parameter)
         * @summary List Audit Events
         * @param {string | null} [keyword] Search keyword
         * @param {string | null} [filterBy] Filter by: create, update, delete, user
         * @param {string | null} [entityType] Filter by entity type
         * @param {number} [page] Page number (0-indexed)
         * @param {number} [perPage] Items per page
         * @param {string} [sortBy] Sort field
         * @param {string} [order] Sort order: asc or desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAuditLogEvents: async (keyword?: string | null, filterBy?: string | null, entityType?: string | null, page?: number, perPage?: number, sortBy?: string, order?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/audit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditApi - functional programming interface
 */
export const AuditApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditApiAxiosParamCreator(configuration)
    return {
        /**
         * Get single audit log event by ID  Matches Java: GET /audit/{id} Maps to Java: AuditLogController.fetchAuditLogEvent(UUID id) line 22 Requires ACTIVITY_LOG authority
         * @summary Get Audit Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAuditLogEvent(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditLogEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAuditLogEvent(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditApi.fetchAuditLogEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List audit log events with filtering, sorting, and pagination  Matches Java: GET /audit/ Maps to Java: AuditLogController.fetchAuditLogEvents() line 27 Requires ACTIVITY_LOG authority  Supports filters: - keyword: Search in entity type and event type - filterBy: \"create\", \"update\", \"delete\" (event type), \"user\" (current user only) - entityType: Filter by specific entity type (Python-only parameter)
         * @summary List Audit Events
         * @param {string | null} [keyword] Search keyword
         * @param {string | null} [filterBy] Filter by: create, update, delete, user
         * @param {string | null} [entityType] Filter by entity type
         * @param {number} [page] Page number (0-indexed)
         * @param {number} [perPage] Items per page
         * @param {string} [sortBy] Sort field
         * @param {string} [order] Sort order: asc or desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAuditLogEvents(keyword?: string | null, filterBy?: string | null, entityType?: string | null, page?: number, perPage?: number, sortBy?: string, order?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditLogEventListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAuditLogEvents(keyword, filterBy, entityType, page, perPage, sortBy, order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditApi.fetchAuditLogEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditApi - factory interface
 */
export const AuditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditApiFp(configuration)
    return {
        /**
         * Get single audit log event by ID  Matches Java: GET /audit/{id} Maps to Java: AuditLogController.fetchAuditLogEvent(UUID id) line 22 Requires ACTIVITY_LOG authority
         * @summary Get Audit Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAuditLogEvent(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<AuditLogEventResponse> {
            return localVarFp.fetchAuditLogEvent(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * List audit log events with filtering, sorting, and pagination  Matches Java: GET /audit/ Maps to Java: AuditLogController.fetchAuditLogEvents() line 27 Requires ACTIVITY_LOG authority  Supports filters: - keyword: Search in entity type and event type - filterBy: \"create\", \"update\", \"delete\" (event type), \"user\" (current user only) - entityType: Filter by specific entity type (Python-only parameter)
         * @summary List Audit Events
         * @param {string | null} [keyword] Search keyword
         * @param {string | null} [filterBy] Filter by: create, update, delete, user
         * @param {string | null} [entityType] Filter by entity type
         * @param {number} [page] Page number (0-indexed)
         * @param {number} [perPage] Items per page
         * @param {string} [sortBy] Sort field
         * @param {string} [order] Sort order: asc or desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAuditLogEvents(keyword?: string | null, filterBy?: string | null, entityType?: string | null, page?: number, perPage?: number, sortBy?: string, order?: string, options?: RawAxiosRequestConfig): AxiosPromise<AuditLogEventListResponse> {
            return localVarFp.fetchAuditLogEvents(keyword, filterBy, entityType, page, perPage, sortBy, order, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditApi - object-oriented interface
 */
export class AuditApi extends BaseAPI {
    /**
     * Get single audit log event by ID  Matches Java: GET /audit/{id} Maps to Java: AuditLogController.fetchAuditLogEvent(UUID id) line 22 Requires ACTIVITY_LOG authority
     * @summary Get Audit Event
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAuditLogEvent(eventId: string, options?: RawAxiosRequestConfig) {
        return AuditApiFp(this.configuration).fetchAuditLogEvent(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List audit log events with filtering, sorting, and pagination  Matches Java: GET /audit/ Maps to Java: AuditLogController.fetchAuditLogEvents() line 27 Requires ACTIVITY_LOG authority  Supports filters: - keyword: Search in entity type and event type - filterBy: \"create\", \"update\", \"delete\" (event type), \"user\" (current user only) - entityType: Filter by specific entity type (Python-only parameter)
     * @summary List Audit Events
     * @param {string | null} [keyword] Search keyword
     * @param {string | null} [filterBy] Filter by: create, update, delete, user
     * @param {string | null} [entityType] Filter by entity type
     * @param {number} [page] Page number (0-indexed)
     * @param {number} [perPage] Items per page
     * @param {string} [sortBy] Sort field
     * @param {string} [order] Sort order: asc or desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAuditLogEvents(keyword?: string | null, filterBy?: string | null, entityType?: string | null, page?: number, perPage?: number, sortBy?: string, order?: string, options?: RawAxiosRequestConfig) {
        return AuditApiFp(this.configuration).fetchAuditLogEvents(keyword, filterBy, entityType, page, perPage, sortBy, order, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationApi - axios parameter creator
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept terms and conditions + GDPR
         * @summary Accept Terms
         * @param {AcceptTermsRequest} acceptTermsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTerms: async (acceptTermsRequest: AcceptTermsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptTermsRequest' is not null or undefined
            assertParamExists('acceptTerms', 'acceptTermsRequest', acceptTermsRequest)
            const localVarPath = `/api/auth/accept-terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptTermsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm password reset with token and new password.  Verifies token, updates password, and invalidates all user sessions.
         * @summary Confirm Password Reset
         * @param {PasswordResetConfirm} passwordResetConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPasswordReset: async (passwordResetConfirm: PasswordResetConfirm, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetConfirm' is not null or undefined
            assertParamExists('confirmPasswordReset', 'passwordResetConfirm', passwordResetConfirm)
            const localVarPath = `/api/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetConfirm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm email address using the one-time token from the verification email.  - Returns 400 for invalid, expired, or already-used tokens. - Marks the token as used (single-use) and sets email_verified_at on the user. - Safe to call multiple times: subsequent calls after first use return 400 (token consumed).
         * @summary Confirm Email Verification
         * @param {BodyConfirmUserEmailVerification} bodyConfirmUserEmailVerification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmUserEmailVerification: async (bodyConfirmUserEmailVerification: BodyConfirmUserEmailVerification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bodyConfirmUserEmailVerification' is not null or undefined
            assertParamExists('confirmUserEmailVerification', 'bodyConfirmUserEmailVerification', bodyConfirmUserEmailVerification)
            const localVarPath = `/api/auth/verify-email/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bodyConfirmUserEmailVerification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get current user information
         * @summary Get Current User Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all organizations the current user belongs to, including membershipId.  If userId is provided, returns that user\'s membership(s) scoped to the caller\'s current organization. Caller must be CLINIC_ADMIN or PLATFORM_ADMINISTRATOR. Authorization is driven by OrganizationMembership.role via get_org_context().
         * @summary Get User Organizations
         * @param {string | null} [userId] Look up memberships for another user (CLINIC_ADMIN only, scoped to caller\&#39;s org)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrganizations: async (userId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/orgs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Login and get access tokens
         * @summary Login
         * @param {UserLogin} userLogin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (userLogin: UserLogin, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userLogin' is not null or undefined
            assertParamExists('login', 'userLogin', userLogin)
            const localVarPath = `/api/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userLogin, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logout and track logout event for audit purposes  Uses organization_id from JWT token claim if available, falls back to user\'s default org.
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public endpoint — resend email verification link (no auth required).  Rate limits (server-side): - Per-user (by email): 1 request per 60-second cooldown - Per-user (by email): max 5 per hour - Per-IP: max 20 per hour  Returns 429 with retry_after_seconds when rate-limited. Returns 200 for all valid (non-rate-limited) requests — never reveals whether email exists.
         * @summary Public Resend Email Verification
         * @param {ResendEmailVerificationRequest} resendEmailVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicResendEmailVerification: async (resendEmailVerificationRequest: ResendEmailVerificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendEmailVerificationRequest' is not null or undefined
            assertParamExists('publicResendEmailVerification', 'resendEmailVerificationRequest', resendEmailVerificationRequest)
            const localVarPath = `/api/auth/resend-email-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendEmailVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh access token using refresh token
         * @summary Refresh Token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (refreshTokenRequest: RefreshTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshTokenRequest' is not null or undefined
            assertParamExists('refreshToken', 'refreshTokenRequest', refreshTokenRequest)
            const localVarPath = `/api/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request password reset email.  Returns the same response regardless of whether the email exists, to prevent account enumeration attacks.  Rate limiting: 5 requests per email per hour.
         * @summary Request Password Reset
         * @param {PasswordResetRequest} passwordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset: async (passwordResetRequest: PasswordResetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetRequest' is not null or undefined
            assertParamExists('requestPasswordReset', 'passwordResetRequest', passwordResetRequest)
            const localVarPath = `/api/auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send (or resend) the email-verification link for the authenticated user.  - Returns 400 if the email is already verified. - Rate-limited to EMAIL_RATE_LIMIT_PER_HOUR per email address per hour. - Any previously-issued, unused EMAIL_VERIFICATION tokens are invalidated   before the new one is created (single active token at a time).
         * @summary Resend Verification Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendUserVerificationEmail: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/verify-email/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Select active organization for the session.  Returns a new access token with the selected organization_id in the JWT claim. Also updates the user\'s last active organization for convenience.
         * @summary Select Organization
         * @param {SelectOrganizationRequest} selectOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectOrganization: async (selectOrganizationRequest: SelectOrganizationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectOrganizationRequest' is not null or undefined
            assertParamExists('selectOrganization', 'selectOrganizationRequest', selectOrganizationRequest)
            const localVarPath = `/api/auth/select-org`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove or suspend a user\'s membership in the current organization.  - CLINIC_ADMIN only, scoped to the caller\'s JWT organization - Cannot modify your own membership (prevents accidental self-lockout) - Allowed transitions: any status → removed | suspended - After removal, the affected user\'s next request to that org returns 403   (enforced by require_role / get_org_context which checks status == ACTIVE)
         * @summary Update Membership Status
         * @param {string} membershipId 
         * @param {UpdateMembershipStatusRequest} updateMembershipStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMembershipStatus: async (membershipId: string, updateMembershipStatusRequest: UpdateMembershipStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'membershipId' is not null or undefined
            assertParamExists('updateMembershipStatus', 'membershipId', membershipId)
            // verify required parameter 'updateMembershipStatusRequest' is not null or undefined
            assertParamExists('updateMembershipStatus', 'updateMembershipStatusRequest', updateMembershipStatusRequest)
            const localVarPath = `/api/auth/memberships/{membership_id}`
                .replace(`{${"membership_id"}}`, encodeURIComponent(String(membershipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMembershipStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept terms and conditions + GDPR
         * @summary Accept Terms
         * @param {AcceptTermsRequest} acceptTermsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptTerms(acceptTermsRequest: AcceptTermsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptTerms(acceptTermsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.acceptTerms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm password reset with token and new password.  Verifies token, updates password, and invalidates all user sessions.
         * @summary Confirm Password Reset
         * @param {PasswordResetConfirm} passwordResetConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmPasswordReset(passwordResetConfirm: PasswordResetConfirm, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordResetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmPasswordReset(passwordResetConfirm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.confirmPasswordReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm email address using the one-time token from the verification email.  - Returns 400 for invalid, expired, or already-used tokens. - Marks the token as used (single-use) and sets email_verified_at on the user. - Safe to call multiple times: subsequent calls after first use return 400 (token consumed).
         * @summary Confirm Email Verification
         * @param {BodyConfirmUserEmailVerification} bodyConfirmUserEmailVerification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmUserEmailVerification(bodyConfirmUserEmailVerification: BodyConfirmUserEmailVerification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmUserEmailVerification(bodyConfirmUserEmailVerification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.confirmUserEmailVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get current user information
         * @summary Get Current User Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getCurrentUserInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all organizations the current user belongs to, including membershipId.  If userId is provided, returns that user\'s membership(s) scoped to the caller\'s current organization. Caller must be CLINIC_ADMIN or PLATFORM_ADMINISTRATOR. Authorization is driven by OrganizationMembership.role via get_org_context().
         * @summary Get User Organizations
         * @param {string | null} [userId] Look up memberships for another user (CLINIC_ADMIN only, scoped to caller\&#39;s org)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserOrganizations(userId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationMembershipResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserOrganizations(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getUserOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Login and get access tokens
         * @summary Login
         * @param {UserLogin} userLogin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(userLogin: UserLogin, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(userLogin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Logout and track logout event for audit purposes  Uses organization_id from JWT token claim if available, falls back to user\'s default org.
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public endpoint — resend email verification link (no auth required).  Rate limits (server-side): - Per-user (by email): 1 request per 60-second cooldown - Per-user (by email): max 5 per hour - Per-IP: max 20 per hour  Returns 429 with retry_after_seconds when rate-limited. Returns 200 for all valid (non-rate-limited) requests — never reveals whether email exists.
         * @summary Public Resend Email Verification
         * @param {ResendEmailVerificationRequest} resendEmailVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicResendEmailVerification(resendEmailVerificationRequest: ResendEmailVerificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicResendEmailVerification(resendEmailVerificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.publicResendEmailVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refresh access token using refresh token
         * @summary Refresh Token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(refreshTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request password reset email.  Returns the same response regardless of whether the email exists, to prevent account enumeration attacks.  Rate limiting: 5 requests per email per hour.
         * @summary Request Password Reset
         * @param {PasswordResetRequest} passwordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestPasswordReset(passwordResetRequest: PasswordResetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordResetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestPasswordReset(passwordResetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.requestPasswordReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send (or resend) the email-verification link for the authenticated user.  - Returns 400 if the email is already verified. - Rate-limited to EMAIL_RATE_LIMIT_PER_HOUR per email address per hour. - Any previously-issued, unused EMAIL_VERIFICATION tokens are invalidated   before the new one is created (single active token at a time).
         * @summary Resend Verification Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendUserVerificationEmail(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendUserVerificationEmail(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.resendUserVerificationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Select active organization for the session.  Returns a new access token with the selected organization_id in the JWT claim. Also updates the user\'s last active organization for convenience.
         * @summary Select Organization
         * @param {SelectOrganizationRequest} selectOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selectOrganization(selectOrganizationRequest: SelectOrganizationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selectOrganization(selectOrganizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.selectOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove or suspend a user\'s membership in the current organization.  - CLINIC_ADMIN only, scoped to the caller\'s JWT organization - Cannot modify your own membership (prevents accidental self-lockout) - Allowed transitions: any status → removed | suspended - After removal, the affected user\'s next request to that org returns 403   (enforced by require_role / get_org_context which checks status == ACTIVE)
         * @summary Update Membership Status
         * @param {string} membershipId 
         * @param {UpdateMembershipStatusRequest} updateMembershipStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMembershipStatus(membershipId: string, updateMembershipStatusRequest: UpdateMembershipStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMembershipStatus(membershipId, updateMembershipStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.updateMembershipStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * Accept terms and conditions + GDPR
         * @summary Accept Terms
         * @param {AcceptTermsRequest} acceptTermsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTerms(acceptTermsRequest: AcceptTermsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthUserResponse> {
            return localVarFp.acceptTerms(acceptTermsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm password reset with token and new password.  Verifies token, updates password, and invalidates all user sessions.
         * @summary Confirm Password Reset
         * @param {PasswordResetConfirm} passwordResetConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPasswordReset(passwordResetConfirm: PasswordResetConfirm, options?: RawAxiosRequestConfig): AxiosPromise<PasswordResetResponse> {
            return localVarFp.confirmPasswordReset(passwordResetConfirm, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm email address using the one-time token from the verification email.  - Returns 400 for invalid, expired, or already-used tokens. - Marks the token as used (single-use) and sets email_verified_at on the user. - Safe to call multiple times: subsequent calls after first use return 400 (token consumed).
         * @summary Confirm Email Verification
         * @param {BodyConfirmUserEmailVerification} bodyConfirmUserEmailVerification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmUserEmailVerification(bodyConfirmUserEmailVerification: BodyConfirmUserEmailVerification, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.confirmUserEmailVerification(bodyConfirmUserEmailVerification, options).then((request) => request(axios, basePath));
        },
        /**
         * Get current user information
         * @summary Get Current User Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserInfo(options?: RawAxiosRequestConfig): AxiosPromise<AuthUserResponse> {
            return localVarFp.getCurrentUserInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all organizations the current user belongs to, including membershipId.  If userId is provided, returns that user\'s membership(s) scoped to the caller\'s current organization. Caller must be CLINIC_ADMIN or PLATFORM_ADMINISTRATOR. Authorization is driven by OrganizationMembership.role via get_org_context().
         * @summary Get User Organizations
         * @param {string | null} [userId] Look up memberships for another user (CLINIC_ADMIN only, scoped to caller\&#39;s org)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrganizations(userId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganizationMembershipResponse>> {
            return localVarFp.getUserOrganizations(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Login and get access tokens
         * @summary Login
         * @param {UserLogin} userLogin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(userLogin: UserLogin, options?: RawAxiosRequestConfig): AxiosPromise<Token> {
            return localVarFp.login(userLogin, options).then((request) => request(axios, basePath));
        },
        /**
         * Logout and track logout event for audit purposes  Uses organization_id from JWT token claim if available, falls back to user\'s default org.
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * Public endpoint — resend email verification link (no auth required).  Rate limits (server-side): - Per-user (by email): 1 request per 60-second cooldown - Per-user (by email): max 5 per hour - Per-IP: max 20 per hour  Returns 429 with retry_after_seconds when rate-limited. Returns 200 for all valid (non-rate-limited) requests — never reveals whether email exists.
         * @summary Public Resend Email Verification
         * @param {ResendEmailVerificationRequest} resendEmailVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicResendEmailVerification(resendEmailVerificationRequest: ResendEmailVerificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.publicResendEmailVerification(resendEmailVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh access token using refresh token
         * @summary Refresh Token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<Token> {
            return localVarFp.refreshToken(refreshTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Request password reset email.  Returns the same response regardless of whether the email exists, to prevent account enumeration attacks.  Rate limiting: 5 requests per email per hour.
         * @summary Request Password Reset
         * @param {PasswordResetRequest} passwordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(passwordResetRequest: PasswordResetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PasswordResetResponse> {
            return localVarFp.requestPasswordReset(passwordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send (or resend) the email-verification link for the authenticated user.  - Returns 400 if the email is already verified. - Rate-limited to EMAIL_RATE_LIMIT_PER_HOUR per email address per hour. - Any previously-issued, unused EMAIL_VERIFICATION tokens are invalidated   before the new one is created (single active token at a time).
         * @summary Resend Verification Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendUserVerificationEmail(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.resendUserVerificationEmail(options).then((request) => request(axios, basePath));
        },
        /**
         * Select active organization for the session.  Returns a new access token with the selected organization_id in the JWT claim. Also updates the user\'s last active organization for convenience.
         * @summary Select Organization
         * @param {SelectOrganizationRequest} selectOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectOrganization(selectOrganizationRequest: SelectOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Token> {
            return localVarFp.selectOrganization(selectOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove or suspend a user\'s membership in the current organization.  - CLINIC_ADMIN only, scoped to the caller\'s JWT organization - Cannot modify your own membership (prevents accidental self-lockout) - Allowed transitions: any status → removed | suspended - After removal, the affected user\'s next request to that org returns 403   (enforced by require_role / get_org_context which checks status == ACTIVE)
         * @summary Update Membership Status
         * @param {string} membershipId 
         * @param {UpdateMembershipStatusRequest} updateMembershipStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMembershipStatus(membershipId: string, updateMembershipStatusRequest: UpdateMembershipStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<MembershipStatusResponse> {
            return localVarFp.updateMembershipStatus(membershipId, updateMembershipStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * Accept terms and conditions + GDPR
     * @summary Accept Terms
     * @param {AcceptTermsRequest} acceptTermsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public acceptTerms(acceptTermsRequest: AcceptTermsRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).acceptTerms(acceptTermsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm password reset with token and new password.  Verifies token, updates password, and invalidates all user sessions.
     * @summary Confirm Password Reset
     * @param {PasswordResetConfirm} passwordResetConfirm 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirmPasswordReset(passwordResetConfirm: PasswordResetConfirm, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).confirmPasswordReset(passwordResetConfirm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm email address using the one-time token from the verification email.  - Returns 400 for invalid, expired, or already-used tokens. - Marks the token as used (single-use) and sets email_verified_at on the user. - Safe to call multiple times: subsequent calls after first use return 400 (token consumed).
     * @summary Confirm Email Verification
     * @param {BodyConfirmUserEmailVerification} bodyConfirmUserEmailVerification 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirmUserEmailVerification(bodyConfirmUserEmailVerification: BodyConfirmUserEmailVerification, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).confirmUserEmailVerification(bodyConfirmUserEmailVerification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get current user information
     * @summary Get Current User Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentUserInfo(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getCurrentUserInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all organizations the current user belongs to, including membershipId.  If userId is provided, returns that user\'s membership(s) scoped to the caller\'s current organization. Caller must be CLINIC_ADMIN or PLATFORM_ADMINISTRATOR. Authorization is driven by OrganizationMembership.role via get_org_context().
     * @summary Get User Organizations
     * @param {string | null} [userId] Look up memberships for another user (CLINIC_ADMIN only, scoped to caller\&#39;s org)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserOrganizations(userId?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getUserOrganizations(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Login and get access tokens
     * @summary Login
     * @param {UserLogin} userLogin 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public login(userLogin: UserLogin, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).login(userLogin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logout and track logout event for audit purposes  Uses organization_id from JWT token claim if available, falls back to user\'s default org.
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public logout(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public endpoint — resend email verification link (no auth required).  Rate limits (server-side): - Per-user (by email): 1 request per 60-second cooldown - Per-user (by email): max 5 per hour - Per-IP: max 20 per hour  Returns 429 with retry_after_seconds when rate-limited. Returns 200 for all valid (non-rate-limited) requests — never reveals whether email exists.
     * @summary Public Resend Email Verification
     * @param {ResendEmailVerificationRequest} resendEmailVerificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public publicResendEmailVerification(resendEmailVerificationRequest: ResendEmailVerificationRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).publicResendEmailVerification(resendEmailVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refresh access token using refresh token
     * @summary Refresh Token
     * @param {RefreshTokenRequest} refreshTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).refreshToken(refreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request password reset email.  Returns the same response regardless of whether the email exists, to prevent account enumeration attacks.  Rate limiting: 5 requests per email per hour.
     * @summary Request Password Reset
     * @param {PasswordResetRequest} passwordResetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public requestPasswordReset(passwordResetRequest: PasswordResetRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).requestPasswordReset(passwordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send (or resend) the email-verification link for the authenticated user.  - Returns 400 if the email is already verified. - Rate-limited to EMAIL_RATE_LIMIT_PER_HOUR per email address per hour. - Any previously-issued, unused EMAIL_VERIFICATION tokens are invalidated   before the new one is created (single active token at a time).
     * @summary Resend Verification Email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resendUserVerificationEmail(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).resendUserVerificationEmail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Select active organization for the session.  Returns a new access token with the selected organization_id in the JWT claim. Also updates the user\'s last active organization for convenience.
     * @summary Select Organization
     * @param {SelectOrganizationRequest} selectOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public selectOrganization(selectOrganizationRequest: SelectOrganizationRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).selectOrganization(selectOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove or suspend a user\'s membership in the current organization.  - CLINIC_ADMIN only, scoped to the caller\'s JWT organization - Cannot modify your own membership (prevents accidental self-lockout) - Allowed transitions: any status → removed | suspended - After removal, the affected user\'s next request to that org returns 403   (enforced by require_role / get_org_context which checks status == ACTIVE)
     * @summary Update Membership Status
     * @param {string} membershipId 
     * @param {UpdateMembershipStatusRequest} updateMembershipStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMembershipStatus(membershipId: string, updateMembershipStatusRequest: UpdateMembershipStatusRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).updateMembershipStatus(membershipId, updateMembershipStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CalendarApi - axios parameter creator
 */
export const CalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get calendar event counts for multiple organizations in one request (batch-get endpoint)
         * @summary Batch Get Calendar Events Counts
         * @param {BatchGetRequest} batchGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchGetCalendarEventsCounts: async (batchGetRequest: BatchGetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchGetRequest' is not null or undefined
            assertParamExists('batchGetCalendarEventsCounts', 'batchGetRequest', batchGetRequest)
            const localVarPath = `/api/calendar/events/batch-get-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get calendar events for multiple patients in one request (batch-get endpoint)
         * @summary Batch Get Events By Patients
         * @param {BatchGetEventsByPatientsRequest} batchGetEventsByPatientsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchGetEventsByPatients: async (batchGetEventsByPatientsRequest: BatchGetEventsByPatientsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchGetEventsByPatientsRequest' is not null or undefined
            assertParamExists('batchGetEventsByPatients', 'batchGetEventsByPatientsRequest', batchGetEventsByPatientsRequest)
            const localVarPath = `/api/calendar/events/batch-get-by-patients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchGetEventsByPatientsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new calendar event with audit logging
         * @summary Create Calendar Event
         * @param {CalendarEventCreate} calendarEventCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarEvent: async (calendarEventCreate: CalendarEventCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarEventCreate' is not null or undefined
            assertParamExists('createCalendarEvent', 'calendarEventCreate', calendarEventCreate)
            const localVarPath = `/api/calendar/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarEventCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a calendar event with audit logging
         * @summary Delete Calendar Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarEvent: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteCalendarEvent', 'eventId', eventId)
            const localVarPath = `/api/calendar/events/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete all calendar events for a patient
         * @summary Delete Patient Calendar Events
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientCalendarEvents: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('deletePatientCalendarEvents', 'patientId', patientId)
            const localVarPath = `/api/calendar/events/patient/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all calendar events for the user\'s organization
         * @summary Fetch All Calendar Events
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [medicalStaffId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllCalendarEvents: async (startDate?: string | null, endDate?: string | null, medicalStaffId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/calendar/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (medicalStaffId !== undefined) {
                localVarQueryParameter['medical_staff_id'] = medicalStaffId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single calendar event by ID
         * @summary Fetch Calendar Event
         * @param {string} eventId 
         * @param {string | null} [clinicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCalendarEventById: async (eventId: string, clinicId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('fetchCalendarEventById', 'eventId', eventId)
            const localVarPath = `/api/calendar/events/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clinicId !== undefined) {
                localVarQueryParameter['clinic_id'] = clinicId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get total count of calendar events for an organization (admin only)
         * @summary Fetch Calendar Events Count By Org
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCalendarEventsCountByOrg: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchCalendarEventsCountByOrg', 'organizationId', organizationId)
            const localVarPath = `/api/calendar/events/count/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the next 3 upcoming calendar events for the user\'s organization  Maps to Java endpoint: GET /calendar/events/last-three/ Returns the next 3 upcoming events (start > now) sorted by start date ascending.
         * @summary Fetch Last Three Calendar Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLastThreeCalendarEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/calendar/events/last-three`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all calendar events for a specific patient
         * @summary Fetch Patient Calendar Events
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientCalendarEvents: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('fetchPatientCalendarEvents', 'patientId', patientId)
            const localVarPath = `/api/calendar/events/patient/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch events pending Google Calendar sync
         * @summary Fetch Pending Sync Events
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPendingSyncEvents: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchPendingSyncEvents', 'organizationId', organizationId)
            const localVarPath = `/api/calendar/events/pending-sync/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a calendar event with audit logging
         * @summary Update Calendar Event
         * @param {string} eventId 
         * @param {CalendarEventUpdate} calendarEventUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarEvent: async (eventId: string, calendarEventUpdate: CalendarEventUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('updateCalendarEvent', 'eventId', eventId)
            // verify required parameter 'calendarEventUpdate' is not null or undefined
            assertParamExists('updateCalendarEvent', 'calendarEventUpdate', calendarEventUpdate)
            const localVarPath = `/api/calendar/events/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarEventUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update event Google Calendar sync status
         * @summary Update Event Sync Status
         * @param {string} eventId 
         * @param {string} syncStatus 
         * @param {string | null} [googleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventSyncStatus: async (eventId: string, syncStatus: string, googleId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('updateEventSyncStatus', 'eventId', eventId)
            // verify required parameter 'syncStatus' is not null or undefined
            assertParamExists('updateEventSyncStatus', 'syncStatus', syncStatus)
            const localVarPath = `/api/calendar/events/{event_id}/sync-status`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (syncStatus !== undefined) {
                localVarQueryParameter['sync_status'] = syncStatus;
            }

            if (googleId !== undefined) {
                localVarQueryParameter['google_id'] = googleId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarApi - functional programming interface
 */
export const CalendarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalendarApiAxiosParamCreator(configuration)
    return {
        /**
         * Get calendar event counts for multiple organizations in one request (batch-get endpoint)
         * @summary Batch Get Calendar Events Counts
         * @param {BatchGetRequest} batchGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchGetCalendarEventsCounts(batchGetRequest: BatchGetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchGetCalendarEventsCounts(batchGetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.batchGetCalendarEventsCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get calendar events for multiple patients in one request (batch-get endpoint)
         * @summary Batch Get Events By Patients
         * @param {BatchGetEventsByPatientsRequest} batchGetEventsByPatientsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchGetEventsByPatients(batchGetEventsByPatientsRequest: BatchGetEventsByPatientsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<SimplifiedCalendarEvent>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchGetEventsByPatients(batchGetEventsByPatientsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.batchGetEventsByPatients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new calendar event with audit logging
         * @summary Create Calendar Event
         * @param {CalendarEventCreate} calendarEventCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCalendarEvent(calendarEventCreate: CalendarEventCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCalendarEvent(calendarEventCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.createCalendarEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a calendar event with audit logging
         * @summary Delete Calendar Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCalendarEvent(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCalendarEvent(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.deleteCalendarEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete all calendar events for a patient
         * @summary Delete Patient Calendar Events
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientCalendarEvents(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientCalendarEvents(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.deletePatientCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all calendar events for the user\'s organization
         * @summary Fetch All Calendar Events
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [medicalStaffId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllCalendarEvents(startDate?: string | null, endDate?: string | null, medicalStaffId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEventResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllCalendarEvents(startDate, endDate, medicalStaffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.fetchAllCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch a single calendar event by ID
         * @summary Fetch Calendar Event
         * @param {string} eventId 
         * @param {string | null} [clinicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchCalendarEventById(eventId: string, clinicId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchCalendarEventById(eventId, clinicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.fetchCalendarEventById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get total count of calendar events for an organization (admin only)
         * @summary Fetch Calendar Events Count By Org
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchCalendarEventsCountByOrg(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchCalendarEventsCountByOrg(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.fetchCalendarEventsCountByOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch the next 3 upcoming calendar events for the user\'s organization  Maps to Java endpoint: GET /calendar/events/last-three/ Returns the next 3 upcoming events (start > now) sorted by start date ascending.
         * @summary Fetch Last Three Calendar Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchLastThreeCalendarEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEventResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchLastThreeCalendarEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.fetchLastThreeCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all calendar events for a specific patient
         * @summary Fetch Patient Calendar Events
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPatientCalendarEvents(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEventResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPatientCalendarEvents(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.fetchPatientCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch events pending Google Calendar sync
         * @summary Fetch Pending Sync Events
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPendingSyncEvents(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEventResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPendingSyncEvents(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.fetchPendingSyncEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a calendar event with audit logging
         * @summary Update Calendar Event
         * @param {string} eventId 
         * @param {CalendarEventUpdate} calendarEventUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalendarEvent(eventId: string, calendarEventUpdate: CalendarEventUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendarEvent(eventId, calendarEventUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.updateCalendarEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update event Google Calendar sync status
         * @summary Update Event Sync Status
         * @param {string} eventId 
         * @param {string} syncStatus 
         * @param {string | null} [googleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventSyncStatus(eventId: string, syncStatus: string, googleId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventSyncStatus(eventId, syncStatus, googleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.updateEventSyncStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalendarApi - factory interface
 */
export const CalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalendarApiFp(configuration)
    return {
        /**
         * Get calendar event counts for multiple organizations in one request (batch-get endpoint)
         * @summary Batch Get Calendar Events Counts
         * @param {BatchGetRequest} batchGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchGetCalendarEventsCounts(batchGetRequest: BatchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.batchGetCalendarEventsCounts(batchGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get calendar events for multiple patients in one request (batch-get endpoint)
         * @summary Batch Get Events By Patients
         * @param {BatchGetEventsByPatientsRequest} batchGetEventsByPatientsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchGetEventsByPatients(batchGetEventsByPatientsRequest: BatchGetEventsByPatientsRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<SimplifiedCalendarEvent>; }> {
            return localVarFp.batchGetEventsByPatients(batchGetEventsByPatientsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new calendar event with audit logging
         * @summary Create Calendar Event
         * @param {CalendarEventCreate} calendarEventCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarEvent(calendarEventCreate: CalendarEventCreate, options?: RawAxiosRequestConfig): AxiosPromise<CalendarEventResponse> {
            return localVarFp.createCalendarEvent(calendarEventCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a calendar event with audit logging
         * @summary Delete Calendar Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarEvent(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCalendarEvent(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete all calendar events for a patient
         * @summary Delete Patient Calendar Events
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientCalendarEvents(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePatientCalendarEvents(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all calendar events for the user\'s organization
         * @summary Fetch All Calendar Events
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [medicalStaffId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllCalendarEvents(startDate?: string | null, endDate?: string | null, medicalStaffId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarEventResponse>> {
            return localVarFp.fetchAllCalendarEvents(startDate, endDate, medicalStaffId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a single calendar event by ID
         * @summary Fetch Calendar Event
         * @param {string} eventId 
         * @param {string | null} [clinicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCalendarEventById(eventId: string, clinicId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<CalendarEventResponse> {
            return localVarFp.fetchCalendarEventById(eventId, clinicId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get total count of calendar events for an organization (admin only)
         * @summary Fetch Calendar Events Count By Org
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCalendarEventsCountByOrg(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.fetchCalendarEventsCountByOrg(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch the next 3 upcoming calendar events for the user\'s organization  Maps to Java endpoint: GET /calendar/events/last-three/ Returns the next 3 upcoming events (start > now) sorted by start date ascending.
         * @summary Fetch Last Three Calendar Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLastThreeCalendarEvents(options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarEventResponse>> {
            return localVarFp.fetchLastThreeCalendarEvents(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all calendar events for a specific patient
         * @summary Fetch Patient Calendar Events
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientCalendarEvents(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarEventResponse>> {
            return localVarFp.fetchPatientCalendarEvents(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch events pending Google Calendar sync
         * @summary Fetch Pending Sync Events
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPendingSyncEvents(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarEventResponse>> {
            return localVarFp.fetchPendingSyncEvents(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a calendar event with audit logging
         * @summary Update Calendar Event
         * @param {string} eventId 
         * @param {CalendarEventUpdate} calendarEventUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarEvent(eventId: string, calendarEventUpdate: CalendarEventUpdate, options?: RawAxiosRequestConfig): AxiosPromise<CalendarEventResponse> {
            return localVarFp.updateCalendarEvent(eventId, calendarEventUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update event Google Calendar sync status
         * @summary Update Event Sync Status
         * @param {string} eventId 
         * @param {string} syncStatus 
         * @param {string | null} [googleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventSyncStatus(eventId: string, syncStatus: string, googleId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<CalendarEventResponse> {
            return localVarFp.updateEventSyncStatus(eventId, syncStatus, googleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarApi - object-oriented interface
 */
export class CalendarApi extends BaseAPI {
    /**
     * Get calendar event counts for multiple organizations in one request (batch-get endpoint)
     * @summary Batch Get Calendar Events Counts
     * @param {BatchGetRequest} batchGetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public batchGetCalendarEventsCounts(batchGetRequest: BatchGetRequest, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).batchGetCalendarEventsCounts(batchGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get calendar events for multiple patients in one request (batch-get endpoint)
     * @summary Batch Get Events By Patients
     * @param {BatchGetEventsByPatientsRequest} batchGetEventsByPatientsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public batchGetEventsByPatients(batchGetEventsByPatientsRequest: BatchGetEventsByPatientsRequest, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).batchGetEventsByPatients(batchGetEventsByPatientsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new calendar event with audit logging
     * @summary Create Calendar Event
     * @param {CalendarEventCreate} calendarEventCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCalendarEvent(calendarEventCreate: CalendarEventCreate, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).createCalendarEvent(calendarEventCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a calendar event with audit logging
     * @summary Delete Calendar Event
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCalendarEvent(eventId: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).deleteCalendarEvent(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete all calendar events for a patient
     * @summary Delete Patient Calendar Events
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePatientCalendarEvents(patientId: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).deletePatientCalendarEvents(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all calendar events for the user\'s organization
     * @summary Fetch All Calendar Events
     * @param {string | null} [startDate] 
     * @param {string | null} [endDate] 
     * @param {string | null} [medicalStaffId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllCalendarEvents(startDate?: string | null, endDate?: string | null, medicalStaffId?: string | null, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).fetchAllCalendarEvents(startDate, endDate, medicalStaffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch a single calendar event by ID
     * @summary Fetch Calendar Event
     * @param {string} eventId 
     * @param {string | null} [clinicId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchCalendarEventById(eventId: string, clinicId?: string | null, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).fetchCalendarEventById(eventId, clinicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get total count of calendar events for an organization (admin only)
     * @summary Fetch Calendar Events Count By Org
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchCalendarEventsCountByOrg(organizationId: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).fetchCalendarEventsCountByOrg(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch the next 3 upcoming calendar events for the user\'s organization  Maps to Java endpoint: GET /calendar/events/last-three/ Returns the next 3 upcoming events (start > now) sorted by start date ascending.
     * @summary Fetch Last Three Calendar Events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchLastThreeCalendarEvents(options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).fetchLastThreeCalendarEvents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all calendar events for a specific patient
     * @summary Fetch Patient Calendar Events
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPatientCalendarEvents(patientId: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).fetchPatientCalendarEvents(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch events pending Google Calendar sync
     * @summary Fetch Pending Sync Events
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPendingSyncEvents(organizationId: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).fetchPendingSyncEvents(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a calendar event with audit logging
     * @summary Update Calendar Event
     * @param {string} eventId 
     * @param {CalendarEventUpdate} calendarEventUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCalendarEvent(eventId: string, calendarEventUpdate: CalendarEventUpdate, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updateCalendarEvent(eventId, calendarEventUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update event Google Calendar sync status
     * @summary Update Event Sync Status
     * @param {string} eventId 
     * @param {string} syncStatus 
     * @param {string | null} [googleId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEventSyncStatus(eventId: string, syncStatus: string, googleId?: string | null, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updateEventSyncStatus(eventId, syncStatus, googleId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClinicsApi - axios parameter creator
 */
export const ClinicsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create new clinic  Tenant isolation: enforces org_ctx.organization_id (JWT-derived). Only PLATFORM_ADMINISTRATOR can specify different organization_id.
         * @summary Create Clinic
         * @param {ClinicCreate} clinicCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClinic: async (clinicCreate: ClinicCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinicCreate' is not null or undefined
            assertParamExists('createClinic', 'clinicCreate', clinicCreate)
            const localVarPath = `/api/clinics/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clinicCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete clinic  Tenant isolation: service layer validates ownership before deletion.
         * @summary Delete Clinic
         * @param {string} clinicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClinic: async (clinicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinicId' is not null or undefined
            assertParamExists('deleteClinic', 'clinicId', clinicId)
            const localVarPath = `/api/clinics/{clinic_id}`
                .replace(`{${"clinic_id"}}`, encodeURIComponent(String(clinicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all clinics for the current user\'s organization  Tenant isolation: filters by org_ctx.organization_id (JWT-derived). Platform administrators see all clinics if organization_id is not set.
         * @summary List Clinics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clinics/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update clinic  Tenant isolation: service layer validates ownership before update.
         * @summary Update Clinic
         * @param {string} clinicId 
         * @param {ClinicUpdate} clinicUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinic: async (clinicId: string, clinicUpdate: ClinicUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinicId' is not null or undefined
            assertParamExists('updateClinic', 'clinicId', clinicId)
            // verify required parameter 'clinicUpdate' is not null or undefined
            assertParamExists('updateClinic', 'clinicUpdate', clinicUpdate)
            const localVarPath = `/api/clinics/{clinic_id}`
                .replace(`{${"clinic_id"}}`, encodeURIComponent(String(clinicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clinicUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClinicsApi - functional programming interface
 */
export const ClinicsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClinicsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create new clinic  Tenant isolation: enforces org_ctx.organization_id (JWT-derived). Only PLATFORM_ADMINISTRATOR can specify different organization_id.
         * @summary Create Clinic
         * @param {ClinicCreate} clinicCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClinic(clinicCreate: ClinicCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClinicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClinic(clinicCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClinicsApi.createClinic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete clinic  Tenant isolation: service layer validates ownership before deletion.
         * @summary Delete Clinic
         * @param {string} clinicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClinic(clinicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClinic(clinicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClinicsApi.deleteClinic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all clinics for the current user\'s organization  Tenant isolation: filters by org_ctx.organization_id (JWT-derived). Platform administrators see all clinics if organization_id is not set.
         * @summary List Clinics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listClinics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClinicResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listClinics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClinicsApi.listClinics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update clinic  Tenant isolation: service layer validates ownership before update.
         * @summary Update Clinic
         * @param {string} clinicId 
         * @param {ClinicUpdate} clinicUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClinic(clinicId: string, clinicUpdate: ClinicUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClinicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClinic(clinicId, clinicUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClinicsApi.updateClinic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClinicsApi - factory interface
 */
export const ClinicsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClinicsApiFp(configuration)
    return {
        /**
         * Create new clinic  Tenant isolation: enforces org_ctx.organization_id (JWT-derived). Only PLATFORM_ADMINISTRATOR can specify different organization_id.
         * @summary Create Clinic
         * @param {ClinicCreate} clinicCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClinic(clinicCreate: ClinicCreate, options?: RawAxiosRequestConfig): AxiosPromise<ClinicResponse> {
            return localVarFp.createClinic(clinicCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete clinic  Tenant isolation: service layer validates ownership before deletion.
         * @summary Delete Clinic
         * @param {string} clinicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClinic(clinicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteClinic(clinicId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all clinics for the current user\'s organization  Tenant isolation: filters by org_ctx.organization_id (JWT-derived). Platform administrators see all clinics if organization_id is not set.
         * @summary List Clinics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinics(options?: RawAxiosRequestConfig): AxiosPromise<Array<ClinicResponse>> {
            return localVarFp.listClinics(options).then((request) => request(axios, basePath));
        },
        /**
         * Update clinic  Tenant isolation: service layer validates ownership before update.
         * @summary Update Clinic
         * @param {string} clinicId 
         * @param {ClinicUpdate} clinicUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinic(clinicId: string, clinicUpdate: ClinicUpdate, options?: RawAxiosRequestConfig): AxiosPromise<ClinicResponse> {
            return localVarFp.updateClinic(clinicId, clinicUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClinicsApi - object-oriented interface
 */
export class ClinicsApi extends BaseAPI {
    /**
     * Create new clinic  Tenant isolation: enforces org_ctx.organization_id (JWT-derived). Only PLATFORM_ADMINISTRATOR can specify different organization_id.
     * @summary Create Clinic
     * @param {ClinicCreate} clinicCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createClinic(clinicCreate: ClinicCreate, options?: RawAxiosRequestConfig) {
        return ClinicsApiFp(this.configuration).createClinic(clinicCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete clinic  Tenant isolation: service layer validates ownership before deletion.
     * @summary Delete Clinic
     * @param {string} clinicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteClinic(clinicId: string, options?: RawAxiosRequestConfig) {
        return ClinicsApiFp(this.configuration).deleteClinic(clinicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all clinics for the current user\'s organization  Tenant isolation: filters by org_ctx.organization_id (JWT-derived). Platform administrators see all clinics if organization_id is not set.
     * @summary List Clinics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listClinics(options?: RawAxiosRequestConfig) {
        return ClinicsApiFp(this.configuration).listClinics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update clinic  Tenant isolation: service layer validates ownership before update.
     * @summary Update Clinic
     * @param {string} clinicId 
     * @param {ClinicUpdate} clinicUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateClinic(clinicId: string, clinicUpdate: ClinicUpdate, options?: RawAxiosRequestConfig) {
        return ClinicsApiFp(this.configuration).updateClinic(clinicId, clinicUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentsApi - axios parameter creator
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Upload document to R2 storage.  Matches Java: POST /documents/ Request: multipart/form-data with \'file\' field and optional \'name\' field Response: DocumentResponse JSON  Transaction safety: If R2 upload fails, no DB record is created.
         * @summary Upload Document
         * @param {File} file 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClinicDocument: async (file: File, name?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createClinicDocument', 'file', file)
            const localVarPath = `/api/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete document (mark as deleted, don\'t remove from R2).  Matches Java: DELETE /documents/{id}/ Response: 200 OK
         * @summary Delete Document
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationDocumentById: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteOrganizationDocumentById', 'documentId', documentId)
            const localVarPath = `/api/documents/{document_id}`
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download document file from R2.  Matches Java: GET /documents/{id}/generate Response: Binary stream with Content-Disposition header
         * @summary Download Document
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchClinicDocument: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('fetchClinicDocument', 'documentId', documentId)
            const localVarPath = `/api/documents/{document_id}/generate`
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all documents for an organization.  Matches Java: GET /documents/{id}/ Response: Array of DocumentResponse
         * @summary List Documents
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchClinicDocuments: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchClinicDocuments', 'organizationId', organizationId)
            const localVarPath = `/api/documents/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate PDF for printing document.  Matches Java: GET /documents/print Request: documentType query parameter (integer) Response: Binary PDF stream with Content-Disposition header  Note: Java implementation currently hardcodes documentType=1
         * @summary Generate Pdf For Print
         * @param {number} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfForPrint: async (documentType?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/documents/print`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (documentType !== undefined) {
                localVarQueryParameter['document_type'] = documentType;
            }

            localVarHeaderParameter['Accept'] = 'application/pdf,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get presigned URL for document preview (images only).  Returns a temporary presigned URL that allows direct access to the image from R2 without downloading through the backend. URL expires after 1 hour.  Response: {\"url\": \"https://...presigned-url...\"}
         * @summary Get Document Preview Url
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicDocumentPreviewUrl: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('getClinicDocumentPreviewUrl', 'documentId', documentId)
            const localVarPath = `/api/documents/{document_id}/preview-url`
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Upload document to R2 storage.  Matches Java: POST /documents/ Request: multipart/form-data with \'file\' field and optional \'name\' field Response: DocumentResponse JSON  Transaction safety: If R2 upload fails, no DB record is created.
         * @summary Upload Document
         * @param {File} file 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClinicDocument(file: File, name?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClinicDocument(file, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.createClinicDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft delete document (mark as deleted, don\'t remove from R2).  Matches Java: DELETE /documents/{id}/ Response: 200 OK
         * @summary Delete Document
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationDocumentById(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationDocumentById(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.deleteOrganizationDocumentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download document file from R2.  Matches Java: GET /documents/{id}/generate Response: Binary stream with Content-Disposition header
         * @summary Download Document
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchClinicDocument(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchClinicDocument(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.fetchClinicDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all documents for an organization.  Matches Java: GET /documents/{id}/ Response: Array of DocumentResponse
         * @summary List Documents
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchClinicDocuments(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchClinicDocuments(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.fetchClinicDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate PDF for printing document.  Matches Java: GET /documents/print Request: documentType query parameter (integer) Response: Binary PDF stream with Content-Disposition header  Note: Java implementation currently hardcodes documentType=1
         * @summary Generate Pdf For Print
         * @param {number} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePdfForPrint(documentType?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePdfForPrint(documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.generatePdfForPrint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get presigned URL for document preview (images only).  Returns a temporary presigned URL that allows direct access to the image from R2 without downloading through the backend. URL expires after 1 hour.  Response: {\"url\": \"https://...presigned-url...\"}
         * @summary Get Document Preview Url
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClinicDocumentPreviewUrl(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicDocumentPreviewUrl(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getClinicDocumentPreviewUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentsApi - factory interface
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * Upload document to R2 storage.  Matches Java: POST /documents/ Request: multipart/form-data with \'file\' field and optional \'name\' field Response: DocumentResponse JSON  Transaction safety: If R2 upload fails, no DB record is created.
         * @summary Upload Document
         * @param {File} file 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClinicDocument(file: File, name?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<DocumentResponse> {
            return localVarFp.createClinicDocument(file, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete document (mark as deleted, don\'t remove from R2).  Matches Java: DELETE /documents/{id}/ Response: 200 OK
         * @summary Delete Document
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationDocumentById(documentId: string, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDeleteResponse> {
            return localVarFp.deleteOrganizationDocumentById(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download document file from R2.  Matches Java: GET /documents/{id}/generate Response: Binary stream with Content-Disposition header
         * @summary Download Document
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchClinicDocument(documentId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.fetchClinicDocument(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all documents for an organization.  Matches Java: GET /documents/{id}/ Response: Array of DocumentResponse
         * @summary List Documents
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchClinicDocuments(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentResponse>> {
            return localVarFp.fetchClinicDocuments(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate PDF for printing document.  Matches Java: GET /documents/print Request: documentType query parameter (integer) Response: Binary PDF stream with Content-Disposition header  Note: Java implementation currently hardcodes documentType=1
         * @summary Generate Pdf For Print
         * @param {number} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfForPrint(documentType?: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.generatePdfForPrint(documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get presigned URL for document preview (images only).  Returns a temporary presigned URL that allows direct access to the image from R2 without downloading through the backend. URL expires after 1 hour.  Response: {\"url\": \"https://...presigned-url...\"}
         * @summary Get Document Preview Url
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicDocumentPreviewUrl(documentId: string, options?: RawAxiosRequestConfig): AxiosPromise<PreviewUrlResponse> {
            return localVarFp.getClinicDocumentPreviewUrl(documentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentsApi - object-oriented interface
 */
export class DocumentsApi extends BaseAPI {
    /**
     * Upload document to R2 storage.  Matches Java: POST /documents/ Request: multipart/form-data with \'file\' field and optional \'name\' field Response: DocumentResponse JSON  Transaction safety: If R2 upload fails, no DB record is created.
     * @summary Upload Document
     * @param {File} file 
     * @param {string | null} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createClinicDocument(file: File, name?: string | null, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).createClinicDocument(file, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete document (mark as deleted, don\'t remove from R2).  Matches Java: DELETE /documents/{id}/ Response: 200 OK
     * @summary Delete Document
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOrganizationDocumentById(documentId: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).deleteOrganizationDocumentById(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download document file from R2.  Matches Java: GET /documents/{id}/generate Response: Binary stream with Content-Disposition header
     * @summary Download Document
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchClinicDocument(documentId: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).fetchClinicDocument(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all documents for an organization.  Matches Java: GET /documents/{id}/ Response: Array of DocumentResponse
     * @summary List Documents
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchClinicDocuments(organizationId: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).fetchClinicDocuments(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate PDF for printing document.  Matches Java: GET /documents/print Request: documentType query parameter (integer) Response: Binary PDF stream with Content-Disposition header  Note: Java implementation currently hardcodes documentType=1
     * @summary Generate Pdf For Print
     * @param {number} [documentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generatePdfForPrint(documentType?: number, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).generatePdfForPrint(documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get presigned URL for document preview (images only).  Returns a temporary presigned URL that allows direct access to the image from R2 without downloading through the backend. URL expires after 1 hour.  Response: {\"url\": \"https://...presigned-url...\"}
     * @summary Get Document Preview Url
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getClinicDocumentPreviewUrl(documentId: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getClinicDocumentPreviewUrl(documentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailsApi - axios parameter creator
 */
export const EmailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Enqueue an email for sending (PLATFORM_ADMINISTRATOR only).  Idempotent based on idempotency_key. If key not provided, generates one from email content hash.
         * @summary Enqueue Email
         * @param {EmailEnqueueRequest} emailEnqueueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enqueueEmail: async (emailEnqueueRequest: EmailEnqueueRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailEnqueueRequest' is not null or undefined
            assertParamExists('enqueueEmail', 'emailEnqueueRequest', emailEnqueueRequest)
            const localVarPath = `/api/emails/enqueue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailEnqueueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details of a specific email (PLATFORM_ADMINISTRATOR only).
         * @summary Get Email
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmail: async (emailId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('getEmail', 'emailId', emailId)
            const localVarPath = `/api/emails/queue/{email_id}`
                .replace(`{${"email_id"}}`, encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get queue statistics (PLATFORM_ADMINISTRATOR only).
         * @summary Get Queue Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueueStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/emails/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get email worker status (PLATFORM_ADMINISTRATOR only).
         * @summary Get Worker Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkerStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/emails/worker/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List emails in queue with optional filtering (PLATFORM_ADMINISTRATOR only).
         * @summary List Emails
         * @param {EmailStatus | null} [status] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmails: async (status?: EmailStatus | null, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/emails/queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requeue a failed or dead email for retry (PLATFORM_ADMINISTRATOR only).
         * @summary Requeue Email
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requeueEmail: async (emailId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('requeueEmail', 'emailId', emailId)
            const localVarPath = `/api/emails/queue/{email_id}/requeue`
                .replace(`{${"email_id"}}`, encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailsApi - functional programming interface
 */
export const EmailsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailsApiAxiosParamCreator(configuration)
    return {
        /**
         * Enqueue an email for sending (PLATFORM_ADMINISTRATOR only).  Idempotent based on idempotency_key. If key not provided, generates one from email content hash.
         * @summary Enqueue Email
         * @param {EmailEnqueueRequest} emailEnqueueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enqueueEmail(emailEnqueueRequest: EmailEnqueueRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutboundEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enqueueEmail(emailEnqueueRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailsApi.enqueueEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get details of a specific email (PLATFORM_ADMINISTRATOR only).
         * @summary Get Email
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmail(emailId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutboundEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmail(emailId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailsApi.getEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get queue statistics (PLATFORM_ADMINISTRATOR only).
         * @summary Get Queue Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueueStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailQueueStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQueueStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailsApi.getQueueStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get email worker status (PLATFORM_ADMINISTRATOR only).
         * @summary Get Worker Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkerStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailWorkerStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkerStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailsApi.getWorkerStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List emails in queue with optional filtering (PLATFORM_ADMINISTRATOR only).
         * @summary List Emails
         * @param {EmailStatus | null} [status] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEmails(status?: EmailStatus | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEmails(status, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailsApi.listEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requeue a failed or dead email for retry (PLATFORM_ADMINISTRATOR only).
         * @summary Requeue Email
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requeueEmail(emailId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutboundEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requeueEmail(emailId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailsApi.requeueEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailsApi - factory interface
 */
export const EmailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailsApiFp(configuration)
    return {
        /**
         * Enqueue an email for sending (PLATFORM_ADMINISTRATOR only).  Idempotent based on idempotency_key. If key not provided, generates one from email content hash.
         * @summary Enqueue Email
         * @param {EmailEnqueueRequest} emailEnqueueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enqueueEmail(emailEnqueueRequest: EmailEnqueueRequest, options?: RawAxiosRequestConfig): AxiosPromise<OutboundEmailResponse> {
            return localVarFp.enqueueEmail(emailEnqueueRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get details of a specific email (PLATFORM_ADMINISTRATOR only).
         * @summary Get Email
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmail(emailId: string, options?: RawAxiosRequestConfig): AxiosPromise<OutboundEmailResponse> {
            return localVarFp.getEmail(emailId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get queue statistics (PLATFORM_ADMINISTRATOR only).
         * @summary Get Queue Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueueStats(options?: RawAxiosRequestConfig): AxiosPromise<EmailQueueStatsResponse> {
            return localVarFp.getQueueStats(options).then((request) => request(axios, basePath));
        },
        /**
         * Get email worker status (PLATFORM_ADMINISTRATOR only).
         * @summary Get Worker Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkerStatus(options?: RawAxiosRequestConfig): AxiosPromise<EmailWorkerStatusResponse> {
            return localVarFp.getWorkerStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * List emails in queue with optional filtering (PLATFORM_ADMINISTRATOR only).
         * @summary List Emails
         * @param {EmailStatus | null} [status] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmails(status?: EmailStatus | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<EmailListResponse> {
            return localVarFp.listEmails(status, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Requeue a failed or dead email for retry (PLATFORM_ADMINISTRATOR only).
         * @summary Requeue Email
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requeueEmail(emailId: string, options?: RawAxiosRequestConfig): AxiosPromise<OutboundEmailResponse> {
            return localVarFp.requeueEmail(emailId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailsApi - object-oriented interface
 */
export class EmailsApi extends BaseAPI {
    /**
     * Enqueue an email for sending (PLATFORM_ADMINISTRATOR only).  Idempotent based on idempotency_key. If key not provided, generates one from email content hash.
     * @summary Enqueue Email
     * @param {EmailEnqueueRequest} emailEnqueueRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public enqueueEmail(emailEnqueueRequest: EmailEnqueueRequest, options?: RawAxiosRequestConfig) {
        return EmailsApiFp(this.configuration).enqueueEmail(emailEnqueueRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details of a specific email (PLATFORM_ADMINISTRATOR only).
     * @summary Get Email
     * @param {string} emailId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmail(emailId: string, options?: RawAxiosRequestConfig) {
        return EmailsApiFp(this.configuration).getEmail(emailId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get queue statistics (PLATFORM_ADMINISTRATOR only).
     * @summary Get Queue Stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getQueueStats(options?: RawAxiosRequestConfig) {
        return EmailsApiFp(this.configuration).getQueueStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get email worker status (PLATFORM_ADMINISTRATOR only).
     * @summary Get Worker Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkerStatus(options?: RawAxiosRequestConfig) {
        return EmailsApiFp(this.configuration).getWorkerStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List emails in queue with optional filtering (PLATFORM_ADMINISTRATOR only).
     * @summary List Emails
     * @param {EmailStatus | null} [status] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listEmails(status?: EmailStatus | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return EmailsApiFp(this.configuration).listEmails(status, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requeue a failed or dead email for retry (PLATFORM_ADMINISTRATOR only).
     * @summary Requeue Email
     * @param {string} emailId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public requeueEmail(emailId: string, options?: RawAxiosRequestConfig) {
        return EmailsApiFp(this.configuration).requeueEmail(emailId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeaturesApi - axios parameter creator
 */
export const FeaturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch all features for an organization. Matches Java FeatureController.fetchFeatures() endpoint.  PATH: GET /api/features/{organizationId}/
         * @summary Fetch Features
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFeaturesByOrganization: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchFeaturesByOrganization', 'organizationId', organizationId)
            const localVarPath = `/api/features/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeaturesApi - functional programming interface
 */
export const FeaturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeaturesApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch all features for an organization. Matches Java FeatureController.fetchFeatures() endpoint.  PATH: GET /api/features/{organizationId}/
         * @summary Fetch Features
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchFeaturesByOrganization(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchFeaturesByOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.fetchFeaturesByOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeaturesApi - factory interface
 */
export const FeaturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeaturesApiFp(configuration)
    return {
        /**
         * Fetch all features for an organization. Matches Java FeatureController.fetchFeatures() endpoint.  PATH: GET /api/features/{organizationId}/
         * @summary Fetch Features
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFeaturesByOrganization(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FeatureResponse>> {
            return localVarFp.fetchFeaturesByOrganization(organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeaturesApi - object-oriented interface
 */
export class FeaturesApi extends BaseAPI {
    /**
     * Fetch all features for an organization. Matches Java FeatureController.fetchFeatures() endpoint.  PATH: GET /api/features/{organizationId}/
     * @summary Fetch Features
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchFeaturesByOrganization(organizationId: string, options?: RawAxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).fetchFeaturesByOrganization(organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GoogleCalendarApi - axios parameter creator
 */
export const GoogleCalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Disconnect Google Calendar integration (CLINIC_ADMIN only)  Removes connection record. Existing calendar_events remain with their google_id but will no longer sync.
         * @summary Disconnect Calendar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectGoogleCalendarV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/google-calendar/disconnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Google Calendar connection status for current user\'s organization  Returns:     - connected: bool     - google_account_email: Optional[str]     - calendar_id: Optional[str]     - status: Optional[str] (CONNECTED, ERROR, DISCONNECTED)     - last_sync_at: Optional[datetime]     - last_error: Optional[str]
         * @summary Get Connection Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleCalendarConnectionStatusV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/google-calendar/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * OAuth callback endpoint - handles Google redirect after user authorization  This endpoint is called by Google after user grants/denies access. It redirects to a frontend page that shows success/error and closes the popup.
         * @summary Oauth Callback
         * @param {string | null} [code] OAuth authorization code
         * @param {string | null} [state] OAuth state token
         * @param {string | null} [error] OAuth error from Google
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleCalendarOAuthCallbackV2: async (code?: string | null, state?: string | null, error?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/google-calendar/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate Google Calendar connection (CLINIC_ADMIN only)  Returns authorization URL for OAuth flow. Frontend should redirect user to this URL.
         * @summary Initiate Connection
         * @param {GoogleCalendarConnectRequest} googleCalendarConnectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateGoogleCalendarConnectionV2: async (googleCalendarConnectRequest: GoogleCalendarConnectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'googleCalendarConnectRequest' is not null or undefined
            assertParamExists('initiateGoogleCalendarConnectionV2', 'googleCalendarConnectRequest', googleCalendarConnectRequest)
            const localVarPath = `/api/google-calendar/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(googleCalendarConnectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manually trigger Google Calendar sync (CLINIC_ADMIN only)  This is a convenience endpoint for admins to force immediate sync. Normal sync happens automatically via background processor.
         * @summary Trigger Sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerGoogleCalendarSyncV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/google-calendar/sync-now`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GoogleCalendarApi - functional programming interface
 */
export const GoogleCalendarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GoogleCalendarApiAxiosParamCreator(configuration)
    return {
        /**
         * Disconnect Google Calendar integration (CLINIC_ADMIN only)  Removes connection record. Existing calendar_events remain with their google_id but will no longer sync.
         * @summary Disconnect Calendar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectGoogleCalendarV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleCalendarDisconnectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectGoogleCalendarV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.disconnectGoogleCalendarV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Google Calendar connection status for current user\'s organization  Returns:     - connected: bool     - google_account_email: Optional[str]     - calendar_id: Optional[str]     - status: Optional[str] (CONNECTED, ERROR, DISCONNECTED)     - last_sync_at: Optional[datetime]     - last_error: Optional[str]
         * @summary Get Connection Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGoogleCalendarConnectionStatusV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleCalendarConnectionStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGoogleCalendarConnectionStatusV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.getGoogleCalendarConnectionStatusV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * OAuth callback endpoint - handles Google redirect after user authorization  This endpoint is called by Google after user grants/denies access. It redirects to a frontend page that shows success/error and closes the popup.
         * @summary Oauth Callback
         * @param {string | null} [code] OAuth authorization code
         * @param {string | null} [state] OAuth state token
         * @param {string | null} [error] OAuth error from Google
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleCalendarOAuthCallbackV2(code?: string | null, state?: string | null, error?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleCalendarOAuthCallbackV2(code, state, error, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.googleCalendarOAuthCallbackV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiate Google Calendar connection (CLINIC_ADMIN only)  Returns authorization URL for OAuth flow. Frontend should redirect user to this URL.
         * @summary Initiate Connection
         * @param {GoogleCalendarConnectRequest} googleCalendarConnectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateGoogleCalendarConnectionV2(googleCalendarConnectRequest: GoogleCalendarConnectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleCalendarConnectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateGoogleCalendarConnectionV2(googleCalendarConnectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.initiateGoogleCalendarConnectionV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Manually trigger Google Calendar sync (CLINIC_ADMIN only)  This is a convenience endpoint for admins to force immediate sync. Normal sync happens automatically via background processor.
         * @summary Trigger Sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerGoogleCalendarSyncV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleCalendarSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerGoogleCalendarSyncV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleCalendarApi.triggerGoogleCalendarSyncV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GoogleCalendarApi - factory interface
 */
export const GoogleCalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GoogleCalendarApiFp(configuration)
    return {
        /**
         * Disconnect Google Calendar integration (CLINIC_ADMIN only)  Removes connection record. Existing calendar_events remain with their google_id but will no longer sync.
         * @summary Disconnect Calendar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectGoogleCalendarV2(options?: RawAxiosRequestConfig): AxiosPromise<GoogleCalendarDisconnectResponse> {
            return localVarFp.disconnectGoogleCalendarV2(options).then((request) => request(axios, basePath));
        },
        /**
         * Get Google Calendar connection status for current user\'s organization  Returns:     - connected: bool     - google_account_email: Optional[str]     - calendar_id: Optional[str]     - status: Optional[str] (CONNECTED, ERROR, DISCONNECTED)     - last_sync_at: Optional[datetime]     - last_error: Optional[str]
         * @summary Get Connection Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleCalendarConnectionStatusV2(options?: RawAxiosRequestConfig): AxiosPromise<GoogleCalendarConnectionStatus> {
            return localVarFp.getGoogleCalendarConnectionStatusV2(options).then((request) => request(axios, basePath));
        },
        /**
         * OAuth callback endpoint - handles Google redirect after user authorization  This endpoint is called by Google after user grants/denies access. It redirects to a frontend page that shows success/error and closes the popup.
         * @summary Oauth Callback
         * @param {string | null} [code] OAuth authorization code
         * @param {string | null} [state] OAuth state token
         * @param {string | null} [error] OAuth error from Google
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleCalendarOAuthCallbackV2(code?: string | null, state?: string | null, error?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.googleCalendarOAuthCallbackV2(code, state, error, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate Google Calendar connection (CLINIC_ADMIN only)  Returns authorization URL for OAuth flow. Frontend should redirect user to this URL.
         * @summary Initiate Connection
         * @param {GoogleCalendarConnectRequest} googleCalendarConnectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateGoogleCalendarConnectionV2(googleCalendarConnectRequest: GoogleCalendarConnectRequest, options?: RawAxiosRequestConfig): AxiosPromise<GoogleCalendarConnectResponse> {
            return localVarFp.initiateGoogleCalendarConnectionV2(googleCalendarConnectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Manually trigger Google Calendar sync (CLINIC_ADMIN only)  This is a convenience endpoint for admins to force immediate sync. Normal sync happens automatically via background processor.
         * @summary Trigger Sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerGoogleCalendarSyncV2(options?: RawAxiosRequestConfig): AxiosPromise<GoogleCalendarSyncResponse> {
            return localVarFp.triggerGoogleCalendarSyncV2(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GoogleCalendarApi - object-oriented interface
 */
export class GoogleCalendarApi extends BaseAPI {
    /**
     * Disconnect Google Calendar integration (CLINIC_ADMIN only)  Removes connection record. Existing calendar_events remain with their google_id but will no longer sync.
     * @summary Disconnect Calendar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public disconnectGoogleCalendarV2(options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).disconnectGoogleCalendarV2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Google Calendar connection status for current user\'s organization  Returns:     - connected: bool     - google_account_email: Optional[str]     - calendar_id: Optional[str]     - status: Optional[str] (CONNECTED, ERROR, DISCONNECTED)     - last_sync_at: Optional[datetime]     - last_error: Optional[str]
     * @summary Get Connection Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGoogleCalendarConnectionStatusV2(options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).getGoogleCalendarConnectionStatusV2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * OAuth callback endpoint - handles Google redirect after user authorization  This endpoint is called by Google after user grants/denies access. It redirects to a frontend page that shows success/error and closes the popup.
     * @summary Oauth Callback
     * @param {string | null} [code] OAuth authorization code
     * @param {string | null} [state] OAuth state token
     * @param {string | null} [error] OAuth error from Google
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public googleCalendarOAuthCallbackV2(code?: string | null, state?: string | null, error?: string | null, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).googleCalendarOAuthCallbackV2(code, state, error, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate Google Calendar connection (CLINIC_ADMIN only)  Returns authorization URL for OAuth flow. Frontend should redirect user to this URL.
     * @summary Initiate Connection
     * @param {GoogleCalendarConnectRequest} googleCalendarConnectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initiateGoogleCalendarConnectionV2(googleCalendarConnectRequest: GoogleCalendarConnectRequest, options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).initiateGoogleCalendarConnectionV2(googleCalendarConnectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Manually trigger Google Calendar sync (CLINIC_ADMIN only)  This is a convenience endpoint for admins to force immediate sync. Normal sync happens automatically via background processor.
     * @summary Trigger Sync
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public triggerGoogleCalendarSyncV2(options?: RawAxiosRequestConfig) {
        return GoogleCalendarApiFp(this.configuration).triggerGoogleCalendarSyncV2(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoicesApi - axios parameter creator
 */
export const InvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel an invoice
         * @summary Cancel Invoice
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelInvoice: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('cancelInvoice', 'invoiceId', invoiceId)
            const localVarPath = `/api/invoices/{invoice_id}/cancel`
                .replace(`{${"invoice_id"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if invoice configuration exists for an organization and document type  Maps to Java endpoint: GET /invoices/{organizationId}/check-existence?documentType={type} Returns true if invoice configuration exists, false otherwise.
         * @summary Check Invoice Existence
         * @param {string} organizationId 
         * @param {string} documentType Document type: INVOICE or PROFORMA_INVOICE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInvoiceExistence: async (organizationId: string, documentType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('checkInvoiceExistence', 'organizationId', organizationId)
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('checkInvoiceExistence', 'documentType', documentType)
            const localVarPath = `/api/invoices/{organization_id}/check-existence`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (documentType !== undefined) {
                localVarQueryParameter['document_type'] = documentType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Convert proforma invoice to regular invoice  Maps to Java endpoint: POST /invoices/{id}/convert Converts a proforma invoice to a regular invoice by: - Generating new invoice number for INVOICE type - Changing document_type to INVOICE - Setting status to UNPAID
         * @summary Convert Proforma To Invoice
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertProformaToInvoice: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('convertProformaToInvoice', 'invoiceId', invoiceId)
            const localVarPath = `/api/invoices/{invoice_id}/convert`
                .replace(`{${"invoice_id"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new invoice matching Java backend  Maps to Java endpoint: POST /invoices/ InvoiceController.createInvoice() - creates invoice with treatments
         * @summary Create Invoice
         * @param {InvoiceCreate} invoiceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoice: async (invoiceCreate: InvoiceCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceCreate' is not null or undefined
            assertParamExists('createInvoice', 'invoiceCreate', invoiceCreate)
            const localVarPath = `/api/invoices/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or update invoice configuration  Maps to Java endpoint: POST /invoices/invoice-config Creates new config or updates existing if new invoice number is greater.
         * @summary Create Or Update Invoice Config
         * @param {InvoiceConfigCreate} invoiceConfigCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateInvoiceConfig: async (invoiceConfigCreate: InvoiceConfigCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceConfigCreate' is not null or undefined
            assertParamExists('createOrUpdateInvoiceConfig', 'invoiceConfigCreate', invoiceConfigCreate)
            const localVarPath = `/api/invoices/invoice-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceConfigCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an invoice (Admin only) with audit logging
         * @summary Delete Invoice
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvoice: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('deleteInvoice', 'invoiceId', invoiceId)
            const localVarPath = `/api/invoices/{invoice_id}`
                .replace(`{${"invoice_id"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch invoices with optional filters
         * @summary Fetch Invoices
         * @param {string | null} [patientId] Filter by patient
         * @param {string | null} [status] Filter by status
         * @param {string | null} [startDate] Filter by start date
         * @param {string | null} [endDate] Filter by end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllInvoices: async (patientId?: string | null, status?: string | null, startDate?: string | null, endDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invoices/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch invoice by ID
         * @summary Fetch Invoice
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoiceById: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('fetchInvoiceById', 'invoiceId', invoiceId)
            const localVarPath = `/api/invoices/{invoice_id}`
                .replace(`{${"invoice_id"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get invoice configuration for an organization and document type  Maps to Java endpoint: GET /invoices/invoice-config Returns invoice configuration settings including numbering format.
         * @summary Get Invoice Configuration
         * @param {string} organizationId Organization ID
         * @param {string} documentType Document type: INVOICE or PROFORMA_INVOICE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoiceConfiguration: async (organizationId: string, documentType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchInvoiceConfiguration', 'organizationId', organizationId)
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('fetchInvoiceConfiguration', 'documentType', documentType)
            const localVarPath = `/api/invoices/invoice-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get invoice statistics for the organization
         * @summary Get Invoice Statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoiceStatistics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invoices/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all invoices for a patient (legacy endpoint)  Legacy endpoint - use /patient/{patient_id} instead. Returns all invoices for the specified patient.
         * @summary Fetch Invoices By Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoicesByPatient: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('fetchInvoicesByPatient', 'patientId', patientId)
            const localVarPath = `/api/invoices/by-patient/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all invoices for a patient  Maps to Java endpoint: GET /invoices/patient/{patientId} InvoiceController.fetchInvoicesByPatientId() lines 97-100  Returns all invoices for the specified patient (or empty array if none exist).
         * @summary Fetch Invoices By Patient Id
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoicesByPatientId: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('fetchInvoicesByPatientId', 'patientId', patientId)
            const localVarPath = `/api/invoices/patient/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get next invoice number for an organization and document type  Generates and returns the next formatted invoice number. This increments the counter in the invoice config.
         * @summary Get Next Invoice Number
         * @param {string} organizationId Organization ID
         * @param {string} [documentType] Document type: INVOICE or PROFORMA_INVOICE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNextInvoiceNumber: async (organizationId: string, documentType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchNextInvoiceNumber', 'organizationId', organizationId)
            const localVarPath = `/api/invoices/number/next`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate PDF for invoice  Matches Java: GET /invoices/{invoiceId}/generate-pdf InvoiceController.generateInvoicePdf() line 61  Java implementation: Generates invoice PDF with all details Returns: PDF file as binary stream  Implementation: Professional invoice PDF with ReportLab Uses standard invoice template - customize with branding
         * @summary Generate Invoice Pdf
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateInvoicePdf: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('generateInvoicePdf', 'invoiceId', invoiceId)
            const localVarPath = `/api/invoices/{invoice_id}/generate-pdf`
                .replace(`{${"invoice_id"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/pdf,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Record a payment for an invoice
         * @summary Record Payment
         * @param {string} invoiceId 
         * @param {PaymentRequest} paymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordInvoicePayment: async (invoiceId: string, paymentRequest: PaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('recordInvoicePayment', 'invoiceId', invoiceId)
            // verify required parameter 'paymentRequest' is not null or undefined
            assertParamExists('recordInvoicePayment', 'paymentRequest', paymentRequest)
            const localVarPath = `/api/invoices/{invoice_id}/payment`
                .replace(`{${"invoice_id"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update invoice information with audit logging
         * @summary Update Invoice
         * @param {string} invoiceId 
         * @param {InvoiceUpdate} invoiceUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoice: async (invoiceId: string, invoiceUpdate: InvoiceUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('updateInvoice', 'invoiceId', invoiceId)
            // verify required parameter 'invoiceUpdate' is not null or undefined
            assertParamExists('updateInvoice', 'invoiceUpdate', invoiceUpdate)
            const localVarPath = `/api/invoices/{invoice_id}`
                .replace(`{${"invoice_id"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update proforma invoice  Maps to Java endpoint: PUT /invoices/proforma/{invoiceId} Updates proforma invoice fields: document_type, status, payment_method, vat.
         * @summary Update Proforma Invoice
         * @param {string} invoiceId 
         * @param {ProformaInvoiceUpdate} proformaInvoiceUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProformaInvoice: async (invoiceId: string, proformaInvoiceUpdate: ProformaInvoiceUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('updateProformaInvoice', 'invoiceId', invoiceId)
            // verify required parameter 'proformaInvoiceUpdate' is not null or undefined
            assertParamExists('updateProformaInvoice', 'proformaInvoiceUpdate', proformaInvoiceUpdate)
            const localVarPath = `/api/invoices/proforma/{invoice_id}`
                .replace(`{${"invoice_id"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proformaInvoiceUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicesApi - functional programming interface
 */
export const InvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel an invoice
         * @summary Cancel Invoice
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelInvoice(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelInvoice(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.cancelInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if invoice configuration exists for an organization and document type  Maps to Java endpoint: GET /invoices/{organizationId}/check-existence?documentType={type} Returns true if invoice configuration exists, false otherwise.
         * @summary Check Invoice Existence
         * @param {string} organizationId 
         * @param {string} documentType Document type: INVOICE or PROFORMA_INVOICE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkInvoiceExistence(organizationId: string, documentType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkInvoiceExistence(organizationId, documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.checkInvoiceExistence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Convert proforma invoice to regular invoice  Maps to Java endpoint: POST /invoices/{id}/convert Converts a proforma invoice to a regular invoice by: - Generating new invoice number for INVOICE type - Changing document_type to INVOICE - Setting status to UNPAID
         * @summary Convert Proforma To Invoice
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertProformaToInvoice(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertProformaToInvoice(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.convertProformaToInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new invoice matching Java backend  Maps to Java endpoint: POST /invoices/ InvoiceController.createInvoice() - creates invoice with treatments
         * @summary Create Invoice
         * @param {InvoiceCreate} invoiceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoice(invoiceCreate: InvoiceCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoice(invoiceCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.createInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create or update invoice configuration  Maps to Java endpoint: POST /invoices/invoice-config Creates new config or updates existing if new invoice number is greater.
         * @summary Create Or Update Invoice Config
         * @param {InvoiceConfigCreate} invoiceConfigCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateInvoiceConfig(invoiceConfigCreate: InvoiceConfigCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateInvoiceConfig(invoiceConfigCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.createOrUpdateInvoiceConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an invoice (Admin only) with audit logging
         * @summary Delete Invoice
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInvoice(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInvoice(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.deleteInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch invoices with optional filters
         * @summary Fetch Invoices
         * @param {string | null} [patientId] Filter by patient
         * @param {string | null} [status] Filter by status
         * @param {string | null} [startDate] Filter by start date
         * @param {string | null} [endDate] Filter by end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllInvoices(patientId?: string | null, status?: string | null, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllInvoices(patientId, status, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.fetchAllInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch invoice by ID
         * @summary Fetch Invoice
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchInvoiceById(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchInvoiceById(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.fetchInvoiceById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get invoice configuration for an organization and document type  Maps to Java endpoint: GET /invoices/invoice-config Returns invoice configuration settings including numbering format.
         * @summary Get Invoice Configuration
         * @param {string} organizationId Organization ID
         * @param {string} documentType Document type: INVOICE or PROFORMA_INVOICE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchInvoiceConfiguration(organizationId: string, documentType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchInvoiceConfiguration(organizationId, documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.fetchInvoiceConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get invoice statistics for the organization
         * @summary Get Invoice Statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchInvoiceStatistics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchInvoiceStatistics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.fetchInvoiceStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all invoices for a patient (legacy endpoint)  Legacy endpoint - use /patient/{patient_id} instead. Returns all invoices for the specified patient.
         * @summary Fetch Invoices By Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchInvoicesByPatient(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchInvoicesByPatient(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.fetchInvoicesByPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all invoices for a patient  Maps to Java endpoint: GET /invoices/patient/{patientId} InvoiceController.fetchInvoicesByPatientId() lines 97-100  Returns all invoices for the specified patient (or empty array if none exist).
         * @summary Fetch Invoices By Patient Id
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchInvoicesByPatientId(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchInvoicesByPatientId(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.fetchInvoicesByPatientId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get next invoice number for an organization and document type  Generates and returns the next formatted invoice number. This increments the counter in the invoice config.
         * @summary Get Next Invoice Number
         * @param {string} organizationId Organization ID
         * @param {string} [documentType] Document type: INVOICE or PROFORMA_INVOICE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchNextInvoiceNumber(organizationId: string, documentType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NextInvoiceNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchNextInvoiceNumber(organizationId, documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.fetchNextInvoiceNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate PDF for invoice  Matches Java: GET /invoices/{invoiceId}/generate-pdf InvoiceController.generateInvoicePdf() line 61  Java implementation: Generates invoice PDF with all details Returns: PDF file as binary stream  Implementation: Professional invoice PDF with ReportLab Uses standard invoice template - customize with branding
         * @summary Generate Invoice Pdf
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateInvoicePdf(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateInvoicePdf(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.generateInvoicePdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Record a payment for an invoice
         * @summary Record Payment
         * @param {string} invoiceId 
         * @param {PaymentRequest} paymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordInvoicePayment(invoiceId: string, paymentRequest: PaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordInvoicePayment(invoiceId, paymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.recordInvoicePayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update invoice information with audit logging
         * @summary Update Invoice
         * @param {string} invoiceId 
         * @param {InvoiceUpdate} invoiceUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInvoice(invoiceId: string, invoiceUpdate: InvoiceUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInvoice(invoiceId, invoiceUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.updateInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update proforma invoice  Maps to Java endpoint: PUT /invoices/proforma/{invoiceId} Updates proforma invoice fields: document_type, status, payment_method, vat.
         * @summary Update Proforma Invoice
         * @param {string} invoiceId 
         * @param {ProformaInvoiceUpdate} proformaInvoiceUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProformaInvoice(invoiceId: string, proformaInvoiceUpdate: ProformaInvoiceUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProformaInvoice(invoiceId, proformaInvoiceUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.updateProformaInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoicesApi - factory interface
 */
export const InvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoicesApiFp(configuration)
    return {
        /**
         * Cancel an invoice
         * @summary Cancel Invoice
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelInvoice(invoiceId: string, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse> {
            return localVarFp.cancelInvoice(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if invoice configuration exists for an organization and document type  Maps to Java endpoint: GET /invoices/{organizationId}/check-existence?documentType={type} Returns true if invoice configuration exists, false otherwise.
         * @summary Check Invoice Existence
         * @param {string} organizationId 
         * @param {string} documentType Document type: INVOICE or PROFORMA_INVOICE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInvoiceExistence(organizationId: string, documentType: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.checkInvoiceExistence(organizationId, documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Convert proforma invoice to regular invoice  Maps to Java endpoint: POST /invoices/{id}/convert Converts a proforma invoice to a regular invoice by: - Generating new invoice number for INVOICE type - Changing document_type to INVOICE - Setting status to UNPAID
         * @summary Convert Proforma To Invoice
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertProformaToInvoice(invoiceId: string, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse> {
            return localVarFp.convertProformaToInvoice(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new invoice matching Java backend  Maps to Java endpoint: POST /invoices/ InvoiceController.createInvoice() - creates invoice with treatments
         * @summary Create Invoice
         * @param {InvoiceCreate} invoiceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoice(invoiceCreate: InvoiceCreate, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse> {
            return localVarFp.createInvoice(invoiceCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or update invoice configuration  Maps to Java endpoint: POST /invoices/invoice-config Creates new config or updates existing if new invoice number is greater.
         * @summary Create Or Update Invoice Config
         * @param {InvoiceConfigCreate} invoiceConfigCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateInvoiceConfig(invoiceConfigCreate: InvoiceConfigCreate, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceConfigResponse> {
            return localVarFp.createOrUpdateInvoiceConfig(invoiceConfigCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an invoice (Admin only) with audit logging
         * @summary Delete Invoice
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvoice(invoiceId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteInvoice(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch invoices with optional filters
         * @summary Fetch Invoices
         * @param {string | null} [patientId] Filter by patient
         * @param {string | null} [status] Filter by status
         * @param {string | null} [startDate] Filter by start date
         * @param {string | null} [endDate] Filter by end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllInvoices(patientId?: string | null, status?: string | null, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<InvoiceResponse>> {
            return localVarFp.fetchAllInvoices(patientId, status, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch invoice by ID
         * @summary Fetch Invoice
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoiceById(invoiceId: string, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse> {
            return localVarFp.fetchInvoiceById(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get invoice configuration for an organization and document type  Maps to Java endpoint: GET /invoices/invoice-config Returns invoice configuration settings including numbering format.
         * @summary Get Invoice Configuration
         * @param {string} organizationId Organization ID
         * @param {string} documentType Document type: INVOICE or PROFORMA_INVOICE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoiceConfiguration(organizationId: string, documentType: string, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceConfigResponse> {
            return localVarFp.fetchInvoiceConfiguration(organizationId, documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get invoice statistics for the organization
         * @summary Get Invoice Statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoiceStatistics(options?: RawAxiosRequestConfig): AxiosPromise<InvoiceStatisticsResponse> {
            return localVarFp.fetchInvoiceStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all invoices for a patient (legacy endpoint)  Legacy endpoint - use /patient/{patient_id} instead. Returns all invoices for the specified patient.
         * @summary Fetch Invoices By Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoicesByPatient(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<InvoiceResponse>> {
            return localVarFp.fetchInvoicesByPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all invoices for a patient  Maps to Java endpoint: GET /invoices/patient/{patientId} InvoiceController.fetchInvoicesByPatientId() lines 97-100  Returns all invoices for the specified patient (or empty array if none exist).
         * @summary Fetch Invoices By Patient Id
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInvoicesByPatientId(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<InvoiceResponse>> {
            return localVarFp.fetchInvoicesByPatientId(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get next invoice number for an organization and document type  Generates and returns the next formatted invoice number. This increments the counter in the invoice config.
         * @summary Get Next Invoice Number
         * @param {string} organizationId Organization ID
         * @param {string} [documentType] Document type: INVOICE or PROFORMA_INVOICE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNextInvoiceNumber(organizationId: string, documentType?: string, options?: RawAxiosRequestConfig): AxiosPromise<NextInvoiceNumberResponse> {
            return localVarFp.fetchNextInvoiceNumber(organizationId, documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate PDF for invoice  Matches Java: GET /invoices/{invoiceId}/generate-pdf InvoiceController.generateInvoicePdf() line 61  Java implementation: Generates invoice PDF with all details Returns: PDF file as binary stream  Implementation: Professional invoice PDF with ReportLab Uses standard invoice template - customize with branding
         * @summary Generate Invoice Pdf
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateInvoicePdf(invoiceId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.generateInvoicePdf(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Record a payment for an invoice
         * @summary Record Payment
         * @param {string} invoiceId 
         * @param {PaymentRequest} paymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordInvoicePayment(invoiceId: string, paymentRequest: PaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse> {
            return localVarFp.recordInvoicePayment(invoiceId, paymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update invoice information with audit logging
         * @summary Update Invoice
         * @param {string} invoiceId 
         * @param {InvoiceUpdate} invoiceUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoice(invoiceId: string, invoiceUpdate: InvoiceUpdate, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse> {
            return localVarFp.updateInvoice(invoiceId, invoiceUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update proforma invoice  Maps to Java endpoint: PUT /invoices/proforma/{invoiceId} Updates proforma invoice fields: document_type, status, payment_method, vat.
         * @summary Update Proforma Invoice
         * @param {string} invoiceId 
         * @param {ProformaInvoiceUpdate} proformaInvoiceUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProformaInvoice(invoiceId: string, proformaInvoiceUpdate: ProformaInvoiceUpdate, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse> {
            return localVarFp.updateProformaInvoice(invoiceId, proformaInvoiceUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoicesApi - object-oriented interface
 */
export class InvoicesApi extends BaseAPI {
    /**
     * Cancel an invoice
     * @summary Cancel Invoice
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelInvoice(invoiceId: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).cancelInvoice(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if invoice configuration exists for an organization and document type  Maps to Java endpoint: GET /invoices/{organizationId}/check-existence?documentType={type} Returns true if invoice configuration exists, false otherwise.
     * @summary Check Invoice Existence
     * @param {string} organizationId 
     * @param {string} documentType Document type: INVOICE or PROFORMA_INVOICE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkInvoiceExistence(organizationId: string, documentType: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).checkInvoiceExistence(organizationId, documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Convert proforma invoice to regular invoice  Maps to Java endpoint: POST /invoices/{id}/convert Converts a proforma invoice to a regular invoice by: - Generating new invoice number for INVOICE type - Changing document_type to INVOICE - Setting status to UNPAID
     * @summary Convert Proforma To Invoice
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public convertProformaToInvoice(invoiceId: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).convertProformaToInvoice(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new invoice matching Java backend  Maps to Java endpoint: POST /invoices/ InvoiceController.createInvoice() - creates invoice with treatments
     * @summary Create Invoice
     * @param {InvoiceCreate} invoiceCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInvoice(invoiceCreate: InvoiceCreate, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).createInvoice(invoiceCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or update invoice configuration  Maps to Java endpoint: POST /invoices/invoice-config Creates new config or updates existing if new invoice number is greater.
     * @summary Create Or Update Invoice Config
     * @param {InvoiceConfigCreate} invoiceConfigCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOrUpdateInvoiceConfig(invoiceConfigCreate: InvoiceConfigCreate, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).createOrUpdateInvoiceConfig(invoiceConfigCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an invoice (Admin only) with audit logging
     * @summary Delete Invoice
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteInvoice(invoiceId: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).deleteInvoice(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch invoices with optional filters
     * @summary Fetch Invoices
     * @param {string | null} [patientId] Filter by patient
     * @param {string | null} [status] Filter by status
     * @param {string | null} [startDate] Filter by start date
     * @param {string | null} [endDate] Filter by end date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllInvoices(patientId?: string | null, status?: string | null, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).fetchAllInvoices(patientId, status, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch invoice by ID
     * @summary Fetch Invoice
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchInvoiceById(invoiceId: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).fetchInvoiceById(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get invoice configuration for an organization and document type  Maps to Java endpoint: GET /invoices/invoice-config Returns invoice configuration settings including numbering format.
     * @summary Get Invoice Configuration
     * @param {string} organizationId Organization ID
     * @param {string} documentType Document type: INVOICE or PROFORMA_INVOICE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchInvoiceConfiguration(organizationId: string, documentType: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).fetchInvoiceConfiguration(organizationId, documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get invoice statistics for the organization
     * @summary Get Invoice Statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchInvoiceStatistics(options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).fetchInvoiceStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all invoices for a patient (legacy endpoint)  Legacy endpoint - use /patient/{patient_id} instead. Returns all invoices for the specified patient.
     * @summary Fetch Invoices By Patient
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchInvoicesByPatient(patientId: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).fetchInvoicesByPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all invoices for a patient  Maps to Java endpoint: GET /invoices/patient/{patientId} InvoiceController.fetchInvoicesByPatientId() lines 97-100  Returns all invoices for the specified patient (or empty array if none exist).
     * @summary Fetch Invoices By Patient Id
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchInvoicesByPatientId(patientId: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).fetchInvoicesByPatientId(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get next invoice number for an organization and document type  Generates and returns the next formatted invoice number. This increments the counter in the invoice config.
     * @summary Get Next Invoice Number
     * @param {string} organizationId Organization ID
     * @param {string} [documentType] Document type: INVOICE or PROFORMA_INVOICE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchNextInvoiceNumber(organizationId: string, documentType?: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).fetchNextInvoiceNumber(organizationId, documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate PDF for invoice  Matches Java: GET /invoices/{invoiceId}/generate-pdf InvoiceController.generateInvoicePdf() line 61  Java implementation: Generates invoice PDF with all details Returns: PDF file as binary stream  Implementation: Professional invoice PDF with ReportLab Uses standard invoice template - customize with branding
     * @summary Generate Invoice Pdf
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateInvoicePdf(invoiceId: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).generateInvoicePdf(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Record a payment for an invoice
     * @summary Record Payment
     * @param {string} invoiceId 
     * @param {PaymentRequest} paymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recordInvoicePayment(invoiceId: string, paymentRequest: PaymentRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).recordInvoicePayment(invoiceId, paymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update invoice information with audit logging
     * @summary Update Invoice
     * @param {string} invoiceId 
     * @param {InvoiceUpdate} invoiceUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateInvoice(invoiceId: string, invoiceUpdate: InvoiceUpdate, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).updateInvoice(invoiceId, invoiceUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update proforma invoice  Maps to Java endpoint: PUT /invoices/proforma/{invoiceId} Updates proforma invoice fields: document_type, status, payment_method, vat.
     * @summary Update Proforma Invoice
     * @param {string} invoiceId 
     * @param {ProformaInvoiceUpdate} proformaInvoiceUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProformaInvoice(invoiceId: string, proformaInvoiceUpdate: ProformaInvoiceUpdate, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).updateProformaInvoice(invoiceId, proformaInvoiceUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MedicalApi - axios parameter creator
 */
export const MedicalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Reactivate a medical staff member (set is_active=True).  CLINIC_ADMIN only, tenant-scoped. Returns 409 if the member is already active.
         * @summary Activate Medical Staff
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateMedicalStaff: async (staffId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('activateMedicalStaff', 'staffId', staffId)
            const localVarPath = `/api/medical/staff/{staff_id}/activate`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create insurance company
         * @summary Create Insurance Company
         * @param {HealthInsuranceCompanyCreate} healthInsuranceCompanyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInsuranceCompany: async (healthInsuranceCompanyCreate: HealthInsuranceCompanyCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'healthInsuranceCompanyCreate' is not null or undefined
            assertParamExists('createInsuranceCompany', 'healthInsuranceCompanyCreate', healthInsuranceCompanyCreate)
            const localVarPath = `/api/medical/insurance-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(healthInsuranceCompanyCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a medical staff member with explicit access-mode control (Admin only).  access_mode = \"no_login\"  (default)     Creates the staff record only.  No User account is created.     contact_email is stored for notification purposes.  access_mode = \"invite\"     Creates the staff record and sends an invitation to the email address     (invite_email if provided, otherwise contact_email).     An OrganizationInvite token + outbound email are written in a single     transaction.  staff.user_id is NEVER set here — only at invite     redemption time (Phase 3 invariant).  Response: { staff: ..., inviteStatus: null | \"invite_sent\" }
         * @summary Create Medical Staff
         * @param {MedicalStaffCreateWithAccess} medicalStaffCreateWithAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalStaff: async (medicalStaffCreateWithAccess: MedicalStaffCreateWithAccess, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalStaffCreateWithAccess' is not null or undefined
            assertParamExists('createMedicalStaff', 'medicalStaffCreateWithAccess', medicalStaffCreateWithAccess)
            const localVarPath = `/api/medical/staff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medicalStaffCreateWithAccess, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a document
         * @summary Upload Document
         * @param {File} file 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientDocument: async (file: File, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createPatientDocument', 'file', file)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('createPatientDocument', 'name', name)
            const localVarPath = `/api/medical/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create payment details for an organization  Maps to Java endpoint: POST /payment-details from PaymentDetailsController.createPaymentDetails()  Creates payment details with encrypted sensitive data using EncryptionUtil. Card number and CVV are encrypted before storage using AES-128 encryption. Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.  Matches Java implementation: EncryptionUtil.encrypt(value, \"key\")
         * @summary Create Payment Details
         * @param {PaymentDetailsCreate} paymentDetailsCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentDetails: async (paymentDetailsCreate: PaymentDetailsCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentDetailsCreate' is not null or undefined
            assertParamExists('createPaymentDetails', 'paymentDetailsCreate', paymentDetailsCreate)
            const localVarPath = `/api/medical/payment-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentDetailsCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new procedure
         * @summary Create Procedure
         * @param {ProcedureCreate} procedureCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcedure: async (procedureCreate: ProcedureCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'procedureCreate' is not null or undefined
            assertParamExists('createProcedure', 'procedureCreate', procedureCreate)
            const localVarPath = `/api/medical/procedures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(procedureCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate a medical staff member (set is_active=False).  The record is kept in the database but the member no longer appears in the active staff list.  CLINIC_ADMIN only, tenant-scoped. Returns 409 if the member is already deactivated.
         * @summary Deactivate Medical Staff
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateMedicalStaff: async (staffId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('deactivateMedicalStaff', 'staffId', staffId)
            const localVarPath = `/api/medical/staff/{staff_id}/deactivate`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a document (soft delete)
         * @summary Delete Document
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteDocument', 'documentId', documentId)
            const localVarPath = `/api/medical/documents/{document_id}`
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete insurance company
         * @summary Delete Insurance Company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInsuranceCompany: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('deleteInsuranceCompany', 'companyId', companyId)
            const localVarPath = `/api/medical/insurance-companies/{company_id}`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete medical staff (Admin only) with audit logging  Returns 204 No Content on successful deletion.
         * @summary Delete Medical Staff
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedicalStaff: async (staffId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('deleteMedicalStaff', 'staffId', staffId)
            const localVarPath = `/api/medical/staff/{staff_id}`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently delete medical staff (hard delete)  Maps to Java endpoint: DELETE /medical/staff/{id}/delete-permanent/ Performs hard delete (not soft delete). Note: Java uses MEDICAL_STAFF_REGISTRY role which doesn\'t exist in Python.  Returns 204 No Content on successful deletion.
         * @summary Delete Medical Staff Permanently
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedicalStaffPermanently: async (staffId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('deleteMedicalStaffPermanently', 'staffId', staffId)
            const localVarPath = `/api/medical/staff/{staff_id}/delete-permanent`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete payment details by ID  Maps to Java endpoint: DELETE /payment-details/{id}/ from PaymentDetailsController.deletePaymentDetailsById()  Deletes payment details for the specified ID. Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.
         * @summary Delete Payment Details By Id
         * @param {string} paymentDetailsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentDetailsById: async (paymentDetailsId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentDetailsId' is not null or undefined
            assertParamExists('deletePaymentDetailsById', 'paymentDetailsId', paymentDetailsId)
            const localVarPath = `/api/medical/payment-details/{payment_details_id}`
                .replace(`{${"payment_details_id"}}`, encodeURIComponent(String(paymentDetailsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete procedure (Admin only)
         * @summary Delete Procedure
         * @param {string} procedureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcedure: async (procedureId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'procedureId' is not null or undefined
            assertParamExists('deleteProcedure', 'procedureId', procedureId)
            const localVarPath = `/api/medical/procedures/{procedure_id}`
                .replace(`{${"procedure_id"}}`, encodeURIComponent(String(procedureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all health insurance companies, optionally filtered by country code  Maps to Java: GET /insurance-companies?country_code={code}  **IMPORTANT:** Country code should be the phone dialing code (e.g., \"359\" for Bulgaria), NOT the ISO alpha-2 code (e.g., \"BG\"). This matches Java\'s seeded data format.  Bulgaria companies are seeded with country_code=\"359\".
         * @summary Fetch All Insurance Companies
         * @param {string | null} [countryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllInsuranceCompanies: async (countryCode?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/medical/insurance-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (countryCode !== undefined) {
                localVarQueryParameter['country_code'] = countryCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all medical staff in the organization with pagination  All authenticated users can view medical staff in their organization. Note: sortBy parameter is accepted but not implemented (frontend compatibility).
         * @summary Fetch All Medical Staff
         * @param {string | null} [keyword] 
         * @param {string | null} [sortBy] Sort field (ignored, for frontend compatibility)
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllMedicalStaff: async (keyword?: string | null, sortBy?: string | null, page?: number, perPage?: number, includeInactive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/medical/staff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }

            if (includeInactive !== undefined) {
                localVarQueryParameter['includeInactive'] = includeInactive;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all procedures in the organization
         * @summary Fetch All Procedures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllProcedures: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/medical/procedures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch health insurance company by ID  Maps to Java endpoint: GET /insurance-companies/{id}  Returns a specific insurance company by its ID.
         * @summary Fetch Insurance Company By Id
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInsuranceCompanyById: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('fetchInsuranceCompanyById', 'companyId', companyId)
            const localVarPath = `/api/medical/insurance-companies/{company_id}`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch medical staff avatar  Maps to Java endpoint: GET /medical/staff/{id}/avatar/ from MedicalStaffController.fetchMedicalStaffAvatar()  Returns the medical staff member\'s avatar image file. Authorization: CLINIC_ADMIN, MEDICAL_DOCTOR, MEDICAL_ASSISTANT, or RECEPTIONIST
         * @summary Fetch Medical Staff Avatar
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStaffAvatar: async (staffId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('fetchMedicalStaffAvatar', 'staffId', staffId)
            const localVarPath = `/api/medical/staff/{staff_id}/avatar`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'image/jpeg,image/png,image/gif,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get medical staff by email address  Maps to Java endpoint: GET /medical/staff/by-email/ Returns first staff member with matching email, or null if not found.
         * @summary Fetch Medical Staff By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStaffByEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('fetchMedicalStaffByEmail', 'email', email)
            const localVarPath = `/api/medical/staff/by-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch medical staff by ID.  The returned portalAccessStatus is computed from live DB state:   - ACTIVE   : has_portal_access=True   - PENDING_INVITE : pending (un-accepted, un-revoked) invite token exists   - NONE     : membership REMOVED (revoked after prior redemption) or no history   - INVITED  : legacy — user linked but membership not yet ACTIVE
         * @summary Fetch Medical Staff
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStaffById: async (staffId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('fetchMedicalStaffById', 'staffId', staffId)
            const localVarPath = `/api/medical/staff/{staff_id}`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch medical staff count by role (doctors, receptionists, assistants)  Maps to Java endpoint: GET /medical/staff/count/ Returns counts of medical staff grouped by role for the current user\'s organization.
         * @summary Fetch Medical Staff Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStaffCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/medical/staff/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch fetch medical staff by IDs, or return all if no IDs provided  Maps to Java endpoint: POST /medical/staff/doctors/ If ids is null or empty, returns all staff. Otherwise returns staff matching the provided IDs.
         * @summary Fetch Medical Staff Doctors
         * @param {Array<string> | null} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStaffDoctors: async (requestBody?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/medical/staff/doctors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get medical staff IDs for an organization (RECEPTIONIST role)  Maps to Java endpoint: GET /medical/staff/organization/{organizationId}/ Returns IDs of staff with RECEPTIONIST role for the specified organization.
         * @summary Fetch Medical Staff Ids By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStaffIdsByOrganization: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchMedicalStaffIdsByOrganization', 'organizationId', organizationId)
            const localVarPath = `/api/medical/staff/organization/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch payment details by ID  Maps to Java endpoint: GET /payment-details/{id}/ from PaymentDetailsController.fetchPaymentDetailsById()  Returns payment details for the specified ID (card data remains encrypted). Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.
         * @summary Fetch Payment Details By Id
         * @param {string} paymentDetailsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPaymentDetailsById: async (paymentDetailsId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentDetailsId' is not null or undefined
            assertParamExists('fetchPaymentDetailsById', 'paymentDetailsId', paymentDetailsId)
            const localVarPath = `/api/medical/payment-details/{payment_details_id}`
                .replace(`{${"payment_details_id"}}`, encodeURIComponent(String(paymentDetailsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch procedure by ID
         * @summary Fetch Procedure
         * @param {string} procedureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProcedureById: async (procedureId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'procedureId' is not null or undefined
            assertParamExists('fetchProcedureById', 'procedureId', procedureId)
            const localVarPath = `/api/medical/procedures/{procedure_id}`
                .replace(`{${"procedure_id"}}`, encodeURIComponent(String(procedureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a compact access snapshot for the given staff member.  Resolves membership status from the linked user (if any) or checks for a pending OrganizationInvite when no user is linked yet.  CLINIC_ADMIN only, tenant-scoped.
         * @summary Get Medical Staff Access
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalStaffAccess: async (staffId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('getMedicalStaffAccess', 'staffId', staffId)
            const localVarPath = `/api/medical/staff/{staff_id}/access`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all documents for an organization
         * @summary Get Organization Documents
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationDocuments: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationDocuments', 'organizationId', organizationId)
            const localVarPath = `/api/medical/documents/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant portal access to an existing staff member via an invite token.  CLINIC_ADMIN only, tenant-scoped.  Phase 3 invariant: ALL grants go through an invite token regardless of whether the email belongs to an existing user.  staff.user_id and membership.status=ACTIVE are set only at invite redemption time, not here.  An OrganizationInvite record + OutboundEmail are written in a single transaction and an invite email is sent to the provided address.  Returns 409 if:   - staff is inactive   - staff already has active portal access (has_portal_access=True)   - a pending invite already exists for this staff member (revoke or resend first)   - staff is linked to a different user\'s email (identity mismatch)
         * @summary Grant Medical Staff Access
         * @param {string} staffId 
         * @param {StaffAccessGrantRequest} staffAccessGrantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantMedicalStaffAccess: async (staffId: string, staffAccessGrantRequest: StaffAccessGrantRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('grantMedicalStaffAccess', 'staffId', staffId)
            // verify required parameter 'staffAccessGrantRequest' is not null or undefined
            assertParamExists('grantMedicalStaffAccess', 'staffAccessGrantRequest', staffAccessGrantRequest)
            const localVarPath = `/api/medical/staff/{staff_id}/grant-access`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(staffAccessGrantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Re-send the portal access invite email with a fresh token.  CLINIC_ADMIN only, tenant-scoped.  Rotates the token on the existing pending invite (regenerates token_hash + extends expires_at by 7 days) and re-enqueues a new invite email. All writes are in a single transaction.  Returns 409 if no pending (un-accepted, un-revoked) invite exists for this staff member.
         * @summary Resend Staff Invite
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendStaffInvite: async (staffId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('resendStaffInvite', 'staffId', staffId)
            const localVarPath = `/api/medical/staff/{staff_id}/resend-invite`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove portal access for a staff member in this org.  CLINIC_ADMIN only, tenant-scoped.  Handles atomically:   - Pending invite: sets invite.revoked_at to now.   - Active/linked membership: sets membership.status=REMOVED; has_portal_access=False.  INVARIANT: staff.user_id is NEVER nullified.  Identity linkage is preserved so re-granting access later (to the same user) works without orphan detection.  Does NOT delete the User account or affect memberships in other organisations.  Returns 409 if there is no pending invite and no active membership to revoke.
         * @summary Revoke Medical Staff Access
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeMedicalStaffAccess: async (staffId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('revokeMedicalStaffAccess', 'staffId', staffId)
            const localVarPath = `/api/medical/staff/{staff_id}/revoke-access`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update insurance company
         * @summary Update Insurance Company
         * @param {string} companyId 
         * @param {HealthInsuranceCompanyUpdate} healthInsuranceCompanyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInsuranceCompany: async (companyId: string, healthInsuranceCompanyUpdate: HealthInsuranceCompanyUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateInsuranceCompany', 'companyId', companyId)
            // verify required parameter 'healthInsuranceCompanyUpdate' is not null or undefined
            assertParamExists('updateInsuranceCompany', 'healthInsuranceCompanyUpdate', healthInsuranceCompanyUpdate)
            const localVarPath = `/api/medical/insurance-companies/{company_id}`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(healthInsuranceCompanyUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update medical staff information (Admin only) with audit logging  Uses PUT method following RESTful standards (changed from Java\'s POST approach)
         * @summary Update Medical Staff
         * @param {string} staffId 
         * @param {MedicalStaffUpdate} medicalStaffUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalStaff: async (staffId: string, medicalStaffUpdate: MedicalStaffUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('updateMedicalStaff', 'staffId', staffId)
            // verify required parameter 'medicalStaffUpdate' is not null or undefined
            assertParamExists('updateMedicalStaff', 'medicalStaffUpdate', medicalStaffUpdate)
            const localVarPath = `/api/medical/staff/{staff_id}`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medicalStaffUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update payment details by ID  Maps to Java endpoint: PUT /payment-details/{id}/ from PaymentDetailsController.updatePaymentDetailsById()  Updates payment details with new values. Card data is re-encrypted if changed. Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.
         * @summary Update Payment Details By Id
         * @param {string} paymentDetailsId 
         * @param {PaymentDetailsUpdate} paymentDetailsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentDetailsById: async (paymentDetailsId: string, paymentDetailsUpdate: PaymentDetailsUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentDetailsId' is not null or undefined
            assertParamExists('updatePaymentDetailsById', 'paymentDetailsId', paymentDetailsId)
            // verify required parameter 'paymentDetailsUpdate' is not null or undefined
            assertParamExists('updatePaymentDetailsById', 'paymentDetailsUpdate', paymentDetailsUpdate)
            const localVarPath = `/api/medical/payment-details/{payment_details_id}`
                .replace(`{${"payment_details_id"}}`, encodeURIComponent(String(paymentDetailsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentDetailsUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update procedure information
         * @summary Update Procedure
         * @param {string} procedureId 
         * @param {ProcedureUpdate} procedureUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcedure: async (procedureId: string, procedureUpdate: ProcedureUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'procedureId' is not null or undefined
            assertParamExists('updateProcedure', 'procedureId', procedureId)
            // verify required parameter 'procedureUpdate' is not null or undefined
            assertParamExists('updateProcedure', 'procedureUpdate', procedureUpdate)
            const localVarPath = `/api/medical/procedures/{procedure_id}`
                .replace(`{${"procedure_id"}}`, encodeURIComponent(String(procedureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(procedureUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload avatar for medical staff (Admin only)
         * @summary Upload Staff Avatar
         * @param {string} staffId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadStaffAvatar: async (staffId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('uploadStaffAvatar', 'staffId', staffId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadStaffAvatar', 'file', file)
            const localVarPath = `/api/medical/staff/{staff_id}/avatar`
                .replace(`{${"staff_id"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedicalApi - functional programming interface
 */
export const MedicalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedicalApiAxiosParamCreator(configuration)
    return {
        /**
         * Reactivate a medical staff member (set is_active=True).  CLINIC_ADMIN only, tenant-scoped. Returns 409 if the member is already active.
         * @summary Activate Medical Staff
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateMedicalStaff(staffId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicalStaff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateMedicalStaff(staffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.activateMedicalStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create insurance company
         * @summary Create Insurance Company
         * @param {HealthInsuranceCompanyCreate} healthInsuranceCompanyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInsuranceCompany(healthInsuranceCompanyCreate: HealthInsuranceCompanyCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthInsuranceCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInsuranceCompany(healthInsuranceCompanyCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.createInsuranceCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a medical staff member with explicit access-mode control (Admin only).  access_mode = \"no_login\"  (default)     Creates the staff record only.  No User account is created.     contact_email is stored for notification purposes.  access_mode = \"invite\"     Creates the staff record and sends an invitation to the email address     (invite_email if provided, otherwise contact_email).     An OrganizationInvite token + outbound email are written in a single     transaction.  staff.user_id is NEVER set here — only at invite     redemption time (Phase 3 invariant).  Response: { staff: ..., inviteStatus: null | \"invite_sent\" }
         * @summary Create Medical Staff
         * @param {MedicalStaffCreateWithAccess} medicalStaffCreateWithAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMedicalStaff(medicalStaffCreateWithAccess: MedicalStaffCreateWithAccess, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicalStaffCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMedicalStaff(medicalStaffCreateWithAccess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.createMedicalStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a document
         * @summary Upload Document
         * @param {File} file 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientDocument(file: File, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientDocumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientDocument(file, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.createPatientDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create payment details for an organization  Maps to Java endpoint: POST /payment-details from PaymentDetailsController.createPaymentDetails()  Creates payment details with encrypted sensitive data using EncryptionUtil. Card number and CVV are encrypted before storage using AES-128 encryption. Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.  Matches Java implementation: EncryptionUtil.encrypt(value, \"key\")
         * @summary Create Payment Details
         * @param {PaymentDetailsCreate} paymentDetailsCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPaymentDetails(paymentDetailsCreate: PaymentDetailsCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPaymentDetails(paymentDetailsCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.createPaymentDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create new procedure
         * @summary Create Procedure
         * @param {ProcedureCreate} procedureCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProcedure(procedureCreate: ProcedureCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Procedure>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProcedure(procedureCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.createProcedure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate a medical staff member (set is_active=False).  The record is kept in the database but the member no longer appears in the active staff list.  CLINIC_ADMIN only, tenant-scoped. Returns 409 if the member is already deactivated.
         * @summary Deactivate Medical Staff
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateMedicalStaff(staffId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicalStaff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateMedicalStaff(staffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.deactivateMedicalStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a document (soft delete)
         * @summary Delete Document
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocument(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocument(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.deleteDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete insurance company
         * @summary Delete Insurance Company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInsuranceCompany(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInsuranceCompany(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.deleteInsuranceCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete medical staff (Admin only) with audit logging  Returns 204 No Content on successful deletion.
         * @summary Delete Medical Staff
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMedicalStaff(staffId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMedicalStaff(staffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.deleteMedicalStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Permanently delete medical staff (hard delete)  Maps to Java endpoint: DELETE /medical/staff/{id}/delete-permanent/ Performs hard delete (not soft delete). Note: Java uses MEDICAL_STAFF_REGISTRY role which doesn\'t exist in Python.  Returns 204 No Content on successful deletion.
         * @summary Delete Medical Staff Permanently
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMedicalStaffPermanently(staffId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMedicalStaffPermanently(staffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.deleteMedicalStaffPermanently']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete payment details by ID  Maps to Java endpoint: DELETE /payment-details/{id}/ from PaymentDetailsController.deletePaymentDetailsById()  Deletes payment details for the specified ID. Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.
         * @summary Delete Payment Details By Id
         * @param {string} paymentDetailsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePaymentDetailsById(paymentDetailsId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePaymentDetailsById(paymentDetailsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.deletePaymentDetailsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete procedure (Admin only)
         * @summary Delete Procedure
         * @param {string} procedureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProcedure(procedureId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProcedure(procedureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.deleteProcedure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all health insurance companies, optionally filtered by country code  Maps to Java: GET /insurance-companies?country_code={code}  **IMPORTANT:** Country code should be the phone dialing code (e.g., \"359\" for Bulgaria), NOT the ISO alpha-2 code (e.g., \"BG\"). This matches Java\'s seeded data format.  Bulgaria companies are seeded with country_code=\"359\".
         * @summary Fetch All Insurance Companies
         * @param {string | null} [countryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllInsuranceCompanies(countryCode?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HealthInsuranceCompanyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllInsuranceCompanies(countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.fetchAllInsuranceCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all medical staff in the organization with pagination  All authenticated users can view medical staff in their organization. Note: sortBy parameter is accepted but not implemented (frontend compatibility).
         * @summary Fetch All Medical Staff
         * @param {string | null} [keyword] 
         * @param {string | null} [sortBy] Sort field (ignored, for frontend compatibility)
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllMedicalStaff(keyword?: string | null, sortBy?: string | null, page?: number, perPage?: number, includeInactive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicalStaffPaginationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllMedicalStaff(keyword, sortBy, page, perPage, includeInactive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.fetchAllMedicalStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all procedures in the organization
         * @summary Fetch All Procedures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllProcedures(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Procedure>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllProcedures(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.fetchAllProcedures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch health insurance company by ID  Maps to Java endpoint: GET /insurance-companies/{id}  Returns a specific insurance company by its ID.
         * @summary Fetch Insurance Company By Id
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchInsuranceCompanyById(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthInsuranceCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchInsuranceCompanyById(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.fetchInsuranceCompanyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch medical staff avatar  Maps to Java endpoint: GET /medical/staff/{id}/avatar/ from MedicalStaffController.fetchMedicalStaffAvatar()  Returns the medical staff member\'s avatar image file. Authorization: CLINIC_ADMIN, MEDICAL_DOCTOR, MEDICAL_ASSISTANT, or RECEPTIONIST
         * @summary Fetch Medical Staff Avatar
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMedicalStaffAvatar(staffId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMedicalStaffAvatar(staffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.fetchMedicalStaffAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get medical staff by email address  Maps to Java endpoint: GET /medical/staff/by-email/ Returns first staff member with matching email, or null if not found.
         * @summary Fetch Medical Staff By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMedicalStaffByEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicalStaff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMedicalStaffByEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.fetchMedicalStaffByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch medical staff by ID.  The returned portalAccessStatus is computed from live DB state:   - ACTIVE   : has_portal_access=True   - PENDING_INVITE : pending (un-accepted, un-revoked) invite token exists   - NONE     : membership REMOVED (revoked after prior redemption) or no history   - INVITED  : legacy — user linked but membership not yet ACTIVE
         * @summary Fetch Medical Staff
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMedicalStaffById(staffId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicalStaff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMedicalStaffById(staffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.fetchMedicalStaffById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch medical staff count by role (doctors, receptionists, assistants)  Maps to Java endpoint: GET /medical/staff/count/ Returns counts of medical staff grouped by role for the current user\'s organization.
         * @summary Fetch Medical Staff Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMedicalStaffCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicalStaffCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMedicalStaffCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.fetchMedicalStaffCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch fetch medical staff by IDs, or return all if no IDs provided  Maps to Java endpoint: POST /medical/staff/doctors/ If ids is null or empty, returns all staff. Otherwise returns staff matching the provided IDs.
         * @summary Fetch Medical Staff Doctors
         * @param {Array<string> | null} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMedicalStaffDoctors(requestBody?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MedicalStaff>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMedicalStaffDoctors(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.fetchMedicalStaffDoctors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get medical staff IDs for an organization (RECEPTIONIST role)  Maps to Java endpoint: GET /medical/staff/organization/{organizationId}/ Returns IDs of staff with RECEPTIONIST role for the specified organization.
         * @summary Fetch Medical Staff Ids By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMedicalStaffIdsByOrganization(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMedicalStaffIdsByOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.fetchMedicalStaffIdsByOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch payment details by ID  Maps to Java endpoint: GET /payment-details/{id}/ from PaymentDetailsController.fetchPaymentDetailsById()  Returns payment details for the specified ID (card data remains encrypted). Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.
         * @summary Fetch Payment Details By Id
         * @param {string} paymentDetailsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPaymentDetailsById(paymentDetailsId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPaymentDetailsById(paymentDetailsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.fetchPaymentDetailsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch procedure by ID
         * @summary Fetch Procedure
         * @param {string} procedureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchProcedureById(procedureId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Procedure>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchProcedureById(procedureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.fetchProcedureById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a compact access snapshot for the given staff member.  Resolves membership status from the linked user (if any) or checks for a pending OrganizationInvite when no user is linked yet.  CLINIC_ADMIN only, tenant-scoped.
         * @summary Get Medical Staff Access
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMedicalStaffAccess(staffId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaffAccessView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMedicalStaffAccess(staffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.getMedicalStaffAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all documents for an organization
         * @summary Get Organization Documents
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationDocuments(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientDocumentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationDocuments(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.getOrganizationDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Grant portal access to an existing staff member via an invite token.  CLINIC_ADMIN only, tenant-scoped.  Phase 3 invariant: ALL grants go through an invite token regardless of whether the email belongs to an existing user.  staff.user_id and membership.status=ACTIVE are set only at invite redemption time, not here.  An OrganizationInvite record + OutboundEmail are written in a single transaction and an invite email is sent to the provided address.  Returns 409 if:   - staff is inactive   - staff already has active portal access (has_portal_access=True)   - a pending invite already exists for this staff member (revoke or resend first)   - staff is linked to a different user\'s email (identity mismatch)
         * @summary Grant Medical Staff Access
         * @param {string} staffId 
         * @param {StaffAccessGrantRequest} staffAccessGrantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantMedicalStaffAccess(staffId: string, staffAccessGrantRequest: StaffAccessGrantRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaffAccessGrantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantMedicalStaffAccess(staffId, staffAccessGrantRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.grantMedicalStaffAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Re-send the portal access invite email with a fresh token.  CLINIC_ADMIN only, tenant-scoped.  Rotates the token on the existing pending invite (regenerates token_hash + extends expires_at by 7 days) and re-enqueues a new invite email. All writes are in a single transaction.  Returns 409 if no pending (un-accepted, un-revoked) invite exists for this staff member.
         * @summary Resend Staff Invite
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendStaffInvite(staffId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicalStaff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendStaffInvite(staffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.resendStaffInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove portal access for a staff member in this org.  CLINIC_ADMIN only, tenant-scoped.  Handles atomically:   - Pending invite: sets invite.revoked_at to now.   - Active/linked membership: sets membership.status=REMOVED; has_portal_access=False.  INVARIANT: staff.user_id is NEVER nullified.  Identity linkage is preserved so re-granting access later (to the same user) works without orphan detection.  Does NOT delete the User account or affect memberships in other organisations.  Returns 409 if there is no pending invite and no active membership to revoke.
         * @summary Revoke Medical Staff Access
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeMedicalStaffAccess(staffId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicalStaff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeMedicalStaffAccess(staffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.revokeMedicalStaffAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update insurance company
         * @summary Update Insurance Company
         * @param {string} companyId 
         * @param {HealthInsuranceCompanyUpdate} healthInsuranceCompanyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInsuranceCompany(companyId: string, healthInsuranceCompanyUpdate: HealthInsuranceCompanyUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthInsuranceCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInsuranceCompany(companyId, healthInsuranceCompanyUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.updateInsuranceCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update medical staff information (Admin only) with audit logging  Uses PUT method following RESTful standards (changed from Java\'s POST approach)
         * @summary Update Medical Staff
         * @param {string} staffId 
         * @param {MedicalStaffUpdate} medicalStaffUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMedicalStaff(staffId: string, medicalStaffUpdate: MedicalStaffUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicalStaff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMedicalStaff(staffId, medicalStaffUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.updateMedicalStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update payment details by ID  Maps to Java endpoint: PUT /payment-details/{id}/ from PaymentDetailsController.updatePaymentDetailsById()  Updates payment details with new values. Card data is re-encrypted if changed. Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.
         * @summary Update Payment Details By Id
         * @param {string} paymentDetailsId 
         * @param {PaymentDetailsUpdate} paymentDetailsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePaymentDetailsById(paymentDetailsId: string, paymentDetailsUpdate: PaymentDetailsUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePaymentDetailsById(paymentDetailsId, paymentDetailsUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.updatePaymentDetailsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update procedure information
         * @summary Update Procedure
         * @param {string} procedureId 
         * @param {ProcedureUpdate} procedureUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcedure(procedureId: string, procedureUpdate: ProcedureUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Procedure>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcedure(procedureId, procedureUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.updateProcedure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload avatar for medical staff (Admin only)
         * @summary Upload Staff Avatar
         * @param {string} staffId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadStaffAvatar(staffId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicalStaff>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadStaffAvatar(staffId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalApi.uploadStaffAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MedicalApi - factory interface
 */
export const MedicalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedicalApiFp(configuration)
    return {
        /**
         * Reactivate a medical staff member (set is_active=True).  CLINIC_ADMIN only, tenant-scoped. Returns 409 if the member is already active.
         * @summary Activate Medical Staff
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateMedicalStaff(staffId: string, options?: RawAxiosRequestConfig): AxiosPromise<MedicalStaff> {
            return localVarFp.activateMedicalStaff(staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create insurance company
         * @summary Create Insurance Company
         * @param {HealthInsuranceCompanyCreate} healthInsuranceCompanyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInsuranceCompany(healthInsuranceCompanyCreate: HealthInsuranceCompanyCreate, options?: RawAxiosRequestConfig): AxiosPromise<HealthInsuranceCompanyResponse> {
            return localVarFp.createInsuranceCompany(healthInsuranceCompanyCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a medical staff member with explicit access-mode control (Admin only).  access_mode = \"no_login\"  (default)     Creates the staff record only.  No User account is created.     contact_email is stored for notification purposes.  access_mode = \"invite\"     Creates the staff record and sends an invitation to the email address     (invite_email if provided, otherwise contact_email).     An OrganizationInvite token + outbound email are written in a single     transaction.  staff.user_id is NEVER set here — only at invite     redemption time (Phase 3 invariant).  Response: { staff: ..., inviteStatus: null | \"invite_sent\" }
         * @summary Create Medical Staff
         * @param {MedicalStaffCreateWithAccess} medicalStaffCreateWithAccess 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalStaff(medicalStaffCreateWithAccess: MedicalStaffCreateWithAccess, options?: RawAxiosRequestConfig): AxiosPromise<MedicalStaffCreateResponse> {
            return localVarFp.createMedicalStaff(medicalStaffCreateWithAccess, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a document
         * @summary Upload Document
         * @param {File} file 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientDocument(file: File, name: string, options?: RawAxiosRequestConfig): AxiosPromise<PatientDocumentResponse> {
            return localVarFp.createPatientDocument(file, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Create payment details for an organization  Maps to Java endpoint: POST /payment-details from PaymentDetailsController.createPaymentDetails()  Creates payment details with encrypted sensitive data using EncryptionUtil. Card number and CVV are encrypted before storage using AES-128 encryption. Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.  Matches Java implementation: EncryptionUtil.encrypt(value, \"key\")
         * @summary Create Payment Details
         * @param {PaymentDetailsCreate} paymentDetailsCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentDetails(paymentDetailsCreate: PaymentDetailsCreate, options?: RawAxiosRequestConfig): AxiosPromise<PaymentDetailsResponse> {
            return localVarFp.createPaymentDetails(paymentDetailsCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new procedure
         * @summary Create Procedure
         * @param {ProcedureCreate} procedureCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcedure(procedureCreate: ProcedureCreate, options?: RawAxiosRequestConfig): AxiosPromise<Procedure> {
            return localVarFp.createProcedure(procedureCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate a medical staff member (set is_active=False).  The record is kept in the database but the member no longer appears in the active staff list.  CLINIC_ADMIN only, tenant-scoped. Returns 409 if the member is already deactivated.
         * @summary Deactivate Medical Staff
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateMedicalStaff(staffId: string, options?: RawAxiosRequestConfig): AxiosPromise<MedicalStaff> {
            return localVarFp.deactivateMedicalStaff(staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a document (soft delete)
         * @summary Delete Document
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(documentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDocument(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete insurance company
         * @summary Delete Insurance Company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInsuranceCompany(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteInsuranceCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete medical staff (Admin only) with audit logging  Returns 204 No Content on successful deletion.
         * @summary Delete Medical Staff
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedicalStaff(staffId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMedicalStaff(staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * Permanently delete medical staff (hard delete)  Maps to Java endpoint: DELETE /medical/staff/{id}/delete-permanent/ Performs hard delete (not soft delete). Note: Java uses MEDICAL_STAFF_REGISTRY role which doesn\'t exist in Python.  Returns 204 No Content on successful deletion.
         * @summary Delete Medical Staff Permanently
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedicalStaffPermanently(staffId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMedicalStaffPermanently(staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete payment details by ID  Maps to Java endpoint: DELETE /payment-details/{id}/ from PaymentDetailsController.deletePaymentDetailsById()  Deletes payment details for the specified ID. Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.
         * @summary Delete Payment Details By Id
         * @param {string} paymentDetailsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentDetailsById(paymentDetailsId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePaymentDetailsById(paymentDetailsId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete procedure (Admin only)
         * @summary Delete Procedure
         * @param {string} procedureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcedure(procedureId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProcedure(procedureId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all health insurance companies, optionally filtered by country code  Maps to Java: GET /insurance-companies?country_code={code}  **IMPORTANT:** Country code should be the phone dialing code (e.g., \"359\" for Bulgaria), NOT the ISO alpha-2 code (e.g., \"BG\"). This matches Java\'s seeded data format.  Bulgaria companies are seeded with country_code=\"359\".
         * @summary Fetch All Insurance Companies
         * @param {string | null} [countryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllInsuranceCompanies(countryCode?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<HealthInsuranceCompanyResponse>> {
            return localVarFp.fetchAllInsuranceCompanies(countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all medical staff in the organization with pagination  All authenticated users can view medical staff in their organization. Note: sortBy parameter is accepted but not implemented (frontend compatibility).
         * @summary Fetch All Medical Staff
         * @param {string | null} [keyword] 
         * @param {string | null} [sortBy] Sort field (ignored, for frontend compatibility)
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllMedicalStaff(keyword?: string | null, sortBy?: string | null, page?: number, perPage?: number, includeInactive?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<MedicalStaffPaginationResponse> {
            return localVarFp.fetchAllMedicalStaff(keyword, sortBy, page, perPage, includeInactive, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all procedures in the organization
         * @summary Fetch All Procedures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllProcedures(options?: RawAxiosRequestConfig): AxiosPromise<Array<Procedure>> {
            return localVarFp.fetchAllProcedures(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch health insurance company by ID  Maps to Java endpoint: GET /insurance-companies/{id}  Returns a specific insurance company by its ID.
         * @summary Fetch Insurance Company By Id
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchInsuranceCompanyById(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<HealthInsuranceCompanyResponse> {
            return localVarFp.fetchInsuranceCompanyById(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch medical staff avatar  Maps to Java endpoint: GET /medical/staff/{id}/avatar/ from MedicalStaffController.fetchMedicalStaffAvatar()  Returns the medical staff member\'s avatar image file. Authorization: CLINIC_ADMIN, MEDICAL_DOCTOR, MEDICAL_ASSISTANT, or RECEPTIONIST
         * @summary Fetch Medical Staff Avatar
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStaffAvatar(staffId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.fetchMedicalStaffAvatar(staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get medical staff by email address  Maps to Java endpoint: GET /medical/staff/by-email/ Returns first staff member with matching email, or null if not found.
         * @summary Fetch Medical Staff By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStaffByEmail(email: string, options?: RawAxiosRequestConfig): AxiosPromise<MedicalStaff> {
            return localVarFp.fetchMedicalStaffByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch medical staff by ID.  The returned portalAccessStatus is computed from live DB state:   - ACTIVE   : has_portal_access=True   - PENDING_INVITE : pending (un-accepted, un-revoked) invite token exists   - NONE     : membership REMOVED (revoked after prior redemption) or no history   - INVITED  : legacy — user linked but membership not yet ACTIVE
         * @summary Fetch Medical Staff
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStaffById(staffId: string, options?: RawAxiosRequestConfig): AxiosPromise<MedicalStaff> {
            return localVarFp.fetchMedicalStaffById(staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch medical staff count by role (doctors, receptionists, assistants)  Maps to Java endpoint: GET /medical/staff/count/ Returns counts of medical staff grouped by role for the current user\'s organization.
         * @summary Fetch Medical Staff Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStaffCount(options?: RawAxiosRequestConfig): AxiosPromise<MedicalStaffCountResponse> {
            return localVarFp.fetchMedicalStaffCount(options).then((request) => request(axios, basePath));
        },
        /**
         * Batch fetch medical staff by IDs, or return all if no IDs provided  Maps to Java endpoint: POST /medical/staff/doctors/ If ids is null or empty, returns all staff. Otherwise returns staff matching the provided IDs.
         * @summary Fetch Medical Staff Doctors
         * @param {Array<string> | null} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStaffDoctors(requestBody?: Array<string> | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<MedicalStaff>> {
            return localVarFp.fetchMedicalStaffDoctors(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Get medical staff IDs for an organization (RECEPTIONIST role)  Maps to Java endpoint: GET /medical/staff/organization/{organizationId}/ Returns IDs of staff with RECEPTIONIST role for the specified organization.
         * @summary Fetch Medical Staff Ids By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStaffIdsByOrganization(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.fetchMedicalStaffIdsByOrganization(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch payment details by ID  Maps to Java endpoint: GET /payment-details/{id}/ from PaymentDetailsController.fetchPaymentDetailsById()  Returns payment details for the specified ID (card data remains encrypted). Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.
         * @summary Fetch Payment Details By Id
         * @param {string} paymentDetailsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPaymentDetailsById(paymentDetailsId: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentDetailsResponse> {
            return localVarFp.fetchPaymentDetailsById(paymentDetailsId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch procedure by ID
         * @summary Fetch Procedure
         * @param {string} procedureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProcedureById(procedureId: string, options?: RawAxiosRequestConfig): AxiosPromise<Procedure> {
            return localVarFp.fetchProcedureById(procedureId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return a compact access snapshot for the given staff member.  Resolves membership status from the linked user (if any) or checks for a pending OrganizationInvite when no user is linked yet.  CLINIC_ADMIN only, tenant-scoped.
         * @summary Get Medical Staff Access
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalStaffAccess(staffId: string, options?: RawAxiosRequestConfig): AxiosPromise<StaffAccessView> {
            return localVarFp.getMedicalStaffAccess(staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all documents for an organization
         * @summary Get Organization Documents
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationDocuments(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PatientDocumentResponse>> {
            return localVarFp.getOrganizationDocuments(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant portal access to an existing staff member via an invite token.  CLINIC_ADMIN only, tenant-scoped.  Phase 3 invariant: ALL grants go through an invite token regardless of whether the email belongs to an existing user.  staff.user_id and membership.status=ACTIVE are set only at invite redemption time, not here.  An OrganizationInvite record + OutboundEmail are written in a single transaction and an invite email is sent to the provided address.  Returns 409 if:   - staff is inactive   - staff already has active portal access (has_portal_access=True)   - a pending invite already exists for this staff member (revoke or resend first)   - staff is linked to a different user\'s email (identity mismatch)
         * @summary Grant Medical Staff Access
         * @param {string} staffId 
         * @param {StaffAccessGrantRequest} staffAccessGrantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantMedicalStaffAccess(staffId: string, staffAccessGrantRequest: StaffAccessGrantRequest, options?: RawAxiosRequestConfig): AxiosPromise<StaffAccessGrantResponse> {
            return localVarFp.grantMedicalStaffAccess(staffId, staffAccessGrantRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Re-send the portal access invite email with a fresh token.  CLINIC_ADMIN only, tenant-scoped.  Rotates the token on the existing pending invite (regenerates token_hash + extends expires_at by 7 days) and re-enqueues a new invite email. All writes are in a single transaction.  Returns 409 if no pending (un-accepted, un-revoked) invite exists for this staff member.
         * @summary Resend Staff Invite
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendStaffInvite(staffId: string, options?: RawAxiosRequestConfig): AxiosPromise<MedicalStaff> {
            return localVarFp.resendStaffInvite(staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove portal access for a staff member in this org.  CLINIC_ADMIN only, tenant-scoped.  Handles atomically:   - Pending invite: sets invite.revoked_at to now.   - Active/linked membership: sets membership.status=REMOVED; has_portal_access=False.  INVARIANT: staff.user_id is NEVER nullified.  Identity linkage is preserved so re-granting access later (to the same user) works without orphan detection.  Does NOT delete the User account or affect memberships in other organisations.  Returns 409 if there is no pending invite and no active membership to revoke.
         * @summary Revoke Medical Staff Access
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeMedicalStaffAccess(staffId: string, options?: RawAxiosRequestConfig): AxiosPromise<MedicalStaff> {
            return localVarFp.revokeMedicalStaffAccess(staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update insurance company
         * @summary Update Insurance Company
         * @param {string} companyId 
         * @param {HealthInsuranceCompanyUpdate} healthInsuranceCompanyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInsuranceCompany(companyId: string, healthInsuranceCompanyUpdate: HealthInsuranceCompanyUpdate, options?: RawAxiosRequestConfig): AxiosPromise<HealthInsuranceCompanyResponse> {
            return localVarFp.updateInsuranceCompany(companyId, healthInsuranceCompanyUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update medical staff information (Admin only) with audit logging  Uses PUT method following RESTful standards (changed from Java\'s POST approach)
         * @summary Update Medical Staff
         * @param {string} staffId 
         * @param {MedicalStaffUpdate} medicalStaffUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalStaff(staffId: string, medicalStaffUpdate: MedicalStaffUpdate, options?: RawAxiosRequestConfig): AxiosPromise<MedicalStaff> {
            return localVarFp.updateMedicalStaff(staffId, medicalStaffUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update payment details by ID  Maps to Java endpoint: PUT /payment-details/{id}/ from PaymentDetailsController.updatePaymentDetailsById()  Updates payment details with new values. Card data is re-encrypted if changed. Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.
         * @summary Update Payment Details By Id
         * @param {string} paymentDetailsId 
         * @param {PaymentDetailsUpdate} paymentDetailsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentDetailsById(paymentDetailsId: string, paymentDetailsUpdate: PaymentDetailsUpdate, options?: RawAxiosRequestConfig): AxiosPromise<PaymentDetailsResponse> {
            return localVarFp.updatePaymentDetailsById(paymentDetailsId, paymentDetailsUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update procedure information
         * @summary Update Procedure
         * @param {string} procedureId 
         * @param {ProcedureUpdate} procedureUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcedure(procedureId: string, procedureUpdate: ProcedureUpdate, options?: RawAxiosRequestConfig): AxiosPromise<Procedure> {
            return localVarFp.updateProcedure(procedureId, procedureUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload avatar for medical staff (Admin only)
         * @summary Upload Staff Avatar
         * @param {string} staffId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadStaffAvatar(staffId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<MedicalStaff> {
            return localVarFp.uploadStaffAvatar(staffId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MedicalApi - object-oriented interface
 */
export class MedicalApi extends BaseAPI {
    /**
     * Reactivate a medical staff member (set is_active=True).  CLINIC_ADMIN only, tenant-scoped. Returns 409 if the member is already active.
     * @summary Activate Medical Staff
     * @param {string} staffId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public activateMedicalStaff(staffId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).activateMedicalStaff(staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create insurance company
     * @summary Create Insurance Company
     * @param {HealthInsuranceCompanyCreate} healthInsuranceCompanyCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInsuranceCompany(healthInsuranceCompanyCreate: HealthInsuranceCompanyCreate, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).createInsuranceCompany(healthInsuranceCompanyCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a medical staff member with explicit access-mode control (Admin only).  access_mode = \"no_login\"  (default)     Creates the staff record only.  No User account is created.     contact_email is stored for notification purposes.  access_mode = \"invite\"     Creates the staff record and sends an invitation to the email address     (invite_email if provided, otherwise contact_email).     An OrganizationInvite token + outbound email are written in a single     transaction.  staff.user_id is NEVER set here — only at invite     redemption time (Phase 3 invariant).  Response: { staff: ..., inviteStatus: null | \"invite_sent\" }
     * @summary Create Medical Staff
     * @param {MedicalStaffCreateWithAccess} medicalStaffCreateWithAccess 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createMedicalStaff(medicalStaffCreateWithAccess: MedicalStaffCreateWithAccess, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).createMedicalStaff(medicalStaffCreateWithAccess, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a document
     * @summary Upload Document
     * @param {File} file 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPatientDocument(file: File, name: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).createPatientDocument(file, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create payment details for an organization  Maps to Java endpoint: POST /payment-details from PaymentDetailsController.createPaymentDetails()  Creates payment details with encrypted sensitive data using EncryptionUtil. Card number and CVV are encrypted before storage using AES-128 encryption. Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.  Matches Java implementation: EncryptionUtil.encrypt(value, \"key\")
     * @summary Create Payment Details
     * @param {PaymentDetailsCreate} paymentDetailsCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPaymentDetails(paymentDetailsCreate: PaymentDetailsCreate, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).createPaymentDetails(paymentDetailsCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new procedure
     * @summary Create Procedure
     * @param {ProcedureCreate} procedureCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProcedure(procedureCreate: ProcedureCreate, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).createProcedure(procedureCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate a medical staff member (set is_active=False).  The record is kept in the database but the member no longer appears in the active staff list.  CLINIC_ADMIN only, tenant-scoped. Returns 409 if the member is already deactivated.
     * @summary Deactivate Medical Staff
     * @param {string} staffId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deactivateMedicalStaff(staffId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).deactivateMedicalStaff(staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a document (soft delete)
     * @summary Delete Document
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDocument(documentId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).deleteDocument(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete insurance company
     * @summary Delete Insurance Company
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteInsuranceCompany(companyId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).deleteInsuranceCompany(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete medical staff (Admin only) with audit logging  Returns 204 No Content on successful deletion.
     * @summary Delete Medical Staff
     * @param {string} staffId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMedicalStaff(staffId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).deleteMedicalStaff(staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Permanently delete medical staff (hard delete)  Maps to Java endpoint: DELETE /medical/staff/{id}/delete-permanent/ Performs hard delete (not soft delete). Note: Java uses MEDICAL_STAFF_REGISTRY role which doesn\'t exist in Python.  Returns 204 No Content on successful deletion.
     * @summary Delete Medical Staff Permanently
     * @param {string} staffId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMedicalStaffPermanently(staffId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).deleteMedicalStaffPermanently(staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete payment details by ID  Maps to Java endpoint: DELETE /payment-details/{id}/ from PaymentDetailsController.deletePaymentDetailsById()  Deletes payment details for the specified ID. Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.
     * @summary Delete Payment Details By Id
     * @param {string} paymentDetailsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePaymentDetailsById(paymentDetailsId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).deletePaymentDetailsById(paymentDetailsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete procedure (Admin only)
     * @summary Delete Procedure
     * @param {string} procedureId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteProcedure(procedureId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).deleteProcedure(procedureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all health insurance companies, optionally filtered by country code  Maps to Java: GET /insurance-companies?country_code={code}  **IMPORTANT:** Country code should be the phone dialing code (e.g., \"359\" for Bulgaria), NOT the ISO alpha-2 code (e.g., \"BG\"). This matches Java\'s seeded data format.  Bulgaria companies are seeded with country_code=\"359\".
     * @summary Fetch All Insurance Companies
     * @param {string | null} [countryCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllInsuranceCompanies(countryCode?: string | null, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).fetchAllInsuranceCompanies(countryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all medical staff in the organization with pagination  All authenticated users can view medical staff in their organization. Note: sortBy parameter is accepted but not implemented (frontend compatibility).
     * @summary Fetch All Medical Staff
     * @param {string | null} [keyword] 
     * @param {string | null} [sortBy] Sort field (ignored, for frontend compatibility)
     * @param {number} [page] 
     * @param {number} [perPage] 
     * @param {boolean} [includeInactive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllMedicalStaff(keyword?: string | null, sortBy?: string | null, page?: number, perPage?: number, includeInactive?: boolean, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).fetchAllMedicalStaff(keyword, sortBy, page, perPage, includeInactive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all procedures in the organization
     * @summary Fetch All Procedures
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllProcedures(options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).fetchAllProcedures(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch health insurance company by ID  Maps to Java endpoint: GET /insurance-companies/{id}  Returns a specific insurance company by its ID.
     * @summary Fetch Insurance Company By Id
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchInsuranceCompanyById(companyId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).fetchInsuranceCompanyById(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch medical staff avatar  Maps to Java endpoint: GET /medical/staff/{id}/avatar/ from MedicalStaffController.fetchMedicalStaffAvatar()  Returns the medical staff member\'s avatar image file. Authorization: CLINIC_ADMIN, MEDICAL_DOCTOR, MEDICAL_ASSISTANT, or RECEPTIONIST
     * @summary Fetch Medical Staff Avatar
     * @param {string} staffId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchMedicalStaffAvatar(staffId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).fetchMedicalStaffAvatar(staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get medical staff by email address  Maps to Java endpoint: GET /medical/staff/by-email/ Returns first staff member with matching email, or null if not found.
     * @summary Fetch Medical Staff By Email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchMedicalStaffByEmail(email: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).fetchMedicalStaffByEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch medical staff by ID.  The returned portalAccessStatus is computed from live DB state:   - ACTIVE   : has_portal_access=True   - PENDING_INVITE : pending (un-accepted, un-revoked) invite token exists   - NONE     : membership REMOVED (revoked after prior redemption) or no history   - INVITED  : legacy — user linked but membership not yet ACTIVE
     * @summary Fetch Medical Staff
     * @param {string} staffId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchMedicalStaffById(staffId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).fetchMedicalStaffById(staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch medical staff count by role (doctors, receptionists, assistants)  Maps to Java endpoint: GET /medical/staff/count/ Returns counts of medical staff grouped by role for the current user\'s organization.
     * @summary Fetch Medical Staff Count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchMedicalStaffCount(options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).fetchMedicalStaffCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch fetch medical staff by IDs, or return all if no IDs provided  Maps to Java endpoint: POST /medical/staff/doctors/ If ids is null or empty, returns all staff. Otherwise returns staff matching the provided IDs.
     * @summary Fetch Medical Staff Doctors
     * @param {Array<string> | null} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchMedicalStaffDoctors(requestBody?: Array<string> | null, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).fetchMedicalStaffDoctors(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get medical staff IDs for an organization (RECEPTIONIST role)  Maps to Java endpoint: GET /medical/staff/organization/{organizationId}/ Returns IDs of staff with RECEPTIONIST role for the specified organization.
     * @summary Fetch Medical Staff Ids By Organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchMedicalStaffIdsByOrganization(organizationId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).fetchMedicalStaffIdsByOrganization(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch payment details by ID  Maps to Java endpoint: GET /payment-details/{id}/ from PaymentDetailsController.fetchPaymentDetailsById()  Returns payment details for the specified ID (card data remains encrypted). Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.
     * @summary Fetch Payment Details By Id
     * @param {string} paymentDetailsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPaymentDetailsById(paymentDetailsId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).fetchPaymentDetailsById(paymentDetailsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch procedure by ID
     * @summary Fetch Procedure
     * @param {string} procedureId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchProcedureById(procedureId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).fetchProcedureById(procedureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a compact access snapshot for the given staff member.  Resolves membership status from the linked user (if any) or checks for a pending OrganizationInvite when no user is linked yet.  CLINIC_ADMIN only, tenant-scoped.
     * @summary Get Medical Staff Access
     * @param {string} staffId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMedicalStaffAccess(staffId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).getMedicalStaffAccess(staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all documents for an organization
     * @summary Get Organization Documents
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationDocuments(organizationId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).getOrganizationDocuments(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant portal access to an existing staff member via an invite token.  CLINIC_ADMIN only, tenant-scoped.  Phase 3 invariant: ALL grants go through an invite token regardless of whether the email belongs to an existing user.  staff.user_id and membership.status=ACTIVE are set only at invite redemption time, not here.  An OrganizationInvite record + OutboundEmail are written in a single transaction and an invite email is sent to the provided address.  Returns 409 if:   - staff is inactive   - staff already has active portal access (has_portal_access=True)   - a pending invite already exists for this staff member (revoke or resend first)   - staff is linked to a different user\'s email (identity mismatch)
     * @summary Grant Medical Staff Access
     * @param {string} staffId 
     * @param {StaffAccessGrantRequest} staffAccessGrantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public grantMedicalStaffAccess(staffId: string, staffAccessGrantRequest: StaffAccessGrantRequest, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).grantMedicalStaffAccess(staffId, staffAccessGrantRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Re-send the portal access invite email with a fresh token.  CLINIC_ADMIN only, tenant-scoped.  Rotates the token on the existing pending invite (regenerates token_hash + extends expires_at by 7 days) and re-enqueues a new invite email. All writes are in a single transaction.  Returns 409 if no pending (un-accepted, un-revoked) invite exists for this staff member.
     * @summary Resend Staff Invite
     * @param {string} staffId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resendStaffInvite(staffId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).resendStaffInvite(staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove portal access for a staff member in this org.  CLINIC_ADMIN only, tenant-scoped.  Handles atomically:   - Pending invite: sets invite.revoked_at to now.   - Active/linked membership: sets membership.status=REMOVED; has_portal_access=False.  INVARIANT: staff.user_id is NEVER nullified.  Identity linkage is preserved so re-granting access later (to the same user) works without orphan detection.  Does NOT delete the User account or affect memberships in other organisations.  Returns 409 if there is no pending invite and no active membership to revoke.
     * @summary Revoke Medical Staff Access
     * @param {string} staffId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeMedicalStaffAccess(staffId: string, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).revokeMedicalStaffAccess(staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update insurance company
     * @summary Update Insurance Company
     * @param {string} companyId 
     * @param {HealthInsuranceCompanyUpdate} healthInsuranceCompanyUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateInsuranceCompany(companyId: string, healthInsuranceCompanyUpdate: HealthInsuranceCompanyUpdate, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).updateInsuranceCompany(companyId, healthInsuranceCompanyUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update medical staff information (Admin only) with audit logging  Uses PUT method following RESTful standards (changed from Java\'s POST approach)
     * @summary Update Medical Staff
     * @param {string} staffId 
     * @param {MedicalStaffUpdate} medicalStaffUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMedicalStaff(staffId: string, medicalStaffUpdate: MedicalStaffUpdate, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).updateMedicalStaff(staffId, medicalStaffUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update payment details by ID  Maps to Java endpoint: PUT /payment-details/{id}/ from PaymentDetailsController.updatePaymentDetailsById()  Updates payment details with new values. Card data is re-encrypted if changed. Only accessible by PLATFORM_ADMINISTRATOR and CLINIC_ADMIN roles.
     * @summary Update Payment Details By Id
     * @param {string} paymentDetailsId 
     * @param {PaymentDetailsUpdate} paymentDetailsUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePaymentDetailsById(paymentDetailsId: string, paymentDetailsUpdate: PaymentDetailsUpdate, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).updatePaymentDetailsById(paymentDetailsId, paymentDetailsUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update procedure information
     * @summary Update Procedure
     * @param {string} procedureId 
     * @param {ProcedureUpdate} procedureUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcedure(procedureId: string, procedureUpdate: ProcedureUpdate, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).updateProcedure(procedureId, procedureUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload avatar for medical staff (Admin only)
     * @summary Upload Staff Avatar
     * @param {string} staffId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadStaffAvatar(staffId: string, file: File, options?: RawAxiosRequestConfig) {
        return MedicalApiFp(this.configuration).uploadStaffAvatar(staffId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new notification
         * @summary Create Notification
         * @param {NotificationCreate} notificationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification: async (notificationCreate: NotificationCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationCreate' is not null or undefined
            assertParamExists('createNotification', 'notificationCreate', notificationCreate)
            const localVarPath = `/api/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a notification
         * @summary Delete Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('deleteNotification', 'notificationId', notificationId)
            const localVarPath = `/api/notifications/{notification_id}`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get notifications for the current user
         * @summary Get My Notifications
         * @param {boolean} [unreadOnly] Get only unread notifications
         * @param {number} [limit] Maximum number of notifications to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMyNotifications: async (unreadOnly?: boolean, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (unreadOnly !== undefined) {
                localVarQueryParameter['unread_only'] = unreadOnly;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific notification
         * @summary Get Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNotificationById: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('fetchNotificationById', 'notificationId', notificationId)
            const localVarPath = `/api/notifications/{notification_id}`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all notifications for an organization
         * @summary Get Organization Notifications
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOrganizationNotifications: async (organizationId: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchOrganizationNotifications', 'organizationId', organizationId)
            const localVarPath = `/api/notifications/organization/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get count of unread notifications for the current user
         * @summary Get Unread Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUnreadNotificationCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/unread-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark all notifications as read for the current user
         * @summary Mark All As Read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotificationsAsRead: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/mark-all-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a notification as read
         * @summary Mark Notification As Read
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsRead: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('markNotificationAsRead', 'notificationId', notificationId)
            const localVarPath = `/api/notifications/{notification_id}/read`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new notification
         * @summary Create Notification
         * @param {NotificationCreate} notificationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotification(notificationCreate: NotificationCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotification(notificationCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.createNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a notification
         * @summary Delete Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNotification(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNotification(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.deleteNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get notifications for the current user
         * @summary Get My Notifications
         * @param {boolean} [unreadOnly] Get only unread notifications
         * @param {number} [limit] Maximum number of notifications to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMyNotifications(unreadOnly?: boolean, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMyNotifications(unreadOnly, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.fetchMyNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific notification
         * @summary Get Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchNotificationById(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchNotificationById(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.fetchNotificationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all notifications for an organization
         * @summary Get Organization Notifications
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchOrganizationNotifications(organizationId: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchOrganizationNotifications(organizationId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.fetchOrganizationNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get count of unread notifications for the current user
         * @summary Get Unread Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchUnreadNotificationCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnreadCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchUnreadNotificationCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.fetchUnreadNotificationCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark all notifications as read for the current user
         * @summary Mark All As Read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAllNotificationsAsRead(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkAllReadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAllNotificationsAsRead(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.markAllNotificationsAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark a notification as read
         * @summary Mark Notification As Read
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationAsRead(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationAsRead(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.markNotificationAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * Create a new notification
         * @summary Create Notification
         * @param {NotificationCreate} notificationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(notificationCreate: NotificationCreate, options?: RawAxiosRequestConfig): AxiosPromise<NotificationResponse> {
            return localVarFp.createNotification(notificationCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a notification
         * @summary Delete Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(notificationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteNotification(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get notifications for the current user
         * @summary Get My Notifications
         * @param {boolean} [unreadOnly] Get only unread notifications
         * @param {number} [limit] Maximum number of notifications to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMyNotifications(unreadOnly?: boolean, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationResponse>> {
            return localVarFp.fetchMyNotifications(unreadOnly, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific notification
         * @summary Get Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNotificationById(notificationId: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationResponse> {
            return localVarFp.fetchNotificationById(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all notifications for an organization
         * @summary Get Organization Notifications
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOrganizationNotifications(organizationId: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationResponse>> {
            return localVarFp.fetchOrganizationNotifications(organizationId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get count of unread notifications for the current user
         * @summary Get Unread Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUnreadNotificationCount(options?: RawAxiosRequestConfig): AxiosPromise<UnreadCountResponse> {
            return localVarFp.fetchUnreadNotificationCount(options).then((request) => request(axios, basePath));
        },
        /**
         * Mark all notifications as read for the current user
         * @summary Mark All As Read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotificationsAsRead(options?: RawAxiosRequestConfig): AxiosPromise<MarkAllReadResponse> {
            return localVarFp.markAllNotificationsAsRead(options).then((request) => request(axios, basePath));
        },
        /**
         * Mark a notification as read
         * @summary Mark Notification As Read
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsRead(notificationId: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationResponse> {
            return localVarFp.markNotificationAsRead(notificationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 */
export class NotificationsApi extends BaseAPI {
    /**
     * Create a new notification
     * @summary Create Notification
     * @param {NotificationCreate} notificationCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createNotification(notificationCreate: NotificationCreate, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).createNotification(notificationCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a notification
     * @summary Delete Notification
     * @param {string} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteNotification(notificationId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).deleteNotification(notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get notifications for the current user
     * @summary Get My Notifications
     * @param {boolean} [unreadOnly] Get only unread notifications
     * @param {number} [limit] Maximum number of notifications to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchMyNotifications(unreadOnly?: boolean, limit?: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).fetchMyNotifications(unreadOnly, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific notification
     * @summary Get Notification
     * @param {string} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchNotificationById(notificationId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).fetchNotificationById(notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all notifications for an organization
     * @summary Get Organization Notifications
     * @param {string} organizationId 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchOrganizationNotifications(organizationId: string, limit?: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).fetchOrganizationNotifications(organizationId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get count of unread notifications for the current user
     * @summary Get Unread Count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchUnreadNotificationCount(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).fetchUnreadNotificationCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark all notifications as read for the current user
     * @summary Mark All As Read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markAllNotificationsAsRead(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).markAllNotificationsAsRead(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark a notification as read
     * @summary Mark Notification As Read
     * @param {string} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markNotificationAsRead(notificationId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).markNotificationAsRead(notificationId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NzisApi - axios parameter creator
 */
export const NzisApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/cancel/ Request: CreateNZISedentalTreatmentRequest Returns: DentalTreatmentCancelResponse
         * @summary Cancel Nzis Edental Treatment
         * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelNZISedentalTreatment: async (createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNZISedentalTreatmentRequest' is not null or undefined
            assertParamExists('cancelNZISedentalTreatment', 'createNZISedentalTreatmentRequest', createNZISedentalTreatmentRequest)
            const localVarPath = `/api/nzis/edental/record/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNZISedentalTreatmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate XML for cancelling dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/cancel/xml/ Request: DentalTreatmentCancelRequest Returns: XML string
         * @summary Cancel Nzis Edental Treatment Xml
         * @param {DentalTreatmentCancelRequest} dentalTreatmentCancelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelNZISedentalTreatmentXml: async (dentalTreatmentCancelRequest: DentalTreatmentCancelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dentalTreatmentCancelRequest' is not null or undefined
            assertParamExists('cancelNZISedentalTreatmentXml', 'dentalTreatmentCancelRequest', dentalTreatmentCancelRequest)
            const localVarPath = `/api/nzis/edental/record/cancel/xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dentalTreatmentCancelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Open new dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/open/ Request: CreateNZISedentalTreatmentRequest Returns: DentalTreatmentOpenResponse with NRN
         * @summary Create Nzis Edental Treatment
         * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNZISedentalTreatment: async (createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNZISedentalTreatmentRequest' is not null or undefined
            assertParamExists('createNZISedentalTreatment', 'createNZISedentalTreatmentRequest', createNZISedentalTreatmentRequest)
            const localVarPath = `/api/nzis/edental/record/open`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNZISedentalTreatmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate XML for opening dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/open/xml/ Request: DentalTreatmentOpenRequest Returns: XML string
         * @summary Create Nzis Edental Treatment Xml
         * @param {DentalTreatmentOpenRequest} dentalTreatmentOpenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNZISedentalTreatmentXml: async (dentalTreatmentOpenRequest: DentalTreatmentOpenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dentalTreatmentOpenRequest' is not null or undefined
            assertParamExists('createNZISedentalTreatmentXml', 'dentalTreatmentOpenRequest', dentalTreatmentOpenRequest)
            const localVarPath = `/api/nzis/edental/record/open/xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dentalTreatmentOpenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Augment/edit existing dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/augment/ Request: CreateNZISedentalTreatmentRequest Returns: DentalTreatmentAugmentResponse
         * @summary Edit Nzis Edental Treatment
         * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNZISedentalTreatment: async (createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNZISedentalTreatmentRequest' is not null or undefined
            assertParamExists('editNZISedentalTreatment', 'createNZISedentalTreatmentRequest', createNZISedentalTreatmentRequest)
            const localVarPath = `/api/nzis/edental/record/augment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNZISedentalTreatmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate XML for augmenting dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/augment/xml/ Request: DentalTreatmentAugmentRequest Returns: XML string
         * @summary Edit Nzis Edental Treatment Xml
         * @param {DentalTreatmentAugmentRequest} dentalTreatmentAugmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNZISedentalTreatmentXml: async (dentalTreatmentAugmentRequest: DentalTreatmentAugmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dentalTreatmentAugmentRequest' is not null or undefined
            assertParamExists('editNZISedentalTreatmentXml', 'dentalTreatmentAugmentRequest', dentalTreatmentAugmentRequest)
            const localVarPath = `/api/nzis/edental/record/augment/xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dentalTreatmentAugmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of NZIS dental activity type codes  Matches Java: GET /nzis/dental-activity-types Returns: List<DentalActivityType>
         * @summary Fetch Dental Activity Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDentalActivityTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nzis/dental-activity-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch NZIS nomenclatures (JSON format)  Matches Java: POST /nzis/nomenclatures/all/get Request: String body (token or filter) Returns: NomenclatureResponse with nomenclature data
         * @summary Fetch Nzis Nomenclatures
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNZISNomenclatures: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('fetchNZISNomenclatures', 'body', body)
            const localVarPath = `/api/nzis/nomenclatures/all/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch NZIS nomenclatures (XML format)  Matches Java: POST /nzis/xml/nomenclatures/all/get Request: NomenclatureRequest Returns: XML string
         * @summary Fetch Nzis Nomenclatures Xml
         * @param {NomenclatureRequest} nomenclatureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNZISNomenclaturesXml: async (nomenclatureRequest: NomenclatureRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nomenclatureRequest' is not null or undefined
            assertParamExists('fetchNZISNomenclaturesXml', 'nomenclatureRequest', nomenclatureRequest)
            const localVarPath = `/api/nzis/xml/nomenclatures/all/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nomenclatureRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchange challenge for NZIS access token  Matches Java: POST /nzis/token/ Request: challenge string Returns: FetchNzisAccessToken200Response with token
         * @summary Fetch Nzis Access Token
         * @param {BodyFetchNzisAccessToken} bodyFetchNzisAccessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNzisAccessToken: async (bodyFetchNzisAccessToken: BodyFetchNzisAccessToken, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bodyFetchNzisAccessToken' is not null or undefined
            assertParamExists('fetchNzisAccessToken', 'bodyFetchNzisAccessToken', bodyFetchNzisAccessToken)
            const localVarPath = `/api/nzis/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bodyFetchNzisAccessToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get NZIS authentication challenge token  Matches Java: GET /nzis/token/ Returns: Challenge string for token exchange
         * @summary Fetch Nzis Challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNzisChallenge: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nzis/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of NZIS tooth condition codes  Matches Java: GET /nzis/tooth-condition-codes Returns: List<ToothConditionCode>
         * @summary Fetch Tooth Condition Codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchToothConditionCodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nzis/tooth-condition-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issue medical notice (excuse note) to NZIS  Matches Java: POST /nzis/commons/doctor/medical-notice-issue/ Request: CreateNZISedentalTreatmentRequest Returns: MedicalNoticeIssueResponse
         * @summary Issue Nzis Medical Notice
         * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueNZISmedicalNotice: async (createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNZISedentalTreatmentRequest' is not null or undefined
            assertParamExists('issueNZISmedicalNotice', 'createNZISedentalTreatmentRequest', createNZISedentalTreatmentRequest)
            const localVarPath = `/api/nzis/commons/doctor/medical-notice-issue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNZISedentalTreatmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate XML for medical notice issuance to NZIS  Matches Java: POST /nzis/commons/doctor/medical-notice-issue/xml/ Request: MedicalNoticeIssueRequest Returns: XML string
         * @summary Issue Nzis Medical Notice Xml
         * @param {MedicalNoticeIssueRequest} medicalNoticeIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueNZISmedicalNoticeXml: async (medicalNoticeIssueRequest: MedicalNoticeIssueRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalNoticeIssueRequest' is not null or undefined
            assertParamExists('issueNZISmedicalNoticeXml', 'medicalNoticeIssueRequest', medicalNoticeIssueRequest)
            const localVarPath = `/api/nzis/commons/doctor/medical-notice-issue/xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medicalNoticeIssueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NzisApi - functional programming interface
 */
export const NzisApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NzisApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/cancel/ Request: CreateNZISedentalTreatmentRequest Returns: DentalTreatmentCancelResponse
         * @summary Cancel Nzis Edental Treatment
         * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelNZISedentalTreatment(createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DentalTreatmentCancelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelNZISedentalTreatment(createNZISedentalTreatmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.cancelNZISedentalTreatment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate XML for cancelling dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/cancel/xml/ Request: DentalTreatmentCancelRequest Returns: XML string
         * @summary Cancel Nzis Edental Treatment Xml
         * @param {DentalTreatmentCancelRequest} dentalTreatmentCancelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelNZISedentalTreatmentXml(dentalTreatmentCancelRequest: DentalTreatmentCancelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelNZISedentalTreatmentXml(dentalTreatmentCancelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.cancelNZISedentalTreatmentXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Open new dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/open/ Request: CreateNZISedentalTreatmentRequest Returns: DentalTreatmentOpenResponse with NRN
         * @summary Create Nzis Edental Treatment
         * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNZISedentalTreatment(createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DentalTreatmentOpenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNZISedentalTreatment(createNZISedentalTreatmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.createNZISedentalTreatment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate XML for opening dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/open/xml/ Request: DentalTreatmentOpenRequest Returns: XML string
         * @summary Create Nzis Edental Treatment Xml
         * @param {DentalTreatmentOpenRequest} dentalTreatmentOpenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNZISedentalTreatmentXml(dentalTreatmentOpenRequest: DentalTreatmentOpenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNZISedentalTreatmentXml(dentalTreatmentOpenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.createNZISedentalTreatmentXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Augment/edit existing dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/augment/ Request: CreateNZISedentalTreatmentRequest Returns: DentalTreatmentAugmentResponse
         * @summary Edit Nzis Edental Treatment
         * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editNZISedentalTreatment(createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DentalTreatmentAugmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editNZISedentalTreatment(createNZISedentalTreatmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.editNZISedentalTreatment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate XML for augmenting dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/augment/xml/ Request: DentalTreatmentAugmentRequest Returns: XML string
         * @summary Edit Nzis Edental Treatment Xml
         * @param {DentalTreatmentAugmentRequest} dentalTreatmentAugmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editNZISedentalTreatmentXml(dentalTreatmentAugmentRequest: DentalTreatmentAugmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editNZISedentalTreatmentXml(dentalTreatmentAugmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.editNZISedentalTreatmentXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of NZIS dental activity type codes  Matches Java: GET /nzis/dental-activity-types Returns: List<DentalActivityType>
         * @summary Fetch Dental Activity Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchDentalActivityTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DentalActivityType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchDentalActivityTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.fetchDentalActivityTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch NZIS nomenclatures (JSON format)  Matches Java: POST /nzis/nomenclatures/all/get Request: String body (token or filter) Returns: NomenclatureResponse with nomenclature data
         * @summary Fetch Nzis Nomenclatures
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchNZISNomenclatures(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NomenclatureResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchNZISNomenclatures(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.fetchNZISNomenclatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch NZIS nomenclatures (XML format)  Matches Java: POST /nzis/xml/nomenclatures/all/get Request: NomenclatureRequest Returns: XML string
         * @summary Fetch Nzis Nomenclatures Xml
         * @param {NomenclatureRequest} nomenclatureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchNZISNomenclaturesXml(nomenclatureRequest: NomenclatureRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchNZISNomenclaturesXml(nomenclatureRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.fetchNZISNomenclaturesXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exchange challenge for NZIS access token  Matches Java: POST /nzis/token/ Request: challenge string Returns: FetchNzisAccessToken200Response with token
         * @summary Fetch Nzis Access Token
         * @param {BodyFetchNzisAccessToken} bodyFetchNzisAccessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchNzisAccessToken(bodyFetchNzisAccessToken: BodyFetchNzisAccessToken, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchNzisAccessTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchNzisAccessToken(bodyFetchNzisAccessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.fetchNzisAccessToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get NZIS authentication challenge token  Matches Java: GET /nzis/token/ Returns: Challenge string for token exchange
         * @summary Fetch Nzis Challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchNzisChallenge(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchNzisChallenge(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.fetchNzisChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of NZIS tooth condition codes  Matches Java: GET /nzis/tooth-condition-codes Returns: List<ToothConditionCode>
         * @summary Fetch Tooth Condition Codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchToothConditionCodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToothConditionCode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchToothConditionCodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.fetchToothConditionCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Issue medical notice (excuse note) to NZIS  Matches Java: POST /nzis/commons/doctor/medical-notice-issue/ Request: CreateNZISedentalTreatmentRequest Returns: MedicalNoticeIssueResponse
         * @summary Issue Nzis Medical Notice
         * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueNZISmedicalNotice(createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MedicalNoticeIssueResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueNZISmedicalNotice(createNZISedentalTreatmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.issueNZISmedicalNotice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate XML for medical notice issuance to NZIS  Matches Java: POST /nzis/commons/doctor/medical-notice-issue/xml/ Request: MedicalNoticeIssueRequest Returns: XML string
         * @summary Issue Nzis Medical Notice Xml
         * @param {MedicalNoticeIssueRequest} medicalNoticeIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueNZISmedicalNoticeXml(medicalNoticeIssueRequest: MedicalNoticeIssueRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueNZISmedicalNoticeXml(medicalNoticeIssueRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NzisApi.issueNZISmedicalNoticeXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NzisApi - factory interface
 */
export const NzisApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NzisApiFp(configuration)
    return {
        /**
         * Cancel dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/cancel/ Request: CreateNZISedentalTreatmentRequest Returns: DentalTreatmentCancelResponse
         * @summary Cancel Nzis Edental Treatment
         * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelNZISedentalTreatment(createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<DentalTreatmentCancelResponse> {
            return localVarFp.cancelNZISedentalTreatment(createNZISedentalTreatmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate XML for cancelling dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/cancel/xml/ Request: DentalTreatmentCancelRequest Returns: XML string
         * @summary Cancel Nzis Edental Treatment Xml
         * @param {DentalTreatmentCancelRequest} dentalTreatmentCancelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelNZISedentalTreatmentXml(dentalTreatmentCancelRequest: DentalTreatmentCancelRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.cancelNZISedentalTreatmentXml(dentalTreatmentCancelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Open new dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/open/ Request: CreateNZISedentalTreatmentRequest Returns: DentalTreatmentOpenResponse with NRN
         * @summary Create Nzis Edental Treatment
         * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNZISedentalTreatment(createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<DentalTreatmentOpenResponse> {
            return localVarFp.createNZISedentalTreatment(createNZISedentalTreatmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate XML for opening dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/open/xml/ Request: DentalTreatmentOpenRequest Returns: XML string
         * @summary Create Nzis Edental Treatment Xml
         * @param {DentalTreatmentOpenRequest} dentalTreatmentOpenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNZISedentalTreatmentXml(dentalTreatmentOpenRequest: DentalTreatmentOpenRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createNZISedentalTreatmentXml(dentalTreatmentOpenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Augment/edit existing dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/augment/ Request: CreateNZISedentalTreatmentRequest Returns: DentalTreatmentAugmentResponse
         * @summary Edit Nzis Edental Treatment
         * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNZISedentalTreatment(createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<DentalTreatmentAugmentResponse> {
            return localVarFp.editNZISedentalTreatment(createNZISedentalTreatmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate XML for augmenting dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/augment/xml/ Request: DentalTreatmentAugmentRequest Returns: XML string
         * @summary Edit Nzis Edental Treatment Xml
         * @param {DentalTreatmentAugmentRequest} dentalTreatmentAugmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNZISedentalTreatmentXml(dentalTreatmentAugmentRequest: DentalTreatmentAugmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.editNZISedentalTreatmentXml(dentalTreatmentAugmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of NZIS dental activity type codes  Matches Java: GET /nzis/dental-activity-types Returns: List<DentalActivityType>
         * @summary Fetch Dental Activity Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDentalActivityTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<DentalActivityType>> {
            return localVarFp.fetchDentalActivityTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch NZIS nomenclatures (JSON format)  Matches Java: POST /nzis/nomenclatures/all/get Request: String body (token or filter) Returns: NomenclatureResponse with nomenclature data
         * @summary Fetch Nzis Nomenclatures
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNZISNomenclatures(body: string, options?: RawAxiosRequestConfig): AxiosPromise<NomenclatureResponse> {
            return localVarFp.fetchNZISNomenclatures(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch NZIS nomenclatures (XML format)  Matches Java: POST /nzis/xml/nomenclatures/all/get Request: NomenclatureRequest Returns: XML string
         * @summary Fetch Nzis Nomenclatures Xml
         * @param {NomenclatureRequest} nomenclatureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNZISNomenclaturesXml(nomenclatureRequest: NomenclatureRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.fetchNZISNomenclaturesXml(nomenclatureRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Exchange challenge for NZIS access token  Matches Java: POST /nzis/token/ Request: challenge string Returns: FetchNzisAccessToken200Response with token
         * @summary Fetch Nzis Access Token
         * @param {BodyFetchNzisAccessToken} bodyFetchNzisAccessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNzisAccessToken(bodyFetchNzisAccessToken: BodyFetchNzisAccessToken, options?: RawAxiosRequestConfig): AxiosPromise<FetchNzisAccessTokenResponse> {
            return localVarFp.fetchNzisAccessToken(bodyFetchNzisAccessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get NZIS authentication challenge token  Matches Java: GET /nzis/token/ Returns: Challenge string for token exchange
         * @summary Fetch Nzis Challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNzisChallenge(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.fetchNzisChallenge(options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of NZIS tooth condition codes  Matches Java: GET /nzis/tooth-condition-codes Returns: List<ToothConditionCode>
         * @summary Fetch Tooth Condition Codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchToothConditionCodes(options?: RawAxiosRequestConfig): AxiosPromise<Array<ToothConditionCode>> {
            return localVarFp.fetchToothConditionCodes(options).then((request) => request(axios, basePath));
        },
        /**
         * Issue medical notice (excuse note) to NZIS  Matches Java: POST /nzis/commons/doctor/medical-notice-issue/ Request: CreateNZISedentalTreatmentRequest Returns: MedicalNoticeIssueResponse
         * @summary Issue Nzis Medical Notice
         * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueNZISmedicalNotice(createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<MedicalNoticeIssueResponse> {
            return localVarFp.issueNZISmedicalNotice(createNZISedentalTreatmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate XML for medical notice issuance to NZIS  Matches Java: POST /nzis/commons/doctor/medical-notice-issue/xml/ Request: MedicalNoticeIssueRequest Returns: XML string
         * @summary Issue Nzis Medical Notice Xml
         * @param {MedicalNoticeIssueRequest} medicalNoticeIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueNZISmedicalNoticeXml(medicalNoticeIssueRequest: MedicalNoticeIssueRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.issueNZISmedicalNoticeXml(medicalNoticeIssueRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NzisApi - object-oriented interface
 */
export class NzisApi extends BaseAPI {
    /**
     * Cancel dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/cancel/ Request: CreateNZISedentalTreatmentRequest Returns: DentalTreatmentCancelResponse
     * @summary Cancel Nzis Edental Treatment
     * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelNZISedentalTreatment(createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).cancelNZISedentalTreatment(createNZISedentalTreatmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate XML for cancelling dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/cancel/xml/ Request: DentalTreatmentCancelRequest Returns: XML string
     * @summary Cancel Nzis Edental Treatment Xml
     * @param {DentalTreatmentCancelRequest} dentalTreatmentCancelRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelNZISedentalTreatmentXml(dentalTreatmentCancelRequest: DentalTreatmentCancelRequest, options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).cancelNZISedentalTreatmentXml(dentalTreatmentCancelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Open new dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/open/ Request: CreateNZISedentalTreatmentRequest Returns: DentalTreatmentOpenResponse with NRN
     * @summary Create Nzis Edental Treatment
     * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createNZISedentalTreatment(createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).createNZISedentalTreatment(createNZISedentalTreatmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate XML for opening dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/open/xml/ Request: DentalTreatmentOpenRequest Returns: XML string
     * @summary Create Nzis Edental Treatment Xml
     * @param {DentalTreatmentOpenRequest} dentalTreatmentOpenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createNZISedentalTreatmentXml(dentalTreatmentOpenRequest: DentalTreatmentOpenRequest, options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).createNZISedentalTreatmentXml(dentalTreatmentOpenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Augment/edit existing dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/augment/ Request: CreateNZISedentalTreatmentRequest Returns: DentalTreatmentAugmentResponse
     * @summary Edit Nzis Edental Treatment
     * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public editNZISedentalTreatment(createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).editNZISedentalTreatment(createNZISedentalTreatmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate XML for augmenting dental treatment record in NZIS  Matches Java: POST /nzis/edental/record/augment/xml/ Request: DentalTreatmentAugmentRequest Returns: XML string
     * @summary Edit Nzis Edental Treatment Xml
     * @param {DentalTreatmentAugmentRequest} dentalTreatmentAugmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public editNZISedentalTreatmentXml(dentalTreatmentAugmentRequest: DentalTreatmentAugmentRequest, options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).editNZISedentalTreatmentXml(dentalTreatmentAugmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of NZIS dental activity type codes  Matches Java: GET /nzis/dental-activity-types Returns: List<DentalActivityType>
     * @summary Fetch Dental Activity Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchDentalActivityTypes(options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).fetchDentalActivityTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch NZIS nomenclatures (JSON format)  Matches Java: POST /nzis/nomenclatures/all/get Request: String body (token or filter) Returns: NomenclatureResponse with nomenclature data
     * @summary Fetch Nzis Nomenclatures
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchNZISNomenclatures(body: string, options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).fetchNZISNomenclatures(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch NZIS nomenclatures (XML format)  Matches Java: POST /nzis/xml/nomenclatures/all/get Request: NomenclatureRequest Returns: XML string
     * @summary Fetch Nzis Nomenclatures Xml
     * @param {NomenclatureRequest} nomenclatureRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchNZISNomenclaturesXml(nomenclatureRequest: NomenclatureRequest, options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).fetchNZISNomenclaturesXml(nomenclatureRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exchange challenge for NZIS access token  Matches Java: POST /nzis/token/ Request: challenge string Returns: FetchNzisAccessToken200Response with token
     * @summary Fetch Nzis Access Token
     * @param {BodyFetchNzisAccessToken} bodyFetchNzisAccessToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchNzisAccessToken(bodyFetchNzisAccessToken: BodyFetchNzisAccessToken, options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).fetchNzisAccessToken(bodyFetchNzisAccessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get NZIS authentication challenge token  Matches Java: GET /nzis/token/ Returns: Challenge string for token exchange
     * @summary Fetch Nzis Challenge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchNzisChallenge(options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).fetchNzisChallenge(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of NZIS tooth condition codes  Matches Java: GET /nzis/tooth-condition-codes Returns: List<ToothConditionCode>
     * @summary Fetch Tooth Condition Codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchToothConditionCodes(options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).fetchToothConditionCodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issue medical notice (excuse note) to NZIS  Matches Java: POST /nzis/commons/doctor/medical-notice-issue/ Request: CreateNZISedentalTreatmentRequest Returns: MedicalNoticeIssueResponse
     * @summary Issue Nzis Medical Notice
     * @param {CreateNZISedentalTreatmentRequest} createNZISedentalTreatmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public issueNZISmedicalNotice(createNZISedentalTreatmentRequest: CreateNZISedentalTreatmentRequest, options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).issueNZISmedicalNotice(createNZISedentalTreatmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate XML for medical notice issuance to NZIS  Matches Java: POST /nzis/commons/doctor/medical-notice-issue/xml/ Request: MedicalNoticeIssueRequest Returns: XML string
     * @summary Issue Nzis Medical Notice Xml
     * @param {MedicalNoticeIssueRequest} medicalNoticeIssueRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public issueNZISmedicalNoticeXml(medicalNoticeIssueRequest: MedicalNoticeIssueRequest, options?: RawAxiosRequestConfig) {
        return NzisApiFp(this.configuration).issueNZISmedicalNoticeXml(medicalNoticeIssueRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizationsApi - axios parameter creator
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create feature (Admin only)
         * @summary Create Feature
         * @param {FeatureCreate} featureCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeature: async (featureCreate: FeatureCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureCreate' is not null or undefined
            assertParamExists('createFeature', 'featureCreate', featureCreate)
            const localVarPath = `/api/organizations/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featureCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new organization (Admin only) with audit logging
         * @summary Create Organization
         * @param {OrganizationCreate} organizationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization: async (organizationCreate: OrganizationCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationCreate' is not null or undefined
            assertParamExists('createOrganization', 'organizationCreate', organizationCreate)
            const localVarPath = `/api/organizations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Self-serve: create a new organization and become its CLINIC_ADMIN.  Any authenticated non-patient user can call this endpoint.  It is distinct from POST /organizations/ (which is PLATFORM_ADMINISTRATOR-only).  Behaviour (single atomic transaction): • Create an Organization from the supplied payload. • Seed default statuses, treatments, procedures and conditions. • Create an OrganizationMembership for the caller with:     role   = CLINIC_ADMIN     status = active • Preserve all existing memberships — no other memberships are touched. • Update users.organization_id to the new org (last-active-org shim).  Returns the created organization plus a new JWT already scoped to the new org.  The frontend can use the token immediately without calling /api/auth/select-org separately. Authorization driven by OrganizationMembership.role via get_org_context().
         * @summary Create Organization Self
         * @param {OrganizationCreate} organizationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationSelf: async (organizationCreate: OrganizationCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationCreate' is not null or undefined
            assertParamExists('createOrganizationSelf', 'organizationCreate', organizationCreate)
            const localVarPath = `/api/organizations/self`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create subscription plan (Admin only)
         * @summary Create Plan
         * @param {PlanCreate} planCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlan: async (planCreate: PlanCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planCreate' is not null or undefined
            assertParamExists('createPlan', 'planCreate', planCreate)
            const localVarPath = `/api/organizations/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(planCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete feature (Admin only)
         * @summary Delete Feature
         * @param {string} featureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeature: async (featureId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('deleteFeature', 'featureId', featureId)
            const localVarPath = `/api/organizations/features/{feature_id}`
                .replace(`{${"feature_id"}}`, encodeURIComponent(String(featureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an organization (Admin only) with audit logging  Maps to Java endpoint: DELETE /organizations/{id} Returns 200 OK to match Java\'s ResponseEntity.ok().build() behavior
         * @summary Delete Organization
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganization: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deleteOrganization', 'orgId', orgId)
            const localVarPath = `/api/organizations/{org_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete subscription plan (Admin only)
         * @summary Delete Plan
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlan: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('deletePlan', 'planId', planId)
            const localVarPath = `/api/organizations/plans/{plan_id}`
                .replace(`{${"plan_id"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all features
         * @summary Fetch All Features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllFeatures: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all organizations with optional keyword search  Maps to Java endpoint: GET /organizations?keyword=search_term - PLATFORM_ADMINISTRATOR: Can see all organizations (with optional keyword filter) - Other roles: Can only see their own organization Authorization driven by OrganizationMembership via get_org_context().
         * @summary Fetch All Organizations
         * @param {string | null} [keyword] Search keyword for organization name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllOrganizations: async (keyword?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all subscription plans
         * @summary Fetch All Plans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllPlans: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch organization avatar/logo  Maps to Java endpoint: GET /organizations/{id}/avatar/ from OrganizationController.fetchOrganizationAvatar()  Returns the organization\'s avatar image file. Authorization: PLATFORM_ADMINISTRATOR or CLINIC_ADMIN
         * @summary Fetch Organization Avatar
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOrganizationAvatar: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchOrganizationAvatar', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organization_id}/avatar`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'image/jpeg,image/png,image/gif,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch organization by ID
         * @summary Fetch Organization
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOrganizationById: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('fetchOrganizationById', 'orgId', orgId)
            const localVarPath = `/api/organizations/{org_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch organization by name  Maps to Java endpoint: GET /organizations/by-name/ Returns organization matching the specified name.
         * @summary Fetch Organization By Name
         * @param {string} organizationName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOrganizationByName: async (organizationName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationName' is not null or undefined
            assertParamExists('fetchOrganizationByName', 'organizationName', organizationName)
            const localVarPath = `/api/organizations/by-name/{organization_name}`
                .replace(`{${"organization_name"}}`, encodeURIComponent(String(organizationName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get current organization subscription.  When Stripe is disabled, auto-provisions an ACTIVE PAID subscription for orgs that don\'t have one yet (self-healing for existing orgs created before seeding).
         * @summary Get Current Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSubscription: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/subscriptions/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get organization messaging settings.  Returns the stored row for the org, or safe opt-in defaults if no row exists yet (email_enabled=False, default_channel=\'none\').
         * @summary Get Messaging Settings
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMessagingSettings: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrganizationMessagingSettings', 'orgId', orgId)
            const localVarPath = `/api/organizations/{org_id}/messaging-settings`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant subscription to organization (Platform Admin only) - Internal use
         * @summary Grant Subscription
         * @param {SubscriptionCreate} subscriptionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantSubscription: async (subscriptionCreate: SubscriptionCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionCreate' is not null or undefined
            assertParamExists('grantSubscription', 'subscriptionCreate', subscriptionCreate)
            const localVarPath = `/api/organizations/subscriptions/grant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a test SMS or WhatsApp message using the org\'s stored Twilio credentials.  Returns {\"success\": true/false, \"error\": \"...\"}.
         * @summary Test Send Message
         * @param {string} orgId 
         * @param {TestSmsRequest} testSmsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSendMessage: async (orgId: string, testSmsRequest: TestSmsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('testSendMessage', 'orgId', orgId)
            // verify required parameter 'testSmsRequest' is not null or undefined
            assertParamExists('testSendMessage', 'testSmsRequest', testSmsRequest)
            const localVarPath = `/api/organizations/{org_id}/messaging-settings/test-send`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testSmsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update organization information (Platform Admin or Clinic Admin for own org)
         * @summary Update Organization
         * @param {string} orgId 
         * @param {OrganizationUpdate} organizationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization: async (orgId: string, organizationUpdate: OrganizationUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateOrganization', 'orgId', orgId)
            // verify required parameter 'organizationUpdate' is not null or undefined
            assertParamExists('updateOrganization', 'organizationUpdate', organizationUpdate)
            const localVarPath = `/api/organizations/{org_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or update organization messaging settings (upsert).  Only CLINIC_ADMIN and PLATFORM_ADMINISTRATOR may call this endpoint.
         * @summary Update Messaging Settings
         * @param {string} orgId 
         * @param {MessagingSettingsUpdate} messagingSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationMessagingSettings: async (orgId: string, messagingSettingsUpdate: MessagingSettingsUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateOrganizationMessagingSettings', 'orgId', orgId)
            // verify required parameter 'messagingSettingsUpdate' is not null or undefined
            assertParamExists('updateOrganizationMessagingSettings', 'messagingSettingsUpdate', messagingSettingsUpdate)
            const localVarPath = `/api/organizations/{org_id}/messaging-settings`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messagingSettingsUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update subscription plan (Admin only)
         * @summary Update Plan
         * @param {string} planId 
         * @param {PlanUpdate} planUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlan: async (planId: string, planUpdate: PlanUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('updatePlan', 'planId', planId)
            // verify required parameter 'planUpdate' is not null or undefined
            assertParamExists('updatePlan', 'planUpdate', planUpdate)
            const localVarPath = `/api/organizations/plans/{plan_id}`
                .replace(`{${"plan_id"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(planUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update subscription (Admin only)
         * @summary Update Subscription
         * @param {string} subscriptionId 
         * @param {SubscriptionUpdate} subscriptionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription: async (subscriptionId: string, subscriptionUpdate: SubscriptionUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('updateSubscription', 'subscriptionId', subscriptionId)
            // verify required parameter 'subscriptionUpdate' is not null or undefined
            assertParamExists('updateSubscription', 'subscriptionUpdate', subscriptionUpdate)
            const localVarPath = `/api/organizations/subscriptions/{subscription_id}`
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload avatar/logo for organization (Platform Admin or Clinic Admin for own org)
         * @summary Upload Organization Avatar
         * @param {string} orgId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadOrganizationAvatar: async (orgId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('uploadOrganizationAvatar', 'orgId', orgId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadOrganizationAvatar', 'file', file)
            const localVarPath = `/api/organizations/{org_id}/avatar`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify stored Twilio credentials by calling the Twilio Accounts API.  Returns {\"verified\": true/false, \"error\": \"...\"}. On success, sets twilio_verified_at on the settings row.
         * @summary Verify Twilio Credentials
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTwilioCredentials: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('verifyTwilioCredentials', 'orgId', orgId)
            const localVarPath = `/api/organizations/{org_id}/messaging-settings/verify-twilio`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create feature (Admin only)
         * @summary Create Feature
         * @param {FeatureCreate} featureCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFeature(featureCreate: FeatureCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFeature(featureCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.createFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new organization (Admin only) with audit logging
         * @summary Create Organization
         * @param {OrganizationCreate} organizationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganization(organizationCreate: OrganizationCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganization(organizationCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.createOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Self-serve: create a new organization and become its CLINIC_ADMIN.  Any authenticated non-patient user can call this endpoint.  It is distinct from POST /organizations/ (which is PLATFORM_ADMINISTRATOR-only).  Behaviour (single atomic transaction): • Create an Organization from the supplied payload. • Seed default statuses, treatments, procedures and conditions. • Create an OrganizationMembership for the caller with:     role   = CLINIC_ADMIN     status = active • Preserve all existing memberships — no other memberships are touched. • Update users.organization_id to the new org (last-active-org shim).  Returns the created organization plus a new JWT already scoped to the new org.  The frontend can use the token immediately without calling /api/auth/select-org separately. Authorization driven by OrganizationMembership.role via get_org_context().
         * @summary Create Organization Self
         * @param {OrganizationCreate} organizationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganizationSelf(organizationCreate: OrganizationCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationSelfCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganizationSelf(organizationCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.createOrganizationSelf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create subscription plan (Admin only)
         * @summary Create Plan
         * @param {PlanCreate} planCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlan(planCreate: PlanCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlan(planCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.createPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete feature (Admin only)
         * @summary Delete Feature
         * @param {string} featureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFeature(featureId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFeature(featureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.deleteFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an organization (Admin only) with audit logging  Maps to Java endpoint: DELETE /organizations/{id} Returns 200 OK to match Java\'s ResponseEntity.ok().build() behavior
         * @summary Delete Organization
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganization(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganization(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.deleteOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete subscription plan (Admin only)
         * @summary Delete Plan
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlan(planId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlan(planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.deletePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all features
         * @summary Fetch All Features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllFeatures(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllFeatures(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.fetchAllFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all organizations with optional keyword search  Maps to Java endpoint: GET /organizations?keyword=search_term - PLATFORM_ADMINISTRATOR: Can see all organizations (with optional keyword filter) - Other roles: Can only see their own organization Authorization driven by OrganizationMembership via get_org_context().
         * @summary Fetch All Organizations
         * @param {string | null} [keyword] Search keyword for organization name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllOrganizations(keyword?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Organization>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllOrganizations(keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.fetchAllOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all subscription plans
         * @summary Fetch All Plans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllPlans(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllPlans(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.fetchAllPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch organization avatar/logo  Maps to Java endpoint: GET /organizations/{id}/avatar/ from OrganizationController.fetchOrganizationAvatar()  Returns the organization\'s avatar image file. Authorization: PLATFORM_ADMINISTRATOR or CLINIC_ADMIN
         * @summary Fetch Organization Avatar
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchOrganizationAvatar(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchOrganizationAvatar(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.fetchOrganizationAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch organization by ID
         * @summary Fetch Organization
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchOrganizationById(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchOrganizationById(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.fetchOrganizationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch organization by name  Maps to Java endpoint: GET /organizations/by-name/ Returns organization matching the specified name.
         * @summary Fetch Organization By Name
         * @param {string} organizationName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchOrganizationByName(organizationName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchOrganizationByName(organizationName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.fetchOrganizationByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get current organization subscription.  When Stripe is disabled, auto-provisions an ACTIVE PAID subscription for orgs that don\'t have one yet (self-healing for existing orgs created before seeding).
         * @summary Get Current Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentSubscription(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentSubscription(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getCurrentSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get organization messaging settings.  Returns the stored row for the org, or safe opt-in defaults if no row exists yet (email_enabled=False, default_channel=\'none\').
         * @summary Get Messaging Settings
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationMessagingSettings(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationMessagingSettings(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationMessagingSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Grant subscription to organization (Platform Admin only) - Internal use
         * @summary Grant Subscription
         * @param {SubscriptionCreate} subscriptionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantSubscription(subscriptionCreate: SubscriptionCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantSubscription(subscriptionCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.grantSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a test SMS or WhatsApp message using the org\'s stored Twilio credentials.  Returns {\"success\": true/false, \"error\": \"...\"}.
         * @summary Test Send Message
         * @param {string} orgId 
         * @param {TestSmsRequest} testSmsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testSendMessage(orgId: string, testSmsRequest: TestSmsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testSendMessage(orgId, testSmsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.testSendMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update organization information (Platform Admin or Clinic Admin for own org)
         * @summary Update Organization
         * @param {string} orgId 
         * @param {OrganizationUpdate} organizationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganization(orgId: string, organizationUpdate: OrganizationUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganization(orgId, organizationUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.updateOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create or update organization messaging settings (upsert).  Only CLINIC_ADMIN and PLATFORM_ADMINISTRATOR may call this endpoint.
         * @summary Update Messaging Settings
         * @param {string} orgId 
         * @param {MessagingSettingsUpdate} messagingSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationMessagingSettings(orgId: string, messagingSettingsUpdate: MessagingSettingsUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagingSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationMessagingSettings(orgId, messagingSettingsUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.updateOrganizationMessagingSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update subscription plan (Admin only)
         * @summary Update Plan
         * @param {string} planId 
         * @param {PlanUpdate} planUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlan(planId: string, planUpdate: PlanUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlan(planId, planUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.updatePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update subscription (Admin only)
         * @summary Update Subscription
         * @param {string} subscriptionId 
         * @param {SubscriptionUpdate} subscriptionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscription(subscriptionId: string, subscriptionUpdate: SubscriptionUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscription(subscriptionId, subscriptionUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.updateSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload avatar/logo for organization (Platform Admin or Clinic Admin for own org)
         * @summary Upload Organization Avatar
         * @param {string} orgId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadOrganizationAvatar(orgId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadOrganizationAvatar(orgId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.uploadOrganizationAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify stored Twilio credentials by calling the Twilio Accounts API.  Returns {\"verified\": true/false, \"error\": \"...\"}. On success, sets twilio_verified_at on the settings row.
         * @summary Verify Twilio Credentials
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyTwilioCredentials(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyTwilioCredentials(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.verifyTwilioCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationsApi - factory interface
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsApiFp(configuration)
    return {
        /**
         * Create feature (Admin only)
         * @summary Create Feature
         * @param {FeatureCreate} featureCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeature(featureCreate: FeatureCreate, options?: RawAxiosRequestConfig): AxiosPromise<FeatureResponse> {
            return localVarFp.createFeature(featureCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new organization (Admin only) with audit logging
         * @summary Create Organization
         * @param {OrganizationCreate} organizationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization(organizationCreate: OrganizationCreate, options?: RawAxiosRequestConfig): AxiosPromise<Organization> {
            return localVarFp.createOrganization(organizationCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Self-serve: create a new organization and become its CLINIC_ADMIN.  Any authenticated non-patient user can call this endpoint.  It is distinct from POST /organizations/ (which is PLATFORM_ADMINISTRATOR-only).  Behaviour (single atomic transaction): • Create an Organization from the supplied payload. • Seed default statuses, treatments, procedures and conditions. • Create an OrganizationMembership for the caller with:     role   = CLINIC_ADMIN     status = active • Preserve all existing memberships — no other memberships are touched. • Update users.organization_id to the new org (last-active-org shim).  Returns the created organization plus a new JWT already scoped to the new org.  The frontend can use the token immediately without calling /api/auth/select-org separately. Authorization driven by OrganizationMembership.role via get_org_context().
         * @summary Create Organization Self
         * @param {OrganizationCreate} organizationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationSelf(organizationCreate: OrganizationCreate, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationSelfCreateResponse> {
            return localVarFp.createOrganizationSelf(organizationCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create subscription plan (Admin only)
         * @summary Create Plan
         * @param {PlanCreate} planCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlan(planCreate: PlanCreate, options?: RawAxiosRequestConfig): AxiosPromise<PlanResponse> {
            return localVarFp.createPlan(planCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete feature (Admin only)
         * @summary Delete Feature
         * @param {string} featureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeature(featureId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFeature(featureId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an organization (Admin only) with audit logging  Maps to Java endpoint: DELETE /organizations/{id} Returns 200 OK to match Java\'s ResponseEntity.ok().build() behavior
         * @summary Delete Organization
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganization(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteOrganization(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete subscription plan (Admin only)
         * @summary Delete Plan
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlan(planId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePlan(planId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all features
         * @summary Fetch All Features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllFeatures(options?: RawAxiosRequestConfig): AxiosPromise<Array<FeatureResponse>> {
            return localVarFp.fetchAllFeatures(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all organizations with optional keyword search  Maps to Java endpoint: GET /organizations?keyword=search_term - PLATFORM_ADMINISTRATOR: Can see all organizations (with optional keyword filter) - Other roles: Can only see their own organization Authorization driven by OrganizationMembership via get_org_context().
         * @summary Fetch All Organizations
         * @param {string | null} [keyword] Search keyword for organization name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllOrganizations(keyword?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<Organization>> {
            return localVarFp.fetchAllOrganizations(keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all subscription plans
         * @summary Fetch All Plans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllPlans(options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanResponse>> {
            return localVarFp.fetchAllPlans(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch organization avatar/logo  Maps to Java endpoint: GET /organizations/{id}/avatar/ from OrganizationController.fetchOrganizationAvatar()  Returns the organization\'s avatar image file. Authorization: PLATFORM_ADMINISTRATOR or CLINIC_ADMIN
         * @summary Fetch Organization Avatar
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOrganizationAvatar(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.fetchOrganizationAvatar(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch organization by ID
         * @summary Fetch Organization
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOrganizationById(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<Organization> {
            return localVarFp.fetchOrganizationById(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch organization by name  Maps to Java endpoint: GET /organizations/by-name/ Returns organization matching the specified name.
         * @summary Fetch Organization By Name
         * @param {string} organizationName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOrganizationByName(organizationName: string, options?: RawAxiosRequestConfig): AxiosPromise<Organization> {
            return localVarFp.fetchOrganizationByName(organizationName, options).then((request) => request(axios, basePath));
        },
        /**
         * Get current organization subscription.  When Stripe is disabled, auto-provisions an ACTIVE PAID subscription for orgs that don\'t have one yet (self-healing for existing orgs created before seeding).
         * @summary Get Current Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSubscription(options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionResponse> {
            return localVarFp.getCurrentSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         * Get organization messaging settings.  Returns the stored row for the org, or safe opt-in defaults if no row exists yet (email_enabled=False, default_channel=\'none\').
         * @summary Get Messaging Settings
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMessagingSettings(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<MessagingSettingsResponse> {
            return localVarFp.getOrganizationMessagingSettings(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant subscription to organization (Platform Admin only) - Internal use
         * @summary Grant Subscription
         * @param {SubscriptionCreate} subscriptionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantSubscription(subscriptionCreate: SubscriptionCreate, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionResponse> {
            return localVarFp.grantSubscription(subscriptionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a test SMS or WhatsApp message using the org\'s stored Twilio credentials.  Returns {\"success\": true/false, \"error\": \"...\"}.
         * @summary Test Send Message
         * @param {string} orgId 
         * @param {TestSmsRequest} testSmsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSendMessage(orgId: string, testSmsRequest: TestSmsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.testSendMessage(orgId, testSmsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update organization information (Platform Admin or Clinic Admin for own org)
         * @summary Update Organization
         * @param {string} orgId 
         * @param {OrganizationUpdate} organizationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(orgId: string, organizationUpdate: OrganizationUpdate, options?: RawAxiosRequestConfig): AxiosPromise<Organization> {
            return localVarFp.updateOrganization(orgId, organizationUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or update organization messaging settings (upsert).  Only CLINIC_ADMIN and PLATFORM_ADMINISTRATOR may call this endpoint.
         * @summary Update Messaging Settings
         * @param {string} orgId 
         * @param {MessagingSettingsUpdate} messagingSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationMessagingSettings(orgId: string, messagingSettingsUpdate: MessagingSettingsUpdate, options?: RawAxiosRequestConfig): AxiosPromise<MessagingSettingsResponse> {
            return localVarFp.updateOrganizationMessagingSettings(orgId, messagingSettingsUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update subscription plan (Admin only)
         * @summary Update Plan
         * @param {string} planId 
         * @param {PlanUpdate} planUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlan(planId: string, planUpdate: PlanUpdate, options?: RawAxiosRequestConfig): AxiosPromise<PlanResponse> {
            return localVarFp.updatePlan(planId, planUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update subscription (Admin only)
         * @summary Update Subscription
         * @param {string} subscriptionId 
         * @param {SubscriptionUpdate} subscriptionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(subscriptionId: string, subscriptionUpdate: SubscriptionUpdate, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionResponse> {
            return localVarFp.updateSubscription(subscriptionId, subscriptionUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload avatar/logo for organization (Platform Admin or Clinic Admin for own org)
         * @summary Upload Organization Avatar
         * @param {string} orgId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadOrganizationAvatar(orgId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<Organization> {
            return localVarFp.uploadOrganizationAvatar(orgId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify stored Twilio credentials by calling the Twilio Accounts API.  Returns {\"verified\": true/false, \"error\": \"...\"}. On success, sets twilio_verified_at on the settings row.
         * @summary Verify Twilio Credentials
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTwilioCredentials(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.verifyTwilioCredentials(orgId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationsApi - object-oriented interface
 */
export class OrganizationsApi extends BaseAPI {
    /**
     * Create feature (Admin only)
     * @summary Create Feature
     * @param {FeatureCreate} featureCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createFeature(featureCreate: FeatureCreate, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).createFeature(featureCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new organization (Admin only) with audit logging
     * @summary Create Organization
     * @param {OrganizationCreate} organizationCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOrganization(organizationCreate: OrganizationCreate, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).createOrganization(organizationCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Self-serve: create a new organization and become its CLINIC_ADMIN.  Any authenticated non-patient user can call this endpoint.  It is distinct from POST /organizations/ (which is PLATFORM_ADMINISTRATOR-only).  Behaviour (single atomic transaction): • Create an Organization from the supplied payload. • Seed default statuses, treatments, procedures and conditions. • Create an OrganizationMembership for the caller with:     role   = CLINIC_ADMIN     status = active • Preserve all existing memberships — no other memberships are touched. • Update users.organization_id to the new org (last-active-org shim).  Returns the created organization plus a new JWT already scoped to the new org.  The frontend can use the token immediately without calling /api/auth/select-org separately. Authorization driven by OrganizationMembership.role via get_org_context().
     * @summary Create Organization Self
     * @param {OrganizationCreate} organizationCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOrganizationSelf(organizationCreate: OrganizationCreate, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).createOrganizationSelf(organizationCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create subscription plan (Admin only)
     * @summary Create Plan
     * @param {PlanCreate} planCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPlan(planCreate: PlanCreate, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).createPlan(planCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete feature (Admin only)
     * @summary Delete Feature
     * @param {string} featureId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFeature(featureId: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).deleteFeature(featureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an organization (Admin only) with audit logging  Maps to Java endpoint: DELETE /organizations/{id} Returns 200 OK to match Java\'s ResponseEntity.ok().build() behavior
     * @summary Delete Organization
     * @param {string} orgId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOrganization(orgId: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).deleteOrganization(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete subscription plan (Admin only)
     * @summary Delete Plan
     * @param {string} planId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePlan(planId: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).deletePlan(planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all features
     * @summary Fetch All Features
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllFeatures(options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).fetchAllFeatures(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all organizations with optional keyword search  Maps to Java endpoint: GET /organizations?keyword=search_term - PLATFORM_ADMINISTRATOR: Can see all organizations (with optional keyword filter) - Other roles: Can only see their own organization Authorization driven by OrganizationMembership via get_org_context().
     * @summary Fetch All Organizations
     * @param {string | null} [keyword] Search keyword for organization name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllOrganizations(keyword?: string | null, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).fetchAllOrganizations(keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all subscription plans
     * @summary Fetch All Plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllPlans(options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).fetchAllPlans(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch organization avatar/logo  Maps to Java endpoint: GET /organizations/{id}/avatar/ from OrganizationController.fetchOrganizationAvatar()  Returns the organization\'s avatar image file. Authorization: PLATFORM_ADMINISTRATOR or CLINIC_ADMIN
     * @summary Fetch Organization Avatar
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchOrganizationAvatar(organizationId: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).fetchOrganizationAvatar(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch organization by ID
     * @summary Fetch Organization
     * @param {string} orgId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchOrganizationById(orgId: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).fetchOrganizationById(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch organization by name  Maps to Java endpoint: GET /organizations/by-name/ Returns organization matching the specified name.
     * @summary Fetch Organization By Name
     * @param {string} organizationName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchOrganizationByName(organizationName: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).fetchOrganizationByName(organizationName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get current organization subscription.  When Stripe is disabled, auto-provisions an ACTIVE PAID subscription for orgs that don\'t have one yet (self-healing for existing orgs created before seeding).
     * @summary Get Current Subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentSubscription(options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getCurrentSubscription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get organization messaging settings.  Returns the stored row for the org, or safe opt-in defaults if no row exists yet (email_enabled=False, default_channel=\'none\').
     * @summary Get Messaging Settings
     * @param {string} orgId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationMessagingSettings(orgId: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationMessagingSettings(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant subscription to organization (Platform Admin only) - Internal use
     * @summary Grant Subscription
     * @param {SubscriptionCreate} subscriptionCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public grantSubscription(subscriptionCreate: SubscriptionCreate, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).grantSubscription(subscriptionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a test SMS or WhatsApp message using the org\'s stored Twilio credentials.  Returns {\"success\": true/false, \"error\": \"...\"}.
     * @summary Test Send Message
     * @param {string} orgId 
     * @param {TestSmsRequest} testSmsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public testSendMessage(orgId: string, testSmsRequest: TestSmsRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).testSendMessage(orgId, testSmsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update organization information (Platform Admin or Clinic Admin for own org)
     * @summary Update Organization
     * @param {string} orgId 
     * @param {OrganizationUpdate} organizationUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganization(orgId: string, organizationUpdate: OrganizationUpdate, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateOrganization(orgId, organizationUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or update organization messaging settings (upsert).  Only CLINIC_ADMIN and PLATFORM_ADMINISTRATOR may call this endpoint.
     * @summary Update Messaging Settings
     * @param {string} orgId 
     * @param {MessagingSettingsUpdate} messagingSettingsUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganizationMessagingSettings(orgId: string, messagingSettingsUpdate: MessagingSettingsUpdate, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateOrganizationMessagingSettings(orgId, messagingSettingsUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update subscription plan (Admin only)
     * @summary Update Plan
     * @param {string} planId 
     * @param {PlanUpdate} planUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePlan(planId: string, planUpdate: PlanUpdate, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updatePlan(planId, planUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update subscription (Admin only)
     * @summary Update Subscription
     * @param {string} subscriptionId 
     * @param {SubscriptionUpdate} subscriptionUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSubscription(subscriptionId: string, subscriptionUpdate: SubscriptionUpdate, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateSubscription(subscriptionId, subscriptionUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload avatar/logo for organization (Platform Admin or Clinic Admin for own org)
     * @summary Upload Organization Avatar
     * @param {string} orgId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadOrganizationAvatar(orgId: string, file: File, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).uploadOrganizationAvatar(orgId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify stored Twilio credentials by calling the Twilio Accounts API.  Returns {\"verified\": true/false, \"error\": \"...\"}. On success, sets twilio_verified_at on the settings row.
     * @summary Verify Twilio Credentials
     * @param {string} orgId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public verifyTwilioCredentials(orgId: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).verifyTwilioCredentials(orgId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientImportsApi - axios parameter creator
 */
export const PatientImportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Validate, create session, and commit manual quick-entry rows
         * @param {CommitManualRequest} commitManualRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitManualImport: async (commitManualRequest: CommitManualRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commitManualRequest' is not null or undefined
            assertParamExists('commitManualImport', 'commitManualRequest', commitManualRequest)
            const localVarPath = `/api/patient-imports/commit-manual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commitManualRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Commit all valid/warned rows in a patient import
         * @param {string} importId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitPatientImport: async (importId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('commitPatientImport', 'importId', importId)
            const localVarPath = `/api/patient-imports/{import_id}/commit`
                .replace(`{${"import_id"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download the canonical patient import template as CSV
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImportTemplateCsv: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/patient-imports/template-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json,text/csv';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download the canonical patient import template as XLSX
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImportTemplateXlsx: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/patient-imports/template-xlsx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get patient import with all rows
         * @param {string} importId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientImport: async (importId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('getPatientImport', 'importId', importId)
            const localVarPath = `/api/patient-imports/{import_id}`
                .replace(`{${"import_id"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List patient imports for the current organisation (history)
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listImportHistory: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/patient-imports/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send an admin email requesting help with a custom import format
         * @param {string} message 
         * @param {string} targetOrganizationId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitImportSupportRequest: async (message: string, targetOrganizationId: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'message' is not null or undefined
            assertParamExists('submitImportSupportRequest', 'message', message)
            // verify required parameter 'targetOrganizationId' is not null or undefined
            assertParamExists('submitImportSupportRequest', 'targetOrganizationId', targetOrganizationId)
            const localVarPath = `/api/patient-imports/support-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (message !== undefined) { 
                localVarFormParams.append('message', message as any);
            }

            if (targetOrganizationId !== undefined) { 
                localVarFormParams.append('target_organization_id', targetOrganizationId as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Parse CSV/XLSX, validate rows, create patient import record
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImportFile: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadImportFile', 'file', file)
            const localVarPath = `/api/patient-imports/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate import rows — stateless, no DB write
         * @param {ValidateRequest} validateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateImportRows: async (validateRequest: ValidateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateRequest' is not null or undefined
            assertParamExists('validateImportRows', 'validateRequest', validateRequest)
            const localVarPath = `/api/patient-imports/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientImportsApi - functional programming interface
 */
export const PatientImportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientImportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Validate, create session, and commit manual quick-entry rows
         * @param {CommitManualRequest} commitManualRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitManualImport(commitManualRequest: CommitManualRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitManualImport(commitManualRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientImportsApi.commitManualImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Commit all valid/warned rows in a patient import
         * @param {string} importId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitPatientImport(importId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitPatientImport(importId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientImportsApi.commitPatientImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download the canonical patient import template as CSV
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadImportTemplateCsv(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadImportTemplateCsv(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientImportsApi.downloadImportTemplateCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download the canonical patient import template as XLSX
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadImportTemplateXlsx(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadImportTemplateXlsx(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientImportsApi.downloadImportTemplateXlsx']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get patient import with all rows
         * @param {string} importId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientImport(importId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientImport(importId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientImportsApi.getPatientImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List patient imports for the current organisation (history)
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listImportHistory(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientImportHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listImportHistory(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientImportsApi.listImportHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send an admin email requesting help with a custom import format
         * @param {string} message 
         * @param {string} targetOrganizationId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitImportSupportRequest(message: string, targetOrganizationId: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitImportSupportRequest(message, targetOrganizationId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientImportsApi.submitImportSupportRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Parse CSV/XLSX, validate rows, create patient import record
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadImportFile(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadImportFile(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientImportsApi.uploadImportFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate import rows — stateless, no DB write
         * @param {ValidateRequest} validateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateImportRows(validateRequest: ValidateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateImportRows(validateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientImportsApi.validateImportRows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientImportsApi - factory interface
 */
export const PatientImportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientImportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Validate, create session, and commit manual quick-entry rows
         * @param {CommitManualRequest} commitManualRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitManualImport(commitManualRequest: CommitManualRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommitResponse> {
            return localVarFp.commitManualImport(commitManualRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Commit all valid/warned rows in a patient import
         * @param {string} importId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitPatientImport(importId: string, options?: RawAxiosRequestConfig): AxiosPromise<CommitResponse> {
            return localVarFp.commitPatientImport(importId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download the canonical patient import template as CSV
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImportTemplateCsv(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadImportTemplateCsv(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download the canonical patient import template as XLSX
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImportTemplateXlsx(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadImportTemplateXlsx(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get patient import with all rows
         * @param {string} importId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientImport(importId: string, options?: RawAxiosRequestConfig): AxiosPromise<PatientImportResponse> {
            return localVarFp.getPatientImport(importId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List patient imports for the current organisation (history)
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listImportHistory(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PatientImportHistoryResponse> {
            return localVarFp.listImportHistory(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send an admin email requesting help with a custom import format
         * @param {string} message 
         * @param {string} targetOrganizationId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitImportSupportRequest(message: string, targetOrganizationId: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.submitImportSupportRequest(message, targetOrganizationId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Parse CSV/XLSX, validate rows, create patient import record
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImportFile(file: File, options?: RawAxiosRequestConfig): AxiosPromise<PatientImportResponse> {
            return localVarFp.uploadImportFile(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate import rows — stateless, no DB write
         * @param {ValidateRequest} validateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateImportRows(validateRequest: ValidateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateResponse> {
            return localVarFp.validateImportRows(validateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientImportsApi - object-oriented interface
 */
export class PatientImportsApi extends BaseAPI {
    /**
     * 
     * @summary Validate, create session, and commit manual quick-entry rows
     * @param {CommitManualRequest} commitManualRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public commitManualImport(commitManualRequest: CommitManualRequest, options?: RawAxiosRequestConfig) {
        return PatientImportsApiFp(this.configuration).commitManualImport(commitManualRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Commit all valid/warned rows in a patient import
     * @param {string} importId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public commitPatientImport(importId: string, options?: RawAxiosRequestConfig) {
        return PatientImportsApiFp(this.configuration).commitPatientImport(importId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download the canonical patient import template as CSV
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadImportTemplateCsv(options?: RawAxiosRequestConfig) {
        return PatientImportsApiFp(this.configuration).downloadImportTemplateCsv(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download the canonical patient import template as XLSX
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadImportTemplateXlsx(options?: RawAxiosRequestConfig) {
        return PatientImportsApiFp(this.configuration).downloadImportTemplateXlsx(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get patient import with all rows
     * @param {string} importId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientImport(importId: string, options?: RawAxiosRequestConfig) {
        return PatientImportsApiFp(this.configuration).getPatientImport(importId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List patient imports for the current organisation (history)
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listImportHistory(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return PatientImportsApiFp(this.configuration).listImportHistory(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send an admin email requesting help with a custom import format
     * @param {string} message 
     * @param {string} targetOrganizationId 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitImportSupportRequest(message: string, targetOrganizationId: string, file?: File, options?: RawAxiosRequestConfig) {
        return PatientImportsApiFp(this.configuration).submitImportSupportRequest(message, targetOrganizationId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Parse CSV/XLSX, validate rows, create patient import record
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadImportFile(file: File, options?: RawAxiosRequestConfig) {
        return PatientImportsApiFp(this.configuration).uploadImportFile(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate import rows — stateless, no DB write
     * @param {ValidateRequest} validateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateImportRows(validateRequest: ValidateRequest, options?: RawAxiosRequestConfig) {
        return PatientImportsApiFp(this.configuration).validateImportRows(validateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientsApi - axios parameter creator
 */
export const PatientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get patient counts for multiple organizations in one request (batch-get endpoint)
         * @summary Batch Get Patients Counts
         * @param {BatchGetRequest} batchGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchGetPatientsCounts: async (batchGetRequest: BatchGetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchGetRequest' is not null or undefined
            assertParamExists('batchGetPatientsCounts', 'batchGetRequest', batchGetRequest)
            const localVarPath = `/api/patients/batch-get-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change NZIS status for treatment and related treatments with same sequence_id  Maps to Java: PatientController.changePatientTreatmentNzisStatus()  Endpoint: POST /patients/treatments/change-nzis-status
         * @summary Change Patient Treatment Nzis Status
         * @param {ChangePatientTreatmentNzisStatusRequest} changePatientTreatmentNzisStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePatientTreatmentNzisStatus: async (changePatientTreatmentNzisStatusRequest: ChangePatientTreatmentNzisStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePatientTreatmentNzisStatusRequest' is not null or undefined
            assertParamExists('changePatientTreatmentNzisStatus', 'changePatientTreatmentNzisStatusRequest', changePatientTreatmentNzisStatusRequest)
            const localVarPath = `/api/patients/treatments/change-nzis-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePatientTreatmentNzisStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new patient condition with audit logging
         * @summary Create Condition
         * @param {ConditionCreate} conditionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCondition: async (conditionCreate: ConditionCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conditionCreate' is not null or undefined
            assertParamExists('createCondition', 'conditionCreate', conditionCreate)
            const localVarPath = `/api/patients/conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conditionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new notice  Maps to Java endpoint: POST /patients/notices/ Java returns: 200 OK (line 468) Creates a medical notice for a patient with ICD code, institution, and date range.
         * @summary Create Notice
         * @param {NoticeCreate} noticeCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotice: async (noticeCreate: NoticeCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noticeCreate' is not null or undefined
            assertParamExists('createNotice', 'noticeCreate', noticeCreate)
            const localVarPath = `/api/patients/notices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noticeCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new patient with audit logging
         * @summary Create Patient
         * @param {PatientCreate} patientCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatient: async (patientCreate: PatientCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientCreate' is not null or undefined
            assertParamExists('createPatient', 'patientCreate', patientCreate)
            const localVarPath = `/api/patients/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new appointment for a patient with audit logging  Maps to Java endpoint: POST /patients/{patientId}/appointments/
         * @summary Create Patient Appointment
         * @param {string} patientId 
         * @param {AppointmentCreate} appointmentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientAppointment: async (patientId: string, appointmentCreate: AppointmentCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('createPatientAppointment', 'patientId', patientId)
            // verify required parameter 'appointmentCreate' is not null or undefined
            assertParamExists('createPatientAppointment', 'appointmentCreate', appointmentCreate)
            const localVarPath = `/api/patients/{patient_id}/appointments`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new tooth record
         * @summary Create Tooth
         * @param {ToothCreate} toothCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTooth: async (toothCreate: ToothCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toothCreate' is not null or undefined
            assertParamExists('createTooth', 'toothCreate', toothCreate)
            const localVarPath = `/api/patients/teeth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toothCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create tooth statuses (batch create) with audit logging
         * @summary Create Tooth Status
         * @param {string} appointmentId 
         * @param {Array<StatusToothCreate>} statusToothCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToothStatus: async (appointmentId: string, statusToothCreate: Array<StatusToothCreate>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('createToothStatus', 'appointmentId', appointmentId)
            // verify required parameter 'statusToothCreate' is not null or undefined
            assertParamExists('createToothStatus', 'statusToothCreate', statusToothCreate)
            const localVarPath = `/api/patients/appointments/{appointment_id}/statuses`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statusToothCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new tooth treatments (batch operation) with audit logging  Maps to Java: PatientController.createPatientTreatment() Java returns: 200 OK (line 346) Accepts a list of treatments to create in a single request.
         * @summary Create Tooth Treatment
         * @param {string} appointmentId 
         * @param {Array<TreatmentToothCreate>} treatmentToothCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToothTreatment: async (appointmentId: string, treatmentToothCreate: Array<TreatmentToothCreate>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('createToothTreatment', 'appointmentId', appointmentId)
            // verify required parameter 'treatmentToothCreate' is not null or undefined
            assertParamExists('createToothTreatment', 'treatmentToothCreate', treatmentToothCreate)
            const localVarPath = `/api/patients/appointments/{appointment_id}/treatments`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(treatmentToothCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a patient condition with audit logging
         * @summary Delete Condition
         * @param {string} conditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCondition: async (conditionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conditionId' is not null or undefined
            assertParamExists('deleteCondition', 'conditionId', conditionId)
            const localVarPath = `/api/patients/conditions/{condition_id}`
                .replace(`{${"condition_id"}}`, encodeURIComponent(String(conditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a patient (Admin only) with audit logging  Returns 204 No Content on successful deletion.
         * @summary Delete Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatient: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('deletePatient', 'patientId', patientId)
            const localVarPath = `/api/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an appointment for a patient with audit logging  Maps to Java endpoint: DELETE /patients/{patientId}/appointments/{appointmentId}/
         * @summary Delete Patient Appointment
         * @param {string} patientId 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientAppointment: async (patientId: string, appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('deletePatientAppointment', 'patientId', patientId)
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('deletePatientAppointment', 'appointmentId', appointmentId)
            const localVarPath = `/api/patients/{patient_id}/appointments/{appointment_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete all patients in an organization (Admin only)
         * @summary Delete Patients By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientsByOrganization: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletePatientsByOrganization', 'organizationId', organizationId)
            const localVarPath = `/api/patients/by-organization/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a patient photo with audit logging
         * @summary Delete Photo
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhoto: async (photoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('deletePhoto', 'photoId', photoId)
            const localVarPath = `/api/patients/photos/{photo_id}`
                .replace(`{${"photo_id"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a tooth status (soft delete) with audit logging
         * @summary Delete Tooth Status
         * @param {string} appointmentId 
         * @param {string} statusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToothStatus: async (appointmentId: string, statusId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('deleteToothStatus', 'appointmentId', appointmentId)
            // verify required parameter 'statusId' is not null or undefined
            assertParamExists('deleteToothStatus', 'statusId', statusId)
            const localVarPath = `/api/patients/appointments/{appointment_id}/statuses/{status_id}`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)))
                .replace(`{${"status_id"}}`, encodeURIComponent(String(statusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a tooth treatment (soft delete) with audit logging
         * @summary Delete Tooth Treatment
         * @param {string} appointmentId 
         * @param {string} treatmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToothTreatment: async (appointmentId: string, treatmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('deleteToothTreatment', 'appointmentId', appointmentId)
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('deleteToothTreatment', 'treatmentId', treatmentId)
            const localVarPath = `/api/patients/appointments/{appointment_id}/treatments/{treatment_id}`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)))
                .replace(`{${"treatment_id"}}`, encodeURIComponent(String(treatmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all patients with pagination and filtering  Accepts both camelCase (sortBy) and snake_case (sort_by) for Java API compatibility. Page numbering: Frontend sends 0-indexed, backend converts to 1-indexed.  Uses OrgContext for multi-organization support - respects selected organization from JWT.
         * @summary Fetch All Patients
         * @param {string | null} [keyword] Search keyword
         * @param {string | null} [sortBy] Field to sort by
         * @param {string} [order] Sort order (asc/desc)
         * @param {number} [page] Page number (0-indexed from frontend)
         * @param {number} [perPage] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllPatients: async (keyword?: string | null, sortBy?: string | null, order?: string, page?: number, perPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/patients/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all appointments for a patient (excluding deleted)  Maps to Java endpoint: GET /patients/{patientId}/appointments/ Returns all appointments for the specified patient, filtering out deleted ones.
         * @summary Fetch Patient Appointments
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientAppointments: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('fetchPatientAppointments', 'patientId', patientId)
            const localVarPath = `/api/patients/{patient_id}/appointments`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch patient avatar  Maps to Java endpoint: GET /patient/{id}/avatar/ from PatientController.fetchPatientAvatar()  Returns the patient\'s avatar image file. Authorization: CLINIC_ADMIN, MEDICAL_DOCTOR, MEDICAL_ASSISTANT, or RECEPTIONIST
         * @summary Fetch Patient Avatar
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientAvatar: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('fetchPatientAvatar', 'patientId', patientId)
            const localVarPath = `/api/patients/{patient_id}/avatar`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'image/jpeg,image/png,image/gif,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch patient by ID
         * @summary Fetch Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientById: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('fetchPatientById', 'patientId', patientId)
            const localVarPath = `/api/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all teeth for the patient associated with the appointment  Maps to Java: PatientController.fetchPatientTeeth() Returns teeth with nested toothStatuses including status objects (label, color, displayName)
         * @summary Get Appointment Teeth
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientTeeth: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('fetchPatientTeeth', 'appointmentId', appointmentId)
            const localVarPath = `/api/patients/appointments/{appointment_id}/teeth`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all tooth statuses for an appointment  Maps to Java: PatientController.fetchPatientToothStatuses()
         * @summary Get Appointment Tooth Statuses
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientToothStatuses: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('fetchPatientToothStatuses', 'appointmentId', appointmentId)
            const localVarPath = `/api/patients/appointments/{appointment_id}/statuses`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get total count of patients in the selected organization  Uses OrgContext for multi-organization support - counts patients in selected organization. Platform administrators can count across all orgs by passing None.
         * @summary Fetch Patients Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientsCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/patients/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get total count of patients for a specific organization (admin only)
         * @summary Fetch Patients Count By Org
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientsCountByOrg: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchPatientsCountByOrg', 'organizationId', organizationId)
            const localVarPath = `/api/patients/count/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch patients with sent NZIS data  Maps to Java endpoint: GET /patients/sent/ Returns patients who have treatments that HAVE been sent to NZIS.
         * @summary Fetch Patients With Sent Nzis Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientsWithSentNzisData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/patients/sent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch patients with unsent NZIS data  Maps to Java endpoint: GET /patients/unsent/ Returns patients who have treatments that have NOT been sent to NZIS.
         * @summary Fetch Patients With Unsent Nzis Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientsWithUnsentNzisData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/patients/unsent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve photo file by ID  Matches Java endpoint: GET /patients/photos/{id} from PatientController.fetchPhoto()  Returns the photo file as a file response.
         * @summary Fetch Photo
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPhoto: async (photoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('fetchPhoto', 'photoId', photoId)
            const localVarPath = `/api/patients/photos/{photo_id}`
                .replace(`{${"photo_id"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'image/jpeg,image/png,image/gif,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate PDF for patient medical history and treatment records  Returns: PDF file with patient name as filename  Implementation: Basic PDF generation with ReportLab Uses placeholder template - customize with actual business requirements
         * @summary Generate Medical History Pdf
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMedicalHistoryPdf: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('generateMedicalHistoryPdf', 'patientId', patientId)
            const localVarPath = `/api/patients/{patient_id}/medical-history/pdf`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/pdf,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Backward-compatible alias for the Dental Visit Record PDF.  Kept for the existing frontend and Java API path compatibility (\"ambolatory\" spelling). Delegates to the same generator as ``/visit-record`` and now returns the file as an attachment (was previously a stub served inline).  Parameters: - patient_id: Patient UUID - variant: \'bg\' (default) or \'intl\' - toothTreatmentIds: treatment UUIDs to include in the activity table
         * @summary Generate Ambolatory Sheet
         * @param {string} patientId 
         * @param {string | null} [variant] Optional override: \&#39;bg\&#39; or \&#39;intl\&#39;. Omit to auto-select from the organization.
         * @param {Array<string>} [toothTreatmentIds] 
         * @param {boolean} [debugOverlay] Internal/calibration only: draw red field boxes on the BG template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfAmbolatorySheetForPatient: async (patientId: string, variant?: string | null, toothTreatmentIds?: Array<string>, debugOverlay?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('generatePdfAmbolatorySheetForPatient', 'patientId', patientId)
            const localVarPath = `/api/patients/{patient_id}/ambolatory-sheet`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (variant !== undefined) {
                localVarQueryParameter['variant'] = variant;
            }

            if (toothTreatmentIds) {
                localVarQueryParameter['toothTreatmentIds'] = toothTreatmentIds;
            }

            if (debugOverlay !== undefined) {
                localVarQueryParameter['debugOverlay'] = debugOverlay;
            }

            localVarHeaderParameter['Accept'] = 'application/pdf,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate patient document PDF from appointment  Matches Java endpoint: GET /patients/{patientId}/pdf/ from PatientController.generatePdfForPatient()  Takes appointmentId as path parameter. Returns PDF file with attachment content-disposition.
         * @summary Generate Pdf For Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfForPatient: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('generatePdfForPatient', 'appointmentId', appointmentId)
            const localVarPath = `/api/patients/appointments/{appointment_id}/pdf`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/pdf,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all patient conditions
         * @summary Get All Conditions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConditions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/patients/conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all notices for the organization  Maps to Java endpoint: GET /patients/notices/ Returns all medical notices for the current user\'s organization.
         * @summary Get All Notices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/patients/notices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all treatments for the user\'s organization  Matches Java endpoint: GET /patients/treatments/all from PatientController.fetchAllTreatments() -> TreatmentServiceImpl.fetchTreatments()  Returns DONE treatments that haven\'t been sent to NZIS for patients in the user\'s organization. Matches Java filters: - organization_id from principal - sentToNhis == false - status == DONE
         * @summary Get All Treatments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTreatments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/patients/treatments/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all tooth treatments for an appointment  Returns treatments with status object (label, color) for tooth graphic rendering
         * @summary Get Appointment Tooth Treatments
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentToothTreatments: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAppointmentToothTreatments', 'appointmentId', appointmentId)
            const localVarPath = `/api/patients/appointments/{appointment_id}/treatments`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all photos for a patient
         * @summary Get Patient Photos
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPhotos: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientPhotos', 'patientId', patientId)
            const localVarPath = `/api/patients/{patient_id}/photos`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all teeth for a patient
         * @summary Get Patient Teeth
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientTeeth: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientTeeth', 'patientId', patientId)
            const localVarPath = `/api/patients/{patient_id}/teeth`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all tooth treatments for a patient  Returns treatments with status object (label, color) for tooth graphic rendering
         * @summary Get Patient Tooth Treatments
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientToothTreatments: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientToothTreatments', 'patientId', patientId)
            const localVarPath = `/api/patients/{patient_id}/treatments`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a printable Dental Visit Record PDF for a patient.  This is a convenience document only — it is NOT QES-signed and NOT submitted to NZIS. It is downloaded (Content-Disposition: attachment) so the doctor can print and sign/stamp the paper copy.  Parameters: - patient_id: Patient UUID - variant: \'bg\' (default) or \'intl\' - toothTreatmentIds: treatment UUIDs to include in the activity table
         * @summary Get Patient Visit Record
         * @param {string} patientId 
         * @param {string | null} [variant] Optional override: \&#39;bg\&#39; or \&#39;intl\&#39;. Omit to auto-select from the organization (Bulgarian -&gt; bg, otherwise -&gt; intl).
         * @param {Array<string>} [toothTreatmentIds] 
         * @param {boolean} [debugOverlay] Internal/calibration only: draw red field boxes on the BG template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientVisitRecord: async (patientId: string, variant?: string | null, toothTreatmentIds?: Array<string>, debugOverlay?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientVisitRecord', 'patientId', patientId)
            const localVarPath = `/api/patients/{patient_id}/visit-record`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (variant !== undefined) {
                localVarQueryParameter['variant'] = variant;
            }

            if (toothTreatmentIds) {
                localVarQueryParameter['toothTreatmentIds'] = toothTreatmentIds;
            }

            if (debugOverlay !== undefined) {
                localVarQueryParameter['debugOverlay'] = debugOverlay;
            }

            localVarHeaderParameter['Accept'] = 'application/pdf,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a patient condition with audit logging
         * @summary Update Condition
         * @param {string} conditionId 
         * @param {ConditionUpdate} conditionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCondition: async (conditionId: string, conditionUpdate: ConditionUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conditionId' is not null or undefined
            assertParamExists('updateCondition', 'conditionId', conditionId)
            // verify required parameter 'conditionUpdate' is not null or undefined
            assertParamExists('updateCondition', 'conditionUpdate', conditionUpdate)
            const localVarPath = `/api/patients/conditions/{condition_id}`
                .replace(`{${"condition_id"}}`, encodeURIComponent(String(conditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conditionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update patient information with audit logging
         * @summary Update Patient
         * @param {string} patientId 
         * @param {PatientUpdate} patientUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient: async (patientId: string, patientUpdate: PatientUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updatePatient', 'patientId', patientId)
            // verify required parameter 'patientUpdate' is not null or undefined
            assertParamExists('updatePatient', 'patientUpdate', patientUpdate)
            const localVarPath = `/api/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an appointment for a patient with audit logging  Maps to Java endpoint: PUT /patients/{patientId}/appointments/{appointmentId}/
         * @summary Update Patient Appointment
         * @param {string} patientId 
         * @param {string} appointmentId 
         * @param {AppointmentUpdate} appointmentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientAppointment: async (patientId: string, appointmentId: string, appointmentUpdate: AppointmentUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updatePatientAppointment', 'patientId', patientId)
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('updatePatientAppointment', 'appointmentId', appointmentId)
            // verify required parameter 'appointmentUpdate' is not null or undefined
            assertParamExists('updatePatientAppointment', 'appointmentUpdate', appointmentUpdate)
            const localVarPath = `/api/patients/{patient_id}/appointments/{appointment_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update photo metadata with audit logging
         * @summary Update Photo
         * @param {string} photoId 
         * @param {string | null} [photoType] 
         * @param {string | null} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoto: async (photoId: string, photoType?: string | null, description?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('updatePhoto', 'photoId', photoId)
            const localVarPath = `/api/patients/photos/{photo_id}`
                .replace(`{${"photo_id"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (photoType !== undefined) { 
                localVarFormParams.set('photo_type', photoType as any);
            }

            if (description !== undefined) { 
                localVarFormParams.set('description', description as any);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a tooth status with audit logging
         * @summary Update Tooth Status
         * @param {string} appointmentId 
         * @param {string} statusId 
         * @param {StatusToothUpdate} statusToothUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToothStatus: async (appointmentId: string, statusId: string, statusToothUpdate: StatusToothUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('updateToothStatus', 'appointmentId', appointmentId)
            // verify required parameter 'statusId' is not null or undefined
            assertParamExists('updateToothStatus', 'statusId', statusId)
            // verify required parameter 'statusToothUpdate' is not null or undefined
            assertParamExists('updateToothStatus', 'statusToothUpdate', statusToothUpdate)
            const localVarPath = `/api/patients/appointments/{appointment_id}/statuses/{status_id}`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)))
                .replace(`{${"status_id"}}`, encodeURIComponent(String(statusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statusToothUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a tooth treatment with audit logging
         * @summary Update Tooth Treatment
         * @param {string} appointmentId 
         * @param {string} treatmentId 
         * @param {Array<TreatmentToothUpdate>} treatmentToothUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToothTreatment: async (appointmentId: string, treatmentId: string, treatmentToothUpdate: Array<TreatmentToothUpdate>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('updateToothTreatment', 'appointmentId', appointmentId)
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('updateToothTreatment', 'treatmentId', treatmentId)
            // verify required parameter 'treatmentToothUpdate' is not null or undefined
            assertParamExists('updateToothTreatment', 'treatmentToothUpdate', treatmentToothUpdate)
            const localVarPath = `/api/patients/appointments/{appointment_id}/treatments/{treatment_id}`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)))
                .replace(`{${"treatment_id"}}`, encodeURIComponent(String(treatmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(treatmentToothUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update treatment financial information (paid status) Endpoint: PUT /patients/{patientId}/treatments/{treatmentId}/finances/
         * @summary Update Patient Treatments Finances Information
         * @param {string} patientId 
         * @param {string} treatmentId 
         * @param {UpdateTreatmentsFinancialsRequest} updateTreatmentsFinancialsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTreatmentsFinancials: async (patientId: string, treatmentId: string, updateTreatmentsFinancialsRequest: UpdateTreatmentsFinancialsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updateTreatmentsFinancials', 'patientId', patientId)
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('updateTreatmentsFinancials', 'treatmentId', treatmentId)
            // verify required parameter 'updateTreatmentsFinancialsRequest' is not null or undefined
            assertParamExists('updateTreatmentsFinancials', 'updateTreatmentsFinancialsRequest', updateTreatmentsFinancialsRequest)
            const localVarPath = `/api/patients/{patient_id}/treatments/{treatment_id}/finances`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"treatment_id"}}`, encodeURIComponent(String(treatmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTreatmentsFinancialsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload avatar for a patient
         * @summary Upload Patient Avatar
         * @param {string} patientId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPatientAvatar: async (patientId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('uploadPatientAvatar', 'patientId', patientId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadPatientAvatar', 'file', file)
            const localVarPath = `/api/patients/{patient_id}/avatar`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a photo for a patient with audit logging  Maps to Java: PatientController.uploadPhoto(UUID patientId, String type, MultipartFile file) Java returns: 200 OK (line 113) Expects multipart/form-data with fields: file, photo_type, description (optional)
         * @summary Upload Patient Photo
         * @param {string} patientId 
         * @param {File} file 
         * @param {string} photoType 
         * @param {string | null} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPatientPhoto: async (patientId: string, file: File, photoType: string, description?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('uploadPatientPhoto', 'patientId', patientId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadPatientPhoto', 'file', file)
            // verify required parameter 'photoType' is not null or undefined
            assertParamExists('uploadPatientPhoto', 'photoType', photoType)
            const localVarPath = `/api/patients/{patient_id}/photos`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (photoType !== undefined) { 
                localVarFormParams.append('photo_type', photoType as any);
            }

            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientsApi - functional programming interface
 */
export const PatientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get patient counts for multiple organizations in one request (batch-get endpoint)
         * @summary Batch Get Patients Counts
         * @param {BatchGetRequest} batchGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchGetPatientsCounts(batchGetRequest: BatchGetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchGetPatientsCounts(batchGetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.batchGetPatientsCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change NZIS status for treatment and related treatments with same sequence_id  Maps to Java: PatientController.changePatientTreatmentNzisStatus()  Endpoint: POST /patients/treatments/change-nzis-status
         * @summary Change Patient Treatment Nzis Status
         * @param {ChangePatientTreatmentNzisStatusRequest} changePatientTreatmentNzisStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePatientTreatmentNzisStatus(changePatientTreatmentNzisStatusRequest: ChangePatientTreatmentNzisStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePatientTreatmentNzisStatus(changePatientTreatmentNzisStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.changePatientTreatmentNzisStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new patient condition with audit logging
         * @summary Create Condition
         * @param {ConditionCreate} conditionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCondition(conditionCreate: ConditionCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Condition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCondition(conditionCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.createCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new notice  Maps to Java endpoint: POST /patients/notices/ Java returns: 200 OK (line 468) Creates a medical notice for a patient with ICD code, institution, and date range.
         * @summary Create Notice
         * @param {NoticeCreate} noticeCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotice(noticeCreate: NoticeCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotice(noticeCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.createNotice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new patient with audit logging
         * @summary Create Patient
         * @param {PatientCreate} patientCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatient(patientCreate: PatientCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatient(patientCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.createPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new appointment for a patient with audit logging  Maps to Java endpoint: POST /patients/{patientId}/appointments/
         * @summary Create Patient Appointment
         * @param {string} patientId 
         * @param {AppointmentCreate} appointmentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientAppointment(patientId: string, appointmentCreate: AppointmentCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Appointment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientAppointment(patientId, appointmentCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.createPatientAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new tooth record
         * @summary Create Tooth
         * @param {ToothCreate} toothCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTooth(toothCreate: ToothCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tooth>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTooth(toothCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.createTooth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create tooth statuses (batch create) with audit logging
         * @summary Create Tooth Status
         * @param {string} appointmentId 
         * @param {Array<StatusToothCreate>} statusToothCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createToothStatus(appointmentId: string, statusToothCreate: Array<StatusToothCreate>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToothStatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createToothStatus(appointmentId, statusToothCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.createToothStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create new tooth treatments (batch operation) with audit logging  Maps to Java: PatientController.createPatientTreatment() Java returns: 200 OK (line 346) Accepts a list of treatments to create in a single request.
         * @summary Create Tooth Treatment
         * @param {string} appointmentId 
         * @param {Array<TreatmentToothCreate>} treatmentToothCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createToothTreatment(appointmentId: string, treatmentToothCreate: Array<TreatmentToothCreate>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToothTreatment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createToothTreatment(appointmentId, treatmentToothCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.createToothTreatment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a patient condition with audit logging
         * @summary Delete Condition
         * @param {string} conditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCondition(conditionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCondition(conditionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.deleteCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a patient (Admin only) with audit logging  Returns 204 No Content on successful deletion.
         * @summary Delete Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatient(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatient(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.deletePatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an appointment for a patient with audit logging  Maps to Java endpoint: DELETE /patients/{patientId}/appointments/{appointmentId}/
         * @summary Delete Patient Appointment
         * @param {string} patientId 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientAppointment(patientId: string, appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientAppointment(patientId, appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.deletePatientAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete all patients in an organization (Admin only)
         * @summary Delete Patients By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientsByOrganization(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientsByOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.deletePatientsByOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a patient photo with audit logging
         * @summary Delete Photo
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePhoto(photoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePhoto(photoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.deletePhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a tooth status (soft delete) with audit logging
         * @summary Delete Tooth Status
         * @param {string} appointmentId 
         * @param {string} statusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteToothStatus(appointmentId: string, statusId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteToothStatus(appointmentId, statusId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.deleteToothStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a tooth treatment (soft delete) with audit logging
         * @summary Delete Tooth Treatment
         * @param {string} appointmentId 
         * @param {string} treatmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteToothTreatment(appointmentId: string, treatmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteToothTreatment(appointmentId, treatmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.deleteToothTreatment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all patients with pagination and filtering  Accepts both camelCase (sortBy) and snake_case (sort_by) for Java API compatibility. Page numbering: Frontend sends 0-indexed, backend converts to 1-indexed.  Uses OrgContext for multi-organization support - respects selected organization from JWT.
         * @summary Fetch All Patients
         * @param {string | null} [keyword] Search keyword
         * @param {string | null} [sortBy] Field to sort by
         * @param {string} [order] Sort order (asc/desc)
         * @param {number} [page] Page number (0-indexed from frontend)
         * @param {number} [perPage] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllPatients(keyword?: string | null, sortBy?: string | null, order?: string, page?: number, perPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientPaginationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllPatients(keyword, sortBy, order, page, perPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.fetchAllPatients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all appointments for a patient (excluding deleted)  Maps to Java endpoint: GET /patients/{patientId}/appointments/ Returns all appointments for the specified patient, filtering out deleted ones.
         * @summary Fetch Patient Appointments
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPatientAppointments(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Appointment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPatientAppointments(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.fetchPatientAppointments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch patient avatar  Maps to Java endpoint: GET /patient/{id}/avatar/ from PatientController.fetchPatientAvatar()  Returns the patient\'s avatar image file. Authorization: CLINIC_ADMIN, MEDICAL_DOCTOR, MEDICAL_ASSISTANT, or RECEPTIONIST
         * @summary Fetch Patient Avatar
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPatientAvatar(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPatientAvatar(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.fetchPatientAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch patient by ID
         * @summary Fetch Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPatientById(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPatientById(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.fetchPatientById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all teeth for the patient associated with the appointment  Maps to Java: PatientController.fetchPatientTeeth() Returns teeth with nested toothStatuses including status objects (label, color, displayName)
         * @summary Get Appointment Teeth
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPatientTeeth(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToothWithRelationships>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPatientTeeth(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.fetchPatientTeeth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all tooth statuses for an appointment  Maps to Java: PatientController.fetchPatientToothStatuses()
         * @summary Get Appointment Tooth Statuses
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPatientToothStatuses(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToothStatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPatientToothStatuses(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.fetchPatientToothStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get total count of patients in the selected organization  Uses OrgContext for multi-organization support - counts patients in selected organization. Platform administrators can count across all orgs by passing None.
         * @summary Fetch Patients Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPatientsCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPatientsCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.fetchPatientsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get total count of patients for a specific organization (admin only)
         * @summary Fetch Patients Count By Org
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPatientsCountByOrg(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPatientsCountByOrg(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.fetchPatientsCountByOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch patients with sent NZIS data  Maps to Java endpoint: GET /patients/sent/ Returns patients who have treatments that HAVE been sent to NZIS.
         * @summary Fetch Patients With Sent Nzis Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPatientsWithSentNzisData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Patient>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPatientsWithSentNzisData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.fetchPatientsWithSentNzisData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch patients with unsent NZIS data  Maps to Java endpoint: GET /patients/unsent/ Returns patients who have treatments that have NOT been sent to NZIS.
         * @summary Fetch Patients With Unsent Nzis Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPatientsWithUnsentNzisData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Patient>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPatientsWithUnsentNzisData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.fetchPatientsWithUnsentNzisData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve photo file by ID  Matches Java endpoint: GET /patients/photos/{id} from PatientController.fetchPhoto()  Returns the photo file as a file response.
         * @summary Fetch Photo
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPhoto(photoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPhoto(photoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.fetchPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate PDF for patient medical history and treatment records  Returns: PDF file with patient name as filename  Implementation: Basic PDF generation with ReportLab Uses placeholder template - customize with actual business requirements
         * @summary Generate Medical History Pdf
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateMedicalHistoryPdf(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateMedicalHistoryPdf(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.generateMedicalHistoryPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Backward-compatible alias for the Dental Visit Record PDF.  Kept for the existing frontend and Java API path compatibility (\"ambolatory\" spelling). Delegates to the same generator as ``/visit-record`` and now returns the file as an attachment (was previously a stub served inline).  Parameters: - patient_id: Patient UUID - variant: \'bg\' (default) or \'intl\' - toothTreatmentIds: treatment UUIDs to include in the activity table
         * @summary Generate Ambolatory Sheet
         * @param {string} patientId 
         * @param {string | null} [variant] Optional override: \&#39;bg\&#39; or \&#39;intl\&#39;. Omit to auto-select from the organization.
         * @param {Array<string>} [toothTreatmentIds] 
         * @param {boolean} [debugOverlay] Internal/calibration only: draw red field boxes on the BG template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePdfAmbolatorySheetForPatient(patientId: string, variant?: string | null, toothTreatmentIds?: Array<string>, debugOverlay?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePdfAmbolatorySheetForPatient(patientId, variant, toothTreatmentIds, debugOverlay, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.generatePdfAmbolatorySheetForPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate patient document PDF from appointment  Matches Java endpoint: GET /patients/{patientId}/pdf/ from PatientController.generatePdfForPatient()  Takes appointmentId as path parameter. Returns PDF file with attachment content-disposition.
         * @summary Generate Pdf For Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePdfForPatient(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePdfForPatient(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.generatePdfForPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all patient conditions
         * @summary Get All Conditions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllConditions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Condition>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllConditions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.getAllConditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all notices for the organization  Maps to Java endpoint: GET /patients/notices/ Returns all medical notices for the current user\'s organization.
         * @summary Get All Notices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllNotices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllNotices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.getAllNotices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all treatments for the user\'s organization  Matches Java endpoint: GET /patients/treatments/all from PatientController.fetchAllTreatments() -> TreatmentServiceImpl.fetchTreatments()  Returns DONE treatments that haven\'t been sent to NZIS for patients in the user\'s organization. Matches Java filters: - organization_id from principal - sentToNhis == false - status == DONE
         * @summary Get All Treatments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTreatments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToothTreatment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTreatments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.getAllTreatments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all tooth treatments for an appointment  Returns treatments with status object (label, color) for tooth graphic rendering
         * @summary Get Appointment Tooth Treatments
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentToothTreatments(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToothTreatment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentToothTreatments(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.getAppointmentToothTreatments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all photos for a patient
         * @summary Get Patient Photos
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPhotos(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhotoResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPhotos(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.getPatientPhotos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all teeth for a patient
         * @summary Get Patient Teeth
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientTeeth(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tooth>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientTeeth(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.getPatientTeeth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all tooth treatments for a patient  Returns treatments with status object (label, color) for tooth graphic rendering
         * @summary Get Patient Tooth Treatments
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientToothTreatments(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToothTreatment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientToothTreatments(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.getPatientToothTreatments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a printable Dental Visit Record PDF for a patient.  This is a convenience document only — it is NOT QES-signed and NOT submitted to NZIS. It is downloaded (Content-Disposition: attachment) so the doctor can print and sign/stamp the paper copy.  Parameters: - patient_id: Patient UUID - variant: \'bg\' (default) or \'intl\' - toothTreatmentIds: treatment UUIDs to include in the activity table
         * @summary Get Patient Visit Record
         * @param {string} patientId 
         * @param {string | null} [variant] Optional override: \&#39;bg\&#39; or \&#39;intl\&#39;. Omit to auto-select from the organization (Bulgarian -&gt; bg, otherwise -&gt; intl).
         * @param {Array<string>} [toothTreatmentIds] 
         * @param {boolean} [debugOverlay] Internal/calibration only: draw red field boxes on the BG template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientVisitRecord(patientId: string, variant?: string | null, toothTreatmentIds?: Array<string>, debugOverlay?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientVisitRecord(patientId, variant, toothTreatmentIds, debugOverlay, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.getPatientVisitRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a patient condition with audit logging
         * @summary Update Condition
         * @param {string} conditionId 
         * @param {ConditionUpdate} conditionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCondition(conditionId: string, conditionUpdate: ConditionUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Condition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCondition(conditionId, conditionUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.updateCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update patient information with audit logging
         * @summary Update Patient
         * @param {string} patientId 
         * @param {PatientUpdate} patientUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatient(patientId: string, patientUpdate: PatientUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatient(patientId, patientUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.updatePatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an appointment for a patient with audit logging  Maps to Java endpoint: PUT /patients/{patientId}/appointments/{appointmentId}/
         * @summary Update Patient Appointment
         * @param {string} patientId 
         * @param {string} appointmentId 
         * @param {AppointmentUpdate} appointmentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientAppointment(patientId: string, appointmentId: string, appointmentUpdate: AppointmentUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Appointment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientAppointment(patientId, appointmentId, appointmentUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.updatePatientAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update photo metadata with audit logging
         * @summary Update Photo
         * @param {string} photoId 
         * @param {string | null} [photoType] 
         * @param {string | null} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePhoto(photoId: string, photoType?: string | null, description?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhotoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePhoto(photoId, photoType, description, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.updatePhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a tooth status with audit logging
         * @summary Update Tooth Status
         * @param {string} appointmentId 
         * @param {string} statusId 
         * @param {StatusToothUpdate} statusToothUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateToothStatus(appointmentId: string, statusId: string, statusToothUpdate: StatusToothUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToothStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateToothStatus(appointmentId, statusId, statusToothUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.updateToothStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a tooth treatment with audit logging
         * @summary Update Tooth Treatment
         * @param {string} appointmentId 
         * @param {string} treatmentId 
         * @param {Array<TreatmentToothUpdate>} treatmentToothUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateToothTreatment(appointmentId: string, treatmentId: string, treatmentToothUpdate: Array<TreatmentToothUpdate>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateToothTreatment(appointmentId, treatmentId, treatmentToothUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.updateToothTreatment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update treatment financial information (paid status) Endpoint: PUT /patients/{patientId}/treatments/{treatmentId}/finances/
         * @summary Update Patient Treatments Finances Information
         * @param {string} patientId 
         * @param {string} treatmentId 
         * @param {UpdateTreatmentsFinancialsRequest} updateTreatmentsFinancialsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTreatmentsFinancials(patientId: string, treatmentId: string, updateTreatmentsFinancialsRequest: UpdateTreatmentsFinancialsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTreatmentsFinancials(patientId, treatmentId, updateTreatmentsFinancialsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.updateTreatmentsFinancials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload avatar for a patient
         * @summary Upload Patient Avatar
         * @param {string} patientId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPatientAvatar(patientId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPatientAvatar(patientId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.uploadPatientAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a photo for a patient with audit logging  Maps to Java: PatientController.uploadPhoto(UUID patientId, String type, MultipartFile file) Java returns: 200 OK (line 113) Expects multipart/form-data with fields: file, photo_type, description (optional)
         * @summary Upload Patient Photo
         * @param {string} patientId 
         * @param {File} file 
         * @param {string} photoType 
         * @param {string | null} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPatientPhoto(patientId: string, file: File, photoType: string, description?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhotoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPatientPhoto(patientId, file, photoType, description, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientsApi.uploadPatientPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientsApi - factory interface
 */
export const PatientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientsApiFp(configuration)
    return {
        /**
         * Get patient counts for multiple organizations in one request (batch-get endpoint)
         * @summary Batch Get Patients Counts
         * @param {BatchGetRequest} batchGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchGetPatientsCounts(batchGetRequest: BatchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.batchGetPatientsCounts(batchGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Change NZIS status for treatment and related treatments with same sequence_id  Maps to Java: PatientController.changePatientTreatmentNzisStatus()  Endpoint: POST /patients/treatments/change-nzis-status
         * @summary Change Patient Treatment Nzis Status
         * @param {ChangePatientTreatmentNzisStatusRequest} changePatientTreatmentNzisStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePatientTreatmentNzisStatus(changePatientTreatmentNzisStatusRequest: ChangePatientTreatmentNzisStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changePatientTreatmentNzisStatus(changePatientTreatmentNzisStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new patient condition with audit logging
         * @summary Create Condition
         * @param {ConditionCreate} conditionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCondition(conditionCreate: ConditionCreate, options?: RawAxiosRequestConfig): AxiosPromise<Condition> {
            return localVarFp.createCondition(conditionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new notice  Maps to Java endpoint: POST /patients/notices/ Java returns: 200 OK (line 468) Creates a medical notice for a patient with ICD code, institution, and date range.
         * @summary Create Notice
         * @param {NoticeCreate} noticeCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotice(noticeCreate: NoticeCreate, options?: RawAxiosRequestConfig): AxiosPromise<Notice> {
            return localVarFp.createNotice(noticeCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new patient with audit logging
         * @summary Create Patient
         * @param {PatientCreate} patientCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatient(patientCreate: PatientCreate, options?: RawAxiosRequestConfig): AxiosPromise<Patient> {
            return localVarFp.createPatient(patientCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new appointment for a patient with audit logging  Maps to Java endpoint: POST /patients/{patientId}/appointments/
         * @summary Create Patient Appointment
         * @param {string} patientId 
         * @param {AppointmentCreate} appointmentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientAppointment(patientId: string, appointmentCreate: AppointmentCreate, options?: RawAxiosRequestConfig): AxiosPromise<Appointment> {
            return localVarFp.createPatientAppointment(patientId, appointmentCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new tooth record
         * @summary Create Tooth
         * @param {ToothCreate} toothCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTooth(toothCreate: ToothCreate, options?: RawAxiosRequestConfig): AxiosPromise<Tooth> {
            return localVarFp.createTooth(toothCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create tooth statuses (batch create) with audit logging
         * @summary Create Tooth Status
         * @param {string} appointmentId 
         * @param {Array<StatusToothCreate>} statusToothCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToothStatus(appointmentId: string, statusToothCreate: Array<StatusToothCreate>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ToothStatus>> {
            return localVarFp.createToothStatus(appointmentId, statusToothCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new tooth treatments (batch operation) with audit logging  Maps to Java: PatientController.createPatientTreatment() Java returns: 200 OK (line 346) Accepts a list of treatments to create in a single request.
         * @summary Create Tooth Treatment
         * @param {string} appointmentId 
         * @param {Array<TreatmentToothCreate>} treatmentToothCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToothTreatment(appointmentId: string, treatmentToothCreate: Array<TreatmentToothCreate>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ToothTreatment>> {
            return localVarFp.createToothTreatment(appointmentId, treatmentToothCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a patient condition with audit logging
         * @summary Delete Condition
         * @param {string} conditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCondition(conditionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCondition(conditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a patient (Admin only) with audit logging  Returns 204 No Content on successful deletion.
         * @summary Delete Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatient(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an appointment for a patient with audit logging  Maps to Java endpoint: DELETE /patients/{patientId}/appointments/{appointmentId}/
         * @summary Delete Patient Appointment
         * @param {string} patientId 
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientAppointment(patientId: string, appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePatientAppointment(patientId, appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete all patients in an organization (Admin only)
         * @summary Delete Patients By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientsByOrganization(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deletePatientsByOrganization(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a patient photo with audit logging
         * @summary Delete Photo
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhoto(photoId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePhoto(photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a tooth status (soft delete) with audit logging
         * @summary Delete Tooth Status
         * @param {string} appointmentId 
         * @param {string} statusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToothStatus(appointmentId: string, statusId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteToothStatus(appointmentId, statusId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a tooth treatment (soft delete) with audit logging
         * @summary Delete Tooth Treatment
         * @param {string} appointmentId 
         * @param {string} treatmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToothTreatment(appointmentId: string, treatmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteToothTreatment(appointmentId, treatmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all patients with pagination and filtering  Accepts both camelCase (sortBy) and snake_case (sort_by) for Java API compatibility. Page numbering: Frontend sends 0-indexed, backend converts to 1-indexed.  Uses OrgContext for multi-organization support - respects selected organization from JWT.
         * @summary Fetch All Patients
         * @param {string | null} [keyword] Search keyword
         * @param {string | null} [sortBy] Field to sort by
         * @param {string} [order] Sort order (asc/desc)
         * @param {number} [page] Page number (0-indexed from frontend)
         * @param {number} [perPage] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllPatients(keyword?: string | null, sortBy?: string | null, order?: string, page?: number, perPage?: number, options?: RawAxiosRequestConfig): AxiosPromise<PatientPaginationResponse> {
            return localVarFp.fetchAllPatients(keyword, sortBy, order, page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all appointments for a patient (excluding deleted)  Maps to Java endpoint: GET /patients/{patientId}/appointments/ Returns all appointments for the specified patient, filtering out deleted ones.
         * @summary Fetch Patient Appointments
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientAppointments(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Appointment>> {
            return localVarFp.fetchPatientAppointments(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch patient avatar  Maps to Java endpoint: GET /patient/{id}/avatar/ from PatientController.fetchPatientAvatar()  Returns the patient\'s avatar image file. Authorization: CLINIC_ADMIN, MEDICAL_DOCTOR, MEDICAL_ASSISTANT, or RECEPTIONIST
         * @summary Fetch Patient Avatar
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientAvatar(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.fetchPatientAvatar(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch patient by ID
         * @summary Fetch Patient
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientById(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<Patient> {
            return localVarFp.fetchPatientById(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all teeth for the patient associated with the appointment  Maps to Java: PatientController.fetchPatientTeeth() Returns teeth with nested toothStatuses including status objects (label, color, displayName)
         * @summary Get Appointment Teeth
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientTeeth(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ToothWithRelationships>> {
            return localVarFp.fetchPatientTeeth(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all tooth statuses for an appointment  Maps to Java: PatientController.fetchPatientToothStatuses()
         * @summary Get Appointment Tooth Statuses
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientToothStatuses(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ToothStatus>> {
            return localVarFp.fetchPatientToothStatuses(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get total count of patients in the selected organization  Uses OrgContext for multi-organization support - counts patients in selected organization. Platform administrators can count across all orgs by passing None.
         * @summary Fetch Patients Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientsCount(options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.fetchPatientsCount(options).then((request) => request(axios, basePath));
        },
        /**
         * Get total count of patients for a specific organization (admin only)
         * @summary Fetch Patients Count By Org
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientsCountByOrg(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.fetchPatientsCountByOrg(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch patients with sent NZIS data  Maps to Java endpoint: GET /patients/sent/ Returns patients who have treatments that HAVE been sent to NZIS.
         * @summary Fetch Patients With Sent Nzis Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientsWithSentNzisData(options?: RawAxiosRequestConfig): AxiosPromise<Array<Patient>> {
            return localVarFp.fetchPatientsWithSentNzisData(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch patients with unsent NZIS data  Maps to Java endpoint: GET /patients/unsent/ Returns patients who have treatments that have NOT been sent to NZIS.
         * @summary Fetch Patients With Unsent Nzis Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientsWithUnsentNzisData(options?: RawAxiosRequestConfig): AxiosPromise<Array<Patient>> {
            return localVarFp.fetchPatientsWithUnsentNzisData(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve photo file by ID  Matches Java endpoint: GET /patients/photos/{id} from PatientController.fetchPhoto()  Returns the photo file as a file response.
         * @summary Fetch Photo
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPhoto(photoId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.fetchPhoto(photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate PDF for patient medical history and treatment records  Returns: PDF file with patient name as filename  Implementation: Basic PDF generation with ReportLab Uses placeholder template - customize with actual business requirements
         * @summary Generate Medical History Pdf
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMedicalHistoryPdf(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generateMedicalHistoryPdf(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Backward-compatible alias for the Dental Visit Record PDF.  Kept for the existing frontend and Java API path compatibility (\"ambolatory\" spelling). Delegates to the same generator as ``/visit-record`` and now returns the file as an attachment (was previously a stub served inline).  Parameters: - patient_id: Patient UUID - variant: \'bg\' (default) or \'intl\' - toothTreatmentIds: treatment UUIDs to include in the activity table
         * @summary Generate Ambolatory Sheet
         * @param {string} patientId 
         * @param {string | null} [variant] Optional override: \&#39;bg\&#39; or \&#39;intl\&#39;. Omit to auto-select from the organization.
         * @param {Array<string>} [toothTreatmentIds] 
         * @param {boolean} [debugOverlay] Internal/calibration only: draw red field boxes on the BG template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfAmbolatorySheetForPatient(patientId: string, variant?: string | null, toothTreatmentIds?: Array<string>, debugOverlay?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generatePdfAmbolatorySheetForPatient(patientId, variant, toothTreatmentIds, debugOverlay, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate patient document PDF from appointment  Matches Java endpoint: GET /patients/{patientId}/pdf/ from PatientController.generatePdfForPatient()  Takes appointmentId as path parameter. Returns PDF file with attachment content-disposition.
         * @summary Generate Pdf For Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfForPatient(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generatePdfForPatient(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all patient conditions
         * @summary Get All Conditions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConditions(options?: RawAxiosRequestConfig): AxiosPromise<Array<Condition>> {
            return localVarFp.getAllConditions(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all notices for the organization  Maps to Java endpoint: GET /patients/notices/ Returns all medical notices for the current user\'s organization.
         * @summary Get All Notices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotices(options?: RawAxiosRequestConfig): AxiosPromise<Array<Notice>> {
            return localVarFp.getAllNotices(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all treatments for the user\'s organization  Matches Java endpoint: GET /patients/treatments/all from PatientController.fetchAllTreatments() -> TreatmentServiceImpl.fetchTreatments()  Returns DONE treatments that haven\'t been sent to NZIS for patients in the user\'s organization. Matches Java filters: - organization_id from principal - sentToNhis == false - status == DONE
         * @summary Get All Treatments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTreatments(options?: RawAxiosRequestConfig): AxiosPromise<Array<ToothTreatment>> {
            return localVarFp.getAllTreatments(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all tooth treatments for an appointment  Returns treatments with status object (label, color) for tooth graphic rendering
         * @summary Get Appointment Tooth Treatments
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentToothTreatments(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ToothTreatment>> {
            return localVarFp.getAppointmentToothTreatments(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all photos for a patient
         * @summary Get Patient Photos
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPhotos(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PhotoResponse>> {
            return localVarFp.getPatientPhotos(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all teeth for a patient
         * @summary Get Patient Teeth
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientTeeth(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Tooth>> {
            return localVarFp.getPatientTeeth(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all tooth treatments for a patient  Returns treatments with status object (label, color) for tooth graphic rendering
         * @summary Get Patient Tooth Treatments
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientToothTreatments(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ToothTreatment>> {
            return localVarFp.getPatientToothTreatments(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a printable Dental Visit Record PDF for a patient.  This is a convenience document only — it is NOT QES-signed and NOT submitted to NZIS. It is downloaded (Content-Disposition: attachment) so the doctor can print and sign/stamp the paper copy.  Parameters: - patient_id: Patient UUID - variant: \'bg\' (default) or \'intl\' - toothTreatmentIds: treatment UUIDs to include in the activity table
         * @summary Get Patient Visit Record
         * @param {string} patientId 
         * @param {string | null} [variant] Optional override: \&#39;bg\&#39; or \&#39;intl\&#39;. Omit to auto-select from the organization (Bulgarian -&gt; bg, otherwise -&gt; intl).
         * @param {Array<string>} [toothTreatmentIds] 
         * @param {boolean} [debugOverlay] Internal/calibration only: draw red field boxes on the BG template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientVisitRecord(patientId: string, variant?: string | null, toothTreatmentIds?: Array<string>, debugOverlay?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getPatientVisitRecord(patientId, variant, toothTreatmentIds, debugOverlay, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a patient condition with audit logging
         * @summary Update Condition
         * @param {string} conditionId 
         * @param {ConditionUpdate} conditionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCondition(conditionId: string, conditionUpdate: ConditionUpdate, options?: RawAxiosRequestConfig): AxiosPromise<Condition> {
            return localVarFp.updateCondition(conditionId, conditionUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update patient information with audit logging
         * @summary Update Patient
         * @param {string} patientId 
         * @param {PatientUpdate} patientUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient(patientId: string, patientUpdate: PatientUpdate, options?: RawAxiosRequestConfig): AxiosPromise<Patient> {
            return localVarFp.updatePatient(patientId, patientUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an appointment for a patient with audit logging  Maps to Java endpoint: PUT /patients/{patientId}/appointments/{appointmentId}/
         * @summary Update Patient Appointment
         * @param {string} patientId 
         * @param {string} appointmentId 
         * @param {AppointmentUpdate} appointmentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientAppointment(patientId: string, appointmentId: string, appointmentUpdate: AppointmentUpdate, options?: RawAxiosRequestConfig): AxiosPromise<Appointment> {
            return localVarFp.updatePatientAppointment(patientId, appointmentId, appointmentUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update photo metadata with audit logging
         * @summary Update Photo
         * @param {string} photoId 
         * @param {string | null} [photoType] 
         * @param {string | null} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoto(photoId: string, photoType?: string | null, description?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PhotoResponse> {
            return localVarFp.updatePhoto(photoId, photoType, description, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a tooth status with audit logging
         * @summary Update Tooth Status
         * @param {string} appointmentId 
         * @param {string} statusId 
         * @param {StatusToothUpdate} statusToothUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToothStatus(appointmentId: string, statusId: string, statusToothUpdate: StatusToothUpdate, options?: RawAxiosRequestConfig): AxiosPromise<ToothStatus> {
            return localVarFp.updateToothStatus(appointmentId, statusId, statusToothUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a tooth treatment with audit logging
         * @summary Update Tooth Treatment
         * @param {string} appointmentId 
         * @param {string} treatmentId 
         * @param {Array<TreatmentToothUpdate>} treatmentToothUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToothTreatment(appointmentId: string, treatmentId: string, treatmentToothUpdate: Array<TreatmentToothUpdate>, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateToothTreatment(appointmentId, treatmentId, treatmentToothUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update treatment financial information (paid status) Endpoint: PUT /patients/{patientId}/treatments/{treatmentId}/finances/
         * @summary Update Patient Treatments Finances Information
         * @param {string} patientId 
         * @param {string} treatmentId 
         * @param {UpdateTreatmentsFinancialsRequest} updateTreatmentsFinancialsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTreatmentsFinancials(patientId: string, treatmentId: string, updateTreatmentsFinancialsRequest: UpdateTreatmentsFinancialsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTreatmentsFinancials(patientId, treatmentId, updateTreatmentsFinancialsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload avatar for a patient
         * @summary Upload Patient Avatar
         * @param {string} patientId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPatientAvatar(patientId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<Patient> {
            return localVarFp.uploadPatientAvatar(patientId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a photo for a patient with audit logging  Maps to Java: PatientController.uploadPhoto(UUID patientId, String type, MultipartFile file) Java returns: 200 OK (line 113) Expects multipart/form-data with fields: file, photo_type, description (optional)
         * @summary Upload Patient Photo
         * @param {string} patientId 
         * @param {File} file 
         * @param {string} photoType 
         * @param {string | null} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPatientPhoto(patientId: string, file: File, photoType: string, description?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PhotoResponse> {
            return localVarFp.uploadPatientPhoto(patientId, file, photoType, description, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientsApi - object-oriented interface
 */
export class PatientsApi extends BaseAPI {
    /**
     * Get patient counts for multiple organizations in one request (batch-get endpoint)
     * @summary Batch Get Patients Counts
     * @param {BatchGetRequest} batchGetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public batchGetPatientsCounts(batchGetRequest: BatchGetRequest, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).batchGetPatientsCounts(batchGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change NZIS status for treatment and related treatments with same sequence_id  Maps to Java: PatientController.changePatientTreatmentNzisStatus()  Endpoint: POST /patients/treatments/change-nzis-status
     * @summary Change Patient Treatment Nzis Status
     * @param {ChangePatientTreatmentNzisStatusRequest} changePatientTreatmentNzisStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public changePatientTreatmentNzisStatus(changePatientTreatmentNzisStatusRequest: ChangePatientTreatmentNzisStatusRequest, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).changePatientTreatmentNzisStatus(changePatientTreatmentNzisStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new patient condition with audit logging
     * @summary Create Condition
     * @param {ConditionCreate} conditionCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCondition(conditionCreate: ConditionCreate, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).createCondition(conditionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new notice  Maps to Java endpoint: POST /patients/notices/ Java returns: 200 OK (line 468) Creates a medical notice for a patient with ICD code, institution, and date range.
     * @summary Create Notice
     * @param {NoticeCreate} noticeCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createNotice(noticeCreate: NoticeCreate, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).createNotice(noticeCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new patient with audit logging
     * @summary Create Patient
     * @param {PatientCreate} patientCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPatient(patientCreate: PatientCreate, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).createPatient(patientCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new appointment for a patient with audit logging  Maps to Java endpoint: POST /patients/{patientId}/appointments/
     * @summary Create Patient Appointment
     * @param {string} patientId 
     * @param {AppointmentCreate} appointmentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPatientAppointment(patientId: string, appointmentCreate: AppointmentCreate, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).createPatientAppointment(patientId, appointmentCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new tooth record
     * @summary Create Tooth
     * @param {ToothCreate} toothCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTooth(toothCreate: ToothCreate, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).createTooth(toothCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create tooth statuses (batch create) with audit logging
     * @summary Create Tooth Status
     * @param {string} appointmentId 
     * @param {Array<StatusToothCreate>} statusToothCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createToothStatus(appointmentId: string, statusToothCreate: Array<StatusToothCreate>, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).createToothStatus(appointmentId, statusToothCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new tooth treatments (batch operation) with audit logging  Maps to Java: PatientController.createPatientTreatment() Java returns: 200 OK (line 346) Accepts a list of treatments to create in a single request.
     * @summary Create Tooth Treatment
     * @param {string} appointmentId 
     * @param {Array<TreatmentToothCreate>} treatmentToothCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createToothTreatment(appointmentId: string, treatmentToothCreate: Array<TreatmentToothCreate>, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).createToothTreatment(appointmentId, treatmentToothCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a patient condition with audit logging
     * @summary Delete Condition
     * @param {string} conditionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCondition(conditionId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).deleteCondition(conditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a patient (Admin only) with audit logging  Returns 204 No Content on successful deletion.
     * @summary Delete Patient
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePatient(patientId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).deletePatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an appointment for a patient with audit logging  Maps to Java endpoint: DELETE /patients/{patientId}/appointments/{appointmentId}/
     * @summary Delete Patient Appointment
     * @param {string} patientId 
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePatientAppointment(patientId: string, appointmentId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).deletePatientAppointment(patientId, appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete all patients in an organization (Admin only)
     * @summary Delete Patients By Organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePatientsByOrganization(organizationId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).deletePatientsByOrganization(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a patient photo with audit logging
     * @summary Delete Photo
     * @param {string} photoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePhoto(photoId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).deletePhoto(photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a tooth status (soft delete) with audit logging
     * @summary Delete Tooth Status
     * @param {string} appointmentId 
     * @param {string} statusId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteToothStatus(appointmentId: string, statusId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).deleteToothStatus(appointmentId, statusId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a tooth treatment (soft delete) with audit logging
     * @summary Delete Tooth Treatment
     * @param {string} appointmentId 
     * @param {string} treatmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteToothTreatment(appointmentId: string, treatmentId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).deleteToothTreatment(appointmentId, treatmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all patients with pagination and filtering  Accepts both camelCase (sortBy) and snake_case (sort_by) for Java API compatibility. Page numbering: Frontend sends 0-indexed, backend converts to 1-indexed.  Uses OrgContext for multi-organization support - respects selected organization from JWT.
     * @summary Fetch All Patients
     * @param {string | null} [keyword] Search keyword
     * @param {string | null} [sortBy] Field to sort by
     * @param {string} [order] Sort order (asc/desc)
     * @param {number} [page] Page number (0-indexed from frontend)
     * @param {number} [perPage] Items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllPatients(keyword?: string | null, sortBy?: string | null, order?: string, page?: number, perPage?: number, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).fetchAllPatients(keyword, sortBy, order, page, perPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all appointments for a patient (excluding deleted)  Maps to Java endpoint: GET /patients/{patientId}/appointments/ Returns all appointments for the specified patient, filtering out deleted ones.
     * @summary Fetch Patient Appointments
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPatientAppointments(patientId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).fetchPatientAppointments(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch patient avatar  Maps to Java endpoint: GET /patient/{id}/avatar/ from PatientController.fetchPatientAvatar()  Returns the patient\'s avatar image file. Authorization: CLINIC_ADMIN, MEDICAL_DOCTOR, MEDICAL_ASSISTANT, or RECEPTIONIST
     * @summary Fetch Patient Avatar
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPatientAvatar(patientId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).fetchPatientAvatar(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch patient by ID
     * @summary Fetch Patient
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPatientById(patientId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).fetchPatientById(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all teeth for the patient associated with the appointment  Maps to Java: PatientController.fetchPatientTeeth() Returns teeth with nested toothStatuses including status objects (label, color, displayName)
     * @summary Get Appointment Teeth
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPatientTeeth(appointmentId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).fetchPatientTeeth(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all tooth statuses for an appointment  Maps to Java: PatientController.fetchPatientToothStatuses()
     * @summary Get Appointment Tooth Statuses
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPatientToothStatuses(appointmentId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).fetchPatientToothStatuses(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get total count of patients in the selected organization  Uses OrgContext for multi-organization support - counts patients in selected organization. Platform administrators can count across all orgs by passing None.
     * @summary Fetch Patients Count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPatientsCount(options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).fetchPatientsCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get total count of patients for a specific organization (admin only)
     * @summary Fetch Patients Count By Org
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPatientsCountByOrg(organizationId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).fetchPatientsCountByOrg(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch patients with sent NZIS data  Maps to Java endpoint: GET /patients/sent/ Returns patients who have treatments that HAVE been sent to NZIS.
     * @summary Fetch Patients With Sent Nzis Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPatientsWithSentNzisData(options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).fetchPatientsWithSentNzisData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch patients with unsent NZIS data  Maps to Java endpoint: GET /patients/unsent/ Returns patients who have treatments that have NOT been sent to NZIS.
     * @summary Fetch Patients With Unsent Nzis Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPatientsWithUnsentNzisData(options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).fetchPatientsWithUnsentNzisData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve photo file by ID  Matches Java endpoint: GET /patients/photos/{id} from PatientController.fetchPhoto()  Returns the photo file as a file response.
     * @summary Fetch Photo
     * @param {string} photoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPhoto(photoId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).fetchPhoto(photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate PDF for patient medical history and treatment records  Returns: PDF file with patient name as filename  Implementation: Basic PDF generation with ReportLab Uses placeholder template - customize with actual business requirements
     * @summary Generate Medical History Pdf
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateMedicalHistoryPdf(patientId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).generateMedicalHistoryPdf(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Backward-compatible alias for the Dental Visit Record PDF.  Kept for the existing frontend and Java API path compatibility (\"ambolatory\" spelling). Delegates to the same generator as ``/visit-record`` and now returns the file as an attachment (was previously a stub served inline).  Parameters: - patient_id: Patient UUID - variant: \'bg\' (default) or \'intl\' - toothTreatmentIds: treatment UUIDs to include in the activity table
     * @summary Generate Ambolatory Sheet
     * @param {string} patientId 
     * @param {string | null} [variant] Optional override: \&#39;bg\&#39; or \&#39;intl\&#39;. Omit to auto-select from the organization.
     * @param {Array<string>} [toothTreatmentIds] 
     * @param {boolean} [debugOverlay] Internal/calibration only: draw red field boxes on the BG template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generatePdfAmbolatorySheetForPatient(patientId: string, variant?: string | null, toothTreatmentIds?: Array<string>, debugOverlay?: boolean, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).generatePdfAmbolatorySheetForPatient(patientId, variant, toothTreatmentIds, debugOverlay, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate patient document PDF from appointment  Matches Java endpoint: GET /patients/{patientId}/pdf/ from PatientController.generatePdfForPatient()  Takes appointmentId as path parameter. Returns PDF file with attachment content-disposition.
     * @summary Generate Pdf For Appointment
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generatePdfForPatient(appointmentId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).generatePdfForPatient(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all patient conditions
     * @summary Get All Conditions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllConditions(options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getAllConditions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all notices for the organization  Maps to Java endpoint: GET /patients/notices/ Returns all medical notices for the current user\'s organization.
     * @summary Get All Notices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllNotices(options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getAllNotices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all treatments for the user\'s organization  Matches Java endpoint: GET /patients/treatments/all from PatientController.fetchAllTreatments() -> TreatmentServiceImpl.fetchTreatments()  Returns DONE treatments that haven\'t been sent to NZIS for patients in the user\'s organization. Matches Java filters: - organization_id from principal - sentToNhis == false - status == DONE
     * @summary Get All Treatments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllTreatments(options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getAllTreatments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all tooth treatments for an appointment  Returns treatments with status object (label, color) for tooth graphic rendering
     * @summary Get Appointment Tooth Treatments
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAppointmentToothTreatments(appointmentId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getAppointmentToothTreatments(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all photos for a patient
     * @summary Get Patient Photos
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientPhotos(patientId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getPatientPhotos(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all teeth for a patient
     * @summary Get Patient Teeth
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientTeeth(patientId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getPatientTeeth(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all tooth treatments for a patient  Returns treatments with status object (label, color) for tooth graphic rendering
     * @summary Get Patient Tooth Treatments
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientToothTreatments(patientId: string, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getPatientToothTreatments(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a printable Dental Visit Record PDF for a patient.  This is a convenience document only — it is NOT QES-signed and NOT submitted to NZIS. It is downloaded (Content-Disposition: attachment) so the doctor can print and sign/stamp the paper copy.  Parameters: - patient_id: Patient UUID - variant: \'bg\' (default) or \'intl\' - toothTreatmentIds: treatment UUIDs to include in the activity table
     * @summary Get Patient Visit Record
     * @param {string} patientId 
     * @param {string | null} [variant] Optional override: \&#39;bg\&#39; or \&#39;intl\&#39;. Omit to auto-select from the organization (Bulgarian -&gt; bg, otherwise -&gt; intl).
     * @param {Array<string>} [toothTreatmentIds] 
     * @param {boolean} [debugOverlay] Internal/calibration only: draw red field boxes on the BG template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientVisitRecord(patientId: string, variant?: string | null, toothTreatmentIds?: Array<string>, debugOverlay?: boolean, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).getPatientVisitRecord(patientId, variant, toothTreatmentIds, debugOverlay, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a patient condition with audit logging
     * @summary Update Condition
     * @param {string} conditionId 
     * @param {ConditionUpdate} conditionUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCondition(conditionId: string, conditionUpdate: ConditionUpdate, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).updateCondition(conditionId, conditionUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update patient information with audit logging
     * @summary Update Patient
     * @param {string} patientId 
     * @param {PatientUpdate} patientUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePatient(patientId: string, patientUpdate: PatientUpdate, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).updatePatient(patientId, patientUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an appointment for a patient with audit logging  Maps to Java endpoint: PUT /patients/{patientId}/appointments/{appointmentId}/
     * @summary Update Patient Appointment
     * @param {string} patientId 
     * @param {string} appointmentId 
     * @param {AppointmentUpdate} appointmentUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePatientAppointment(patientId: string, appointmentId: string, appointmentUpdate: AppointmentUpdate, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).updatePatientAppointment(patientId, appointmentId, appointmentUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update photo metadata with audit logging
     * @summary Update Photo
     * @param {string} photoId 
     * @param {string | null} [photoType] 
     * @param {string | null} [description] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePhoto(photoId: string, photoType?: string | null, description?: string | null, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).updatePhoto(photoId, photoType, description, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a tooth status with audit logging
     * @summary Update Tooth Status
     * @param {string} appointmentId 
     * @param {string} statusId 
     * @param {StatusToothUpdate} statusToothUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateToothStatus(appointmentId: string, statusId: string, statusToothUpdate: StatusToothUpdate, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).updateToothStatus(appointmentId, statusId, statusToothUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a tooth treatment with audit logging
     * @summary Update Tooth Treatment
     * @param {string} appointmentId 
     * @param {string} treatmentId 
     * @param {Array<TreatmentToothUpdate>} treatmentToothUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateToothTreatment(appointmentId: string, treatmentId: string, treatmentToothUpdate: Array<TreatmentToothUpdate>, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).updateToothTreatment(appointmentId, treatmentId, treatmentToothUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update treatment financial information (paid status) Endpoint: PUT /patients/{patientId}/treatments/{treatmentId}/finances/
     * @summary Update Patient Treatments Finances Information
     * @param {string} patientId 
     * @param {string} treatmentId 
     * @param {UpdateTreatmentsFinancialsRequest} updateTreatmentsFinancialsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTreatmentsFinancials(patientId: string, treatmentId: string, updateTreatmentsFinancialsRequest: UpdateTreatmentsFinancialsRequest, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).updateTreatmentsFinancials(patientId, treatmentId, updateTreatmentsFinancialsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload avatar for a patient
     * @summary Upload Patient Avatar
     * @param {string} patientId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPatientAvatar(patientId: string, file: File, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).uploadPatientAvatar(patientId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a photo for a patient with audit logging  Maps to Java: PatientController.uploadPhoto(UUID patientId, String type, MultipartFile file) Java returns: 200 OK (line 113) Expects multipart/form-data with fields: file, photo_type, description (optional)
     * @summary Upload Patient Photo
     * @param {string} patientId 
     * @param {File} file 
     * @param {string} photoType 
     * @param {string | null} [description] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPatientPhoto(patientId: string, file: File, photoType: string, description?: string | null, options?: RawAxiosRequestConfig) {
        return PatientsApiFp(this.configuration).uploadPatientPhoto(patientId, file, photoType, description, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PdfApi - axios parameter creator
 */
export const PdfApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generate the Dental Visit Record PDF for a patient (alias path under /pdf).  Delegates to the shared :func:`build_visit_record_response`, returning the file as an attachment.  Query params:     treatment_ids: Optional comma-separated list of treatment IDs     variant: \'bg\' (default) or \'intl\'
         * @summary Generate Ambulatory Sheet Pdf
         * @param {string} patientId 
         * @param {string | null} [treatmentIds] 
         * @param {string | null} [variant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAmbulatorySheetPdf: async (patientId: string, treatmentIds?: string | null, variant?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('generateAmbulatorySheetPdf', 'patientId', patientId)
            const localVarPath = `/api/pdf/patients/{patient_id}/ambulatory-sheet`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (treatmentIds !== undefined) {
                localVarQueryParameter['treatment_ids'] = treatmentIds;
            }

            if (variant !== undefined) {
                localVarQueryParameter['variant'] = variant;
            }

            localVarHeaderParameter['Accept'] = 'application/pdf,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate dental chart PDF for a patient
         * @summary Generate Dental Chart Pdf
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDentalChartPdf: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('generateDentalChartPdf', 'patientId', patientId)
            const localVarPath = `/api/pdf/patients/{patient_id}/dental-chart`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/pdf,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PdfApi - functional programming interface
 */
export const PdfApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PdfApiAxiosParamCreator(configuration)
    return {
        /**
         * Generate the Dental Visit Record PDF for a patient (alias path under /pdf).  Delegates to the shared :func:`build_visit_record_response`, returning the file as an attachment.  Query params:     treatment_ids: Optional comma-separated list of treatment IDs     variant: \'bg\' (default) or \'intl\'
         * @summary Generate Ambulatory Sheet Pdf
         * @param {string} patientId 
         * @param {string | null} [treatmentIds] 
         * @param {string | null} [variant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAmbulatorySheetPdf(patientId: string, treatmentIds?: string | null, variant?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAmbulatorySheetPdf(patientId, treatmentIds, variant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PdfApi.generateAmbulatorySheetPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate dental chart PDF for a patient
         * @summary Generate Dental Chart Pdf
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDentalChartPdf(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDentalChartPdf(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PdfApi.generateDentalChartPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PdfApi - factory interface
 */
export const PdfApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PdfApiFp(configuration)
    return {
        /**
         * Generate the Dental Visit Record PDF for a patient (alias path under /pdf).  Delegates to the shared :func:`build_visit_record_response`, returning the file as an attachment.  Query params:     treatment_ids: Optional comma-separated list of treatment IDs     variant: \'bg\' (default) or \'intl\'
         * @summary Generate Ambulatory Sheet Pdf
         * @param {string} patientId 
         * @param {string | null} [treatmentIds] 
         * @param {string | null} [variant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAmbulatorySheetPdf(patientId: string, treatmentIds?: string | null, variant?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generateAmbulatorySheetPdf(patientId, treatmentIds, variant, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate dental chart PDF for a patient
         * @summary Generate Dental Chart Pdf
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDentalChartPdf(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generateDentalChartPdf(patientId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PdfApi - object-oriented interface
 */
export class PdfApi extends BaseAPI {
    /**
     * Generate the Dental Visit Record PDF for a patient (alias path under /pdf).  Delegates to the shared :func:`build_visit_record_response`, returning the file as an attachment.  Query params:     treatment_ids: Optional comma-separated list of treatment IDs     variant: \'bg\' (default) or \'intl\'
     * @summary Generate Ambulatory Sheet Pdf
     * @param {string} patientId 
     * @param {string | null} [treatmentIds] 
     * @param {string | null} [variant] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateAmbulatorySheetPdf(patientId: string, treatmentIds?: string | null, variant?: string | null, options?: RawAxiosRequestConfig) {
        return PdfApiFp(this.configuration).generateAmbulatorySheetPdf(patientId, treatmentIds, variant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate dental chart PDF for a patient
     * @summary Generate Dental Chart Pdf
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateDentalChartPdf(patientId: string, options?: RawAxiosRequestConfig) {
        return PdfApiFp(this.configuration).generateDentalChartPdf(patientId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PublicApi - axios parameter creator
 */
export const PublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check if an organization allows patient self-registration.  This is a public endpoint that doesn\'t require authentication.
         * @summary Check Organization Availability
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOrganizationAvailability: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('checkOrganizationAvailability', 'organizationId', organizationId)
            const localVarPath = `/api/public/organizations/{organization_id}/availability`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return public metadata about a staff portal-access invite token.  No authentication required.  Exposes only masked email, org name, inviter name, expiry, status, and whether a user account already exists for the invited address. No internal IDs are returned.  Status values:   - \"pending\"   : token is valid and awaiting acceptance   - \"expired\"   : token exists but past expires_at   - \"accepted\"  : invite has already been redeemed   - \"revoked\"   : invite was explicitly revoked by a CLINIC_ADMIN
         * @summary Get Staff Invite Info
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaffInviteInfo: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getStaffInviteInfo', 'token', token)
            const localVarPath = `/api/public/staff-invite/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redeem a staff portal-access invite token.  No authentication required (the token IS the credential).  All DB writes (membership, staff linkage, invite accepted_at) are in a single transaction.  SELECT FOR UPDATE on the invite prevents double-redemption under concurrent requests.  Case A — email matches an existing User account:   - Creates or updates OrganizationMembership (status=ACTIVE, role=invite.role).   - Links staff.user_id and sets staff.has_portal_access=True.   - Returns {action: \"linked_existing_user\", redirectHint: \"login\"}.  Case B — no User account for the invited email:   - Requires password, first_name, last_name in the request body (HTTP 422 if missing).   - Creates User + OrganizationMembership (status=ACTIVE).   - Links staff.user_id and sets staff.has_portal_access=True.   - Returns {action: \"created_new_user\", redirectHint: \"login\"}.  Error codes:   - 400 \"Invite token is invalid\"           : token not found   - 400 \"Invite has already been accepted\"   : accepted_at is set   - 400 \"Invite has been revoked\"            : revoked_at is set   - 400 \"Invite has expired\"                 : past expires_at   - 400 \"Invite role is not permitted\"       : PLATFORM_ADMINISTRATOR blocked   - 400 \"Staff is linked to a different user account\"   - 422 \"password is required for new user accounts\"   - 422 \"first_name and last_name are required for new user accounts\"
         * @summary Redeem Staff Invite
         * @param {StaffInviteRedeemRequest} staffInviteRedeemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemStaffInvite: async (staffInviteRedeemRequest: StaffInviteRedeemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffInviteRedeemRequest' is not null or undefined
            assertParamExists('redeemStaffInvite', 'staffInviteRedeemRequest', staffInviteRedeemRequest)
            const localVarPath = `/api/public/staff-invite/redeem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(staffInviteRedeemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patient self-registration endpoint.  This is a public endpoint that allows patients to create their own accounts. Sends a verification email after registration.
         * @summary Register Patient
         * @param {PatientSelfRegistrationRequest} patientSelfRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPatient: async (patientSelfRegistrationRequest: PatientSelfRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientSelfRegistrationRequest' is not null or undefined
            assertParamExists('registerPatient', 'patientSelfRegistrationRequest', patientSelfRegistrationRequest)
            const localVarPath = `/api/public/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientSelfRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend verification email.  This is a public endpoint that resends the verification email if the original was lost or expired.
         * @summary Resend Verification Email
         * @param {ResendVerificationEmailRequest} resendVerificationEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationEmail: async (resendVerificationEmailRequest: ResendVerificationEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendVerificationEmailRequest' is not null or undefined
            assertParamExists('resendVerificationEmail', 'resendVerificationEmailRequest', resendVerificationEmailRequest)
            const localVarPath = `/api/public/resend-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendVerificationEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify email address using verification token.  This is a public endpoint that activates the patient account after email verification.
         * @summary Verify Email
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: async (verifyEmailRequest: VerifyEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyEmailRequest' is not null or undefined
            assertParamExists('verifyEmail', 'verifyEmailRequest', verifyEmailRequest)
            const localVarPath = `/api/public/verify-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApi - functional programming interface
 */
export const PublicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicApiAxiosParamCreator(configuration)
    return {
        /**
         * Check if an organization allows patient self-registration.  This is a public endpoint that doesn\'t require authentication.
         * @summary Check Organization Availability
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkOrganizationAvailability(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationAvailabilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkOrganizationAvailability(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.checkOrganizationAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return public metadata about a staff portal-access invite token.  No authentication required.  Exposes only masked email, org name, inviter name, expiry, status, and whether a user account already exists for the invited address. No internal IDs are returned.  Status values:   - \"pending\"   : token is valid and awaiting acceptance   - \"expired\"   : token exists but past expires_at   - \"accepted\"  : invite has already been redeemed   - \"revoked\"   : invite was explicitly revoked by a CLINIC_ADMIN
         * @summary Get Staff Invite Info
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStaffInviteInfo(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaffInviteInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStaffInviteInfo(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.getStaffInviteInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redeem a staff portal-access invite token.  No authentication required (the token IS the credential).  All DB writes (membership, staff linkage, invite accepted_at) are in a single transaction.  SELECT FOR UPDATE on the invite prevents double-redemption under concurrent requests.  Case A — email matches an existing User account:   - Creates or updates OrganizationMembership (status=ACTIVE, role=invite.role).   - Links staff.user_id and sets staff.has_portal_access=True.   - Returns {action: \"linked_existing_user\", redirectHint: \"login\"}.  Case B — no User account for the invited email:   - Requires password, first_name, last_name in the request body (HTTP 422 if missing).   - Creates User + OrganizationMembership (status=ACTIVE).   - Links staff.user_id and sets staff.has_portal_access=True.   - Returns {action: \"created_new_user\", redirectHint: \"login\"}.  Error codes:   - 400 \"Invite token is invalid\"           : token not found   - 400 \"Invite has already been accepted\"   : accepted_at is set   - 400 \"Invite has been revoked\"            : revoked_at is set   - 400 \"Invite has expired\"                 : past expires_at   - 400 \"Invite role is not permitted\"       : PLATFORM_ADMINISTRATOR blocked   - 400 \"Staff is linked to a different user account\"   - 422 \"password is required for new user accounts\"   - 422 \"first_name and last_name are required for new user accounts\"
         * @summary Redeem Staff Invite
         * @param {StaffInviteRedeemRequest} staffInviteRedeemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeemStaffInvite(staffInviteRedeemRequest: StaffInviteRedeemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaffInviteRedeemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeemStaffInvite(staffInviteRedeemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.redeemStaffInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patient self-registration endpoint.  This is a public endpoint that allows patients to create their own accounts. Sends a verification email after registration.
         * @summary Register Patient
         * @param {PatientSelfRegistrationRequest} patientSelfRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerPatient(patientSelfRegistrationRequest: PatientSelfRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientSelfRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerPatient(patientSelfRegistrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.registerPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend verification email.  This is a public endpoint that resends the verification email if the original was lost or expired.
         * @summary Resend Verification Email
         * @param {ResendVerificationEmailRequest} resendVerificationEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendVerificationEmail(resendVerificationEmailRequest: ResendVerificationEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendVerificationEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendVerificationEmail(resendVerificationEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.resendVerificationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify email address using verification token.  This is a public endpoint that activates the patient account after email verification.
         * @summary Verify Email
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmail(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmail(verifyEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.verifyEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicApi - factory interface
 */
export const PublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicApiFp(configuration)
    return {
        /**
         * Check if an organization allows patient self-registration.  This is a public endpoint that doesn\'t require authentication.
         * @summary Check Organization Availability
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOrganizationAvailability(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationAvailabilityResponse> {
            return localVarFp.checkOrganizationAvailability(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return public metadata about a staff portal-access invite token.  No authentication required.  Exposes only masked email, org name, inviter name, expiry, status, and whether a user account already exists for the invited address. No internal IDs are returned.  Status values:   - \"pending\"   : token is valid and awaiting acceptance   - \"expired\"   : token exists but past expires_at   - \"accepted\"  : invite has already been redeemed   - \"revoked\"   : invite was explicitly revoked by a CLINIC_ADMIN
         * @summary Get Staff Invite Info
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaffInviteInfo(token: string, options?: RawAxiosRequestConfig): AxiosPromise<StaffInviteInfoResponse> {
            return localVarFp.getStaffInviteInfo(token, options).then((request) => request(axios, basePath));
        },
        /**
         * Redeem a staff portal-access invite token.  No authentication required (the token IS the credential).  All DB writes (membership, staff linkage, invite accepted_at) are in a single transaction.  SELECT FOR UPDATE on the invite prevents double-redemption under concurrent requests.  Case A — email matches an existing User account:   - Creates or updates OrganizationMembership (status=ACTIVE, role=invite.role).   - Links staff.user_id and sets staff.has_portal_access=True.   - Returns {action: \"linked_existing_user\", redirectHint: \"login\"}.  Case B — no User account for the invited email:   - Requires password, first_name, last_name in the request body (HTTP 422 if missing).   - Creates User + OrganizationMembership (status=ACTIVE).   - Links staff.user_id and sets staff.has_portal_access=True.   - Returns {action: \"created_new_user\", redirectHint: \"login\"}.  Error codes:   - 400 \"Invite token is invalid\"           : token not found   - 400 \"Invite has already been accepted\"   : accepted_at is set   - 400 \"Invite has been revoked\"            : revoked_at is set   - 400 \"Invite has expired\"                 : past expires_at   - 400 \"Invite role is not permitted\"       : PLATFORM_ADMINISTRATOR blocked   - 400 \"Staff is linked to a different user account\"   - 422 \"password is required for new user accounts\"   - 422 \"first_name and last_name are required for new user accounts\"
         * @summary Redeem Staff Invite
         * @param {StaffInviteRedeemRequest} staffInviteRedeemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemStaffInvite(staffInviteRedeemRequest: StaffInviteRedeemRequest, options?: RawAxiosRequestConfig): AxiosPromise<StaffInviteRedeemResponse> {
            return localVarFp.redeemStaffInvite(staffInviteRedeemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Patient self-registration endpoint.  This is a public endpoint that allows patients to create their own accounts. Sends a verification email after registration.
         * @summary Register Patient
         * @param {PatientSelfRegistrationRequest} patientSelfRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPatient(patientSelfRegistrationRequest: PatientSelfRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientSelfRegistrationResponse> {
            return localVarFp.registerPatient(patientSelfRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend verification email.  This is a public endpoint that resends the verification email if the original was lost or expired.
         * @summary Resend Verification Email
         * @param {ResendVerificationEmailRequest} resendVerificationEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationEmail(resendVerificationEmailRequest: ResendVerificationEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResendVerificationEmailResponse> {
            return localVarFp.resendVerificationEmail(resendVerificationEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify email address using verification token.  This is a public endpoint that activates the patient account after email verification.
         * @summary Verify Email
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifyEmailResponse> {
            return localVarFp.verifyEmail(verifyEmailRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicApi - object-oriented interface
 */
export class PublicApi extends BaseAPI {
    /**
     * Check if an organization allows patient self-registration.  This is a public endpoint that doesn\'t require authentication.
     * @summary Check Organization Availability
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkOrganizationAvailability(organizationId: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).checkOrganizationAvailability(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return public metadata about a staff portal-access invite token.  No authentication required.  Exposes only masked email, org name, inviter name, expiry, status, and whether a user account already exists for the invited address. No internal IDs are returned.  Status values:   - \"pending\"   : token is valid and awaiting acceptance   - \"expired\"   : token exists but past expires_at   - \"accepted\"  : invite has already been redeemed   - \"revoked\"   : invite was explicitly revoked by a CLINIC_ADMIN
     * @summary Get Staff Invite Info
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStaffInviteInfo(token: string, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).getStaffInviteInfo(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redeem a staff portal-access invite token.  No authentication required (the token IS the credential).  All DB writes (membership, staff linkage, invite accepted_at) are in a single transaction.  SELECT FOR UPDATE on the invite prevents double-redemption under concurrent requests.  Case A — email matches an existing User account:   - Creates or updates OrganizationMembership (status=ACTIVE, role=invite.role).   - Links staff.user_id and sets staff.has_portal_access=True.   - Returns {action: \"linked_existing_user\", redirectHint: \"login\"}.  Case B — no User account for the invited email:   - Requires password, first_name, last_name in the request body (HTTP 422 if missing).   - Creates User + OrganizationMembership (status=ACTIVE).   - Links staff.user_id and sets staff.has_portal_access=True.   - Returns {action: \"created_new_user\", redirectHint: \"login\"}.  Error codes:   - 400 \"Invite token is invalid\"           : token not found   - 400 \"Invite has already been accepted\"   : accepted_at is set   - 400 \"Invite has been revoked\"            : revoked_at is set   - 400 \"Invite has expired\"                 : past expires_at   - 400 \"Invite role is not permitted\"       : PLATFORM_ADMINISTRATOR blocked   - 400 \"Staff is linked to a different user account\"   - 422 \"password is required for new user accounts\"   - 422 \"first_name and last_name are required for new user accounts\"
     * @summary Redeem Staff Invite
     * @param {StaffInviteRedeemRequest} staffInviteRedeemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public redeemStaffInvite(staffInviteRedeemRequest: StaffInviteRedeemRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).redeemStaffInvite(staffInviteRedeemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patient self-registration endpoint.  This is a public endpoint that allows patients to create their own accounts. Sends a verification email after registration.
     * @summary Register Patient
     * @param {PatientSelfRegistrationRequest} patientSelfRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerPatient(patientSelfRegistrationRequest: PatientSelfRegistrationRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).registerPatient(patientSelfRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend verification email.  This is a public endpoint that resends the verification email if the original was lost or expired.
     * @summary Resend Verification Email
     * @param {ResendVerificationEmailRequest} resendVerificationEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resendVerificationEmail(resendVerificationEmailRequest: ResendVerificationEmailRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).resendVerificationEmail(resendVerificationEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify email address using verification token.  This is a public endpoint that activates the patient account after email verification.
     * @summary Verify Email
     * @param {VerifyEmailRequest} verifyEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public verifyEmail(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).verifyEmail(verifyEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportsApi - axios parameter creator
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch reports with filters  Maps to Java: ReportController.fetchReports() -> ReportServiceImpl.findAllReports() Queries TreatmentTooth (treatments_teeth) table, not Appointments Returns paginated list of individual tooth treatments with financial data
         * @summary Fetch Reports
         * @param {string} [fromDate] Start date filter
         * @param {string} [toDate] End date filter
         * @param {string} [doctor] Filter by doctor ID
         * @param {string} [patient] Filter by patient ID
         * @param {string} [clinic] Filter by clinic ID (empty &#x3D; all clinics)
         * @param {number} [page] Page number
         * @param {number} [perPage] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchReports: async (fromDate?: string, toDate?: string, doctor?: string, patient?: string, clinic?: string, page?: number, perPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/reports/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (doctor !== undefined) {
                localVarQueryParameter['doctor'] = doctor;
            }

            if (patient !== undefined) {
                localVarQueryParameter['patient'] = patient;
            }

            if (clinic !== undefined) {
                localVarQueryParameter['clinic'] = clinic;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate Excel document for reports  Matches Java: GET /reports/generate-document/ ReportController.generateReportsDocument() line 36  Java implementation: Generates Excel file (.xls) with treatment tooth data Columns: Patient, Date, Condition, Treatment, Tooth, Price, Debt, Paid, Doctor Returns: Excel file as binary stream with Content-Disposition header
         * @summary Generate Reports Document
         * @param {string} [fromDate] Start date filter
         * @param {string} [toDate] End date filter
         * @param {string} [doctor] Filter by doctor ID
         * @param {string} [patient] Filter by patient ID
         * @param {string} [clinic] Filter by clinic ID (empty &#x3D; all clinics)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReportsDocument: async (fromDate?: string, toDate?: string, doctor?: string, patient?: string, clinic?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/reports/generate-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (doctor !== undefined) {
                localVarQueryParameter['doctor'] = doctor;
            }

            if (patient !== undefined) {
                localVarQueryParameter['patient'] = patient;
            }

            if (clinic !== undefined) {
                localVarQueryParameter['clinic'] = clinic;
            }

            localVarHeaderParameter['Accept'] = 'application/vnd.ms-excel,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch reports with filters  Maps to Java: ReportController.fetchReports() -> ReportServiceImpl.findAllReports() Queries TreatmentTooth (treatments_teeth) table, not Appointments Returns paginated list of individual tooth treatments with financial data
         * @summary Fetch Reports
         * @param {string} [fromDate] Start date filter
         * @param {string} [toDate] End date filter
         * @param {string} [doctor] Filter by doctor ID
         * @param {string} [patient] Filter by patient ID
         * @param {string} [clinic] Filter by clinic ID (empty &#x3D; all clinics)
         * @param {number} [page] Page number
         * @param {number} [perPage] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchReports(fromDate?: string, toDate?: string, doctor?: string, patient?: string, clinic?: string, page?: number, perPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportsPaginationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchReports(fromDate, toDate, doctor, patient, clinic, page, perPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.fetchReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate Excel document for reports  Matches Java: GET /reports/generate-document/ ReportController.generateReportsDocument() line 36  Java implementation: Generates Excel file (.xls) with treatment tooth data Columns: Patient, Date, Condition, Treatment, Tooth, Price, Debt, Paid, Doctor Returns: Excel file as binary stream with Content-Disposition header
         * @summary Generate Reports Document
         * @param {string} [fromDate] Start date filter
         * @param {string} [toDate] End date filter
         * @param {string} [doctor] Filter by doctor ID
         * @param {string} [patient] Filter by patient ID
         * @param {string} [clinic] Filter by clinic ID (empty &#x3D; all clinics)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateReportsDocument(fromDate?: string, toDate?: string, doctor?: string, patient?: string, clinic?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateReportsDocument(fromDate, toDate, doctor, patient, clinic, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.generateReportsDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportsApi - factory interface
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * Fetch reports with filters  Maps to Java: ReportController.fetchReports() -> ReportServiceImpl.findAllReports() Queries TreatmentTooth (treatments_teeth) table, not Appointments Returns paginated list of individual tooth treatments with financial data
         * @summary Fetch Reports
         * @param {string} [fromDate] Start date filter
         * @param {string} [toDate] End date filter
         * @param {string} [doctor] Filter by doctor ID
         * @param {string} [patient] Filter by patient ID
         * @param {string} [clinic] Filter by clinic ID (empty &#x3D; all clinics)
         * @param {number} [page] Page number
         * @param {number} [perPage] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchReports(fromDate?: string, toDate?: string, doctor?: string, patient?: string, clinic?: string, page?: number, perPage?: number, options?: RawAxiosRequestConfig): AxiosPromise<ReportsPaginationResponse> {
            return localVarFp.fetchReports(fromDate, toDate, doctor, patient, clinic, page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate Excel document for reports  Matches Java: GET /reports/generate-document/ ReportController.generateReportsDocument() line 36  Java implementation: Generates Excel file (.xls) with treatment tooth data Columns: Patient, Date, Condition, Treatment, Tooth, Price, Debt, Paid, Doctor Returns: Excel file as binary stream with Content-Disposition header
         * @summary Generate Reports Document
         * @param {string} [fromDate] Start date filter
         * @param {string} [toDate] End date filter
         * @param {string} [doctor] Filter by doctor ID
         * @param {string} [patient] Filter by patient ID
         * @param {string} [clinic] Filter by clinic ID (empty &#x3D; all clinics)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReportsDocument(fromDate?: string, toDate?: string, doctor?: string, patient?: string, clinic?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.generateReportsDocument(fromDate, toDate, doctor, patient, clinic, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - object-oriented interface
 */
export class ReportsApi extends BaseAPI {
    /**
     * Fetch reports with filters  Maps to Java: ReportController.fetchReports() -> ReportServiceImpl.findAllReports() Queries TreatmentTooth (treatments_teeth) table, not Appointments Returns paginated list of individual tooth treatments with financial data
     * @summary Fetch Reports
     * @param {string} [fromDate] Start date filter
     * @param {string} [toDate] End date filter
     * @param {string} [doctor] Filter by doctor ID
     * @param {string} [patient] Filter by patient ID
     * @param {string} [clinic] Filter by clinic ID (empty &#x3D; all clinics)
     * @param {number} [page] Page number
     * @param {number} [perPage] Items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchReports(fromDate?: string, toDate?: string, doctor?: string, patient?: string, clinic?: string, page?: number, perPage?: number, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).fetchReports(fromDate, toDate, doctor, patient, clinic, page, perPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate Excel document for reports  Matches Java: GET /reports/generate-document/ ReportController.generateReportsDocument() line 36  Java implementation: Generates Excel file (.xls) with treatment tooth data Columns: Patient, Date, Condition, Treatment, Tooth, Price, Debt, Paid, Doctor Returns: Excel file as binary stream with Content-Disposition header
     * @summary Generate Reports Document
     * @param {string} [fromDate] Start date filter
     * @param {string} [toDate] End date filter
     * @param {string} [doctor] Filter by doctor ID
     * @param {string} [patient] Filter by patient ID
     * @param {string} [clinic] Filter by clinic ID (empty &#x3D; all clinics)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateReportsDocument(fromDate?: string, toDate?: string, doctor?: string, patient?: string, clinic?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).generateReportsDocument(fromDate, toDate, doctor, patient, clinic, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SelfRegisterApi - axios parameter creator
 */
export const SelfRegisterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a patient using a self-registration URL  Maps to Java: SelfRegisterController.createPatientAnonymously(UUID, Patient)  This is a PUBLIC endpoint (no authentication required). Validates URL, marks it as used, then creates the patient.
         * @summary Create Patient Anonymously
         * @param {string} patientCreateUrlId 
         * @param {PatientCreate} patientCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientAnonymously: async (patientCreateUrlId: string, patientCreate: PatientCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientCreateUrlId' is not null or undefined
            assertParamExists('createPatientAnonymously', 'patientCreateUrlId', patientCreateUrlId)
            // verify required parameter 'patientCreate' is not null or undefined
            assertParamExists('createPatientAnonymously', 'patientCreate', patientCreate)
            const localVarPath = `/api/self-register/patients/{patient_create_url_id}`
                .replace(`{${"patient_create_url_id"}}`, encodeURIComponent(String(patientCreateUrlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch health insurance companies by country code (PUBLIC endpoint)  Maps to Java: SelfRegisterController.fetchHealthInsuranceCompaniesAnonymously(String, UUID)  This is a PUBLIC endpoint (no authentication required). In Java, this calls the medical-service via WebClient. For Python, we query the database directly (no microservices).  **IMPORTANT:** Country code should be the phone dialing code (e.g., \"359\" for Bulgaria), NOT the ISO alpha-2 code (e.g., \"BG\"). This matches Java\'s seeded data format.  Bulgaria insurance companies are seeded with country_code=\"359\".  Note: organizationId is accepted but not used (matches Java behavior).
         * @summary Fetch Health Insurance Companies Anonymously
         * @param {string} countryCode 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchHealthInsuranceCompaniesAnonymously: async (countryCode: string, organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('fetchHealthInsuranceCompaniesAnonymously', 'countryCode', countryCode)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchHealthInsuranceCompaniesAnonymously', 'organizationId', organizationId)
            const localVarPath = `/api/self-register/health-insurance-companies/{country_code}/country-code`
                .replace(`{${"country_code"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch conditions for patient self-registration form  Maps to Java: SelfRegisterController.fetchPatientConditionsAnonymously(UUID organizationId)  This is a PUBLIC endpoint (no authentication required). Returns list of conditions (allergies, diseases, etc.) for the registration form.
         * @summary Fetch Patient Conditions Anonymously
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientConditionsAnonymously: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchPatientConditionsAnonymously', 'organizationId', organizationId)
            const localVarPath = `/api/self-register/patients/conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a new patient self-registration URL ID  Maps to Java: SelfRegisterController.fetchPatientCreateUrlId()  Requires authentication - uses current user\'s organization (JWT-derived). Creates a registration URL that expires in 15 minutes.
         * @summary Fetch Patient Create Url Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientCreateUrlId: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/self-register/patients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate a patient self-registration URL  Maps to Java: SelfRegisterController.validatePatientCreateUrlId(UUID urlId)  This is a PUBLIC endpoint (no authentication required). Checks if URL exists, hasn\'t expired (15 min), and hasn\'t been used.
         * @summary Validate Patient Create Url Id
         * @param {string} urlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePatientCreateUrlId: async (urlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'urlId' is not null or undefined
            assertParamExists('validatePatientCreateUrlId', 'urlId', urlId)
            const localVarPath = `/api/self-register/patients/{url_id}/validate-url`
                .replace(`{${"url_id"}}`, encodeURIComponent(String(urlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SelfRegisterApi - functional programming interface
 */
export const SelfRegisterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SelfRegisterApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a patient using a self-registration URL  Maps to Java: SelfRegisterController.createPatientAnonymously(UUID, Patient)  This is a PUBLIC endpoint (no authentication required). Validates URL, marks it as used, then creates the patient.
         * @summary Create Patient Anonymously
         * @param {string} patientCreateUrlId 
         * @param {PatientCreate} patientCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientAnonymously(patientCreateUrlId: string, patientCreate: PatientCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientAnonymously(patientCreateUrlId, patientCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SelfRegisterApi.createPatientAnonymously']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch health insurance companies by country code (PUBLIC endpoint)  Maps to Java: SelfRegisterController.fetchHealthInsuranceCompaniesAnonymously(String, UUID)  This is a PUBLIC endpoint (no authentication required). In Java, this calls the medical-service via WebClient. For Python, we query the database directly (no microservices).  **IMPORTANT:** Country code should be the phone dialing code (e.g., \"359\" for Bulgaria), NOT the ISO alpha-2 code (e.g., \"BG\"). This matches Java\'s seeded data format.  Bulgaria insurance companies are seeded with country_code=\"359\".  Note: organizationId is accepted but not used (matches Java behavior).
         * @summary Fetch Health Insurance Companies Anonymously
         * @param {string} countryCode 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchHealthInsuranceCompaniesAnonymously(countryCode: string, organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HealthInsuranceCompany>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchHealthInsuranceCompaniesAnonymously(countryCode, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SelfRegisterApi.fetchHealthInsuranceCompaniesAnonymously']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch conditions for patient self-registration form  Maps to Java: SelfRegisterController.fetchPatientConditionsAnonymously(UUID organizationId)  This is a PUBLIC endpoint (no authentication required). Returns list of conditions (allergies, diseases, etc.) for the registration form.
         * @summary Fetch Patient Conditions Anonymously
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPatientConditionsAnonymously(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Condition>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPatientConditionsAnonymously(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SelfRegisterApi.fetchPatientConditionsAnonymously']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a new patient self-registration URL ID  Maps to Java: SelfRegisterController.fetchPatientCreateUrlId()  Requires authentication - uses current user\'s organization (JWT-derived). Creates a registration URL that expires in 15 minutes.
         * @summary Fetch Patient Create Url Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPatientCreateUrlId(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientSelfRegisterUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPatientCreateUrlId(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SelfRegisterApi.fetchPatientCreateUrlId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate a patient self-registration URL  Maps to Java: SelfRegisterController.validatePatientCreateUrlId(UUID urlId)  This is a PUBLIC endpoint (no authentication required). Checks if URL exists, hasn\'t expired (15 min), and hasn\'t been used.
         * @summary Validate Patient Create Url Id
         * @param {string} urlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePatientCreateUrlId(urlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientSelfRegisterUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePatientCreateUrlId(urlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SelfRegisterApi.validatePatientCreateUrlId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SelfRegisterApi - factory interface
 */
export const SelfRegisterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SelfRegisterApiFp(configuration)
    return {
        /**
         * Create a patient using a self-registration URL  Maps to Java: SelfRegisterController.createPatientAnonymously(UUID, Patient)  This is a PUBLIC endpoint (no authentication required). Validates URL, marks it as used, then creates the patient.
         * @summary Create Patient Anonymously
         * @param {string} patientCreateUrlId 
         * @param {PatientCreate} patientCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientAnonymously(patientCreateUrlId: string, patientCreate: PatientCreate, options?: RawAxiosRequestConfig): AxiosPromise<Patient> {
            return localVarFp.createPatientAnonymously(patientCreateUrlId, patientCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch health insurance companies by country code (PUBLIC endpoint)  Maps to Java: SelfRegisterController.fetchHealthInsuranceCompaniesAnonymously(String, UUID)  This is a PUBLIC endpoint (no authentication required). In Java, this calls the medical-service via WebClient. For Python, we query the database directly (no microservices).  **IMPORTANT:** Country code should be the phone dialing code (e.g., \"359\" for Bulgaria), NOT the ISO alpha-2 code (e.g., \"BG\"). This matches Java\'s seeded data format.  Bulgaria insurance companies are seeded with country_code=\"359\".  Note: organizationId is accepted but not used (matches Java behavior).
         * @summary Fetch Health Insurance Companies Anonymously
         * @param {string} countryCode 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchHealthInsuranceCompaniesAnonymously(countryCode: string, organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<HealthInsuranceCompany>> {
            return localVarFp.fetchHealthInsuranceCompaniesAnonymously(countryCode, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch conditions for patient self-registration form  Maps to Java: SelfRegisterController.fetchPatientConditionsAnonymously(UUID organizationId)  This is a PUBLIC endpoint (no authentication required). Returns list of conditions (allergies, diseases, etc.) for the registration form.
         * @summary Fetch Patient Conditions Anonymously
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientConditionsAnonymously(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Condition>> {
            return localVarFp.fetchPatientConditionsAnonymously(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a new patient self-registration URL ID  Maps to Java: SelfRegisterController.fetchPatientCreateUrlId()  Requires authentication - uses current user\'s organization (JWT-derived). Creates a registration URL that expires in 15 minutes.
         * @summary Fetch Patient Create Url Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPatientCreateUrlId(options?: RawAxiosRequestConfig): AxiosPromise<PatientSelfRegisterUrlResponse> {
            return localVarFp.fetchPatientCreateUrlId(options).then((request) => request(axios, basePath));
        },
        /**
         * Validate a patient self-registration URL  Maps to Java: SelfRegisterController.validatePatientCreateUrlId(UUID urlId)  This is a PUBLIC endpoint (no authentication required). Checks if URL exists, hasn\'t expired (15 min), and hasn\'t been used.
         * @summary Validate Patient Create Url Id
         * @param {string} urlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePatientCreateUrlId(urlId: string, options?: RawAxiosRequestConfig): AxiosPromise<PatientSelfRegisterUrlResponse> {
            return localVarFp.validatePatientCreateUrlId(urlId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SelfRegisterApi - object-oriented interface
 */
export class SelfRegisterApi extends BaseAPI {
    /**
     * Create a patient using a self-registration URL  Maps to Java: SelfRegisterController.createPatientAnonymously(UUID, Patient)  This is a PUBLIC endpoint (no authentication required). Validates URL, marks it as used, then creates the patient.
     * @summary Create Patient Anonymously
     * @param {string} patientCreateUrlId 
     * @param {PatientCreate} patientCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPatientAnonymously(patientCreateUrlId: string, patientCreate: PatientCreate, options?: RawAxiosRequestConfig) {
        return SelfRegisterApiFp(this.configuration).createPatientAnonymously(patientCreateUrlId, patientCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch health insurance companies by country code (PUBLIC endpoint)  Maps to Java: SelfRegisterController.fetchHealthInsuranceCompaniesAnonymously(String, UUID)  This is a PUBLIC endpoint (no authentication required). In Java, this calls the medical-service via WebClient. For Python, we query the database directly (no microservices).  **IMPORTANT:** Country code should be the phone dialing code (e.g., \"359\" for Bulgaria), NOT the ISO alpha-2 code (e.g., \"BG\"). This matches Java\'s seeded data format.  Bulgaria insurance companies are seeded with country_code=\"359\".  Note: organizationId is accepted but not used (matches Java behavior).
     * @summary Fetch Health Insurance Companies Anonymously
     * @param {string} countryCode 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchHealthInsuranceCompaniesAnonymously(countryCode: string, organizationId: string, options?: RawAxiosRequestConfig) {
        return SelfRegisterApiFp(this.configuration).fetchHealthInsuranceCompaniesAnonymously(countryCode, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch conditions for patient self-registration form  Maps to Java: SelfRegisterController.fetchPatientConditionsAnonymously(UUID organizationId)  This is a PUBLIC endpoint (no authentication required). Returns list of conditions (allergies, diseases, etc.) for the registration form.
     * @summary Fetch Patient Conditions Anonymously
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPatientConditionsAnonymously(organizationId: string, options?: RawAxiosRequestConfig) {
        return SelfRegisterApiFp(this.configuration).fetchPatientConditionsAnonymously(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a new patient self-registration URL ID  Maps to Java: SelfRegisterController.fetchPatientCreateUrlId()  Requires authentication - uses current user\'s organization (JWT-derived). Creates a registration URL that expires in 15 minutes.
     * @summary Fetch Patient Create Url Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPatientCreateUrlId(options?: RawAxiosRequestConfig) {
        return SelfRegisterApiFp(this.configuration).fetchPatientCreateUrlId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate a patient self-registration URL  Maps to Java: SelfRegisterController.validatePatientCreateUrlId(UUID urlId)  This is a PUBLIC endpoint (no authentication required). Checks if URL exists, hasn\'t expired (15 min), and hasn\'t been used.
     * @summary Validate Patient Create Url Id
     * @param {string} urlId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validatePatientCreateUrlId(urlId: string, options?: RawAxiosRequestConfig) {
        return SelfRegisterApiFp(this.configuration).validatePatientCreateUrlId(urlId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StatusesApi - axios parameter creator
 */
export const StatusesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create new status  Maps to Java: StatusController.createStatus()
         * @summary Create Status
         * @param {StatusCreate} statusCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStatus: async (statusCreate: StatusCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'statusCreate' is not null or undefined
            assertParamExists('createStatus', 'statusCreate', statusCreate)
            const localVarPath = `/api/statuses/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statusCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete status  Maps to Java: StatusController.deleteStatus() Returns 204 No Content on successful deletion.
         * @summary Delete Status
         * @param {string} statusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatus: async (statusId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'statusId' is not null or undefined
            assertParamExists('deleteStatus', 'statusId', statusId)
            const localVarPath = `/api/statuses/{status_id}`
                .replace(`{${"status_id"}}`, encodeURIComponent(String(statusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all statuses in the organization  Maps to Java: StatusController.getAllStatuses()
         * @summary Fetch All Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllStatuses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/statuses/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all statuses for specific organization  Maps to Java: StatusController.fetchMedicalStatuses(UUID organizationId) PATH: /statuses/{organizationId}/ TYPE: GET
         * @summary Fetch Statuses By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStatuses: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchMedicalStatuses', 'organizationId', organizationId)
            const localVarPath = `/api/statuses/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch status by ID  Maps to Java: StatusController.getStatusById()
         * @summary Fetch Status
         * @param {string} statusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStatusById: async (statusId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'statusId' is not null or undefined
            assertParamExists('fetchStatusById', 'statusId', statusId)
            const localVarPath = `/api/statuses/{status_id}`
                .replace(`{${"status_id"}}`, encodeURIComponent(String(statusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update status information  Maps to Java: StatusController.updateStatus()
         * @summary Update Status
         * @param {string} statusId 
         * @param {StatusUpdate} statusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus: async (statusId: string, statusUpdate: StatusUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'statusId' is not null or undefined
            assertParamExists('updateStatus', 'statusId', statusId)
            // verify required parameter 'statusUpdate' is not null or undefined
            assertParamExists('updateStatus', 'statusUpdate', statusUpdate)
            const localVarPath = `/api/statuses/{status_id}`
                .replace(`{${"status_id"}}`, encodeURIComponent(String(statusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatusesApi - functional programming interface
 */
export const StatusesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatusesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create new status  Maps to Java: StatusController.createStatus()
         * @summary Create Status
         * @param {StatusCreate} statusCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStatus(statusCreate: StatusCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStatus(statusCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatusesApi.createStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete status  Maps to Java: StatusController.deleteStatus() Returns 204 No Content on successful deletion.
         * @summary Delete Status
         * @param {string} statusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStatus(statusId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStatus(statusId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatusesApi.deleteStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all statuses in the organization  Maps to Java: StatusController.getAllStatuses()
         * @summary Fetch All Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllStatuses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatusResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllStatuses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatusesApi.fetchAllStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all statuses for specific organization  Maps to Java: StatusController.fetchMedicalStatuses(UUID organizationId) PATH: /statuses/{organizationId}/ TYPE: GET
         * @summary Fetch Statuses By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMedicalStatuses(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatusResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMedicalStatuses(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatusesApi.fetchMedicalStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch status by ID  Maps to Java: StatusController.getStatusById()
         * @summary Fetch Status
         * @param {string} statusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchStatusById(statusId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchStatusById(statusId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatusesApi.fetchStatusById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update status information  Maps to Java: StatusController.updateStatus()
         * @summary Update Status
         * @param {string} statusId 
         * @param {StatusUpdate} statusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatus(statusId: string, statusUpdate: StatusUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatus(statusId, statusUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatusesApi.updateStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatusesApi - factory interface
 */
export const StatusesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatusesApiFp(configuration)
    return {
        /**
         * Create new status  Maps to Java: StatusController.createStatus()
         * @summary Create Status
         * @param {StatusCreate} statusCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStatus(statusCreate: StatusCreate, options?: RawAxiosRequestConfig): AxiosPromise<StatusResponse> {
            return localVarFp.createStatus(statusCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete status  Maps to Java: StatusController.deleteStatus() Returns 204 No Content on successful deletion.
         * @summary Delete Status
         * @param {string} statusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatus(statusId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteStatus(statusId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all statuses in the organization  Maps to Java: StatusController.getAllStatuses()
         * @summary Fetch All Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllStatuses(options?: RawAxiosRequestConfig): AxiosPromise<Array<StatusResponse>> {
            return localVarFp.fetchAllStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all statuses for specific organization  Maps to Java: StatusController.fetchMedicalStatuses(UUID organizationId) PATH: /statuses/{organizationId}/ TYPE: GET
         * @summary Fetch Statuses By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalStatuses(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StatusResponse>> {
            return localVarFp.fetchMedicalStatuses(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch status by ID  Maps to Java: StatusController.getStatusById()
         * @summary Fetch Status
         * @param {string} statusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStatusById(statusId: string, options?: RawAxiosRequestConfig): AxiosPromise<StatusResponse> {
            return localVarFp.fetchStatusById(statusId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update status information  Maps to Java: StatusController.updateStatus()
         * @summary Update Status
         * @param {string} statusId 
         * @param {StatusUpdate} statusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus(statusId: string, statusUpdate: StatusUpdate, options?: RawAxiosRequestConfig): AxiosPromise<StatusResponse> {
            return localVarFp.updateStatus(statusId, statusUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatusesApi - object-oriented interface
 */
export class StatusesApi extends BaseAPI {
    /**
     * Create new status  Maps to Java: StatusController.createStatus()
     * @summary Create Status
     * @param {StatusCreate} statusCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createStatus(statusCreate: StatusCreate, options?: RawAxiosRequestConfig) {
        return StatusesApiFp(this.configuration).createStatus(statusCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete status  Maps to Java: StatusController.deleteStatus() Returns 204 No Content on successful deletion.
     * @summary Delete Status
     * @param {string} statusId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteStatus(statusId: string, options?: RawAxiosRequestConfig) {
        return StatusesApiFp(this.configuration).deleteStatus(statusId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all statuses in the organization  Maps to Java: StatusController.getAllStatuses()
     * @summary Fetch All Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllStatuses(options?: RawAxiosRequestConfig) {
        return StatusesApiFp(this.configuration).fetchAllStatuses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all statuses for specific organization  Maps to Java: StatusController.fetchMedicalStatuses(UUID organizationId) PATH: /statuses/{organizationId}/ TYPE: GET
     * @summary Fetch Statuses By Organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchMedicalStatuses(organizationId: string, options?: RawAxiosRequestConfig) {
        return StatusesApiFp(this.configuration).fetchMedicalStatuses(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch status by ID  Maps to Java: StatusController.getStatusById()
     * @summary Fetch Status
     * @param {string} statusId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchStatusById(statusId: string, options?: RawAxiosRequestConfig) {
        return StatusesApiFp(this.configuration).fetchStatusById(statusId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update status information  Maps to Java: StatusController.updateStatus()
     * @summary Update Status
     * @param {string} statusId 
     * @param {StatusUpdate} statusUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateStatus(statusId: string, statusUpdate: StatusUpdate, options?: RawAxiosRequestConfig) {
        return StatusesApiFp(this.configuration).updateStatus(statusId, statusUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StripeApi - axios parameter creator
 */
export const StripeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel a Stripe subscription
         * @summary Cancel Subscription
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: async (subscriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('cancelSubscription', 'subscriptionId', subscriptionId)
            const localVarPath = `/api/stripe/subscriptions/{subscription_id}`
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel subscription for an organization  Maps to Java endpoint: POST /cancel-subscription/{organizationId} from StripeController.cancelSubscription()  Sets subscription to cancel at period end (cancel_at_period_end=true). Sends cancellation email notification.
         * @summary Cancel Subscription By Org
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscriptionByOrg: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cancelSubscriptionByOrg', 'organizationId', organizationId)
            const localVarPath = `/api/stripe/cancel-subscription/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Stripe Checkout session for an invoice
         * @summary Create Checkout Session
         * @param {CreateCheckoutSessionRequest} createCheckoutSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession: async (createCheckoutSessionRequest: CreateCheckoutSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCheckoutSessionRequest' is not null or undefined
            assertParamExists('createCheckoutSession', 'createCheckoutSessionRequest', createCheckoutSessionRequest)
            const localVarPath = `/api/stripe/checkout-sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCheckoutSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Stripe payment intent
         * @summary Create Payment Intent
         * @param {CreatePaymentIntentRequest} createPaymentIntentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentIntent: async (createPaymentIntentRequest: CreatePaymentIntentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPaymentIntentRequest' is not null or undefined
            assertParamExists('createPaymentIntent', 'createPaymentIntentRequest', createPaymentIntentRequest)
            const localVarPath = `/api/stripe/payment-intents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentIntentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a refund for a payment
         * @summary Create Refund
         * @param {CreateRefundRequest} createRefundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefund: async (createRefundRequest: CreateRefundRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRefundRequest' is not null or undefined
            assertParamExists('createRefund', 'createRefundRequest', createRefundRequest)
            const localVarPath = `/api/stripe/refunds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRefundRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Stripe subscription for an organization
         * @summary Create Subscription
         * @param {CreateSubscriptionRequest} createSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription: async (createSubscriptionRequest: CreateSubscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSubscriptionRequest' is not null or undefined
            assertParamExists('createSubscription', 'createSubscriptionRequest', createSubscriptionRequest)
            const localVarPath = `/api/stripe/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch next payment date for an organization\'s subscription  Matches Java: StripeServiceImpl.fetchNextPaymentDate() Returns the next scheduled payment date from active subscriptions
         * @summary Fetch Next Payment Date
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNextPaymentDate: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchNextPaymentDate', 'organizationId', organizationId)
            const localVarPath = `/api/stripe/subscriptions/{organization_id}/next-payment`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch payment history for an organization  Matches Java: StripeServiceImpl.fetchPaymentHistory() Returns list of payment transactions for the organization
         * @summary Fetch Payment History
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPaymentHistory: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchPaymentHistory', 'organizationId', organizationId)
            const localVarPath = `/api/stripe/payments/history/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch payment history for an organization  Matches Java endpoint: GET /payments-history/{organizationId} from StripeController.fetchPaymentHistory()  Returns the list of payment transactions stored in the payments_history table.
         * @summary Fetch Payments History
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPaymentsHistory: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchPaymentsHistory', 'organizationId', organizationId)
            const localVarPath = `/api/stripe/payments-history/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch Stripe invoices for an organization  Matches Java endpoint: GET /invoices/{organizationId} from StripeController.fetchInvoices()  Returns list of Stripe subscription invoices for the organization\'s customer.
         * @summary Fetch Stripe Invoices
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStripeInvoices: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchStripeInvoices', 'organizationId', organizationId)
            const localVarPath = `/api/stripe/invoices/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Stripe publishable key for client-side usage. This key is safe to expose in client-side code.  Requires authentication (matches Java implementation). Frontend should check feature flags before calling this endpoint.
         * @summary Get Publishable Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishableKey: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/stripe/publishable-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Stripe subscription
         * @summary Get Subscription
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription: async (subscriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getSubscription', 'subscriptionId', subscriptionId)
            const localVarPath = `/api/stripe/subscriptions/{subscription_id}`
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle Stripe webhook events.  This endpoint receives and processes webhook events from Stripe, such as successful payments, failed payments, subscription updates, etc.
         * @summary Handle Stripe Webhook
         * @param {string} [stripeSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhook: async (stripeSignature?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/stripe/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            if (stripeSignature != null) {
                localVarHeaderParameter['stripe-signature'] = String(stripeSignature);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if Stripe integration is enabled globally. This is a PUBLIC endpoint (no authentication required).  Returns whether STRIPE_ENABLED environment variable is set to true. Frontend should check this before initializing any Stripe functionality.
         * @summary Is Stripe Enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isStripeEnabled: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/stripe/enabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Process a payment token and create subscription  Maps to Java endpoint: POST /process-payment-token from StripeController.processPaymentToken()  Creates Stripe customer, payment method, and Dentobook Pro subscription. Returns success status and payment intent client secret.
         * @summary Process Payment Token
         * @param {ProcessPaymentTokenRequest} processPaymentTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPaymentToken: async (processPaymentTokenRequest: ProcessPaymentTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processPaymentTokenRequest' is not null or undefined
            assertParamExists('processPaymentToken', 'processPaymentTokenRequest', processPaymentTokenRequest)
            const localVarPath = `/api/stripe/process-payment-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processPaymentTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Renew subscription for an organization  Matches Java endpoint: POST /renew-subscription/{organizationId} from StripeController.renewSubscription()  Finds the organization\'s Stripe subscription that is set to cancel at period end, and updates it to continue (sets cancel_at_period_end = false).
         * @summary Renew Subscription
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewSubscription: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('renewSubscription', 'organizationId', organizationId)
            const localVarPath = `/api/stripe/renew-subscription/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripeApi - functional programming interface
 */
export const StripeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StripeApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel a Stripe subscription
         * @summary Cancel Subscription
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscription(subscriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeSubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscription(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.cancelSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel subscription for an organization  Maps to Java endpoint: POST /cancel-subscription/{organizationId} from StripeController.cancelSubscription()  Sets subscription to cancel at period end (cancel_at_period_end=true). Sends cancellation email notification.
         * @summary Cancel Subscription By Org
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscriptionByOrg(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionCancelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscriptionByOrg(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.cancelSubscriptionByOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Stripe Checkout session for an invoice
         * @summary Create Checkout Session
         * @param {CreateCheckoutSessionRequest} createCheckoutSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCheckoutSession(createCheckoutSessionRequest: CreateCheckoutSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCheckoutSession(createCheckoutSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.createCheckoutSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Stripe payment intent
         * @summary Create Payment Intent
         * @param {CreatePaymentIntentRequest} createPaymentIntentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPaymentIntent(createPaymentIntentRequest: CreatePaymentIntentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentIntentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPaymentIntent(createPaymentIntentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.createPaymentIntent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a refund for a payment
         * @summary Create Refund
         * @param {CreateRefundRequest} createRefundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRefund(createRefundRequest: CreateRefundRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefundResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRefund(createRefundRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.createRefund']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Stripe subscription for an organization
         * @summary Create Subscription
         * @param {CreateSubscriptionRequest} createSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubscription(createSubscriptionRequest: CreateSubscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeSubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubscription(createSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.createSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch next payment date for an organization\'s subscription  Matches Java: StripeServiceImpl.fetchNextPaymentDate() Returns the next scheduled payment date from active subscriptions
         * @summary Fetch Next Payment Date
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchNextPaymentDate(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NextPaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchNextPaymentDate(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.fetchNextPaymentDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch payment history for an organization  Matches Java: StripeServiceImpl.fetchPaymentHistory() Returns list of payment transactions for the organization
         * @summary Fetch Payment History
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPaymentHistory(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentsHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPaymentHistory(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.fetchPaymentHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch payment history for an organization  Matches Java endpoint: GET /payments-history/{organizationId} from StripeController.fetchPaymentHistory()  Returns the list of payment transactions stored in the payments_history table.
         * @summary Fetch Payments History
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPaymentsHistory(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentsHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPaymentsHistory(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.fetchPaymentsHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch Stripe invoices for an organization  Matches Java endpoint: GET /invoices/{organizationId} from StripeController.fetchInvoices()  Returns list of Stripe subscription invoices for the organization\'s customer.
         * @summary Fetch Stripe Invoices
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchStripeInvoices(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StripeInvoiceItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchStripeInvoices(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.fetchStripeInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Stripe publishable key for client-side usage. This key is safe to expose in client-side code.  Requires authentication (matches Java implementation). Frontend should check feature flags before calling this endpoint.
         * @summary Get Publishable Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishableKey(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripePublishableKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishableKey(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.getPublishableKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a Stripe subscription
         * @summary Get Subscription
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscription(subscriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeSubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscription(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.getSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle Stripe webhook events.  This endpoint receives and processes webhook events from Stripe, such as successful payments, failed payments, subscription updates, etc.
         * @summary Handle Stripe Webhook
         * @param {string} [stripeSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleStripeWebhook(stripeSignature?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleStripeWebhook(stripeSignature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.handleStripeWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if Stripe integration is enabled globally. This is a PUBLIC endpoint (no authentication required).  Returns whether STRIPE_ENABLED environment variable is set to true. Frontend should check this before initializing any Stripe functionality.
         * @summary Is Stripe Enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isStripeEnabled(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeEnabledResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isStripeEnabled(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.isStripeEnabled']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Process a payment token and create subscription  Maps to Java endpoint: POST /process-payment-token from StripeController.processPaymentToken()  Creates Stripe customer, payment method, and Dentobook Pro subscription. Returns success status and payment intent client secret.
         * @summary Process Payment Token
         * @param {ProcessPaymentTokenRequest} processPaymentTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processPaymentToken(processPaymentTokenRequest: ProcessPaymentTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessPaymentTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processPaymentToken(processPaymentTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.processPaymentToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Renew subscription for an organization  Matches Java endpoint: POST /renew-subscription/{organizationId} from StripeController.renewSubscription()  Finds the organization\'s Stripe subscription that is set to cancel at period end, and updates it to continue (sets cancel_at_period_end = false).
         * @summary Renew Subscription
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renewSubscription(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionRenewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renewSubscription(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.renewSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StripeApi - factory interface
 */
export const StripeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StripeApiFp(configuration)
    return {
        /**
         * Cancel a Stripe subscription
         * @summary Cancel Subscription
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(subscriptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<StripeSubscriptionResponse> {
            return localVarFp.cancelSubscription(subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel subscription for an organization  Maps to Java endpoint: POST /cancel-subscription/{organizationId} from StripeController.cancelSubscription()  Sets subscription to cancel at period end (cancel_at_period_end=true). Sends cancellation email notification.
         * @summary Cancel Subscription By Org
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscriptionByOrg(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionCancelResponse> {
            return localVarFp.cancelSubscriptionByOrg(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Stripe Checkout session for an invoice
         * @summary Create Checkout Session
         * @param {CreateCheckoutSessionRequest} createCheckoutSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession(createCheckoutSessionRequest: CreateCheckoutSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutSessionResponse> {
            return localVarFp.createCheckoutSession(createCheckoutSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Stripe payment intent
         * @summary Create Payment Intent
         * @param {CreatePaymentIntentRequest} createPaymentIntentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentIntent(createPaymentIntentRequest: CreatePaymentIntentRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentIntentResponse> {
            return localVarFp.createPaymentIntent(createPaymentIntentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a refund for a payment
         * @summary Create Refund
         * @param {CreateRefundRequest} createRefundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefund(createRefundRequest: CreateRefundRequest, options?: RawAxiosRequestConfig): AxiosPromise<RefundResponse> {
            return localVarFp.createRefund(createRefundRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Stripe subscription for an organization
         * @summary Create Subscription
         * @param {CreateSubscriptionRequest} createSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription(createSubscriptionRequest: CreateSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<StripeSubscriptionResponse> {
            return localVarFp.createSubscription(createSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch next payment date for an organization\'s subscription  Matches Java: StripeServiceImpl.fetchNextPaymentDate() Returns the next scheduled payment date from active subscriptions
         * @summary Fetch Next Payment Date
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchNextPaymentDate(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<NextPaymentResponse> {
            return localVarFp.fetchNextPaymentDate(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch payment history for an organization  Matches Java: StripeServiceImpl.fetchPaymentHistory() Returns list of payment transactions for the organization
         * @summary Fetch Payment History
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPaymentHistory(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentsHistoryResponse> {
            return localVarFp.fetchPaymentHistory(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch payment history for an organization  Matches Java endpoint: GET /payments-history/{organizationId} from StripeController.fetchPaymentHistory()  Returns the list of payment transactions stored in the payments_history table.
         * @summary Fetch Payments History
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPaymentsHistory(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentsHistoryResponse> {
            return localVarFp.fetchPaymentsHistory(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch Stripe invoices for an organization  Matches Java endpoint: GET /invoices/{organizationId} from StripeController.fetchInvoices()  Returns list of Stripe subscription invoices for the organization\'s customer.
         * @summary Fetch Stripe Invoices
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStripeInvoices(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StripeInvoiceItem>> {
            return localVarFp.fetchStripeInvoices(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Stripe publishable key for client-side usage. This key is safe to expose in client-side code.  Requires authentication (matches Java implementation). Frontend should check feature flags before calling this endpoint.
         * @summary Get Publishable Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishableKey(options?: RawAxiosRequestConfig): AxiosPromise<StripePublishableKeyResponse> {
            return localVarFp.getPublishableKey(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Stripe subscription
         * @summary Get Subscription
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription(subscriptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<StripeSubscriptionResponse> {
            return localVarFp.getSubscription(subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle Stripe webhook events.  This endpoint receives and processes webhook events from Stripe, such as successful payments, failed payments, subscription updates, etc.
         * @summary Handle Stripe Webhook
         * @param {string} [stripeSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhook(stripeSignature?: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookEventResponse> {
            return localVarFp.handleStripeWebhook(stripeSignature, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if Stripe integration is enabled globally. This is a PUBLIC endpoint (no authentication required).  Returns whether STRIPE_ENABLED environment variable is set to true. Frontend should check this before initializing any Stripe functionality.
         * @summary Is Stripe Enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isStripeEnabled(options?: RawAxiosRequestConfig): AxiosPromise<StripeEnabledResponse> {
            return localVarFp.isStripeEnabled(options).then((request) => request(axios, basePath));
        },
        /**
         * Process a payment token and create subscription  Maps to Java endpoint: POST /process-payment-token from StripeController.processPaymentToken()  Creates Stripe customer, payment method, and Dentobook Pro subscription. Returns success status and payment intent client secret.
         * @summary Process Payment Token
         * @param {ProcessPaymentTokenRequest} processPaymentTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPaymentToken(processPaymentTokenRequest: ProcessPaymentTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcessPaymentTokenResponse> {
            return localVarFp.processPaymentToken(processPaymentTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Renew subscription for an organization  Matches Java endpoint: POST /renew-subscription/{organizationId} from StripeController.renewSubscription()  Finds the organization\'s Stripe subscription that is set to cancel at period end, and updates it to continue (sets cancel_at_period_end = false).
         * @summary Renew Subscription
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewSubscription(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionRenewResponse> {
            return localVarFp.renewSubscription(organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StripeApi - object-oriented interface
 */
export class StripeApi extends BaseAPI {
    /**
     * Cancel a Stripe subscription
     * @summary Cancel Subscription
     * @param {string} subscriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelSubscription(subscriptionId: string, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).cancelSubscription(subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel subscription for an organization  Maps to Java endpoint: POST /cancel-subscription/{organizationId} from StripeController.cancelSubscription()  Sets subscription to cancel at period end (cancel_at_period_end=true). Sends cancellation email notification.
     * @summary Cancel Subscription By Org
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelSubscriptionByOrg(organizationId: string, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).cancelSubscriptionByOrg(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Stripe Checkout session for an invoice
     * @summary Create Checkout Session
     * @param {CreateCheckoutSessionRequest} createCheckoutSessionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCheckoutSession(createCheckoutSessionRequest: CreateCheckoutSessionRequest, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).createCheckoutSession(createCheckoutSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Stripe payment intent
     * @summary Create Payment Intent
     * @param {CreatePaymentIntentRequest} createPaymentIntentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPaymentIntent(createPaymentIntentRequest: CreatePaymentIntentRequest, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).createPaymentIntent(createPaymentIntentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a refund for a payment
     * @summary Create Refund
     * @param {CreateRefundRequest} createRefundRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createRefund(createRefundRequest: CreateRefundRequest, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).createRefund(createRefundRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Stripe subscription for an organization
     * @summary Create Subscription
     * @param {CreateSubscriptionRequest} createSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSubscription(createSubscriptionRequest: CreateSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).createSubscription(createSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch next payment date for an organization\'s subscription  Matches Java: StripeServiceImpl.fetchNextPaymentDate() Returns the next scheduled payment date from active subscriptions
     * @summary Fetch Next Payment Date
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchNextPaymentDate(organizationId: string, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).fetchNextPaymentDate(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch payment history for an organization  Matches Java: StripeServiceImpl.fetchPaymentHistory() Returns list of payment transactions for the organization
     * @summary Fetch Payment History
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPaymentHistory(organizationId: string, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).fetchPaymentHistory(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch payment history for an organization  Matches Java endpoint: GET /payments-history/{organizationId} from StripeController.fetchPaymentHistory()  Returns the list of payment transactions stored in the payments_history table.
     * @summary Fetch Payments History
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPaymentsHistory(organizationId: string, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).fetchPaymentsHistory(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch Stripe invoices for an organization  Matches Java endpoint: GET /invoices/{organizationId} from StripeController.fetchInvoices()  Returns list of Stripe subscription invoices for the organization\'s customer.
     * @summary Fetch Stripe Invoices
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchStripeInvoices(organizationId: string, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).fetchStripeInvoices(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Stripe publishable key for client-side usage. This key is safe to expose in client-side code.  Requires authentication (matches Java implementation). Frontend should check feature flags before calling this endpoint.
     * @summary Get Publishable Key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPublishableKey(options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).getPublishableKey(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Stripe subscription
     * @summary Get Subscription
     * @param {string} subscriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSubscription(subscriptionId: string, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).getSubscription(subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle Stripe webhook events.  This endpoint receives and processes webhook events from Stripe, such as successful payments, failed payments, subscription updates, etc.
     * @summary Handle Stripe Webhook
     * @param {string} [stripeSignature] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public handleStripeWebhook(stripeSignature?: string, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).handleStripeWebhook(stripeSignature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if Stripe integration is enabled globally. This is a PUBLIC endpoint (no authentication required).  Returns whether STRIPE_ENABLED environment variable is set to true. Frontend should check this before initializing any Stripe functionality.
     * @summary Is Stripe Enabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public isStripeEnabled(options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).isStripeEnabled(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Process a payment token and create subscription  Maps to Java endpoint: POST /process-payment-token from StripeController.processPaymentToken()  Creates Stripe customer, payment method, and Dentobook Pro subscription. Returns success status and payment intent client secret.
     * @summary Process Payment Token
     * @param {ProcessPaymentTokenRequest} processPaymentTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public processPaymentToken(processPaymentTokenRequest: ProcessPaymentTokenRequest, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).processPaymentToken(processPaymentTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Renew subscription for an organization  Matches Java endpoint: POST /renew-subscription/{organizationId} from StripeController.renewSubscription()  Finds the organization\'s Stripe subscription that is set to cancel at period end, and updates it to continue (sets cancel_at_period_end = false).
     * @summary Renew Subscription
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public renewSubscription(organizationId: string, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).renewSubscription(organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TreatmentsApi - axios parameter creator
 */
export const TreatmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create treatment  Maps to Java: TreatmentController.createMedicalTreatment(treatment)  Note: Java version returns List<Treatment> for API consistency, wrapping the single created treatment in a list.
         * @summary Create Medical Treatment
         * @param {TreatmentCreate} treatmentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalTreatment: async (treatmentCreate: TreatmentCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treatmentCreate' is not null or undefined
            assertParamExists('createMedicalTreatment', 'treatmentCreate', treatmentCreate)
            const localVarPath = `/api/treatments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(treatmentCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete treatment  Maps to Java: TreatmentController.deleteMedicalTreatment(id) Returns 204 No Content on successful deletion.
         * @summary Delete Medical Treatment
         * @param {string} treatmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedicalTreatment: async (treatmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('deleteMedicalTreatment', 'treatmentId', treatmentId)
            const localVarPath = `/api/treatments/{treatment_id}`
                .replace(`{${"treatment_id"}}`, encodeURIComponent(String(treatmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch treatment by ID  Maps to Java: TreatmentController.fetchMedicalTreatment(id)
         * @summary Fetch Medical Treatment
         * @param {string} treatmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalTreatmentById: async (treatmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('fetchMedicalTreatmentById', 'treatmentId', treatmentId)
            const localVarPath = `/api/treatments/{treatment_id}`
                .replace(`{${"treatment_id"}}`, encodeURIComponent(String(treatmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all treatments  Maps to Java: TreatmentController.fetchMedicalTreatments()
         * @summary Fetch Medical Treatments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalTreatments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/treatments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch treatments by organization ID  Maps to Java: TreatmentController.fetchMedicalTreatmentsByOrganizationId(organizationId)
         * @summary Fetch Medical Treatments By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalTreatmentsByOrganization: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('fetchMedicalTreatmentsByOrganization', 'organizationId', organizationId)
            const localVarPath = `/api/treatments/organization/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update treatment  Maps to Java: TreatmentController.updateMedicalTreatment(id, treatment) Returns 204 No Content on successful update.
         * @summary Update Medical Treatment
         * @param {string} treatmentId 
         * @param {TreatmentUpdate} treatmentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalTreatment: async (treatmentId: string, treatmentUpdate: TreatmentUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treatmentId' is not null or undefined
            assertParamExists('updateMedicalTreatment', 'treatmentId', treatmentId)
            // verify required parameter 'treatmentUpdate' is not null or undefined
            assertParamExists('updateMedicalTreatment', 'treatmentUpdate', treatmentUpdate)
            const localVarPath = `/api/treatments/{treatment_id}`
                .replace(`{${"treatment_id"}}`, encodeURIComponent(String(treatmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(treatmentUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TreatmentsApi - functional programming interface
 */
export const TreatmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TreatmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create treatment  Maps to Java: TreatmentController.createMedicalTreatment(treatment)  Note: Java version returns List<Treatment> for API consistency, wrapping the single created treatment in a list.
         * @summary Create Medical Treatment
         * @param {TreatmentCreate} treatmentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMedicalTreatment(treatmentCreate: TreatmentCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Treatment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMedicalTreatment(treatmentCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreatmentsApi.createMedicalTreatment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete treatment  Maps to Java: TreatmentController.deleteMedicalTreatment(id) Returns 204 No Content on successful deletion.
         * @summary Delete Medical Treatment
         * @param {string} treatmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMedicalTreatment(treatmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMedicalTreatment(treatmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreatmentsApi.deleteMedicalTreatment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch treatment by ID  Maps to Java: TreatmentController.fetchMedicalTreatment(id)
         * @summary Fetch Medical Treatment
         * @param {string} treatmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMedicalTreatmentById(treatmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Treatment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMedicalTreatmentById(treatmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreatmentsApi.fetchMedicalTreatmentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all treatments  Maps to Java: TreatmentController.fetchMedicalTreatments()
         * @summary Fetch Medical Treatments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMedicalTreatments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Treatment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMedicalTreatments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreatmentsApi.fetchMedicalTreatments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch treatments by organization ID  Maps to Java: TreatmentController.fetchMedicalTreatmentsByOrganizationId(organizationId)
         * @summary Fetch Medical Treatments By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMedicalTreatmentsByOrganization(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Treatment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMedicalTreatmentsByOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreatmentsApi.fetchMedicalTreatmentsByOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update treatment  Maps to Java: TreatmentController.updateMedicalTreatment(id, treatment) Returns 204 No Content on successful update.
         * @summary Update Medical Treatment
         * @param {string} treatmentId 
         * @param {TreatmentUpdate} treatmentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMedicalTreatment(treatmentId: string, treatmentUpdate: TreatmentUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMedicalTreatment(treatmentId, treatmentUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreatmentsApi.updateMedicalTreatment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TreatmentsApi - factory interface
 */
export const TreatmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TreatmentsApiFp(configuration)
    return {
        /**
         * Create treatment  Maps to Java: TreatmentController.createMedicalTreatment(treatment)  Note: Java version returns List<Treatment> for API consistency, wrapping the single created treatment in a list.
         * @summary Create Medical Treatment
         * @param {TreatmentCreate} treatmentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalTreatment(treatmentCreate: TreatmentCreate, options?: RawAxiosRequestConfig): AxiosPromise<Array<Treatment>> {
            return localVarFp.createMedicalTreatment(treatmentCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete treatment  Maps to Java: TreatmentController.deleteMedicalTreatment(id) Returns 204 No Content on successful deletion.
         * @summary Delete Medical Treatment
         * @param {string} treatmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedicalTreatment(treatmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMedicalTreatment(treatmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch treatment by ID  Maps to Java: TreatmentController.fetchMedicalTreatment(id)
         * @summary Fetch Medical Treatment
         * @param {string} treatmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalTreatmentById(treatmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<Treatment> {
            return localVarFp.fetchMedicalTreatmentById(treatmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all treatments  Maps to Java: TreatmentController.fetchMedicalTreatments()
         * @summary Fetch Medical Treatments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalTreatments(options?: RawAxiosRequestConfig): AxiosPromise<Array<Treatment>> {
            return localVarFp.fetchMedicalTreatments(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch treatments by organization ID  Maps to Java: TreatmentController.fetchMedicalTreatmentsByOrganizationId(organizationId)
         * @summary Fetch Medical Treatments By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMedicalTreatmentsByOrganization(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Treatment>> {
            return localVarFp.fetchMedicalTreatmentsByOrganization(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update treatment  Maps to Java: TreatmentController.updateMedicalTreatment(id, treatment) Returns 204 No Content on successful update.
         * @summary Update Medical Treatment
         * @param {string} treatmentId 
         * @param {TreatmentUpdate} treatmentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalTreatment(treatmentId: string, treatmentUpdate: TreatmentUpdate, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMedicalTreatment(treatmentId, treatmentUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TreatmentsApi - object-oriented interface
 */
export class TreatmentsApi extends BaseAPI {
    /**
     * Create treatment  Maps to Java: TreatmentController.createMedicalTreatment(treatment)  Note: Java version returns List<Treatment> for API consistency, wrapping the single created treatment in a list.
     * @summary Create Medical Treatment
     * @param {TreatmentCreate} treatmentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createMedicalTreatment(treatmentCreate: TreatmentCreate, options?: RawAxiosRequestConfig) {
        return TreatmentsApiFp(this.configuration).createMedicalTreatment(treatmentCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete treatment  Maps to Java: TreatmentController.deleteMedicalTreatment(id) Returns 204 No Content on successful deletion.
     * @summary Delete Medical Treatment
     * @param {string} treatmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMedicalTreatment(treatmentId: string, options?: RawAxiosRequestConfig) {
        return TreatmentsApiFp(this.configuration).deleteMedicalTreatment(treatmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch treatment by ID  Maps to Java: TreatmentController.fetchMedicalTreatment(id)
     * @summary Fetch Medical Treatment
     * @param {string} treatmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchMedicalTreatmentById(treatmentId: string, options?: RawAxiosRequestConfig) {
        return TreatmentsApiFp(this.configuration).fetchMedicalTreatmentById(treatmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all treatments  Maps to Java: TreatmentController.fetchMedicalTreatments()
     * @summary Fetch Medical Treatments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchMedicalTreatments(options?: RawAxiosRequestConfig) {
        return TreatmentsApiFp(this.configuration).fetchMedicalTreatments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch treatments by organization ID  Maps to Java: TreatmentController.fetchMedicalTreatmentsByOrganizationId(organizationId)
     * @summary Fetch Medical Treatments By Organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchMedicalTreatmentsByOrganization(organizationId: string, options?: RawAxiosRequestConfig) {
        return TreatmentsApiFp(this.configuration).fetchMedicalTreatmentsByOrganization(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update treatment  Maps to Java: TreatmentController.updateMedicalTreatment(id, treatment) Returns 204 No Content on successful update.
     * @summary Update Medical Treatment
     * @param {string} treatmentId 
     * @param {TreatmentUpdate} treatmentUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMedicalTreatment(treatmentId: string, treatmentUpdate: TreatmentUpdate, options?: RawAxiosRequestConfig) {
        return TreatmentsApiFp(this.configuration).updateMedicalTreatment(treatmentId, treatmentUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get total login counts grouped by organization (batch-get endpoint)
         * @summary Batch Get Login Counts
         * @param {BatchGetRequest} batchGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchGetLoginCounts: async (batchGetRequest: BatchGetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchGetRequest' is not null or undefined
            assertParamExists('batchGetLoginCounts', 'batchGetRequest', batchGetRequest)
            const localVarPath = `/api/users/batch-get-login-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a user (Admin only) with audit logging
         * @summary Delete User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/api/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete all users in an organization (Admin only)  Returns 204 No Content on successful deletion.
         * @summary Delete Users By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsersByOrganization: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteUsersByOrganization', 'organizationId', organizationId)
            const localVarPath = `/api/users/by-organization/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all users in the organization
         * @summary Fetch All Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch last login times for all users (any authenticated user)
         * @summary Fetch All Users Last Login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllUsersLastLogin: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/last-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the currently authenticated user with organization features.  Features are populated based on the user\'s organization subscription plan.
         * @summary Fetch Principal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPrincipal: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/principal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch audit logs (Admin only)
         * @summary Fetch Audit Logs
         * @param {string | null} [userId] Filter by user
         * @param {string | null} [eventType] Filter by event type
         * @param {number} [limit] Limit results
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserAuditLogs: async (userId?: string | null, eventType?: string | null, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/audit-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (eventType !== undefined) {
                localVarQueryParameter['event_type'] = eventType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch user by email
         * @summary Fetch User By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserByEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('fetchUserByEmail', 'email', email)
            const localVarPath = `/api/users/by-email/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch user by ID
         * @summary Fetch User By Id
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserById: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('fetchUserById', 'userId', userId)
            const localVarPath = `/api/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get current user\'s settings.  Returns user\'s settings from database. If no settings exist yet, creates default settings based on organization country.
         * @summary Get User Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/me/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register/invite a new user (Admin only) with audit logging  Matches Java: returns 200 OK (Java UserController line 77)
         * @summary Register User
         * @param {UserInvite} userInvite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUser: async (userInvite: UserInvite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userInvite' is not null or undefined
            assertParamExists('registerUser', 'userInvite', userInvite)
            const localVarPath = `/api/users/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userInvite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Self-register a new user and organization (public endpoint)  Matches Java: returns 200 OK (Java UserController line 87)  Rate-limited: EMAIL_RATE_LIMIT_PER_HOUR attempts per IP per hour.
         * @summary Self Register User
         * @param {SelfRegisterRequest} selfRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfRegisterUser: async (selfRegisterRequest: SelfRegisterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selfRegisterRequest' is not null or undefined
            assertParamExists('selfRegisterUser', 'selfRegisterRequest', selfRegisterRequest)
            const localVarPath = `/api/users/self-register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selfRegisterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user information (Admin only) with audit logging
         * @summary Update User
         * @param {string} userId 
         * @param {UserUpdate} userUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userId: string, userUpdate: UserUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'userUpdate' is not null or undefined
            assertParamExists('updateUser', 'userUpdate', userUpdate)
            const localVarPath = `/api/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update current user\'s settings (partial updates supported).  Only provided fields are updated - existing settings are merged.  Examples:     {\"settings\": {\"language\": \"bg\"}}                    # Update language only     {\"settings\": {\"language\": \"en\", \"currency\": \"USD\"}} # Update both     {\"settings\": {\"notifications\": {\"email\": true}}}    # Add new setting
         * @summary Update User Settings
         * @param {UserSettingsUpdate} userSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSettings: async (userSettingsUpdate: UserSettingsUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userSettingsUpdate' is not null or undefined
            assertParamExists('updateUserSettings', 'userSettingsUpdate', userSettingsUpdate)
            const localVarPath = `/api/users/me/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSettingsUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload avatar for a user (Admin only)
         * @summary Upload User Avatar
         * @param {string} userId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserAvatar: async (userId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('uploadUserAvatar', 'userId', userId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadUserAvatar', 'file', file)
            const localVarPath = `/api/users/{user_id}/avatar`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Get total login counts grouped by organization (batch-get endpoint)
         * @summary Batch Get Login Counts
         * @param {BatchGetRequest} batchGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchGetLoginCounts(batchGetRequest: BatchGetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchGetLoginCounts(batchGetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.batchGetLoginCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a user (Admin only) with audit logging
         * @summary Delete User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete all users in an organization (Admin only)  Returns 204 No Content on successful deletion.
         * @summary Delete Users By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsersByOrganization(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsersByOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deleteUsersByOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all users in the organization
         * @summary Fetch All Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.fetchAllUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch last login times for all users (any authenticated user)
         * @summary Fetch All Users Last Login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllUsersLastLogin(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserLastLogin>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllUsersLastLogin(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.fetchAllUsersLastLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch the currently authenticated user with organization features.  Features are populated based on the user\'s organization subscription plan.
         * @summary Fetch Principal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPrincipal(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPrincipal(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.fetchPrincipal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch audit logs (Admin only)
         * @summary Fetch Audit Logs
         * @param {string | null} [userId] Filter by user
         * @param {string | null} [eventType] Filter by event type
         * @param {number} [limit] Limit results
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchUserAuditLogs(userId?: string | null, eventType?: string | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditLogEventResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchUserAuditLogs(userId, eventType, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.fetchUserAuditLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch user by email
         * @summary Fetch User By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchUserByEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchUserByEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.fetchUserByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch user by ID
         * @summary Fetch User By Id
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchUserById(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchUserById(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.fetchUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get current user\'s settings.  Returns user\'s settings from database. If no settings exist yet, creates default settings based on organization country.
         * @summary Get User Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Register/invite a new user (Admin only) with audit logging  Matches Java: returns 200 OK (Java UserController line 77)
         * @summary Register User
         * @param {UserInvite} userInvite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerUser(userInvite: UserInvite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerUser(userInvite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.registerUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Self-register a new user and organization (public endpoint)  Matches Java: returns 200 OK (Java UserController line 87)  Rate-limited: EMAIL_RATE_LIMIT_PER_HOUR attempts per IP per hour.
         * @summary Self Register User
         * @param {SelfRegisterRequest} selfRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfRegisterUser(selfRegisterRequest: SelfRegisterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfRegisterUser(selfRegisterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.selfRegisterUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user information (Admin only) with audit logging
         * @summary Update User
         * @param {string} userId 
         * @param {UserUpdate} userUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userId: string, userUpdate: UserUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userId, userUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update current user\'s settings (partial updates supported).  Only provided fields are updated - existing settings are merged.  Examples:     {\"settings\": {\"language\": \"bg\"}}                    # Update language only     {\"settings\": {\"language\": \"en\", \"currency\": \"USD\"}} # Update both     {\"settings\": {\"notifications\": {\"email\": true}}}    # Add new setting
         * @summary Update User Settings
         * @param {UserSettingsUpdate} userSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserSettings(userSettingsUpdate: UserSettingsUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserSettings(userSettingsUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUserSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload avatar for a user (Admin only)
         * @summary Upload User Avatar
         * @param {string} userId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadUserAvatar(userId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadUserAvatar(userId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.uploadUserAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * Get total login counts grouped by organization (batch-get endpoint)
         * @summary Batch Get Login Counts
         * @param {BatchGetRequest} batchGetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchGetLoginCounts(batchGetRequest: BatchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.batchGetLoginCounts(batchGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a user (Admin only) with audit logging
         * @summary Delete User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete all users in an organization (Admin only)  Returns 204 No Content on successful deletion.
         * @summary Delete Users By Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsersByOrganization(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUsersByOrganization(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all users in the organization
         * @summary Fetch All Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllUsers(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserResponse>> {
            return localVarFp.fetchAllUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch last login times for all users (any authenticated user)
         * @summary Fetch All Users Last Login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllUsersLastLogin(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserLastLogin>> {
            return localVarFp.fetchAllUsersLastLogin(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch the currently authenticated user with organization features.  Features are populated based on the user\'s organization subscription plan.
         * @summary Fetch Principal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPrincipal(options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.fetchPrincipal(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch audit logs (Admin only)
         * @summary Fetch Audit Logs
         * @param {string | null} [userId] Filter by user
         * @param {string | null} [eventType] Filter by event type
         * @param {number} [limit] Limit results
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserAuditLogs(userId?: string | null, eventType?: string | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AuditLogEventResponse>> {
            return localVarFp.fetchUserAuditLogs(userId, eventType, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch user by email
         * @summary Fetch User By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserByEmail(email: string, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.fetchUserByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch user by ID
         * @summary Fetch User By Id
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUserById(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.fetchUserById(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get current user\'s settings.  Returns user\'s settings from database. If no settings exist yet, creates default settings based on organization country.
         * @summary Get User Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettings(options?: RawAxiosRequestConfig): AxiosPromise<UserSettingsResponse> {
            return localVarFp.getUserSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * Register/invite a new user (Admin only) with audit logging  Matches Java: returns 200 OK (Java UserController line 77)
         * @summary Register User
         * @param {UserInvite} userInvite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUser(userInvite: UserInvite, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.registerUser(userInvite, options).then((request) => request(axios, basePath));
        },
        /**
         * Self-register a new user and organization (public endpoint)  Matches Java: returns 200 OK (Java UserController line 87)  Rate-limited: EMAIL_RATE_LIMIT_PER_HOUR attempts per IP per hour.
         * @summary Self Register User
         * @param {SelfRegisterRequest} selfRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfRegisterUser(selfRegisterRequest: SelfRegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.selfRegisterUser(selfRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user information (Admin only) with audit logging
         * @summary Update User
         * @param {string} userId 
         * @param {UserUpdate} userUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userId: string, userUpdate: UserUpdate, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.updateUser(userId, userUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update current user\'s settings (partial updates supported).  Only provided fields are updated - existing settings are merged.  Examples:     {\"settings\": {\"language\": \"bg\"}}                    # Update language only     {\"settings\": {\"language\": \"en\", \"currency\": \"USD\"}} # Update both     {\"settings\": {\"notifications\": {\"email\": true}}}    # Add new setting
         * @summary Update User Settings
         * @param {UserSettingsUpdate} userSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSettings(userSettingsUpdate: UserSettingsUpdate, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingsResponse> {
            return localVarFp.updateUserSettings(userSettingsUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload avatar for a user (Admin only)
         * @summary Upload User Avatar
         * @param {string} userId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserAvatar(userId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.uploadUserAvatar(userId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI {
    /**
     * Get total login counts grouped by organization (batch-get endpoint)
     * @summary Batch Get Login Counts
     * @param {BatchGetRequest} batchGetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public batchGetLoginCounts(batchGetRequest: BatchGetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).batchGetLoginCounts(batchGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a user (Admin only) with audit logging
     * @summary Delete User
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUser(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete all users in an organization (Admin only)  Returns 204 No Content on successful deletion.
     * @summary Delete Users By Organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUsersByOrganization(organizationId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUsersByOrganization(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all users in the organization
     * @summary Fetch All Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllUsers(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).fetchAllUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch last login times for all users (any authenticated user)
     * @summary Fetch All Users Last Login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllUsersLastLogin(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).fetchAllUsersLastLogin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch the currently authenticated user with organization features.  Features are populated based on the user\'s organization subscription plan.
     * @summary Fetch Principal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPrincipal(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).fetchPrincipal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch audit logs (Admin only)
     * @summary Fetch Audit Logs
     * @param {string | null} [userId] Filter by user
     * @param {string | null} [eventType] Filter by event type
     * @param {number} [limit] Limit results
     * @param {number} [offset] Offset for pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchUserAuditLogs(userId?: string | null, eventType?: string | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).fetchUserAuditLogs(userId, eventType, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch user by email
     * @summary Fetch User By Email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchUserByEmail(email: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).fetchUserByEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch user by ID
     * @summary Fetch User By Id
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchUserById(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).fetchUserById(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get current user\'s settings.  Returns user\'s settings from database. If no settings exist yet, creates default settings based on organization country.
     * @summary Get User Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserSettings(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register/invite a new user (Admin only) with audit logging  Matches Java: returns 200 OK (Java UserController line 77)
     * @summary Register User
     * @param {UserInvite} userInvite 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerUser(userInvite: UserInvite, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).registerUser(userInvite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Self-register a new user and organization (public endpoint)  Matches Java: returns 200 OK (Java UserController line 87)  Rate-limited: EMAIL_RATE_LIMIT_PER_HOUR attempts per IP per hour.
     * @summary Self Register User
     * @param {SelfRegisterRequest} selfRegisterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public selfRegisterUser(selfRegisterRequest: SelfRegisterRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).selfRegisterUser(selfRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user information (Admin only) with audit logging
     * @summary Update User
     * @param {string} userId 
     * @param {UserUpdate} userUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUser(userId: string, userUpdate: UserUpdate, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUser(userId, userUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update current user\'s settings (partial updates supported).  Only provided fields are updated - existing settings are merged.  Examples:     {\"settings\": {\"language\": \"bg\"}}                    # Update language only     {\"settings\": {\"language\": \"en\", \"currency\": \"USD\"}} # Update both     {\"settings\": {\"notifications\": {\"email\": true}}}    # Add new setting
     * @summary Update User Settings
     * @param {UserSettingsUpdate} userSettingsUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserSettings(userSettingsUpdate: UserSettingsUpdate, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserSettings(userSettingsUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload avatar for a user (Admin only)
     * @summary Upload User Avatar
     * @param {string} userId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadUserAvatar(userId: string, file: File, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).uploadUserAvatar(userId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



